import { HappinessLevels } from '../../shared/enums/happiness-levels-types';
import { EngagementLevels } from '../../shared/enums/engagement-levels-type';
import { Injectable } from '@angular/core';
import { LanguagePipe } from 'src/app/shared/pipes/language.pipe';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  language: string;
  constructor(private languagePipe: LanguagePipe) { }
  isLanguageRTL() {
    return this.languagePipe.transform(this.language);
  }

  // componentText: any[] = [
  //   {
  //     key: "txtPPA",
  //     text: "Personal Profile Analysis (PPA)",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تحليل السمات الشخصية (PPA)"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHPTI",
  //     text: "High Potential Trait Indicator (HPTI)",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقييم القيادة و الامكانات (HPTI)"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtGIA",
  //     text: "General Intelligence Assessment (GIA)",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قدرات ذهنية و عقلية (GIA)"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTEIQ",
  //     text: "The Emotional Intelligence Assessment (TEIQ)",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تحليل الذكاء العاطفي (TEIQ)"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtLeaversAnswers",
  //     text: "Leaver Answers",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "أجوبة الموظف المغادر"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAnalysis",
  //     text: "Analysis",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تحليلات"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtNavigation",
  //     text: "Navigation",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "التنقل"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtSelectOption",
  //     text: "Select Option",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اختر خيار"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtComparison",
  //     text: "Comparison",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مقارنة"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPeople",
  //     text: "People",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ناس"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtUseSpreadsheet",
  //     text: "Use a spreadsheet",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "استعمل جدول"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAddNewLeaverText",
  //     text: "Please select how you want to add the new leaver:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اخر كيفية إضافة الموظف المغادر الجديد:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtColumnName",
  //     text: "Column Name",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اسم العمود"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCustomizeTable",
  //     text: "Customize Table",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عدِِل الجدول"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCustomize",
  //     text: "Customize",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عدِِل"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTenure",
  //     text: "Tenure",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "سنوات الخدمة"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompanyList",
  //     text: "Company List",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قائمة الشركات"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAccountManager",
  //     text: "Account Manager",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مدير الحساب"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtClientID",
  //     text: "Client ID",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هوية العميل"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAccountDetails",
  //     text: "Account Details",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "بيانات الحساب"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_notStartedYet",
  //     text: "Not Started Yet",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لم يتم البدء بالعمل عليه بعد"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_scheduled",
  //     text: "Scheduled",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مجدولة"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_DISPLAYLANGUAGE",
  //     text: "DISPLAY LANGUAGE",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لغة العرض"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_ACTIVEENTITY",
  //     text: "ACTIVE ENTITY",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الوحدة الفعالة"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompetencyName",
  //     text: "Competency Name",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اسم الجدارة أو المهارة"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_emp_ex_settings",
  //     text: "EMPLOYEE EXPERIENCE SETTINGS",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ضيط منصة تحليل تجربة الموظفين"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtIntegration",
  //     text: "Integration",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ترابط البيانات"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtClearAllNotifications",
  //     text: "Clear All Notifications",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مسح جميع اللإشعارات"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPromoters",
  //     text: "Promoters",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المروجون"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPassives",
  //     text: "Passives",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "السلبيون"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtDetractors",
  //     text: "Detractors",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المنتقدون"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtENPS",
  //     text: "eNPS Score",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "صافي نقاط ترويج الموظفين (eNPS)"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtApplyChanges",
  //     text: "Apply Changes",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "طبق التغييرات"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtDisplayOptions",
  //     text: "Display Options",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "خيارات العرض"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPsychometricAssessments",
  //     text: "Psychometric Assessments",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقييمات القياس النفسي"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEmployeeProducts",
  //     text: "EMPLOYEE EXPERIENCE PRODUCTS",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "أدوات قياس وتحليل تجربة الموظفين"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEvaluatorTypeRequired",
  //     text: "Evaluator type must be included",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يجب ذكر نوع المقيم"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMinimumTwoOptions",
  //     text: "minimum two options are needed.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يجب اختيار خيارين على الأقل."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_copy",
  //     text: "Copy",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نسخ"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_reminder_date",
  //     text: "Reminder Date",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تاريخ التذكير"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_filters",
  //     text: "Filters",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "التصفية والفرز"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_validation_min",
  //     text: "minimum characters not met.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لم يتم مطابقة الحد الأدنى لعدد الحروف."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_validation_max",
  //     text: "Exceeded maximum characters",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لقد تجاوزت الحد الأقصى لعدد الحروف"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_entities",
  //     text: "Entities",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الوحدات"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPreviousScore",
  //     text: "Previous Score",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "النتيجة السابقة"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtChangePercentage",
  //     text: "Change Percentage",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "معدل التغيير"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAverageScore",
  //     text: "Average Score",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "متوسط النتيجة"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtDifference",
  //     text: "Difference",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الفرق"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPreviousScoreDesc",
  //     text: "Compare against the average evaluators scores.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قارن مع متوسط نتائج المقيمين"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAverageScoreDesc",
  //     text: "Compare against the previous score",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قارن مع النتيجة السابقة"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_delete_respondent",
  //     text: "Are you sure you want to delete this respondent?",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هل أنت متأكد أنك تريد مسح هذا المستجيب ؟"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompare",
  //     text: "Compare",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قارن"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtBenchmarks",
  //     text: "Benchmarks",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المعايير"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtGlobal",
  //     text: "Global",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "العالمي"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPrevious",
  //     text: "Previous",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "السابق"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtSelectEntity",
  //     text: "Selected Entity",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اختر الشركة"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtApply",
  //     text: "Apply",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تطبيق"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtViewBy",
  //     text: "View By",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تصفح عن طريق"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtDownloadExcel",
  //     text: "Download Excel",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تحميل ملف Excel"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAllAnswers",
  //     text: "all answers ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "كل الإجابات "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAnswersBy",
  //     text: "answers by ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إجابات بواسطة  "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtExtraQuestionMinimum",
  //     text: "at least one question needs to be added!",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يجب إضافة سؤال واحد على الأقل!"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtExtraQuestionPreview",
  //     text: "Question Preview",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عرض السؤال"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtExtraQuestion",
  //     text: "Rate your working environment productivity index",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قيم مؤشر الانتاجية في مكان عملك"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt4Questions",
  //     text: "Type a maximum of 4 questions on the right to bound to the custom driver",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اكتب 4 أسئلة كحد أقصى للعامل المخصص"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCustomFactotText",
  //     text: "Create and customize your own factor with up to custom 4 questions",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "أنشئ وخصص عامل السعادة الخاص بك مع 4 أسئلة كحد أقصى"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtRemoveSelection",
  //     text: "Remove Selection",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "أزل الاختيارات"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtOverallScore",
  //     text: "Overall Score",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "النتيجة الكلية"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtValue",
  //     text: "Value",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "القيمة"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtWrongPattern",
  //     text: "Email wrong pattern.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "صيغة بريد إلكتروني خاطئة."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtID",
  //     text: "ID",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الرقم الوظيفي"
  //       },
  //       {
  //         language: "FR",
  //         text: "ID"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btnSaveDriver",
  //     text: "Save Driver",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "احفظ العامل"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtExtraDriver",
  //     text: "Extra Driver",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عامل الاندماج الإضافي"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtExtraFactor",
  //     text: "Extra Factor",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عامل السعادة الإضافي"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtDriverName",
  //     text: "Driver Name",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اسم العامل"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCustomDriver",
  //     text: "Add Custom Driver?",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: " أضف عامل اندماج مخصص"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCustomfactor",
  //     text: "Add Custom Factor?",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: " أضف عامل سعادة مخصص"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEnterInformation",
  //     text: "Fill the needed information to proceed.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يرجى تعبئة المعلومات اللازمة للمتابعة."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAllRights",
  //     text: "All Rights Reserved",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "جميع الحقوق محفوظة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Tous les droits sont réservés"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btnRetakeSurvey",
  //     text: "Retake Survey",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إعادة الاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Reprise du Enquęte"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAverage",
  //     text: "Average",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "متوسط"
  //       },
  //       {
  //         language: "FR",
  //         text: "Moyenne"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAllocationDate",
  //     text: "Allocation Date",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تاريخ التخصيص"
  //       },
  //       {
  //         language: "FR",
  //         text: "Date d'attribution"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtNoExpiry",
  //     text: "No Expiry",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لا يوجد تاريخ إنتهاء"
  //       },
  //       {
  //         language: "FR",
  //         text: "Pas de date d'expiration"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAllocationHistory",
  //     text: "Allocation History",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تاريخ التخصيص"
  //       },
  //       {
  //         language: "FR",
  //         text: "Historique de l'attribution"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtContactSoon",
  //     text: "We'll be in contact with you soon.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "سوف يتم الاتصال بك قريباً"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nous serons bientôt en contact avec vous "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtNewBalance",
  //     text: "New Balance",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الرصيد الجديد"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nouveau Solde"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtRequestAmount",
  //     text: "Request Amount",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الرصيد المطلوب"
  //       },
  //       {
  //         language: "FR",
  //         text: "Solde requis"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCurrentBalance",
  //     text: "Current Balance",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الرصيد الحالي"
  //       },
  //       {
  //         language: "FR",
  //         text: "SOLDE courant"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtOverallUNITSBalance",
  //     text: "Overall UNITS Balance",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "رصيد الوحدات الكلي"
  //       },
  //       {
  //         language: "FR",
  //         text: "Solde global des UNITÉS"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtUNITSPERPRODUCT",
  //     text: "UNITS PER PRODUCT / company",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "وحدة لكل منتج / شركة"
  //       },
  //       {
  //         language: "FR",
  //         text: "UNITÉS PAR PRODUIT / société"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtProductName",
  //     text: "Product Name",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اسم المنتج"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nom du produit"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTotalUnits",
  //     text: "Total Units",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مجموع الوحدات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Unités Totales"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtUsedUnits",
  //     text: "Used Units",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الوحدات المستخدمة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Unités Utilisées"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtRemainingUnits",
  //     text: "Remaining Units",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الوحدات المتبقية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Unités Restantes"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtExpiryDate",
  //     text: "Expiry Date",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تاريخ الانتهاء"
  //       },
  //       {
  //         language: "FR",
  //         text: "Date d'expiration"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAssignUnits",
  //     text: "Assign Units",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تخصيص الوحدات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Assignation des Unités"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAssign",
  //     text: "Assign",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تخصيص"
  //       },
  //       {
  //         language: "FR",
  //         text: "Assigner "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPurchaseHistory",
  //     text: "Purchase History",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تاريخ الشراء"
  //       },
  //       {
  //         language: "FR",
  //         text: "Date des Achat"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPurchasedUnits",
  //     text: "Purchased Units",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الوحدات التي تم شراؤها"
  //       },
  //       {
  //         language: "FR",
  //         text: "Unités Achetées"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtProduct",
  //     text: "Product",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المنتج"
  //       },
  //       {
  //         language: "FR",
  //         text: "Produit"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtDateofPurchase",
  //     text: "Date of Purchase",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تاريخ الشراء"
  //       },
  //       {
  //         language: "FR",
  //         text: "Date d'Achat"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtRequestSent",
  //     text: "Request has been sent!",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لقد تكم إرسال طلبك!"
  //       },
  //       {
  //         language: "FR",
  //         text: "Votre demande a été envoyée !"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_one_candidate_needed",
  //     text: "At least a candidate and an evaluator of his need to complete the survey to close",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يجب أن يتم إكمال الاستبيان من قِبَل المرشح ومقيّم واحد له على الأقل لإغلاق الاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Au moins un candidat et un évaluateur de son besoin de répondre ŕ l'enquęte pour clôturer"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_one_respondent_needed",
  //     text: "At least one respondent needs to complete the survey to close",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يجب أن يتم إكمال الاستبيان من مستجيب واحد على الأقل لإغلاق الاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Le Enquęte doit ętre rempli par au moins un répondant pour clôturer l'enquęte"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtNoLeavers",
  //     text: "No leavers!",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لا يوجد مغادرين!"
  //       },
  //       {
  //         language: "FR",
  //         text: "Pas de sortants!"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtNoReportsYet",
  //     text: "No leavers to generate reports yet!",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لا يمكن إنشاء تقارير لعدم وجود مغادرين!"
  //       },
  //       {
  //         language: "FR",
  //         text: "Aucun sortant pour générer des rapports pour le moment!"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_no_respondents_yet",
  //     text: "No Respondents Created",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لم يتم إضافة مستجيبين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Aucun répondant n'a été ajouté"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_setup_a_new_respondent",
  //     text: "Add a Respondent",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "أضف مستجيب"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ajouter un répondant"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTemplateEmail",
  //     text: "This template is optimized for email clients \"Gmail, Outook, ...etc\" please modify with care. If you wish to revert to the default template click on the \"Default Template\" button.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم تحسين هذا النموذج لمستخدمي البريد الالكتروني الخاص بـ \"Gmail, Outlook,…etc\" الرجاء التعديل بحذر. إذا كنت ترغب بالتحويل للنموذج الأساسي اضغط على زر \"النموذج الأساسي\"."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ce modèle est optimisé pour les clients de messagerie \"Gmail, Outlook, ...etc.\" veuillez le modifier avec soin. Si vous souhaitez revenir au modèle de base, cliquez sur le bouton \"Modèle de base\"."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtDefaultTemplate",
  //     text: "Default Template",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "النموذج الأساسي"
  //       },
  //       {
  //         language: "FR",
  //         text: "Modčle de base"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtSpecifyHere",
  //     text: "Specify here...",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "وضح هنا..."
  //       },
  //       {
  //         language: "FR",
  //         text: "Précisez ici ..."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEngagementsComparison",
  //     text: "Engagements Comparison",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مقارنة الاندماج الوظيفي"
  //       },
  //       {
  //         language: "FR",
  //         text: "Comparaison de l’Intégration"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHappinessComparison",
  //     text: "Happiness Comparison",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مقارنة السعادة"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtError",
  //     text: "Error",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "خطأ"
  //       },
  //       {
  //         language: "FR",
  //         text: "Erreur"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtErrorText",
  //     text: "An error occured. Please, sign in again or contact your administrator.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "حصل خطأ. الرجاء إعادة تسجيل الدخول مرة أخرى أو التواصل مع المسؤول."
  //       },
  //       {
  //         language: "FR",
  //         text: "sign in again or contact your administrator."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHopon",
  //     text: "Hop on",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هيا بنا"
  //       },
  //       {
  //         language: "FR",
  //         text: "Allons-y "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtSurveyClosed",
  //     text: "The survey has been closed, keep an eye for the next one.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لقد تم إنهاء هذا الاستبيان"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtSurveyClosedTitle",
  //     text: "Survey Closed",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "استبيان منتهي"
  //       },
  //       {
  //         language: "FR",
  //         text: "Enquęte s'est achevée "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtSurveyComplete",
  //     text: "The survey has been completed.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لقد تم إكمال الاستبيان."
  //       },
  //       {
  //         language: "FR",
  //         text: "Le Enquęte est terminé."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtThankYou",
  //     text: "Thank you!",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "شكراً لك!"
  //       },
  //       {
  //         language: "FR",
  //         text: "Merci!"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtSurveyCompleteTitle",
  //     text: "Survey Completed",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم إكمال الاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Enquęte Terminé"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtSurvey",
  //     text: "Survey",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "استبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Enquęte"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtQ",
  //     text: "Q",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "س"
  //       },
  //       {
  //         language: "FR",
  //         text: "Q"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtYear",
  //     text: "Year",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "السنة"
  //       },
  //       {
  //         language: "FR",
  //         text: "An"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtLogo",
  //     text: "Company Logo",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "شعار الشركة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Logo de la société"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtImageFormat",
  //     text: "Logo needs to be PNG, JPEG, or GIF",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يجب أن يكون الشعار بامتداد PNG أو JPEG أو GIF فقط"
  //       },
  //       {
  //         language: "FR",
  //         text: "Le Logo doit être au format PNG, JPEG ou GIF"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtNumbersOnly",
  //     text: "should be numbers only",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يجب أن يحتوي أرقاماً فقط"
  //       },
  //       {
  //         language: "FR",
  //         text: "Devrait contenir des nombres seulement"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtWrongFormat",
  //     text: "in wrong format",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الامتداد خطأ"
  //       },
  //       {
  //         language: "FR",
  //         text: "Dans un mauvais format"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtWebsite",
  //     text: "Website",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الموقع الإلكتروني"
  //       },
  //       {
  //         language: "FR",
  //         text: "Site Web "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEmailPssword",
  //     text: "Please provide both your email and password to login.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يرجى إدخال بريدك الإلكتروني وكلمة السر لتسجيل الدخول."
  //       },
  //       {
  //         language: "FR",
  //         text: "Veuillez fournir votre Email et votre mot de passe pour vous connecter."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtWrongInfo",
  //     text: "Wrong information provided, please try again.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم إدخال معلومات خاطئة، يرجى المحاولة مرة أخرى."
  //       },
  //       {
  //         language: "FR",
  //         text: "please try again."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCheckEmails",
  //     text: "Request sent, please check your email",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم إرسال الطلب، يرجى التحقق من بريدك الإلكتروني"
  //       },
  //       {
  //         language: "FR",
  //         text: "please check your email"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEnterEmail",
  //     text: "Please, enter an email",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يرجى إدخال بريد إلكتروني"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtResetEmail",
  //     text: "Password reset email sent",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم إرسال بريد إلكتروني لإعادة تعيين كلمة السر"
  //       },
  //       {
  //         language: "FR",
  //         text: "Réinitialisation du mot de passe, Email envoyé"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtNoTemplete",
  //     text: "A template must be selected to proceed!",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يجب اختيار نموذج للمتابعة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Un modčle doit ętre sélectionné pour continuer!"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtNoStatement",
  //     text: "Every Selected competency must at least have one statement.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يجب اختيار عبارة واحدة على الأقل لكل جدارة ومهارة."
  //       },
  //       {
  //         language: "FR",
  //         text: "Au moins une phrase doit ętre choisie pour chaque compétence et mérite."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMinCandidate",
  //     text: "At least one candidate needs to be added!",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يجب إضافة مرشح واحد على الأقل!"
  //       },
  //       {
  //         language: "FR",
  //         text: "Au moins un candidat doit ętre ajouté!"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtManagersFor",
  //     text: "Managers for ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المديرون لـ "
  //       },
  //       {
  //         language: "FR",
  //         text: "Gestionnaires pour"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMin1Max2",
  //     text: "should be minimum 1 max 2!",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يجب أن يكون 1 على الأقل و2 على الأكثر!"
  //       },
  //       {
  //         language: "FR",
  //         text: "Devrait ętre minimum 1 max 2!"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEvaluatorsFor",
  //     text: "Evaluators for ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المستجيبون لـ  "
  //       },
  //       {
  //         language: "FR",
  //         text: "Les Répondants ŕ  "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMin3",
  //     text: "should be 3 at minimum!",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يجب أن يكونوا 3 على الأقل!"
  //       },
  //       {
  //         language: "FR",
  //         text: "Devraient ętre 3 au minimum!"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtWeight100",
  //     text: "Overall weight must be 100% to proceed.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يجب أن يكون الوزن الكلي 100% للمتابعة."
  //       },
  //       {
  //         language: "FR",
  //         text: "Le poids total doit ętre de 100% pour continuer."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtOneStatement",
  //     text: "Every Selected competency must at least have one statement.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يجب اختيار عبارة واحدة على الأقل لكل مهارة و جدارة."
  //       },
  //       {
  //         language: "FR",
  //         text: "Au moins une phrase doit ętre choisie pour chaque compétence et mérite."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMinCompetencies",
  //     text: "Minimium 3 competencies must be selected!",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يجب اختيار 3 مهارات وجدارات على الأقل!"
  //       },
  //       {
  //         language: "FR",
  //         text: "Au moins 3 compétences doivent ętre sélectionnées!"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMinStatements",
  //     text: "Minimium 3 statements must be selected!",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يجب اختيار 3 عبارات على الأقل!"
  //       },
  //       {
  //         language: "FR",
  //         text: "Au moins 3 déclarations doivent ętre sélectionnées!"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtSurveyStatus",
  //     text: "Survey Status",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "حالة الاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Statut de Enquęte "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtSeperationType",
  //     text: "Seperation Type",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نوع الفصل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Type de Séparation"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPercentageOfLeavers",
  //     text: "Percentage of Leavers",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نسبة المغادرين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Pourcentage de sortants"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtNoOfLeavers",
  //     text: "Number of Leavers",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عدد المغادرين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nombre des Partants"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtLeaverAnswerReport",
  //     text: "Leaver Answer Report",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقرير أجوبة المغادر"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtRespbygender",
  //     text: "Respondents by Gender",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المستجيبون حسب الجنس"
  //       },
  //       {
  //         language: "FR",
  //         text: "Répondants par Sexe"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtRespby",
  //     text: "Respondents by ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المستجيبون حسب "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtRespbynationality",
  //     text: "Respondents by Nationality",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المستجيبون حسب الجنسية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Répondants par Nationalité"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_remove_respondent_confirmation_subject",
  //     text: "Delete Confirmation",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تأكيد الحذف"
  //       },
  //       {
  //         language: "FR",
  //         text: "Confirmation de suppression"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_remove_respondent_confirmation_message",
  //     text: "Are you sure you want to delete this respondent?",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هل أنت متأكد من حذف هذا المستجيب؟"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ętes-vous sűr de vouloir supprimer ce répondant?"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_remove_respondents_confirmation_message",
  //     text: "Are you sure you want to delete these respondents?",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هل أنت متأكد من حذف هؤلاء المستجيبون؟"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ętes-vous sűr de vouloir supprimer ces répondants?"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_remove_candidate_confirmation_message",
  //     text: "Are you sure you want to delete this candidate? Respondents for this candidate will be removed as well",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هل أنت متأكد من حذف هذا المرشح؟ سيتم حذف المستجيون لهذا المرشح أيضاً!"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtsuccess",
  //     text: "Success",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تمت العملية بنجاح"
  //       },
  //       {
  //         language: "FR",
  //         text: "Succčs"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtwarning",
  //     text: "Warning",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تحذير"
  //       },
  //       {
  //         language: "FR",
  //         text: "Avertissement"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtalert",
  //     text: "Alert",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تنبيه"
  //       },
  //       {
  //         language: "FR",
  //         text: "Avertissement"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txterror",
  //     text: "Error",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "خطأ"
  //       },
  //       {
  //         language: "FR",
  //         text: "Erreur"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_upload",
  //     text: "Upload",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "رفع"
  //       },
  //       {
  //         language: "FR",
  //         text: "Télécharger"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHeadQuarter",
  //     text: "Headquarter",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المقر الرئيسي"
  //       },
  //       {
  //         language: "FR",
  //         text: "Sičge Social"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompanySetup",
  //     text: "Company Setup",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إعدادات الشركة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Configuration de la société"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCreateCompany",
  //     text: "Create Company",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إنشاء شركة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Créer une société"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtLoader",
  //     text: "Please wait...",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يرجى الانتظار..."
  //       },
  //       {
  //         language: "FR",
  //         text: "S'il vous plaît, attendez..."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_evaluator_limit_reached",
  //     text: "You have exceeded the evaluator limit of #ENO# evaluators for candidate #CANDIDATENAME#, #UNITS# unit(s) will be deducted to increase the limit by #LIMITINCREASE# for the evalutors you are about to add. (1 Unit for every 20 Evaulators)",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لقد تجاوزت العدد المسموح به للمقيمين #ENO# للمرشح #CANDIDATENAME#, سوف يتم خصم #UNITS# وحدات لزيادة العدد المسموح به #LIMITINCREASE# للمقيمين الذين ترغب بإضافاتهم. (1 وحدة لكل 20 مقيم)"
  //       },
  //       {
  //         language: "FR",
  //         text: "Vous avez dépassé la limite des évaluateurs de #ENO# pour le candidat #CANDIDATENAME#, #UNITS# unité (s) sera déduite pour augmenter la limite de #LIMITINCREASE# pour les évaluateurs que vous êtes sur le point d'ajouter. (1 Unité pour 20 Evaluateurs)"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_unit_deduction",
  //     text: "#UNITS# units will be deducted for this action",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "#UNITS# وحدة سيتم خصمها لعمل هذا الاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "#UNITS# les unités seront déduites pour cette action"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_unit_allocation_confirmation",
  //     text: "These #UNITS# units cannot be returned or reassigned to another service.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هذه ال #UNITS# وحدة لا يمكن استرجاعها أو تخصيصها لخدمة أخرى لاحقاً"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ces unités #UNITS# ne peuvent pas ętre retournées ou réaffectées ŕ un autre service."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_allocation_confirmation",
  //     text: "Confirmation",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تأكيد"
  //       },
  //       {
  //         language: "FR",
  //         text: "Confirmation"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtDontShow",
  //     text: "Do not show this message again",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لا تظهر هذه الرسالة مرة أخرى"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ce message n’apparaît plus"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_unitsPopupTile",
  //     text: "Unit(s) Received!",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم إضافة الوحدات!"
  //       },
  //       {
  //         language: "FR",
  //         text: "Unités reçues!"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_units_main_balance",
  //     text: "Your account has been credited with #UNITS# unit(s)",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تمت إضافة #UNITS# وحدة إلى حسابك"
  //       },
  //       {
  //         language: "FR",
  //         text: "Votre compte a été crédité d'unités #UNITS#"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_units_survey_balance",
  //     text: "#COMPANYNAME# has been credited with #UNITS# unit(s) for #SURVEYNAME#",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم إضافة #UNITS# وحدات ل#SURVEYNAME# لحساب #COMPANYNAME#"
  //       },
  //       {
  //         language: "FR",
  //         text: "#COMPANYNAME# a été crédité d'unités #UNITS# pour #SURVEYNAM #"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_unitsAdded",
  //     text: "Unit(s) Added",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الوحدات المضافة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Unités Ajoutées"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_totalUnits",
  //     text: "New Total Balance",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إجمالي الرصيد الجديد"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nouveau Solde Total"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_units",
  //     text: "Units",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "وحدة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Unités"
  //       }
  //     ]
  //   },
  //   {
  //     key: "noUnits",
  //     text: "Please, add at least one unit to proceed.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يرجى إضافة وحدة واحدة على الأقل للمتابعة."
  //       },
  //       {
  //         language: "FR",
  //         text: "add at least one unit to proceed."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_unit",
  //     text: "Unit",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "وحدة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Unité"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_survey",
  //     text: "Survey",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "استبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Enquęte"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAccountOverview",
  //     text: "Account Overview",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نظرة عامة على الحساب"
  //       },
  //       {
  //         language: "FR",
  //         text: "Aperçu du Compte"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAccountOverviewDesc",
  //     text: "View and manage your account information",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عرض وإدارة معلومات حسابك"
  //       },
  //       {
  //         language: "FR",
  //         text: "Voir et gérer les informations de votre compte"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtRemainingBalance",
  //     text: "Remaining Balance",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الرصيد المتبقي"
  //       },
  //       {
  //         language: "FR",
  //         text: "Solde Restant"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btnRequestUnits",
  //     text: "Request Units",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "طلب وحدات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Demande d'Unités"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtUnitsperModule",
  //     text: "Units per Product",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الوحدات لكل منتج"
  //       },
  //       {
  //         language: "FR",
  //         text: "Unités par Produit"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCurrentunits",
  //     text: "Current units:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الوحدات الحالية:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Unités Actuelles:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAllocatedUnits",
  //     text: "Allocated Units:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الوحدات المخصصة:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Unités Allouées:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEmployeeExitAnalysis",
  //     text: "Employee Exit",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "خروج الموظفين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Sortie de l'employé"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt360DegreeFeedback",
  //     text: "360° Feedback",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقييم °360"
  //       },
  //       {
  //         language: "FR",
  //         text: "Commentaire ŕ 360°"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEmployeeExperience",
  //     text: "Employee Experience",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تجربة الموظفين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Expérience des employés"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtResetPassword",
  //     text: "Reset Password",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إعادة تعيين كلمة المرور"
  //       },
  //       {
  //         language: "FR",
  //         text: "Réinitialiser le mot de passe"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_Exit_Questionnaire",
  //     text: "Employee Exit Survey",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "استبيان خروج الموظف وإنتهاء العمل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Enquęte sur les sorties des employés"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_Employee_Engagement_Survey",
  //     text: "Employee Engagement Survey",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "استبيان الاندماج الوظيفي"
  //       },
  //       {
  //         language: "FR",
  //         text: "Enquęte sur l’engagement des employés"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_subject_password_resetConfirmation",
  //     text: "Reset Password",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إعادة تعيين كلمة المرور"
  //       },
  //       {
  //         language: "FR",
  //         text: "Réinitialiser le mot de passe"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_Password_resetConfirmation",
  //     text: "Are you sure you want to reset account password for #EMAIL# ?",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هل أنت متأكد أنك تريد إعادة تعيين كلمة المرور ل #EMAIL# ؟"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ętes-vous sűr de vouloir réinitialiser le mot de passe du compte pour #EMAIL# ?"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInsufficientUnits",
  //     text: "Insufficient Units!",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لا يوجد لديك وحدات كافية!"
  //       },
  //       {
  //         language: "FR",
  //         text: "Unités insuffisantes!"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtYourcurrentbalance",
  //     text: "Your current balance is",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "رصيدك الحالي هو"
  //       },
  //       {
  //         language: "FR",
  //         text: "Votre solde actuel est"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtunits",
  //     text: "units",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "وحدة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Unités"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtSameReminder",
  //     text: "This reminder date has already been set!",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم تحديد تاريخ التذكير هذا مسبقاً!"
  //       },
  //       {
  //         language: "FR",
  //         text: "Cette date de rappel a déjŕ été fixée!"
  //       }
  //     ]
  //   },
  //   {
  //     key: "sameDate",
  //     text: "This date has already been set!",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم تحديد تاريخ التذكير!"
  //       },
  //       {
  //         language: "FR",
  //         text: "Cette date est déjŕ fixée!"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInvitationMissingURL",
  //     text: "The email is missing a link!",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم حذف الرابط الخاص في هذا البريد الإلكتروني!"
  //       },
  //       {
  //         language: "FR",
  //         text: "Il manque un lien au courriel!"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtReminderMissingURL",
  //     text: "The reminder is missing a link!",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم حذف الرابط الخاص في هذا التذكير!"
  //       },
  //       {
  //         language: "FR",
  //         text: "Votre lien a été supprimé dans ce rappel!"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEvaluatorMissing",
  //     text: "The email is missing a link!",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم حذف الرابط الخاص في هذا البريد الإلكتروني!"
  //       },
  //       {
  //         language: "FR",
  //         text: "Il manque un lien au courriel!"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEvaluatorReminderMissing",
  //     text: "The reminder is missing a link!",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم حذف الرابط الخاص في هذا التذكير!"
  //       },
  //       {
  //         language: "FR",
  //         text: "Votre lien a été supprimé dans ce rappel!"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtWelcomeAboard",
  //     text: "Welcome Aboard",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "أهلا وسهلا بك معنا"
  //       },
  //       {
  //         language: "FR",
  //         text: "Bienvenue ŕ bord"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtwelcomedesc",
  //     text: "Log in to ZENITHR to continue",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "للمتابعة، قم بتسجيل الدخول إلى ZENITHR "
  //       },
  //       {
  //         language: "FR",
  //         text: "Connectez-vous ŕ ZENITHR pour continuer"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtResetyourpassword",
  //     text: "Reset your password",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إعادة تعيين كلمة المرور"
  //       },
  //       {
  //         language: "FR",
  //         text: "Réinitialisez votre mot de passe"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtResetPassworddesc",
  //     text: "You'll receive an email with further instructions",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "سيصلك بريد إلكتروني بكامل الإرشادات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Vous recevrez un email avec des instructions supplémentaires"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtUsername",
  //     text: "Username",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اسم المستخدم"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nom d'utilisateur"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtContinue",
  //     text: "Continue",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "استمر"
  //       },
  //       {
  //         language: "FR",
  //         text: "Continuer"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtLogin",
  //     text: "Log in",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تسجيل دخول"
  //       },
  //       {
  //         language: "FR",
  //         text: "Connecter"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPassword",
  //     text: "Password",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "كلمة المرور"
  //       },
  //       {
  //         language: "FR",
  //         text: "Mot de Passe"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHidepassword",
  //     text: "Hide password",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إخفاء كلمة المرور"
  //       },
  //       {
  //         language: "FR",
  //         text: "Masquer le mot de passe"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtForgotYourPassword",
  //     text: "Forgot Your Password?",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نسيت كلمة المرور؟"
  //       },
  //       {
  //         language: "FR",
  //         text: "Vous avez oublié votre mot de passe?"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCheckyourEmail",
  //     text: "Check your Email!",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تفقد بريدك الإلكتروني!"
  //       },
  //       {
  //         language: "FR",
  //         text: "Vérifiez votre Email!"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCheckyourEmaildesc",
  //     text: "An email with further instructions on how to set a new password has been sent to your inbox!",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم إرسال بريد إلكتروني يحتوي على خطوات تعيين كلمة مرور جديدة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Un e-mail contenant des instructions supplémentaires sur la façon de définir un nouveau mot de passe a été envoyé dans votre boîte de réception!"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtBacktoLogin",
  //     text: "Back to Log in",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "العودة إلى تسجيل الدخول"
  //       },
  //       {
  //         language: "FR",
  //         text: "Retour ŕ se Connecter"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtclicktogotoaccount",
  //     text: "You do not have a sufficient amount of units to proceed with creating a new survey / assessment. To request more units, click on the button below.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لا يوجد لديك وحدات كافية لإتمام إنشاء استبيان / تقييم جديد، لطلب وحدات إضافية، اضغط على الزر أدناه."
  //       },
  //       {
  //         language: "FR",
  //         text: "UVous n’avez pas un nombre suffisant d’unités pour procéder à la création d’un nouveau Enquête / évaluation. Pour demander plus d’unités, cliquez sur le bouton ci-dessous."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtIncreaseUnits",
  //     text: "Increase Units:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "زيادة وحدات:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Augmenter les Unités:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtRequest",
  //     text: "Request",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اطلب"
  //       },
  //       {
  //         language: "FR",
  //         text: "Demandez"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtYourcurrentbalanceforsurvey",
  //     text: "Your current balance for this survey is",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "رصيدك الحالي لهذا الاستبيان هو"
  //       },
  //       {
  //         language: "FR",
  //         text: "Votre solde actuel pour ce Enquęte est"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtthissurveyrequires",
  //     text: "units, this survey requires at least",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "وحدة, هذا الاستبيان يحتاج على الأقل"
  //       },
  //       {
  //         language: "FR",
  //         text: "this survey requires at least"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMostLiked",
  //     text: "Most Liked...",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الأكثر تفضيلاً"
  //       },
  //       {
  //         language: "FR",
  //         text: "Le Plus Préféré..."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtLeastLiked",
  //     text: "Least Liked...",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الأقل تفضيلاً"
  //       },
  //       {
  //         language: "FR",
  //         text: "Le Moins Préféré..."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtClearTimeframe",
  //     text: "Clear Timeframe",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إزالة المدة الزمنية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Effacer a délai"
  //       }
  //     ]
  //   },
  //   {
  //     key: "tenant_intro",
  //     text: "Lets define your companies: ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عرّف الشركات الخاصة بك:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Définissez vos entreprises: "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_companies",
  //     text: "Companies",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الشركات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Sociétés"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_new_Company",
  //     text: "New Company",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "شركة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ajouter une Entreprise"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_company_name",
  //     text: "Company Name",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اسم الشركة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nom de la société"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_company_industry",
  //     text: "Company Industry",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قطاع الشركة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Secteur de la société"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_company_size",
  //     text: "Company Size",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "حجم الشركة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Taille de la société"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_company_add",
  //     text: "Add Company",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إضافة شركة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ajouter une Société"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_company_edit",
  //     text: "Edit",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تعديل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Modifier"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_company_remove",
  //     text: "Remove",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "حذف"
  //       },
  //       {
  //         language: "FR",
  //         text: "Supprimer"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_branches",
  //     text: "Location / Branches",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الموقع / الفروع"
  //       },
  //       {
  //         language: "FR",
  //         text: "Emplacement / Succursales"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_country_code",
  //     text: "Country Code",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "رمز الدولة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Code postal"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_contact_number",
  //     text: "Contact Number",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "رقم الاتصال"
  //       },
  //       {
  //         language: "FR",
  //         text: "Numéro de Contact"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_next",
  //     text: "Next",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "التالي"
  //       },
  //       {
  //         language: "FR",
  //         text: "SUIVANT"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_users_setup",
  //     text: "Users Setup",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إعدادات المستخدم"
  //       },
  //       {
  //         language: "FR",
  //         text: "Configuration des Utilisateurs"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_new_users",
  //     text: "New User",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مستخدم"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nouvel Utilisateur"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_user_firstName",
  //     text: "First Name",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الاسم الأول"
  //       },
  //       {
  //         language: "FR",
  //         text: "Prénom"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_user_lastName",
  //     text: "Last Name",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الاسم الأخير"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nom de Famille"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_user_email",
  //     text: "Email",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "البريد الإلكتروني"
  //       },
  //       {
  //         language: "FR",
  //         text: "Email (Courrier électronique)"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_user_password",
  //     text: "Password",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "كلمة المرور"
  //       },
  //       {
  //         language: "FR",
  //         text: "Mot de Passe"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_user_companies",
  //     text: "Companies",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الشركات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Sociétés"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_content_languages",
  //     text: "Supported Languages",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اللغات المدعومة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Langages Supportés"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_company_structure",
  //     text: "Company Structure",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هيكل الشركة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Structure de la société"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_structure_name",
  //     text: "Entity Type",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اسم الوحدة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Type d’Unité"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_structure_edit",
  //     text: "Edit",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تعديل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Modifier "
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_structure_remove",
  //     text: "Remove",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "حذف"
  //       },
  //       {
  //         language: "FR",
  //         text: "Supprimer"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_structure_no_entities",
  //     text: "No Entities found",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لم يتم العثور على أي وحدة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Aucune Unité trouvée"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_structure_new_entity",
  //     text: "New Entity",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "وحدة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Unité"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_entity_group_name",
  //     text: "New Entity",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "وحدة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Unité"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_group_name",
  //     text: "Entity Type",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نوع الوحدة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Type d’Unité"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_custom_input_translation",
  //     text: "Translation",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ترجمة "
  //       },
  //       {
  //         language: "FR",
  //         text: "Traduction"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_parent_entity_group",
  //     text: "Parent Entity",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الوحدة الأم"
  //       },
  //       {
  //         language: "FR",
  //         text: "Société mčre"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_define_entities_reports",
  //     text: "Define Entities belonging to ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عرّف الوحدات التي تنتمي إلى"
  //       },
  //       {
  //         language: "FR",
  //         text: "Définir les entités appartenant ŕ "
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_add_structure_entity",
  //     text: "Add Entity",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إضافة وحدة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ajouter une Entité"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_entity_name",
  //     text: "Entity Name",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اسم الوحدة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nom de l’Unité"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_parent_entity",
  //     text: "Parent Entity",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الوحدة الأم"
  //       },
  //       {
  //         language: "FR",
  //         text: "Société mčre"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_update",
  //     text: "Update",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تحديث"
  //       },
  //       {
  //         language: "FR",
  //         text: "Mettre ŕ jour"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_add",
  //     text: "Add",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إضافة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ajouter"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_update_entity_group",
  //     text: "Successfully Updated",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم التحديث بنجاح"
  //       },
  //       {
  //         language: "FR",
  //         text: "Mise ŕ Jour avec Succčs"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_delete_entity_group",
  //     text: "Successfully Deleted",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم الحذف بنجاح "
  //       },
  //       {
  //         language: "FR",
  //         text: "Supprimé avec succčs"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_add_entity_group",
  //     text: "Successfully Added",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تمت الإضافة بنجاح "
  //       },
  //       {
  //         language: "FR",
  //         text: "Ajouter avec Succčs"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_performance_rate",
  //     text: "Performance Rate",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "معدل تقييم الأداء"
  //       },
  //       {
  //         language: "FR",
  //         text: "Taux de Performance"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_performance_rate_value",
  //     text: "Performance Rate",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "معدل تقييم الأداء"
  //       },
  //       {
  //         language: "FR",
  //         text: "Taux de Performance"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_performance_rate_description",
  //     text: "Description",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الوصف"
  //       },
  //       {
  //         language: "FR",
  //         text: "Description"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_performance_add",
  //     text: "Add Performance Rate",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "معدل تقييم أداء"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ajouter Un Taux de Performance"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_performance_icon",
  //     text: "Icon",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "رمز "
  //       },
  //       {
  //         language: "FR",
  //         text: "Icône"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_bandlevel",
  //     text: "Band Level",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المستوى الوظيفي"
  //       },
  //       {
  //         language: "FR",
  //         text: "Le Niveau de tranche"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_add_band_level",
  //     text: "Add Band Level",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مستوى وظيفي"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ajouter un niveau de la tranche "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_band_level_name",
  //     text: "Name",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الاسم"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nom "
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_edit_band_level",
  //     text: "Edit",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تعديل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Modifier"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_remove_band_level",
  //     text: "Remove",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "حذف"
  //       },
  //       {
  //         language: "FR",
  //         text: "Supprimer"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_add_job_grade",
  //     text: "Add Job Grade",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "درجة وظيفية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ajouter une Catégorie d’Emploi"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_edit_job_grade",
  //     text: "Edit",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تعديل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Modifier "
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_remove_job_grade",
  //     text: "Remove",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "حذف"
  //       },
  //       {
  //         language: "FR",
  //         text: "Supprimer"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_job_grade",
  //     text: "Job Grade",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الدرجة الوظيفية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Catégorie d'Emploi"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_users",
  //     text: "Users",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مستخدمين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Utilisateurs"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_add_user",
  //     text: "Add User",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مستخدم"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ajouter un Utilisateur"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_edit_user",
  //     text: "Edit",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تعديل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Modifier"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_update_user",
  //     text: "Update",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تحديث"
  //       },
  //       {
  //         language: "FR",
  //         text: "Mettre ŕ jour"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_full_name",
  //     text: "Name",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الاسم"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nom "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_questionnaire_name",
  //     text: "Survey Name",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اسم الاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nom de Enquęte "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_survey_questions",
  //     text: "Survey Questions",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "أسئلة الاستبيان"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_new_section",
  //     text: "Add New Section",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إضافة جزء"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ajouter une Nouvelle Section"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_section_name",
  //     text: "Section Name",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اسم الجزء"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nom de la Section"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_question_name",
  //     text: "Question Name",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عنوان السؤال"
  //       },
  //       {
  //         language: "FR",
  //         text: "Titre de la Question"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_question_type",
  //     text: "Question Type",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نوع السؤال"
  //       },
  //       {
  //         language: "FR",
  //         text: "Type de Question"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_add_question",
  //     text: "Add Question",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إضافة سؤال"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ajouter une Question"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_heading_name",
  //     text: "Heading Name",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اسم العنوان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Titre"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_other_answer",
  //     text: "Other",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "غير ذلك"
  //       },
  //       {
  //         language: "FR",
  //         text: "Autre"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_option_name",
  //     text: "Option Name",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الخيار"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nom de l'Option"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_add_option",
  //     text: "Add Option",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إضافة خيار"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ajouter une Option"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_save_questionnaire",
  //     text: "Save",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "حفظ"
  //       },
  //       {
  //         language: "FR",
  //         text: "Sauvegarder"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_page_settings",
  //     text: "Settings",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إعدادات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Paramčtres"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_page_leavers",
  //     text: "Leavers List",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قائمة الموظفين المغادرين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Liste des Sortants"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_add_new_leaver",
  //     text: "Add Leaver",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إضافة موظف مغادر"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ajouter Un Sortant"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leaver_employee_ID",
  //     text: "Leaver ID",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الرقم الوظيفي"
  //       },
  //       {
  //         language: "FR",
  //         text: "ID du Sortant"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leaver_employee_name",
  //     text: "Leaver's Name",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اسم الموظف"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nom du Sortant"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leaver_email",
  //     text: "Email",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "البريد الإلكتروني"
  //       },
  //       {
  //         language: "FR",
  //         text: "Email (Courrier électronique)"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leaver_mobile_number",
  //     text: "Mobile Number",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "رقم الهاتف المحمول"
  //       },
  //       {
  //         language: "FR",
  //         text: "Numéro de Portable"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leaver_date_of_birth",
  //     text: "Date of Birth",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تاريخ الميلاد"
  //       },
  //       {
  //         language: "FR",
  //         text: "Date de Naissance "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leaver_gender",
  //     text: "Gender",
  //     translations: [
  //       { language: "AR", text: "الجنس" },
  //       { language: "FR", text: "Sexe" },
  //       { language: "HI", text: "लिंग" },
  //       { language: "TA", text: "Kasarian" },
  //       { language: "UR", text: "جنس" }
  //     ]
  //   },
  //   {
  //     key: "txt_leaver_nationality",
  //     text: "Nationality",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الجنسية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nationalité"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leaver_company",
  //     text: "Company",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الشركة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Société"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leaver_job_title",
  //     text: "Job Title",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المسمى الوظيفي"
  //       },
  //       {
  //         language: "FR",
  //         text: "Titre d'Emploi"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leaver_direct_manager_name",
  //     text: "Direct Manager's Name",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اسم المدير المباشر"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nom du Directeur Directe"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leaver_job_level",
  //     text: "Job Level",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المستوى الوظيفي"
  //       },
  //       {
  //         language: "FR",
  //         text: "Niveau d'Emploi"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leaver_job_grade",
  //     text: "Job Grade",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الدرجة الوظيفية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Catégorie d'Emploi"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leaver_performance_rate",
  //     text: "Performance Rate",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "معدل تقييم الأداء"
  //       },
  //       {
  //         language: "FR",
  //         text: "Taux de Performance"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leaver_seperation_type",
  //     text: "Separation Type",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نوع الفصل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Type de Séparation"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leaver_joining_date",
  //     text: "Joining Date",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تاريخ الانضمام للعمل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Date d'Inscription"
  //       },
  //       {
  //         language: "HI",
  //         text: "कार्यग्रहण तिथि"
  //       },
  //       {
  //         language: "TA",
  //         text: "Petsa ng Pagsali"
  //       },
  //       {
  //         language: "UR",
  //         text: "شامل ہونے کی تاریخ"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leaver_seperation_date",
  //     text: "Seperation Date",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تاريخ الفصل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Date de Séparation d’emploi"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leaver_start_date",
  //     text: "Survey Start Date",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تاريخ بدء الاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Date de Début de Enquęte "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leaver_end_date",
  //     text: "Survey Completion Date",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تاريخ الانتهاء من الاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Date d’Achčvement du Enquęte"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leaver_personal_info",
  //     text: "Personal Information",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المعلومات الشخصية للموظف المغادر"
  //       },
  //       {
  //         language: "FR",
  //         text: "Informations Personnelles du Sortant"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leaver_positional_info",
  //     text: "Positional Information",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المعلومات الوظيفية للموظف المغادر"
  //       },
  //       {
  //         language: "FR",
  //         text: "Informations sur la Position du Sortant"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leaver_time_frame",
  //     text: "Time Frame",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المدة الزمنية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Délai"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_time_frame_start",
  //     text: "Time Frame Start",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "بداية المدة الزمنية"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_time_frame_end",
  //     text: "Time Frame End",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نهاية المدة الزمنية"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_invitation_date",
  //     text: "Invitation Date",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تاريخ الإرسال"
  //       },
  //       {
  //         language: "FR",
  //         text: "Date d'invitation"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_submitted_date",
  //     text: "Date Submitted",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تاريخ التسليم"
  //       },
  //       {
  //         language: "FR",
  //         text: "Date de Soumission"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_status",
  //     text: "Status",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الحالة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Statut "
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_leaver_list_update",
  //     text: "Update",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تحديث"
  //       },
  //       {
  //         language: "FR",
  //         text: "Mettre ŕ jour"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_leaver_list_delete",
  //     text: "Delete",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "حذف"
  //       },
  //       {
  //         language: "FR",
  //         text: "Supprimer"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_leaver_list_cancel",
  //     text: "Cancel",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إلغاء"
  //       },
  //       {
  //         language: "FR",
  //         text: "Annuler "
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_leaver_list_edit",
  //     text: "Edit",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تعديل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Modifier"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_leaver_list_set_inactive",
  //     text: "Set Inactive",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تعيين غير فعال"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ensemble Inactif"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_edit_company",
  //     text: "Edit Company",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تعديل الشركة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Modifier la société"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_edit_user",
  //     text: "Edit User",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تعديل المستخدم"
  //       },
  //       {
  //         language: "FR",
  //         text: "Modifier l'Utilisateur"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_edit_performance",
  //     text: "Edit Performance",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تعديل معدل تقييم الأداء"
  //       },
  //       {
  //         language: "FR",
  //         text: "Modifier les Performances"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_edit_band",
  //     text: "Edit Band",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تعديل المستوى الوظيفي"
  //       },
  //       {
  //         language: "FR",
  //         text: "Modification du niveau de la tranche"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_edit_grade",
  //     text: "Edit Grade",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تعديل الدرجة الوظيفية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Modification de la Grade Fonctionnelle"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_modal_company",
  //     text: "New Company",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إضافة شركة "
  //       },
  //       {
  //         language: "FR",
  //         text: "Ajouter une Entreprise"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_modal_user",
  //     text: "New User",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إضافة مستخدم "
  //       },
  //       {
  //         language: "FR",
  //         text: "Nouvel Utilisateur"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_modal_band",
  //     text: "New Band",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إضافة مستوى وظيفي "
  //       },
  //       {
  //         language: "FR",
  //         text: "Nouveau Niveau Fonctionnel"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_modal_grade",
  //     text: "New Grade",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إضافة درجة وظيفية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nouvelle Catégorie"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_leaver_list_send_questionnaire",
  //     text: "Send Survey",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إرسال الاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Envoyer un Enquęte"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_leaver_list_view_answers",
  //     text: "View Answers",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تصفح الأجوبة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Voir les Réponses"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_active_leaver_q",
  //     text: "Active Leaver Surveys",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "استبيانات الموظفين المغادرين الفعالة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Enquęte auprčs des sortants actifs"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_expired_leaver_q",
  //     text: "Expired Leaver Surveys",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "استبيانات الموظفين المغادرين المنتهية صلاحيتها"
  //       },
  //       {
  //         language: "FR",
  //         text: "Enquętes sur les sortants expirés"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_inactive_leaver_q",
  //     text: "Inactive Leaver Surveys",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "استبيانات الموظفين المغادرين غير الفعالة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Enquętes sur les Sortants Inactifs"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leaver_list",
  //     text: "Leavers List",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قائمة الموظفين المغادرين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Liste des Sortants"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leaver_creation_today_email",
  //     text: "Leaver #ACTION#, an email been sent to #LEAVEREMAIL# and to your email for your reference or you can share the link below",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "Leaver #ACTION#, an email been sent to #LEAVEREMAIL# and to your email for your reference or you can share the link below"
  //       },
  //       {
  //         language: "FR",
  //         text: "Sortant #ACTION#, un email a été envoyé à #LEAVEREMAIL# et à votre email pour votre référence ou vous pouvez partager le lien ci-dessous"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leaver_creation_today_no_email",
  //     text: "Leaver #ACTION#, an email has been sent to you for your reference or you can share the link below",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "Leaver #ACTION#, an email has been sent to you for your reference or you can share the link below"
  //       },
  //       {
  //         language: "FR",
  //         text: "Sortant #ACTION#, un email vous a été envoyé pour votre référence ou vous pouvez partager le lien ci-dessous"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leaver_creation_not_today_email",
  //     text: "Leaver #ACTION#, an email has been sent to you for your reference. An email will be automatically be sent to #LEAVEREMAIL# on #STARTDATE# or you can share the link below",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "Leaver #ACTION#, an email has been sent to you for your reference. An email will be automatically be sent to #LEAVEREMAIL# on #STARTDATE# or you can share the link below"
  //       },
  //       {
  //         language: "FR",
  //         text: "Sortant #ACTION#, un email vous a été envoyé pour votre référence Un email sera automatiquement envoyé à #LEAVEREMAIL# le #STARTDATE# ou vous pouvez partager le lien ci-dessous"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leaver_creation_not_today_no_email",
  //     text: "Leaver #ACTION#, an email has been sent to you for your reference. An email will be automatically be sent to you on #STARTDATE# or you can share the link below",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "Leaver #ACTION#, an email has been sent to you for your reference. An email will be automatically be sent to you on #STARTDATE# or you can share the link below"
  //       },
  //       {
  //         language: "FR",
  //         text: "Sortant #ACTION#, un email vous a été envoyé pour votre référence Un email vous sera automatiquement envoyé le #STARTDATE# ou vous pouvez partager le lien ci-dessous"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leaver_action_created",
  //     text: "created",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم الإنشاء"
  //       },
  //       {
  //         language: "FR",
  //         text: "Créé"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leaver_action_updated",
  //     text: "updated",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم التحديث"
  //       },
  //       {
  //         language: "FR",
  //         text: "Mis ŕ jour"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_leaver_feedback",
  //     text: "Got It",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم الاستلام"
  //       },
  //       {
  //         language: "FR",
  //         text: "Avoir Reçu"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leaver_q_welcome",
  //     text: "\n  Thank you for taking the time to fill out the Employee Exit survey.<br> Your honest feedback is highly appreciated.<br> Please note that your responses are strictly confidential and are only used for research and improvement purposes by the Human Resources Team.\n",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "\n  نشكرك لمشاركتك في هذا الاستبيان.\n  أجوبتك النزيهة والصريحة مهمة لنا.\n  <br>\n  يرجى العلم بأن جميع النتائج التي سيتم الحصول عليها من هذا الاستبيان سرية للغاية وتستخدم فقط لأغراض البحث والتطوير من قبل فريق الموارد البشرية.\n"
  //       },
  //       {
  //         language: "FR",
  //         text: "Madame, Monsieur\n<br><br>\nNous vous invitons à participer au questionnaire ci-dessous et d'y répondre avec vigilance. Votre participation et vos réponses ainsi que tous les résultats obtenus à partir de ce questionnaire sont strictement confidentiels et ne sont utilisés qu'à des fins de recherche et d'amélioration par l'équipe des ressources humaines.\nVotre coopération et vos observations sont très appréciés.\n\n<br><br>\n"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_engagement_q_welcome",
  //     text: "\nThank you for taking the time to fill out the Employee Engagement survey.<br> Your honest feedback is highly appreciated.<br> Please note that your responses are strictly confidential, and your identity shall remain anonymous throughout the entire process.<br> However, the results of the survey will be used for research and improvement purposes by the Human Resources Team.\n<br><br>\nDisclaimer: All information pertaining to this survey shall remain anonymous and shall not be disclosed to anyone.\n",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نشكرك لمشاركتك في هذا الاستبيان.\n  أجوبتك النزيهة والصريحة مهمة لنا.\n  <br>\n  يرجى العلم بأن جميع النتائج التي سيتم الحصول عليها من هذا الاستبيان سرية للغاية وستبقى هويتك مجهولة.\n  وتستخدم هذه النتائج فقط لأغراض البحث والتطوير من قبل فريق الموارد البشرية.\n  <br>\n  إخلاء المسؤولية: جميع المعلومات المتعلقة بهذا الاستبيان سرية ولن يتم الإفصاح عنها لأي جهة.\n  "
  //       },
  //       {
  //         language: "FR",
  //         text: "Merci d'avoir pris le temps de remplir le Enquête sur l'engagement des employés.  Vos commentaires honnêtes sont très appréciés.  Veuillez noter que vos réponses sont strictement confidentielles et que votre identité restera anonyme tout au long du processus. Toutefois, les résultats de Enquête seront utilisés à des fins de recherche et d’amélioration par l’équipe des ressources humaines. Désistement: Toutes les informations relatives à ce Enquête resteront anonymes et ne seront divulguées à personne."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_happiness_q_welcome",
  //     text: "\nThank you for taking the time to fill out the Employee Happiness survey.<br> Your honest feedback is highly appreciated.<br> Please note that your responses are strictly confidential, and your identity shall remain anonymous throughout the entire process.<br> However, the results of the survey will be used for research and improvement purposes by the Human Resources Team.\n<br><br>\nDisclaimer: All information pertaining to this survey shall remain anonymous and shall not be disclosed to anyone.\n",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نشكرك لمشاركتك في هذا الاستبيان.\n  أجوبتك النزيهة والصريحة مهمة لنا.\n  <br>\n  يرجى العلم بأن جميع النتائج التي سيتم الحصول عليها من هذا الاستبيان سرية للغاية وستبقى هويتك مجهولة.\n  وتستخدم هذه النتائج فقط لأغراض البحث والتطوير من قبل فريق الموارد البشرية.\n  <br>\n  إخلاء المسؤولية: جميع المعلومات المتعلقة بهذا الاستبيان سرية ولن يتم الإفصاح عنها لأي جهة.\n  "
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_leaver_q_start",
  //     text: "Start",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "بدء"
  //       },
  //       {
  //         language: "FR",
  //         text: "Commencer"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_leaver_q_back",
  //     text: "Back",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عودة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Retour"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_leaver_q_next",
  //     text: "Next",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "التالي"
  //       },
  //       {
  //         language: "FR",
  //         text: "Suivant"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_leaver_q_submit",
  //     text: "Submit",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تسليم"
  //       },
  //       {
  //         language: "FR",
  //         text: "Soumettre"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leaver_q_thank_you",
  //     text: "<h6 class='text-2xl font-semibold'>Your responses have been submitted successfully!<br>\n  Thank you for completing the survey and providing your feedback.\n  </h6>.\n",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم استلام جميع ردودك بنجاح!\n  <br>\n  نشكرك على وقتك المبذول في تعبئة هذا الاستبيان.\n  "
  //       },
  //       {
  //         language: "FR",
  //         text: "\t<h6 class='text-2xl font-semibold'>Vos réponses ont été soumises avec succès!<br> Merci d'avoir répondu au Enquête et d’avoir fourni vos commentaires.</h6>"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_engagement_q_thank_you",
  //     text: " <h6 class=\"is-size-6 font-normal\">Your responses have been submitted successfully!<br>\n  Thank you for completing the survey and providing your feedback.\n   </h6>\n",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: " <h6 class=\"is-size-6 font-normal\">تم استلام جميع ردودك بنجاح!\n  <br>\n  نشكرك على وقتك المبذول في تعبئة هذا الاستبيان.\n   </h6>\n"
  //       },
  //       {
  //         language: "FR",
  //         text: "Vos réponses ont été soumises avec succès! Merci d'avoir répondu au Enquête et d’avoir fourni vos commentaires."
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_back",
  //     text: "Back",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عودة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Retour"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_reports",
  //     text: "Reports",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "التقارير"
  //       },
  //       {
  //         language: "FR",
  //         text: "Rapports"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_group_by",
  //     text: "Group By",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "صنّف حسب"
  //       },
  //       {
  //         language: "FR",
  //         text: "groupe par"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_chart_type",
  //     text: "Chart Type",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نوع الرسم البياني"
  //       },
  //       {
  //         language: "FR",
  //         text: "Type de Graphique"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_clear_grouping",
  //     text: "Clear Grouping",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إزالة المجموعات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Effacer le Groupement"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_notification_questionnaire_started",
  //     text: "#LEAVERNAME# has started the #QUESTIONNAIRE#",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "بدأ #LEAVERNAME# #QUESTIONNAIRE#"
  //       },
  //       {
  //         language: "FR",
  //         text: "#LEAVERNAME# a commencé le #QUESTIONNAIRE#"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_notification_questionnaire_completed",
  //     text: "#LEAVERNAME# has completed the #QUESTIONNAIRE#",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اكمل #LEAVERNAME# #QUESTIONNAIRE#"
  //       },
  //       {
  //         language: "FR",
  //         text: "#LEAVERNAME# a terminé le #QUESTIONNAIRE#"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_notifications",
  //     text: "Notifications",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الإشعارات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Notifications"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_Q-STARTED",
  //     text: "Survey Started",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم بدء الاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Enquęte  Commencé"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_Q-SUBMITTED",
  //     text: "Survey Submitted",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم تسليم الاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Enquęte Soumis"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_Q-EXPIRING",
  //     text: "Survey Expiring",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قاربت صلاحية الاستبيان على الانتهاء"
  //       },
  //       {
  //         language: "FR",
  //         text: "Enquęte Expirant"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_Q-EXPIRED",
  //     text: "Survey Expired",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "انتهت صلاحية الاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Enquęte Expirée"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_notification_questionnaire_expiring",
  //     text: "#QUESTIONNAIRE# for #LEAVERNAME# is about to expire",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "#QUESTIONNAIRE# ل #LEAVERNAME# على وشك الانتهاء"
  //       },
  //       {
  //         language: "FR",
  //         text: "#QUESTIONNAIRE# pour #LEAVERNAME# est sur le point d'expirer"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_notification_questionnaire_expired",
  //     text: "#QUESTIONNAIRE# for #LEAVERNAME# has expired",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "#QUESTIONNAIRE# ل #LEAVERNAME# قد انتهى"
  //       },
  //       {
  //         language: "FR",
  //         text: "#QUESTIONNAIRE# pour #LEAVERNAME# a expiré"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_notification_settings",
  //     text: "Notification Settings",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إعدادات الإشعارات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Paramčtres de Notifications"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_notification_expired_questionnaire",
  //     text: "Expired Survey",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "استبيان منتهي الصلاحية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Enquęte expirée"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_notification_completed_questionnaire",
  //     text: "Completed Survey",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "استبيان مكتمل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Enquęte complétée"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_notification_expiring_questionnaire",
  //     text: "Survey about to expire (3 days prior)",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "باقي 3 أيام على انتهاء صلاحية الاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Enquęte sur le point d'expirer (dans 3 jours) "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_notification_remaining_units",
  //     text: "Survey units is 20% or less",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "متبقي 20% أو أقل من الوحدات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Les unités de Enquęte sont 20% ou moins"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_notification_subscription_expiring",
  //     text: "Subscription is about to expire in 2 months",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "سينتهي اشتراكك خلال شهرين"
  //       },
  //       {
  //         language: "FR",
  //         text: "L’abonnement est sur le point d’expirer dans 2 mois"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_notification_subscription_expired",
  //     text: "Subscription has expired",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "انتهت صلاحية الاشتراك"
  //       },
  //       {
  //         language: "FR",
  //         text: "L'abonnement a expiré"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_notification_notification_started",
  //     text: "Survey started",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم بدء الاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Enquęte  Commencé"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_direct_manager_ID",
  //     text: "Direct Manager ID",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الرقم الوظيفي للمدير المباشر"
  //       },
  //       {
  //         language: "FR",
  //         text: "ID du Directeur Direct"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_start_date",
  //     text: "Start Date",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تاريخ البدء"
  //       },
  //       {
  //         language: "FR",
  //         text: "Date de Début "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_end_date",
  //     text: "End Date",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تاريخ الانتهاء"
  //       },
  //       {
  //         language: "FR",
  //         text: "Date de Fin"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_clear_time",
  //     text: "Clear Filters",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إزالة التصفية والفرز"
  //       },
  //       {
  //         language: "FR",
  //         text: "Effacer les Filtres"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_done",
  //     text: "Done",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "منجز"
  //       },
  //       {
  //         language: "FR",
  //         text: "Fait"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_clear_search",
  //     text: "Clear Search",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تفريغ حقل البحث"
  //       },
  //       {
  //         language: "FR",
  //         text: "Effacer la recherche"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_user_exists_message",
  //     text: "User already exists on the system",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المستخدم موجود على النظام"
  //       },
  //       {
  //         language: "FR",
  //         text: "L’utilisateur existe déjŕ sur le systčme"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_user_exists_subject",
  //     text: "User Already Exists",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المستخدم موجود مسبقاً"
  //       },
  //       {
  //         language: "FR",
  //         text: "L’utilisateur existe déjŕ"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_okay_action",
  //     text: "Okay",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "حسناً"
  //       },
  //       {
  //         language: "FR",
  //         text: "D'accord"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_required_field",
  //     text: "This field is required",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هذا الحقل إجباري"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ce champ est requis"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_all_questions_are_required",
  //     text: "Please answer the question to continue",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الرجاء إجابة السؤال للاستمرار"
  //       },
  //       {
  //         language: "FR",
  //         text: "Veuillez répondre ŕ la question pour continuer"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_dashboard",
  //     text: "Dashboard",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "صفحة البيانات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Tableau des Données "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_total_questionnaires",
  //     text: "Total Surveys",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مجموع الاستبيانات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Enquętes Totales"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_completed",
  //     text: "Completed",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مكتمل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Complet"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_pending",
  //     text: "Pending",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قيد الإتمام"
  //       },
  //       {
  //         language: "FR",
  //         text: "En attente"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_expired",
  //     text: "Expired",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "منتهي الصلاحية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Expiré"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leavers_list",
  //     text: "Leavers List",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قائمة الموظفين المغادرين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Liste des Sortants"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_leavers",
  //     text: "Leavers",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الموظفين المغادرين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Sortants"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_new_leaver",
  //     text: "New Leaver",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إنشاء موظف مغادر"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nouveau Sortant"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_edit_leaver",
  //     text: "Edit Leaver",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تعديل الموظف المغادر"
  //       },
  //       {
  //         language: "FR",
  //         text: "Modifier le Sortant"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_delete_denied",
  //     text: "Unable to delete",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "غير قابل للحذف"
  //       },
  //       {
  //         language: "FR",
  //         text: "Impossible de supprimer"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_yes",
  //     text: "Yes",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نعم"
  //       },
  //       {
  //         language: "FR",
  //         text: "Oui"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_delete_performance",
  //     text: "Are you sure you want to delete this Performance Rate?",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هل أنت متأكد أنك تريد حذف معدل تقييم الأداء هذا؟"
  //       },
  //       {
  //         language: "FR",
  //         text: "Etes-vous sűr de vouloir supprimer ce taux de performance ?"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_delete_performance_denied",
  //     text: "Unable to delete, there are leavers assigned to this Performance Rate",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "غير قابل للحذف، هناك موظفين مغادرين مرتبطين بمعدل الأداء هذا."
  //       },
  //       {
  //         language: "FR",
  //         text: "there are leavers assigned to this Band Level"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_delete_user",
  //     text: "Are you sure you want to deactivate this user?",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هل أنت متأكد أنك تريد تعطيل هذا المستخدم؟"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ętes-vous sűr de vouloir désactiver cet utilisateur?"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_delete_user_denied",
  //     text: "Unable to delete.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "غير قابل للحذف."
  //       },
  //       {
  //         language: "FR",
  //         text: "Impossible de supprimer"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_delete_leaver",
  //     text: "Are you sure you want to set this leaver to Inactive?",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هل أنت متأكد أنك تريد تغيير حالة الموظف المغادر لغير فعال؟"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ętes-vous sűr de vouloir mettre ce sortant ŕ Inactif ?"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_delete_band_level",
  //     text: "Are you sure you want to delete this Band Level?",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هل أنت متأكد أنك تريد حذف المستوى الوظيفي هذا؟"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ętes-vous sűr de vouloir supprimer ce niveau de tranche?"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_delete_band_level_denied",
  //     text: "Unable to delete, there are leavers assigned to this Band Level",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "غير قابل للحذف، هناك موظفين مغادرين مرتبطين بهذا المستوى الوظيفي."
  //       },
  //       {
  //         language: "FR",
  //         text: "there are leavers assigned to this Band Level"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_delete_job_grade",
  //     text: "Are you sure you want to delete this Job Grade?",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هل أنت متأكد أنك تريد حذف الدرجة الوظيفية هذه؟"
  //       },
  //       {
  //         language: "FR",
  //         text: "Etes-vous sűr de vouloir supprimer cette catégorie d’emploi?"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_delete_job_grade_denied",
  //     text: "Unable to delete, there are leavers assigned to this Job Grade",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "غير قابل للحذف، هناك موظفين مغادرين مرتبطين بهذه الدرجة الوظيفية."
  //       },
  //       {
  //         language: "FR",
  //         text: "there are leavers assigned to this Band Level"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_delete_structure",
  //     text: "Are you sure you want to delete this Structure?",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هل أنت متأكد أنك تريد حذف هذا الهيكل؟"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ętes-vous sűr de vouloir supprimer cette structure?"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_delete_structure_denied",
  //     text: "Unable to delete, there are leavers assigned to this Structure",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "غير قابل للحذف، هناك موظفين مغادرين مرتبطين بهذا الهيكل."
  //       },
  //       {
  //         language: "FR",
  //         text: "there are leavers assigned to this Band Level"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_delete_entity_denied",
  //     text: "Unable to delete, there are leavers assigned to this Entity",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "غير قابل للحذف، هناك موظفين مغادرين مرتبطين بهذه المؤسسة."
  //       },
  //       {
  //         language: "FR",
  //         text: "there are leavers assigned to this Band Level"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_delete_company",
  //     text: "Are you sure you want to delete this Company?",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هل أنت متأكد أنك تريد حذف هذه الشركة؟"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ętes-vous sűr de vouloir supprimer cette Société?"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_delete_company_denied",
  //     text: "Unable to delete, there are leavers assigned to this Company",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "غير قابل للحذف، هناك موظفين مغادرين مرتبطين بهذه الشركة."
  //       },
  //       {
  //         language: "FR",
  //         text: "there are leavers assigned to this Band Level"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_empty_string",
  //     text: "",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: ""
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_is_super_user",
  //     text: "Super User",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مستخدم متميز"
  //       },
  //       {
  //         language: "FR",
  //         text: "Super Utilisateur"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_question",
  //     text: "Question",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "العبارة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Question"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtof",
  //     text: "of",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "من"
  //       },
  //       {
  //         language: "FR",
  //         text: "De"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtSection",
  //     text: "Section",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قسم"
  //       },
  //       {
  //         language: "FR",
  //         text: "Section"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_employee_exitSurvey",
  //     text: "Employee Exit Survey",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "استبيان خروج الموظفين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Enquęte sur les sorties des employés"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_employee_exit",
  //     text: "Employee Exit",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "خروج الموظفين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Sortie de l'employé"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_min_to",
  //     text: "5 ~ 10 min",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "من 5 إلى 10 دقائق"
  //       },
  //       {
  //         language: "FR",
  //         text: "5 ~ 10 min"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_to_complete",
  //     text: "To complete",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لإكمال"
  //       },
  //       {
  //         language: "FR",
  //         text: "Pour compléter"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_start_survey",
  //     text: "Start Survey",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ابدأ الاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Commencer l'Évaluation "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_more_comment",
  //     text: "Have more comments?",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هل لديك المزيد من التعليقات؟"
  //       },
  //       {
  //         language: "FR",
  //         text: "Vous avez d’autres commentaires?"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_start_and_endDate",
  //     text: "Please, add start date and end date.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يرجى إضافة تاريخ البدء وتاريخ الانتهاء."
  //       },
  //       {
  //         language: "FR",
  //         text: "add at least one unit to proceed."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_fill_fields",
  //     text: "Please, fill all required fields!",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يرجى تعبئة جميع الحقول المطلوبة!"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_added_success",
  //     text: "Added Successfully!",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تمت الإضافة بنجاح!"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ajouté avec succčs!"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_removed_success",
  //     text: "Deleted Successfully!",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم الحذف بنجاح!"
  //       },
  //       {
  //         language: "FR",
  //         text: "Supprimé avec Succčs!"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_updated_success",
  //     text: "Updated Successfully!",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم التحديث بنجاح!"
  //       },
  //       {
  //         language: "FR",
  //         text: "Mise ŕ jour avec Succčs!"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_reminder_sent",
  //     text: "Email sent to relevant respondents.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم إرسال البريد الإلكتروني إلى المستجيبين المعنيين."
  //       },
  //       {
  //         language: "FR",
  //         text: "Courriel envoyé aux répondants concernés."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_go_live",
  //     text: "go live",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "باشر الآن"
  //       },
  //       {
  //         language: "FR",
  //         text: "Aller en direct"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_go_closed",
  //     text: "This survey will now be closed and you will no longer be able to make any changes or add new respondents.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "سيتم إنهاء هذا الاستبيان الآن ولن تتمكن بعد ذلك من إجراء أي تغيير أو إضافة مستجيبين."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ce Enquête sera maintenant fermé et vous ne serez plus en mesure d’apporter des changements ou d’ajouter de nouveaux répondants."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_txt_no_respondents",
  //     text: "At least one respondent needs to added to proceed!",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يجب إضافة مستجيب واحد على الأقل!"
  //       },
  //       {
  //         language: "FR",
  //         text: "Au moins un répondant doit ętre ajouté pour continuer!"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCreatedBy",
  //     text: "Created By:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم الانشاء من قبل:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Créé par:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtGeneratedon",
  //     text: "Generated on:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم إنشاؤه في"
  //       },
  //       {
  //         language: "FR",
  //         text: "Généré le:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPoweredby",
  //     text: "Powered by:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مشغّل بواسطة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Alimenté par:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_activeleaverslist_export",
  //     text: "Active Leavers List",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قائمة الموظفين المغادرين الفعالة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Liste des Sortants Actifs"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_inactiveleaverslist_export",
  //     text: "InActive Leavers List",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قائمة الموظفين المغادرين غير الفعالة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Liste des Sortants Inactifs"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_expiredleaverslist_export",
  //     text: "Expired Leavers List",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قائمة الموظفين المغادرين المنتهية صلاحيتها"
  //       },
  //       {
  //         language: "FR",
  //         text: "Liste des Sortants Expirés"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_wrong_text_count",
  //     text: "Exceeded text limit.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تجاوز عدد الأحرف المسموح به"
  //       },
  //       {
  //         language: "FR",
  //         text: "Limite de texte dépassée."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_questionnaire_builder",
  //     text: "Questionnaire Builder",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مصمم الاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Créateur de Questionnaires"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_no-timeframe",
  //     text: "No timeframe has been chosen.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لم يتم تحديد مدة زمنية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Aucun calendrier n'a été choisi."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_valid_vmail",
  //     text: "Please. provide a valid email.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يرجى إدخال بريد إلكتروني صحيح"
  //       },
  //       {
  //         language: "FR",
  //         text: "S'il vous plaît fournissez un email (courrier électronique) valide."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_active",
  //     text: "Active",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "فعال"
  //       },
  //       {
  //         language: "FR",
  //         text: "Actif"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_inactive",
  //     text: "Inactive",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "غير فعال"
  //       },
  //       {
  //         language: "FR",
  //         text: "Inactif"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_activate",
  //     text: "Activate",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تفعيل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Activer"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_deactivate",
  //     text: "Deactivate",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إلغاء تفعيل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Désactiver"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_close",
  //     text: "Close",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "أغلق"
  //       },
  //       {
  //         language: "FR",
  //         text: "Fermer"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtFindleavers",
  //     text: "Search leavers...",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ابحث عن موظف..."
  //       },
  //       {
  //         language: "FR",
  //         text: "Rechercher des Répondants "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_questions",
  //     text: "Questions",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "العبارات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Questions"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEntity",
  //     text: "Entity",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "وحدة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Unité "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtReportsto",
  //     text: "Reports to",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تابع ل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Rapporter ŕ"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtSurveys",
  //     text: "Surveys",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "استبيانات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Enquętes"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtIsSkippable",
  //     text: "Is Skippable",
  //     translations: [
  //       {
  //         language: "AR"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtIsEngagement",
  //     text: "Is Engagement",
  //     translations: [
  //       {
  //         language: "AR"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtLoggedinas",
  //     text: "Logged in as",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المستخدم الحالي:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Connecté en tant que"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtControlPanel",
  //     text: "Control Panel",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لوحة التحكم"
  //       },
  //       {
  //         language: "FR",
  //         text: "Panneau de Commande"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtControlPaneldesc",
  //     text: "Configure common settings across the Employee Experience platform",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ضبط الإعدادات العامة لمنصة تجربة الموظفين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Configurer les paramčtres communs sur la plate-forme d'expérience de l'employé"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtLockAccount",
  //     text: "Lock Account",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قفل الحساب"
  //       },
  //       {
  //         language: "FR",
  //         text: "Verrouiller Compte"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtLogout",
  //     text: "Log-out",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تسجيل خروج"
  //       },
  //       {
  //         language: "FR",
  //         text: "Se déconnecter"
  //       }
  //     ]
  //   },
  //   {
  //     key: "used_by_products",
  //     text: "This is being used by the following: <br>",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يتم استخدام هذا بواسطة ما يلي: <br>"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ceci est utilisé par les éléments suivants : "
  //       }
  //     ]
  //   },
  //   {
  //     key: "used_by_exit_leaver",
  //     text: "Employee Exit Survey <br>",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "استبيان خروج الموظفين <br>"
  //       },
  //       {
  //         language: "FR",
  //         text: "Enquęte sur les sorties des employés"
  //       }
  //     ]
  //   },
  //   {
  //     key: "used_by_engagement_survey",
  //     text: "Employee Engagement Survey <br>",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "استبيان الاندماج الوظيفي <br>"
  //       },
  //       {
  //         language: "FR",
  //         text: "Enquęte sur l’engagement des employés"
  //       }
  //     ]
  //   },
  //   {
  //     key: "used_by_assessment_survey",
  //     text: "360° Feedback <br>",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقييم °360 <br>"
  //       },
  //       {
  //         language: "FR",
  //         text: "Commentaire ŕ 360° "
  //       }
  //     ]
  //   },
  //   {
  //     key: "btnExport",
  //     text: "Download",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تحميل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Télécharger"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtExportReport",
  //     text: "Download Report",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تحميل التقرير"
  //       },
  //       {
  //         language: "FR",
  //         text: "Rapport de Téléchargement"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtExportSurvey",
  //     text: "Download Survey Questions",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تحميل أسئلة الاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Enquętes de Téléchargement"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtExportSurveyasses",
  //     text: "Download Assessment Questions",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تحميل أسئلة التقييم"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_comment",
  //     text: "Comment",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تعليق"
  //       },
  //       {
  //         language: "FR",
  //         text: "Commentaire"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_generation",
  //     text: "Generation",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نوع الجيل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Génération"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_resp_by_generation",
  //     text: "Respondents by Generation",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المستجيبون حسب نوع الجيل"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_age_group",
  //     text: "Respondents by Age Group",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الفئات العمرية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Tranche d'âge"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_resp_by_age_group",
  //     text: "Age Group",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المستجيبون حسب الفئات العمرية"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_tenure_group",
  //     text: "Tenure Group",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "فئات سنوات الخدمة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Groupe de Mandat"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_resp_by_tenure_group",
  //     text: "Respondents by Tenure Group",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المستجيبون حسب فئات سنوات الخدمة"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtSAnswers",
  //     text: "'s Answers",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "أجوبة "
  //       },
  //       {
  //         language: "FR",
  //         text: "Réponses de"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTypeComment",
  //     text: "Type your comment here ...",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اكتب اقتراحك هنا …"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ecrivez ici…"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHavemorecomments",
  //     text: "Have more comments?",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هل لديك أي تعليق ؟"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtOverview",
  //     text: "Overview",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نظرة عامة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Aperçu "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtIMPACTEngagementModelbyZENITHR",
  //     text: "The IMPACT Model by ZENITHR",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نموذج IMPACT - ZENITHR"
  //       },
  //       {
  //         language: "FR",
  //         text: "Modčle d'Engagement IMPACT par ZENITHR"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_deleted",
  //     text: "Deleted",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم حذفه"
  //       },
  //       {
  //         language: "FR",
  //         text: "Supprimé"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_delete_confirmation_subject",
  //     text: "Confirmation",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تأكيد"
  //       },
  //       {
  //         language: "FR",
  //         text: "Confirmation"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_delete_confirmation_message",
  //     text: "Are you sure you want to delete this survey?",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هل أنت متأكد من حذف هذا الاستبيان؟"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ętes-vous sűr de vouloir supprimer cet enquęte?"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMinimum",
  //     text: "Low",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الأقل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Minimum"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMaximum",
  //     text: "High",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الأكثر"
  //       },
  //       {
  //         language: "FR",
  //         text: "Maximum"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMedian",
  //     text: "Median",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المعدل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Modifié"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_no_selected",
  //     text: "Minimum Record is 1",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الحد الأدنى هو 1"
  //       },
  //       {
  //         language: "FR",
  //         text: "L'enregistrement minimum est 1"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEvaluators",
  //     text: "Evaluators",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المقيمون"
  //       },
  //       {
  //         language: "FR",
  //         text: "Évaluateurs "
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_add_evaluator",
  //     text: "Add Evaluator",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إضافة مستجيب"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ajouter un Évaluateur "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_dashboard_export",
  //     text: "Dashboard",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "صفحة البيانات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Tableau des Données "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_survey_list",
  //     text: "Survey List",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قائمة الاستبيانات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Liste de Enquętes"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_assessment_list",
  //     text: "Assessment List",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قائمة التقييمات"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_new_setup",
  //     text: "New Setup",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إعداد جديد"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nouvelle Configuration"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_search",
  //     text: "Search",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "بحث"
  //       },
  //       {
  //         language: "FR",
  //         text: "Rechercher"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_view_by_drivers",
  //     text: "VIEW BY DRIVERS",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عرض حسب عوامل الاندماج"
  //       },
  //       {
  //         language: "FR",
  //         text: "Présentation par les fecteurs "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtbydrivers",
  //     text: "By Drivers",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "حسب عوامل الاندماج"
  //       },
  //       {
  //         language: "FR",
  //         text: "Par les facteurs d’intégration"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtbyfactors",
  //     text: "By Factors",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "حسب عوامل السعادة"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtByCriteria",
  //     text: "By Criteria",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "حسب المعايير"
  //       },
  //       {
  //         language: "FR",
  //         text: "Par Critčres"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_select_Drivers",
  //     text: "Select Drivers",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اختر عوامل الاندماج"
  //       },
  //       {
  //         language: "FR",
  //         text: "Sélectionner les Facteurs"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_survey_title",
  //     text: "Survey Title",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عنوان الاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Titre de Enquęte"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_workplace_engagement",
  //     text: "Workplace Engagement",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الاندماج الوظيفي في مكان العمل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Engagement en Milieu de Travail"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_workplace_happiness",
  //     text: "Workplace Happiness",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "السعادة في مكان العمل"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_date_created",
  //     text: "Date Created",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تاريخ الإنشاء"
  //       },
  //       {
  //         language: "FR",
  //         text: "Date Créée"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_drivers",
  //     text: "Drivers",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عوامل الاندماج"
  //       },
  //       {
  //         language: "FR",
  //         text: "Facteurs d’Intégration"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_drivers_score",
  //     text: "Drivers' Score",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نتائج عوامل الاندماج"
  //       },
  //       {
  //         language: "FR",
  //         text: "Note des Facteurs d’Intégration"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_drivers_score_happiness",
  //     text: "Factors' Score",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نتائج عوامل السعادة"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_delete",
  //     text: "Delete",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "حذف"
  //       },
  //       {
  //         language: "FR",
  //         text: "Supprimer"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_relaunch",
  //     text: "Relaunch",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إعادة إطلاق"
  //       },
  //       {
  //         language: "FR",
  //         text: "Relancer"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_No_data_matching_the_filter",
  //     text: "No Matches Found",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لا توجد بيانات مطابقة للبحث"
  //       },
  //       {
  //         language: "FR",
  //         text: "Aucun résultat"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_There_are_no_surveys_created_yet",
  //     text: "No Surveys Created",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لم يتم إنشاء أي استبيان حتى الآن!"
  //       },
  //       {
  //         language: "FR",
  //         text: "Aucune enquęte créée"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_setup_a_new_survey",
  //     text: "Setup a New Survey",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "أنشئ استبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Configurer une Nouveau Enquęte"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_respondents_pool",
  //     text: "Respondent Pool",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مجموعة المستجيبون"
  //       },
  //       {
  //         language: "FR",
  //         text: "Réserve des Répondants"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_new_respondent",
  //     text: "New Respondent",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إضافة مستجيب"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nouveau Répondant"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_ID",
  //     text: "ID",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الرقم الوظيفي"
  //       },
  //       {
  //         language: "FR",
  //         text: "ID"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_respondent_name",
  //     text: "Respondent's Name",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الاسم"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nom du Répondant "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_candidate_name",
  //     text: "Candidate's Name",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اسم المرشح"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nom du Candidat"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_evaluator_name",
  //     text: "Evaluator's Name",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اسم المقيم"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nom de l'Évaluateur "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_email_address",
  //     text: "Email Address",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "البريد الالكتروني"
  //       },
  //       {
  //         language: "FR",
  //         text: "Adresse Email (Adresse électronique)"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_delete_test_only",
  //     text: "Delete(test only)",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "حذف"
  //       },
  //       {
  //         language: "FR",
  //         text: "Supprimer (test uniquement)"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_edit",
  //     text: "Edit",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تعديل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Modifier"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_add_respondent",
  //     text: "Add Respondent",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إضافة مستجيب"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ajouter Un Répondant"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_add_candidate",
  //     text: "Add Candidate",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إضافة مرشح"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ajouter Un Candidat"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_evaluator_type",
  //     text: "Relation to candidate",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "العلاقة مع المرشح"
  //       },
  //       {
  //         language: "FR",
  //         text: "Lien avec le Candidat"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEngReminderSubject",
  //     text: "[Reminder] IMPACT Survey 2021",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "[تذكير] استبيان IMPACT 2021"
  //       },
  //       {
  //         language: "FR",
  //         text: "[Rappel] Enquęte D'IMPACT 2021"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAPPROACH",
  //     text: "APPROACH",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "منهجية"
  //       },
  //       {
  //         language: "FR",
  //         text: "APPROCHE"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_add_manually",
  //     text: "Add Manually",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إضافة يدوية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ajouter Manuellement"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_import_file",
  //     text: "Import File",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "رفع الملف"
  //       },
  //       {
  //         language: "FR",
  //         text: "Importer le Fichier"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_employee_ID",
  //     text: "Employee ID",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الرقم الوظيفي"
  //       },
  //       {
  //         language: "FR",
  //         text: "ID de l'Employé"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_step",
  //     text: "STEP",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "خطوة"
  //       },
  //       {
  //         language: "FR",
  //         text: "ETAPE"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_step1",
  //     text: "Click \"Download file\" to download the premade spreadsheet (.csv).",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اضغط على زر \"تحميل الملف\" لتحميل جدول بيانات فارغ (.csv)"
  //       },
  //       {
  //         language: "FR",
  //         text: "Cliquez sur « Télécharger le fichier » pour télécharger la feuille de calcul préfabriquée (.csv)."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_step2",
  //     text: "Fill out the premade template and save it.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "املأ جدول بيانات الذي تم تحميله واحفظه"
  //       },
  //       {
  //         language: "FR",
  //         text: "Remplissez le modčle prédéfini et enregistrez-le."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_step3",
  //     text: "Click \"Upload File\" to upload the filled out spreadsheet.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اضغط على زر \"رفع الملف\" لرفع جدول البيانات الذي تم تعبئته (.csv)"
  //       },
  //       {
  //         language: "FR",
  //         text: "Cliquez sur \"Télécharger le fichier\"pour télécharger la feuille de calcul remplie."
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_download",
  //     text: "Download file",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تحميل الملف"
  //       },
  //       {
  //         language: "FR",
  //         text: "Télécharger un fichier"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_upload_file",
  //     text: "Upload File",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "رفع الملف"
  //       },
  //       {
  //         language: "FR",
  //         text: "Télécharger un fichier"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_auto_return",
  //     text: "Once the data has been uploaded, the page will return to the respondents list.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عند الانتهاء من رفع بياناتك، ستعود لقائمة المستجيبون تلقائياً!"
  //       },
  //       {
  //         language: "FR",
  //         text: "the page will return to the respondents list."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_survey_setup",
  //     text: "Survey Setup",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إعداد الاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Configuration du Enquęte"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_back_to_surveys",
  //     text: "Back to surveys",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "العودة للاستبيانات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Retour au Enquętes"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_resume_later",
  //     text: "Resume later",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "استكمل لاحقاً"
  //       },
  //       {
  //         language: "FR",
  //         text: "Reprendre plus tard"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_survey_info",
  //     text: "Survey Information",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "معلومات الاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Informations sur le Enquęte"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_analytical_criteria",
  //     text: "Analytical Criteria",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المعايير التحليلية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Critčres Analytiques"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_respondents",
  //     text: "Respondents",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المستجيبون"
  //       },
  //       {
  //         language: "FR",
  //         text: "Répondants"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_timeframe",
  //     text: "Timeframe",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المدة الزمنية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Délai"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_invitation_email",
  //     text: "Invitation Email",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "دعوة لاستكمال الاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Courriel d'invitation"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_title",
  //     text: "title",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "العنوان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Titre"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_description",
  //     text: "Description",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الوصف"
  //       },
  //       {
  //         language: "FR",
  //         text: "Description"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_optional",
  //     text: "(optional)",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "(اختياري)"
  //       },
  //       {
  //         language: "FR",
  //         text: "(Optionnel)"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_type_description",
  //     text: "text here…",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اكتب هنا..."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ecrivez ici…"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_select_drivers",
  //     text: "Select Survey",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اختيار الاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Sélectionner un Enquęte"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_impact_survey",
  //     text: "Predefined Survey",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "استبيان معد مسبقاً"
  //       },
  //       {
  //         language: "FR",
  //         text: "Enquęte prédéfinie"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_impact_survey_description",
  //     text: "Use the IMPACT approach with 6 drivers.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم إنشاء هذا الاستبيان على منهجية (IMPACT)"
  //       },
  //       {
  //         language: "FR",
  //         text: "Utilisez l'approche IMPACT dans ce Enquęte."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_custom_survey",
  //     text: "Custom Survey",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إنشاء استبيان خاص"
  //       },
  //       {
  //         language: "FR",
  //         text: "Enquęte Personnalisé"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_minimum_drivers",
  //     text: "Customize a survey by selecting a minimum of 4 drivers.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قم بإنشاء استبيانك الخاص من خلال اختيار 4 إلى 5 عوامل اندماج"
  //       },
  //       {
  //         language: "FR",
  //         text: "Personnalisez une enquęte en sélectionnant un minimum de 4 conducteurs."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_at_least4",
  //     text: "Select a minimum of 4 Drivers:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اختر 4 عوامل اندماج على الأقل:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Sélectionner un minimum de 4 Facteurs d’Intégration."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_customized_approach",
  //     text: "Customized Approach",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "النهج المخصص"
  //       },
  //       {
  //         language: "FR",
  //         text: "Approche Personnalisée"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_default_approach",
  //     text: "Default Approach",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "النهج الأساسي"
  //       },
  //       {
  //         language: "FR",
  //         text: "Approche de Base"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_impact_desc",
  //     text: "Based on the selected drivers the survey will measure the extra mile the employees are willing to put into their work and the interaction they yield in the organization",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "بناءً على الأبعاد التي تم اختيارها سيتم قياس الجهد الزائد المبذول"
  //       },
  //       {
  //         language: "FR",
  //         text: "Sur la base des facteurs sélectionnés, le Enquête mesurera le mile supplémentaire que les employés sont prêts à mettre dans leur travail et l’interaction qu’ils donnent dans l’organisation."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_survey_description",
  //     text: "This survey will provide in depth results and scores on the level of your company's engagement and display recommendations.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "سيوفر هذا الاستبيان درجات ونتائج معمقة على مستوى الاندماج الوظيفي لشركتك وعرض توصيات خاصة بكل مستوى."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ce Enquête fournira des résultats et des scores détaillés au niveau de l’engagement de votre entreprise et affichera des recommandations."
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_preview_survey",
  //     text: "Preview Survey",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عرض الاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Aperçu du Enquęte"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_must_haves",
  //     text: "Must Haves",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يجب الأخذ بها"
  //       },
  //       {
  //         language: "FR",
  //         text: "Incontournables"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_requried",
  //     text: "Required",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مطلوب"
  //       },
  //       {
  //         language: "FR",
  //         text: "Obligatoire"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_gender",
  //     text: "Gender",
  //     translations: [
  //       { language: "AR", text: "الجنس" },
  //       { language: "FR", text: "Sexe" },
  //       { language: "HI", text: "लिंग" },
  //       { language: "TA", text: "Kasarian" },
  //       { language: "UR", text: "جنس" }
  //     ]
  //   },
  //   {
  //     key: "txt_date_of_birth",
  //     text: "Date of Birth",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تاريح الميلاد"
  //       },
  //       {
  //         language: "FR",
  //         text: "Date de Naissance "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_nationality",
  //     text: "Nationality",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الجنسية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nationalité"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_joining_date",
  //     text: "Joining Date",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تاريخ الالتحاق بالعمل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Date d'Inscription"
  //       },
  //       {
  //         language: "HI",
  //         text: "कार्यग्रहण तिथि"
  //       },
  //       {
  //         language: "TA",
  //         text: "Petsa ng Pagsali"
  //       },
  //       {
  //         language: "UR",
  //         text: "شامل ہونے کی تاریخ"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_optional2",
  //     text: "Optional",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اختياري"
  //       },
  //       {
  //         language: "FR",
  //         text: "Optionnel"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_optional_criteria_description",
  //     text: "Select predifined criteria or create your own.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اختار من المعايير المحددة مسبقاً أو أنشئ المعايير الخاصة بك:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Sélectionnez des critčres prédéfinis ou créez les vôtres."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_new_criteria",
  //     text: "New Criteria",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "معيار جديد"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nouveaux Critčres"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_selected_criteria",
  //     text: "Selected criteria will require additional input during respondent setup.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المعايير التي تم اختيارها ستتطلب المزيد من الإعدادات أثناء إضافة المستجيبون."
  //       },
  //       {
  //         language: "FR",
  //         text: "Les critères sélectionnés nécessiteront des commentaires supplémentaires pendant la configuration du répondant."
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_previous",
  //     text: "Previous",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "السابق"
  //       },
  //       {
  //         language: "FR",
  //         text: "Précédent"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_respondents_list",
  //     text: "Respondents List",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قائمة المستجيبون"
  //       },
  //       {
  //         language: "FR",
  //         text: "Liste des Répondants  "
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_remove",
  //     text: "Remove",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "حذف"
  //       },
  //       {
  //         language: "FR",
  //         text: "Supprimer"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_set_timeframe",
  //     text: "Set Timeframe",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "حدد المدة الزمنية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Établir le calendrier"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_completion_date",
  //     text: "Completion Date",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تاريخ الإكمال"
  //       },
  //       {
  //         language: "FR",
  //         text: "Date d’Achčvement"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_completion_date_description",
  //     text: "Date of completetion may be extended or changed later.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يمكن تمديد تاريخ الإكمال أو تغييره بأي وقت لاحق عند الحاجة."
  //       },
  //       {
  //         language: "FR",
  //         text: "La date d'achčvement peut ętre prolongée ou modifiée ultérieurement."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_set_reminders",
  //     text: "Set Reminders",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ضبط التذكيرات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Établir des Rappels"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_add_reminder",
  //     text: "Add Reminder",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إضافة تذكير"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ajouter Un Rappel"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_no_reminders",
  //     text: "No reminders have been created.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لا يوجد أية تذكيرات تم ضبطها حتى الآن!"
  //       },
  //       {
  //         language: "FR",
  //         text: "Aucun rappel n'a été créé."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_reminder_at_12",
  //     text: "Reminders will be sent on the date selected at 12:00 PM",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "سيتم تفعيل التذكيرات عند الساعة 12:00 من اليوم المحدد"
  //       },
  //       {
  //         language: "FR",
  //         text: "Les rappels seront envoyés ŕ la date sélectionnée ŕ 12h00"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_multiple_reminders",
  //     text: "Multiple Reminders",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تذكيرات متعددة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Rappels multiples"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_multiple_reminders_description",
  //     text: "Remind your respondents at preset times to fill the survey before the completion date.<br> Set a maximum of 3 Reminders from using the right interface.<br> Click the button below to edit the email template.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ذكّر المستجيبين بتعبئة الاستبيان قبل موعد الانتهاء من خلال تذكيرات محددة مسبقًا.\n اضبط 3 تذكيرات كحد أقصى باستخدام الواجهة اليمنى.\n اضغط على الزر أدناه لتعديل البريد الالكتروني الخاص بالتذكير."
  //       },
  //       {
  //         language: "FR",
  //         text: "Rappelez à vos répondants à des heures prédéfinies de répondre à l'enquête avant la date de fin. <br> Définissez un maximum de 3 rappels pour ne pas utiliser la bonne interface. <br> Cliquez sur le bouton ci-dessous pour modifier le modèle d'e-mail."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_reminder_template",
  //     text: "Reminder Template",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نموذج التذكير"
  //       },
  //       {
  //         language: "FR",
  //         text: "Modčle de Rappel"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_send_to",
  //     text: "Send To",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إرسال إلى"
  //       },
  //       {
  //         language: "FR",
  //         text: "Envoyer ŕ"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_subject_line",
  //     text: "Subject Line",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "خانة العنوان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Boîte d’adresse"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_message_body",
  //     text: "Body",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نص الرسالة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Le Texte du Message"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_send_invitations",
  //     text: "Send Invitations",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إرسال الدعوات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Envoyer des Invitations"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_auto_fill",
  //     text: "Type ID or Employee Name to autofill the rest of the fields.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اكتب الرقم الوظيفي أو اسم الموظف لتتم تعبئة باقي الحقول تلقائياً!"
  //       },
  //       {
  //         language: "FR",
  //         text: "Tapez ID ou Nom de l’employé pour remplir automatiquement le reste des champs."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_selected_drivers",
  //     text: "Selected Drivers",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عوامل الاندماج التي تم اختيارها"
  //       },
  //       {
  //         language: "FR",
  //         text: "r les Facteurs Sélectionnés"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_share_survey",
  //     text: "Share Survey",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مشاركة الاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Partager le Enquęte"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_close",
  //     text: "Close",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إغلاق"
  //       },
  //       {
  //         language: "FR",
  //         text: "Fermer"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_expand",
  //     text: "EXPAND",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "فتح"
  //       },
  //       {
  //         language: "FR",
  //         text: "DÉVELOPPER"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_collapse",
  //     text: "COLLAPSE",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إغلاق"
  //       },
  //       {
  //         language: "FR",
  //         text: "S'EFFONDRER"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_answers",
  //     text: "Options",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الإجابات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Options"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_answers_description",
  //     text: "Options will be shown in a drop down list. A respondent may select only one option.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "سيتم عرض الإجابات كخيارات (سيتم اختيار إجابة واحدة فقط من قبل المستجيب)"
  //       },
  //       {
  //         language: "FR",
  //         text: "Les options seront affichées dans une liste déroulante. Un répondant ne peut sélectionner qu'une seule option."
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_save_criteria",
  //     text: "Save Criteria",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "حفظ المعايير"
  //       },
  //       {
  //         language: "FR",
  //         text: "Sauvegarder les Critčres"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_send_reminders",
  //     text: "Send Reminders",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "أرسل تذكيرات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Envoyer des Rappels"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_send_reminder",
  //     text: "Send Reminder",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "أرسل تذكير"
  //       },
  //       {
  //         language: "FR",
  //         text: "Envoyer un Rappel"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_save_reminder_template",
  //     text: "Save Template",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "حفظ نموذج التذكير"
  //       },
  //       {
  //         language: "FR",
  //         text: "Sauvegarder le Modčle"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_view_report",
  //     text: "View Report",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عرض التقرير"
  //       },
  //       {
  //         language: "FR",
  //         text: "Présenter le Rapport"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtSurveyReports",
  //     text: "Survey Reports",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقرير الاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Rapports du Enquęte "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_engagement_report_export",
  //     text: "Engagement Survey Report",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقرير استبيان الاندماج الوظيفي"
  //       },
  //       {
  //         language: "FR",
  //         text: "Rapport d'Enquęte d'Engagement"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_happiness_report_export",
  //     text: "Happiness Survey Report",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقرير استبيان سعادة الموظف"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_engagement_preview_survey",
  //     text: "Engagement Survey Preview",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عرض استبيان الاندماج الوظيفي"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_happiness_preview_survey",
  //     text: "Happiness Survey Preview",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عرض استبيان سعادة الموظفين"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtDashboard",
  //     text: "Dashboard",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "صفحة البيانات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Tableau des Données "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_engagement_dashboard_report",
  //     text: "Engagement Dashboard Report",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقرير صفحة بيانات الاندماج الوظيفي"
  //       },
  //       {
  //         language: "FR",
  //         text: "Rapport du tableau de bord de l’engagement"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtDashboardDesc",
  //     text: "Displays the workplace engagement, employee engagement index, and heatmap comparison.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ملخص التحليل، ونسبة الوصول، والأداء الخاص بالاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "employee engagement index"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtResponses",
  //     text: "Respondent Analysis",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تحليل المستجيبون"
  //       },
  //       {
  //         language: "FR",
  //         text: "Analyse des Répondants"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtResponsesdesc",
  //     text: "Displays the overall response rate and response rate per criteria.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تصفح المستجيبون وأدخل للاطلاع على ردودهم الفردية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Affiche le taux de réponse global et le taux de réponse par critčre."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHeatmap",
  //     text: "Heatmap",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مخطط تمثيل البيانات بالألوان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Carte Thermique (Schéma de représentation des données en couleur)"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHeatmapdesc",
  //     text: "Detailed analysis of responses based on drivers and sub-drivers.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تحليل مفصل للردود حسب عوامل الاندماج والمجالات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Analyse détaillée des réponses en fonction des facteurs et sous-facteurs."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_questions_desc",
  //     text: "Displays the engagement score per each driver and each question.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تحليل الأسئلة حسب العوامل المختارة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Affiche le note d’engagement pour chaque conducteur et chaque question."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtComments",
  //     text: "Comments",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "التعليقات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Commentaires"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtComments2",
  //     text: "Comments",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تعليقات"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtComment",
  //     text: "Comment",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تعليق"
  //       },
  //       {
  //         language: "FR",
  //         text: "Commentaire"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCommentsDesc",
  //     text: "Displays respondent's comments and feedback.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ادخل وحمّل تعليقات المستجيبون بشكل مفصّل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Accéder aux commentaires en texte libre des candidats et des évaluateurs"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_response_rate",
  //     text: "Response Rate",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "معدل الاستجابة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Taux de Participation"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_notcompleted",
  //     text: "Not Completed",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "غير مكتمل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Incomplet "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_Workplace_Engagement_Score",
  //     text: "Workplace Engagement",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "درجة الاندماج في مكان العمل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Engagement en Milieu de Travail"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_Workplace_Happiness_Score",
  //     text: "Workplace Happiness Score",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "درجة السعادة في مكان العمل"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEngagement",
  //     text: "Employee Engagement",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الاندماج الوظيفي"
  //       },
  //       {
  //         language: "FR",
  //         text: "Engagement de l'Employé"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEngagementReport",
  //     text: "Employee Engagement Report",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقرير الاندماج الوظيفي"
  //       },
  //       {
  //         language: "FR",
  //         text: "Rapport sur l’Engagement de l'Employé"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEngagementComparisonReport",
  //     text: "Engagement Comparison Report",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقرير مقارنة اندماج الموظفين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Engagement Comparison Report"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHappinessReport",
  //     text: "Employee Happiness Report",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقرير سعادة الموظف"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHappinessComparisonReport",
  //     text: "Happiness Comparison Report",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقرير مقارنة سعادة الموظفين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Happiness Comparison Report"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEngagementScale",
  //     text: "Employee Engagement Index",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مؤشر الاندماج الوظيفي"
  //       },
  //       {
  //         language: "FR",
  //         text: "Indice de l’Engagement de l'Employé"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHappinessScale",
  //     text: "Employee Happiness Index",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مؤشر سعادة الموظفين"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEngagementScaleByDriver",
  //     text: "Employee Engagement Index by Driver",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مؤشر الاندماج الوظيفي حسب كل عامل اندماج"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHappinessScaleByDriver",
  //     text: "Employee Happiness Index by Factor",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مؤشر سعادة الموظف حسب كل عامل سعادة"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEngagementScaleByCriteria",
  //     text: "Employee Engagement by Criteria",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مؤشر الاندماج الوظيفي حسب المعايير"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHappinessScaleByCriteria",
  //     text: "Employee Happiness by Criteria",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "سعادة الموظف حسب المعايير"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEngagementScale2",
  //     text: "Employee Engagement",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الاندماج الوظيفي"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtLowlyEngaged",
  //     text: "Lowly Engaged",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مندمج بنسبة منخفضة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Peu Engagé"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHighlyEngaged",
  //     text: "Highly Engaged",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مندمج بنسبة مرتفعة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Trčs Engagé"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtModeratelyEngaged",
  //     text: "Moderately Engaged",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مندمج بنسبة معتدلة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Modérément Engagé"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtQuestionsAnalysisbyDriver",
  //     text: "Questions Analysis by Driver",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تحليل الأسئلة حسب كل عامل اندماج"
  //       },
  //       {
  //         language: "FR",
  //         text: "Analyse des questions par le facteur d’intégration "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtQuestionsAnalysisbyDriverHappiness",
  //     text: "Questions Analysis by Factor",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تحليل الأسئلة حسب كل عامل سعادة"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtSurveyRespondentList",
  //     text: "Survey Respondents List",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قائمة المستجيبون للاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Liste des Répondants au Enquęte "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtExportCommentCheckbox",
  //     text: "Comments",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "التعليقات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Télécharger avec commentaires"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtExportCommentsUnavailable",
  //     text: "Comments Unavailable",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "التعليقات غير متاحة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Commentaires Indisponibles"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_progress",
  //     text: "Progress",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الحالة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Progrčs"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_not_started",
  //     text: "Not Started",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لم يبدأ"
  //       },
  //       {
  //         language: "FR",
  //         text: "Non Commencé"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_in_progress",
  //     text: "In Progress",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قيد الإتمام"
  //       },
  //       {
  //         language: "FR",
  //         text: "En Progression"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtComparisonOverall",
  //     text: "Comparison: Overall",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مقارنة بالنسبة إلى: الكل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Comparaison: En Général"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtBreakout",
  //     text: "Breakout:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تفصيل حسب:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Discussion:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtOverall",
  //     text: "Overall",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "بشكل عام"
  //       },
  //       {
  //         language: "FR",
  //         text: "En Général"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMean",
  //     text: "Mean",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المتوسط"
  //       },
  //       {
  //         language: "FR",
  //         text: "Moyenne"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtDistribution",
  //     text: "Distribution",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "توزيع الإجابات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Distribution"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtRespondentComments",
  //     text: "Respondents' Comments",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تعليقات المستجيبون"
  //       },
  //       {
  //         language: "FR",
  //         text: "Commentaires des répondants"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_survey_progress",
  //     text: "Survey Progress",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "حالة الاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Progression de Enquęte "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_assessment_progress",
  //     text: "Assessment Progress",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "حالة التقييم"
  //       },
  //       {
  //         language: "FR",
  //         text: "Progression de l'Evaluation"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtLive",
  //     text: "Live",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مباشر"
  //       },
  //       {
  //         language: "FR",
  //         text: "En Direct"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtSendRemindersNow",
  //     text: "Click the button below to instantly send reminders to all respondents who did not fill the survey yet.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اضغط على الزر أدناه لإرسال تذكيرات بشكل مباشر لكل المستجيبين الذين لم يكملوا الاستبيان بعد "
  //       },
  //       {
  //         language: "FR",
  //         text: "Cliquez sur le bouton ci-dessous pour envoyer instantanément des rappels à tous les répondants qui n'ont pas encore répondu au Enquête."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAddRemoveRespondents",
  //     text: "Add / Remove Respondents",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إضافة/حذف مستجيبون"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ajouter / Supprimer des Répondants"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_filter_by",
  //     text: "Filter By",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "فرز حسب"
  //       },
  //       {
  //         language: "FR",
  //         text: "FILTRER PAR"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAll",
  //     text: "All",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الكل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Tout"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btnCloseNow",
  //     text: "CLOSE NOW",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "أغلق الآن"
  //       },
  //       {
  //         language: "FR",
  //         text: "FERMER MAINTENANT"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEmailTemplate",
  //     text: "Email Template",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نموذج البريد الالكتروني"
  //       },
  //       {
  //         language: "FR",
  //         text: "Modčle d’email"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAddRespondent_s",
  //     text: "Add Respondent(s)",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إضافة مستجيب"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ajouter Un (des) Répondant(s)"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtLowest",
  //     text: "Lowest",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الأدنى"
  //       },
  //       {
  //         language: "FR",
  //         text: "Le Plus Bas"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHighest",
  //     text: "Highest",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الأعلى"
  //       },
  //       {
  //         language: "FR",
  //         text: "Le Plus Haut"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtNoComments",
  //     text: "No Comments",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لا يوجد تعليقات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Sans Commentaires"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtDescription",
  //     text: "text here…",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اكتب هنا..."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ecrivez ici…"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTitle",
  //     text: "Survey Title",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عنوان الاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Titre de Enquęte"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtQAnswer",
  //     text: "text here…",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اكتب هنا..."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ecrivez ici…"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCriteriaName",
  //     text: "Criterion Name",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اسم المعيار"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nom du Critčre"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtSelectCriteria",
  //     text: "Select Criteria",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اختر المعايير"
  //       },
  //       {
  //         language: "FR",
  //         text: "Sélectionner les Critčres"
  //       }
  //     ]
  //   },
  //   {
  //     key: "ENGAGED",
  //     text: "Engaged",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مندمج"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt5_7minutes",
  //     text: "10 - 15 mins",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "10 - 15 دقيقة"
  //       },
  //       {
  //         language: "FR",
  //         text: "10 – 15 mins"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtheatmaptooltip",
  //     text: "The value displayed in the cell is delta, which represents a difference in the overall value.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الرقم المكتوب داخل المربع يمثل الفرق بين النتيجة والمعدل الكلي."
  //       },
  //       {
  //         language: "FR",
  //         text: "which represents a difference in the overall value."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtResponsesStatus",
  //     text: "Responses Status",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "حالة الردود"
  //       },
  //       {
  //         language: "FR",
  //         text: "Statut de Réponses"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt10_15minutes",
  //     text: "10 ~ 15 mins",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "10 ~ 15 دقيقة"
  //       },
  //       {
  //         language: "FR",
  //         text: "10 ~ 15 mins"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_respondentsCount",
  //     text: "Respondents",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مستجيب"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_recommended",
  //     text: "(Recommended)",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "(موصى به)"
  //       },
  //       {
  //         language: "FR",
  //         text: "(Recommandé)"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtOveralleng",
  //     text: "Overall",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المعدل الكلي"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEngagementSurvey",
  //     text: "Employee Engagement Survey",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "استبيان الاندماج الوظيفي"
  //       },
  //       {
  //         language: "FR",
  //         text: "Enquęte d'Engagement"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtBeforeStarting",
  //     text: "Before you begin with the survey, kindly fill the below:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قبل البدء بالاستبيان، يرجى تعبئة المعلومات أدناه:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Kindly fill in the info below:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtanswered",
  //     text: "answered",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تمت الإجابة عليه"
  //       },
  //       {
  //         language: "FR",
  //         text: "Répondu"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtinnovation",
  //     text: "Innovation",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الابتكار"
  //       },
  //       {
  //         language: "FR",
  //         text: "Innovation"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtex",
  //     text: "Ex. Mia",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مثال: محمد"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ex. Louise"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivation",
  //     text: "Motivation",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "التحفيز"
  //       },
  //       {
  //         language: "FR",
  //         text: "Motivation"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformance",
  //     text: "Performance",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الأداء"
  //       },
  //       {
  //         language: "FR",
  //         text: "Performance"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomy",
  //     text: "Autonomy",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الاستقلالية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Autonomie"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnection",
  //     text: "Connection",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الاتصال"
  //       },
  //       {
  //         language: "FR",
  //         text: "Connexion"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadership",
  //     text: "Transformational Leadership",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "القيادة التحويلية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Leadership transformationnel"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtinnovation2",
  //     text: "Innovation",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الابتكار"
  //       },
  //       {
  //         language: "FR",
  //         text: "Innovation"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivation2",
  //     text: "Motivation",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "التحفيز"
  //       },
  //       {
  //         language: "FR",
  //         text: "Motivation"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformance2",
  //     text: "Performance",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الأداء"
  //       },
  //       {
  //         language: "FR",
  //         text: "Performance"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomy2",
  //     text: "Autonomy",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الاستقلالية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Autonomie"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnection2",
  //     text: "Connection",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الاتصال"
  //       },
  //       {
  //         language: "FR",
  //         text: "Connexion"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadership2",
  //     text: "Transformational Leadership",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "القيادة التحويلية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Leadership transformationnel"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAddCandidate_s",
  //     text: "Add Candidate(s)",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إضافة المرشح (المرشحين)"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ajouter Un (des) Candidat(s)"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAddEvaluator_s",
  //     text: "Add Evaluator(s)",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إضافة مقيِّم (مقيمين)"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ajouter Un (des) Évaluateur(s) "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtManagers",
  //     text: "Managers",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المدراء"
  //       },
  //       {
  //         language: "FR",
  //         text: "Gestionnaires"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPeers",
  //     text: "Peers",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الزملاء"
  //       },
  //       {
  //         language: "FR",
  //         text: "Pairs"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTeam",
  //     text: "Team",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "أعضاء الفريق"
  //       },
  //       {
  //         language: "FR",
  //         text: "Équipe"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtDirectReports",
  //     text: "Direct Reports",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الموظفين التابعين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Rapports Directs"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCustomers",
  //     text: "Customers",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "العملاء"
  //       },
  //       {
  //         language: "FR",
  //         text: "Les Clients"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCustomer",
  //     text: "Customer",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "العميل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Le Client"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtResponded",
  //     text: "Responded",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "استجاب منهم"
  //       },
  //       {
  //         language: "FR",
  //         text: "A répondu"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtBELOW",
  //     text: "BELOW",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "أقل من"
  //       },
  //       {
  //         language: "FR",
  //         text: "CI-DESSOUS"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtABOVE",
  //     text: "ABOVE",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "أعلى من"
  //       },
  //       {
  //         language: "FR",
  //         text: "DESSUS"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtExtremelyLow",
  //     text: "Extremely Low",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قليل جداً"
  //       },
  //       {
  //         language: "FR",
  //         text: "Extręmement Bas"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtLow",
  //     text: "Low",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قليل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Bas"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtNeutral",
  //     text: "Moderate",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "معتدل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Modéré"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHigh",
  //     text: "High",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عالي"
  //       },
  //       {
  //         language: "FR",
  //         text: "Haut"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtExtremelyHigh",
  //     text: "Extremely High",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عالي جداً"
  //       },
  //       {
  //         language: "FR",
  //         text: "Extręmement Haut "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtExtremelyUnhappy",
  //     text: "Extremely Unhappy",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "غير سعيد إطلاقاً"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtUnhappy",
  //     text: "Unhappy",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "غير سعيد"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHappy",
  //     text: "Happy",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "سعيد"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtExtremelyHappy",
  //     text: "Extremely Happy",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "سعيد للغاية"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtRespondentID",
  //     text: "Respondent ID",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الرقم الوظيفي"
  //       },
  //       {
  //         language: "FR",
  //         text: "ID du Répondant"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEditRespondent",
  //     text: "Edit Respondent",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تعديل بيانات المستجيب"
  //       },
  //       {
  //         language: "FR",
  //         text: "Modifier le Répondant"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtResultsRating",
  //     text: "Results Rating",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مقياس النتائج"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtRatingScale",
  //     text: "Rating Scale",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مقياس التقييم"
  //       },
  //       {
  //         language: "FR",
  //         text: "Échelle d’Évaluation"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCalculationProcess",
  //     text: "Calculation Process",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عملية الحساب"
  //       },
  //       {
  //         language: "FR",
  //         text: "Processus de Calcul"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCalculationProcess1",
  //     text: "Each statement score is given an average rating based on the received feedback.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يتم احتساب نتيجة كل عبارة من خلال أخذ متوسط نتائج اختيارات الموظفين."
  //       },
  //       {
  //         language: "FR",
  //         text: "Chaque note de déclaration reçoit une note moyenne basée sur les commentaires reçus."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCalculationProcess2",
  //     text: "Each driver score is calculated as the overall rating score of the statements.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يتم احتساب نتيجة كل عامل من عوامل الاندماج من خلال أخذ متوسط نتائج العبارات. "
  //       },
  //       {
  //         language: "FR",
  //         text: "Chaque  note de compétences est calculé comme le score global de notation des énoncés sélectionnés."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCalculationProcess3",
  //     text: "The Overall Workplace Engagement is calculated as the average rating of the selected drivers.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يتم احتساب مستوى الاندماج الوظيفي الكلي في مكان العمل من خلال أخذ متوسط نتائج عوامل الاندماج التي تم اختيارها."
  //       },
  //       {
  //         language: "FR",
  //         text: "«Sans objet» est exclu du calcul de la note moyenne."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCalculationProcess4",
  //     text: "The Employee Engagement Index is calculated as per the received feedback.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يتم احتساب مؤشر اندماج الموظفين من خلال نتائج اختيارات الموظفين."
  //       },
  //       {
  //         language: "FR",
  //         text: "La performance globale est calculée comme la note moyenne des compétences pondérées."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHappinessCalculationProcess2",
  //     text: "Each factor score is calculated as the overall rating score of the statements.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يتم احتساب نتيجة كل عامل من عوامل السعادة في مكان العمل من خلال أخذ متوسط نتائج العبارات. "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHappinessCalculationProcess3",
  //     text: "The Overall Workplace Happiness is calculated as the average rating of the selected fattors.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يتم احتساب مستوى الاندماج الوظيفي الكلي في مكان العمل من خلال أخذ متوسط نتائج عوامل السعادة في مكان العمل التي تم اختيارها."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHappinessCalculationProcess4",
  //     text: "The Employee Happiness Index is calculated as per the received feedback.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يتم احتساب مؤشر سعادة الموظفين في مكان العمل من خلال نتائج اختيارات الموظفين."
  //       }
  //     ]
  //   },
  //   {
  //     key: "EngagementLevels.HIGHLY_DISENGAGED",
  //     text: "Highly&nbsp;Disengaged",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "غير&nbsp;مندمج&nbsp;إطلاقًا"
  //       },
  //       {
  //         language: "FR",
  //         text: "Highly Disengaged"
  //       }
  //     ]
  //   },
  //   {
  //     key: "EngagementLevels.DISENGAGED",
  //     text: "Disengaged",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "غير&nbsp;مندمج"
  //       },
  //       {
  //         language: "FR",
  //         text: "Disengaged"
  //       }
  //     ]
  //   },
  //   {
  //     key: "DISENGAGED1",
  //     text: "Disengaged",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "غير مندمج"
  //       }
  //     ]
  //   },
  //   {
  //     key: "EngagementLevels.MODERATELY_ENGAGED",
  //     text: "Moderate",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "معتدل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Moderately Engaged"
  //       }
  //     ]
  //   },
  //   {
  //     key: "EngagementLevels.ENGAGED_LOW",
  //     text: "Engaged&nbsp;<sub>Low</sub>",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مندمج&nbsp;<sub>منخفض</sub>"
  //       },
  //       {
  //         language: "FR",
  //         text: "Engaged Low"
  //       }
  //     ]
  //   },
  //   {
  //     key: "EngagementLevels.ENGAGED_MID",
  //     text: "Engaged&nbsp;<sub>Mid</sub>",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مندمج&nbsp;<sub>معتدل</sub>"
  //       },
  //       {
  //         language: "FR",
  //         text: "Engaged Mid"
  //       }
  //     ]
  //   },
  //   {
  //     key: "EngagementLevels.ENGAGED_HIGH",
  //     text: "Engaged&nbsp;<sub>High</sub>",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مندمج&nbsp;<sub>مرتفع</sub>"
  //       },
  //       {
  //         language: "FR",
  //         text: "Engaged High "
  //       }
  //     ]
  //   },
  //   {
  //     key: "HappinessLevels.EXTREME_UNHAPPY",
  //     text: "Extremely Unhappy",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "غير سعيد إطلاقاً"
  //       }
  //     ]
  //   },
  //   {
  //     key: "HappinessLevels.UNHAPPY",
  //     text: "Unhappy",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "غير سعيد"
  //       }
  //     ]
  //   },
  //   {
  //     key: "HappinessLevels.HAPPY",
  //     text: "Happy",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "سعيد"
  //       }
  //     ]
  //   },
  //   {
  //     key: "HappinessLevels.EXTREME_HAPPY",
  //     text: "Extremely Happy",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "سعيد للغاية"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEmployeesHappinessIndex",
  //     text: "Employee Happiness Index",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مؤشر سعادة الموظفين"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEmployeesEngagementIndex",
  //     text: "Employee Engagement Index",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مؤشر اندماج الموظفين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Indice de l’Engagement de l'Employé"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEmployeesEngagementIndexpara",
  //     text: "The Employee Engagement Index is the next level of the workplace engagement score. It represents the engagement levels of your employees. The below results exhibit the percentages of the respondents who are highly engaged, moderately engaged, and lowly engaged based on their responses to the selected drivers.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "وتمثل مؤشرات اندماج الموظفين المستوى التالي من درجة الاندماج الوظيفي في مكان العمل. وهذه المؤشرات تمثل مستويات اندماج الموظفين. وتعرض النتائج أدناه، النسب المئوية للموظفين الذين يتمتعون باندماج عالٍ، أو معتدل، أو منخفض، بناءً على ردودهم على عوامل الاندماج المختارة."
  //       },
  //       {
  //         language: "FR",
  //         text: "L’indice d’engagement des employés est le prochain niveau de la note d’engagement en milieu de travail. Il représente les niveaux d'engagement de vos employés. Les résultats ci-dessous montrent les pourcentages de répondants qui sont très engagés, modérément engagés et peu engagés en fonction de leurs réponses aux fecteurs sélectionnés."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtDriversofWorkplaceEngagement",
  //     text: "Workplace Engagement Drivers",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عوامل اندماج مكان العمل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Facteurs de l'Engagement du Lieu de Travail"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtOverallWorkplaceEngagement",
  //     text: "Overall Workplace Engagement",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الاندماج الوظيفي الكلي في مكان العمل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Engagement Total sur le Lieu de Travail"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtOverallWorkplaceEngagementScore",
  //     text: "Overall Workplace Engagement Score",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نتيجة الاندماج الوظيفي الكلي في مكان العمل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Note Global d'Engagement sur le Lieu de Travail"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtOverallWorkplaceEngagementpara1",
  //     text: "The Workplace Engagement Score measures the overall engagement & perception across the organization. It is the average score of the selected drivers.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تعبر نتيجة الاندماج الوظيفي في مكان العمل عن التصور والاندماج الكلي في مكان العمل. وهي تشكل المعدل الكلي لنتائج عوامل الاندماج المختارة."
  //       },
  //       {
  //         language: "FR",
  //         text: "Le score d'engagement sur le lieu de travail mesure l'engagement global et la perception au sein de l'organisation. C'est le score moyen des facteurs sélectionnés."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtOverallWorkplaceEngagementpara2",
  //     text: "The more engaged your employees are, the more willing they are to put effort into achieving the business goals and contributing to its success.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "كلما زاد تفاعل موظفيك واندماجهم في العمل، زادت رغبتهم في بذل جهد إضافي لتحقيق أهداف العمل والمساهمة في نجاحه."
  //       },
  //       {
  //         language: "FR",
  //         text: "Plus vos employés sont engagés, plus ils sont prêts à faire des efforts pour atteindre les objectifs de l'entreprise et contribuer à son succès."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_report",
  //     text: "Report",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقرير"
  //       },
  //       {
  //         language: "FR",
  //         text: "Rapport"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_reporteng",
  //     text: "Report",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "التقرير"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHowtousethisreport",
  //     text: "How to Use the Report",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "كيف يمكن الاستفادة من التقرير؟"
  //       },
  //       {
  //         language: "FR",
  //         text: "Comment Utiliser le Rapport  "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHowtousethisreportpara",
  //     text: "<p class=\"mb-4\">This report is a representation of the current level of workplace engagement at [Company Name]. The overall engagement score will help understand how the workplace performs.</p>\n  <p class=\"mb-4\">The drivers and their engagement levels displayed in this report are a result of the employees’ responses. Below every score is the analysis of the current work situation and the recommended actions.</p>\n  <p class=\"mb-4\">Recommended actions in this report are only a few of the many activities that can be taken to improve the environment, and they are not limited to the displayed suggestions. It is highly encouraged that the actions deemed fit for [Company Name] are taken to improve its employee engagement level and performance.</p>",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "<p class=\"mb-4\">يوضح هذا التقرير المستوى الحالي للاندماج الوظيفي في [Company Name]. وسوف تساعد النتيجة الإجمالية للاندماج في فهم كيفية أداء مكان العمل.</p>\n  <p class=\"mb-4\">إن عوامل الاندماج المبينة في هذا التقرير ومستوى الاندماج الخاص بها هي نتيجة وخلاصة استجابة الموظفين لهذا الاستبيان. ويلي كل نتيجة، تحليل خاص بالوضع الحالي في مكان العمل، والتوصيات المقترحة للمحافظة على الوضع الحالي أو العمل على تحسينه.</p>\n  <p class=\"mb-4\">إن الإجراءات الموصى بها في هذا التقرير ما هي الإ جزء من الإجراءات التي من الممكن اتخاذها في تحسين بيئة العمل، ولا تقتصر عليها فقط. وتشجع على اتخاذ الإجراءات المناسبة لتحسين مستوى الاندماج الوظيفي الخاص بـ [Company Name] وتحسين الأداء.</p>"
  //       },
  //       {
  //         language: "FR",
  //         text: "<p class=\"mb-4\">Ce rapport est une représentation du niveau actuel d'engagement sur le lieu de travail chez [Company Name]. Le score global d'engagement aidera à comprendre les performances du lieu de travail.</p>\n<p class=\"mb-4\"> Les facteurs d’Intégration et leurs niveaux d’engagement affichés dans le présent rapport sont le résultat des réponses des employés.</p>\n<p class=\"mb-4\"> Sous chaque note se trouve l’analyse de la situation de travail actuelle et des mesures recommandées.</p>\n<p class=\"mb-4\"> Les mesures recommandées dans le présent rapport ne sont que quelques-unes des nombreuses activités qui peuvent être entreprises pour améliorer l’environnement, et elles ne se limitent pas aux suggestions affichées. Il est fortement recommandé que les mesures jugées appropriées pour [Company Name] soient prises pour améliorer le niveau d'engagement et la performance de ses employés.</p>"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtscience",
  //     text: "Science Behind the IMPACT Model",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "العلم الذي يرتكز عليه نموذج IMPACT"
  //       },
  //       {
  //         language: "FR",
  //         text: "La science sur laquelle repose le modčle IMPACT"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtobjectives",
  //     text: "\n  <h4 class=\"mb-5 fw-bold\">Objectives of this Report</h4>\n  <div class=\"columns-content\">\n  <div class=\"col-left\">\n    <ul>\n      <li>\n        <i class=\"fas fa-circle\"></i>\n        <p>Identify the workplace overall engagement score and understand how lowly, moderately, and highly engaged employees affect the workplace and its performance.</p>\n      </li>\n      <li>\n        <i class=\"fas fa-circle\"></i>\n        <p>Identify strengths through drivers with high engagement and recognize how they impact the workplace.</p>\n      </li>\n      <li>\n        <i class=\"fas fa-circle\"></i>\n        <p>Understand areas of improvement through drivers with low engagement and the reason behind the results.</p>\n      </li>\n    </ul>\n  </div>\n  <div class=\"col-sep\"></div>\n  <div class=\"col-right\">\n    <ul>\n      <li>\n        <i class=\"fas fa-circle\"></i>\n        <p>Access recommended actions to be taken for each driver, whether they are lowly, moderately, or highly engaged, and how they can be implemented to improve the workplace and environment.</p>\n      </li>\n      <li>\n        <i class=\"fas fa-circle\"></i>\n        <p>Obtain open-ended statements or feedback submitted by employees during the survey, use it to improve ways of doing things, and understand how they feel about the workplace.</p>\n      </li>\n    </ul>\n  </div>\n</div> ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "\n  <h4 class=\"mb-5 fw-bold\">أهداف التقرير</h4>\n  <div class=\"columns-content\">\n  <div class=\"col-left\">\n    <ul>\n      <li>\n        <i class=\"fas fa-circle\"></i>\n        <p>تحديد درجة الاندماج الإجمالية وفهم كيف يؤثر الموظفون المندمجون بنسبة متدنية، أو معتدلة، أو عالية على مكان العمل وأدائه.</p>\n      </li>\n      <li>\n        <i class=\"fas fa-circle\"></i>\n        <p>تحديد نِقَاط القوة باعتماد عوامل الاندماج ذات الاندماج العالي وإدراك كيفية تأثيرها في مكان العمل.</p>\n      </li>\n      <li>\n        <i class=\"fas fa-circle\"></i>\n        <p>تحديد نِقَاط التحسين باعتماد عوامل الاندماج ذات الاندماج المتدني والأسباب وراء هذه النتائج. </p>\n      </li>\n    </ul>\n  </div>\n  <div class=\"col-sep\"></div>\n  <div class=\"col-right\">\n    <ul>\n      <li>\n        <i class=\"fas fa-circle\"></i>\n        <p>الحصول على توصيات لأخذها بعين الاعتبار لكل عامل اندماج، بغض النظر عن درجة الاندماج الخاصة به إن كانت متدنية، أو معتدلة، أو عالية وكيفية تطبيق هذه التوصيات لتحسين بيئة ومكان العمل.</p>\n      </li>\n      <li>\n        <i class=\"fas fa-circle\"></i>\n        <p>الحصول على تعليقات الموظفين من خلال الاستبيان، للاستفادة منها في تطوير طرق تنفيذ الأعمال، وفهم شعور الموظفين تجاه مكان العمل. </p>\n      </li>\n    </ul>\n  </div>\n</div> "
  //       },
  //       {
  //         language: "FR",
  //         text: "<h4 class=\"mb-5 fw-bold\">Objectifs de ce rapport</h4>\n<div class=\"columns-content\"> <div class=\"col-left\"> <ul> <li> <i class=\"fas fa-circle\"></i> <p> Identifiez le score global d'engagement sur le lieu de travail et comprenez comment les employés modestes, modérément et fortement engagés affectent le lieu de travail et ses performances.\n</p> </li> <li> <i class=\"fas fa-circle\"></i> <p> Identifiez les points forts par des facteurs très engagés et reconnaissez leur impact sur le lieu de travail.\n</p> </li> <li> <i class=\"fas fa-circle\"></i> <p> Comprendre les domaines d'amélioration par des facteurs avec un faible engagement et la raison derrière les résultats.\n</p> </li> </ul> </div> <div class=\"col-sep\"></div> <div class=\"col-right\"> <ul> <li> <i class=\"fas fa-circle\"></i> <p> Accédez aux mesures recommandées à prendre pour chaque conducteur, qu'il soit faiblement, modérément ou fortement engagé, et comment elles peuvent être mises en œuvre pour améliorer le lieu de travail et l'environnement.\n</p> </li> <li> <i class=\"fas fa-circle\"></i> <p> Obtenez des déclarations ouvertes ou des commentaires soumis par les employés pendant le Enquête, utilisez-les pour améliorer leurs façons de faire et comprendre ce qu'ils pensent du lieu de travail.</p> </li> </ul> </div> </div>"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtsciencepara",
  //     text: "<p class=\"mb-4\">Proved studies have indicated that Employee Engagement depends on several psychological conditions and elements, like meaningfulness, safety, and availability, required for an individual to remain engaged.</p>\n  <p class=\"mb-4\">It is a dynamic principle of employee performance that leads to their retention.</p>\n  <p class=\"mb-4\">The latest scientific research conducted by experts from a wide spectrum of top-rated universities revealed the positive correlation between Employee Engagement and improving both employees’ and business performance.</p>\n  <p class=\"mb-4\">ZENITHR’s team has designed the IMPACT model drivers influencing the employee's engagement based on the latest scientific practices and research, psychological conditions, and the recent business trends.\n  IMPACT stands for Innovation, Motivation, Performance, Autonomy, Connection, and Transfor a “marked influence,” was generated using the initials of the most important drivers that best measure Employee Engagement. Each of these drivers is cascaded into two sub-drivers that explicitly measure psychological conditions, which help dive into the reasons behind what keeps employees engaged and disengaged.</p>",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "<p class=\"mb-4\">أشارت الدراسات المُثبتة إلى أن الاندماج الوظيفي يعتمد على بعض الظروف النفسية (السيكولوجية) للموظف مثل: المغزى من العمل، والسلامة، والتوافر، وهو ما يتطلبه لضمان بقاء الفرد مندمجاً في مكان العمل.</p>\n  <p class=\"mb-4\">الاندماج الوظيفي يعتبر معيار ديناميكي لأداء الموظف والذي بدوره يؤدي إلى الاحتفاظ بهم.</p>\n  <p class=\"mb-4\">كشفت أحدث الأبحاث العلمية التي أجراها خبراء مختصين من جامعات ذات تصنيف عالي عن العلاقة الإيجابية بين اندماج الموظفين في العمل وتحسين أدائهم وأداء الأعمال.</p>\n  <p class=\"mb-4\">صمم فريق عمل ZENITHR عوامل الاندماج في منهجية \"IMPACT\" و التي تؤثر على اندماج الموظفين بناءً على أحدث الممارسات العملية والبحوث والظروف النفسية (السيكولوجية) واتجاهات الأعمال الحديثة.\n  وتُمثل منهجية “IMPACT” عوامل الاندماج: الابتكار (Innovation)، والتشجيع (Motivation)، والأداء (Performance)، والاستقلالية (Autonomy)، والاتصال (Connection)، والقيادة التحويلية (Transformational Leadership).</p>\n  <p class=\"mb-4\">وقد تم تصميم اسم المنهجية “IMPACT” من خلال أخذ الأحرف الأولى لأهم عوامل الاندماج التي تقيس معدل الاندماج الوظيفي. ويشمل كل عامل اندماج من هذه العوامل على مجالين يقيسان الظروف النفسية (السيكولوجية) بشكل واضح ومحدد مما يساعد على الوصول إلى الأسباب الرئيسية التي تجعل الموظفين مندمجين وظيفياً أو تحول دون ذلك.</p>"
  //       },
  //       {
  //         language: "FR",
  //         text: "<p class=\"mb-4\">Des études prouvées ont indiqué que l’engagement des employés dépend de plusieurs conditions et éléments psychologiques, comme la signification, la sécurité et la disponibilité, nécessaires pour qu’une personne demeure engagée.</p>\n<p class=\"mb-4\">C’est un principe dynamique de performance des collaborateurs qui conduit à leur fidélisation.</p>\n<p class=\"mb-4\"> Les dernières recherches scientifiques menées par des experts d’un large éventail d’universités de premier ordre ont révélé la corrélation positive entre l’engagement des employés et l’amélioration des performances des employés et de l’entreprise.</p>\n<p class=\"mb-4\"> L’équipe de ZENITHR a conçu les moteurs du modèle IMPACT qui influencent l’engagement des employés en se basant sur les dernières pratiques et recherches scientifiques, les conditions psychologiques et les tendances commerciales récentes. IMPACT signifie Innovation, Motivation, Performance, Autonomie, Connexion et Leadership Transformationnel.</p>\n<p class=\"mb-4\">Le modèle IMPACT de ZENITHR, défini comme une « influence marquée », a été généré à l’aide des initiales des principaux facteurs qui mesurent le mieux l’engagement des employés. Chacun de ces facteurs est réparti en deux sous-facteurs qui mesurent explicitement les conditions psychologiques, ce qui aide à examiner les raisons qui motivent l’engagement et le désengagement des employés.</p>"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtIntroduction",
  //     text: "Introduction",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مقدمة"
  //       },
  //       {
  //         language: "FR",
  //         text: "introduction"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtIntroductionpara",
  //     text: "<p>Employee Engagement is the employee’s emotional commitment to the workplace and their willingness to give their best and show high performance to achieve business goals.</p>\n  <p>It has no predetermined definition; however, it is wrapped around the connection employees have towards their job and place.</p>\n  <p>Employee Engagement plays an essential role in promoting a culture of loyalty and fostering the motivation for employees who take the leap for the work they feel recognizes them.</p>\n  <p>The Employee Engagement Survey applies the IMPACT model to measure the employees’ interaction in the workplace, displayed in this report through in-depth analysis, scores, and recommendations.</p>",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "<p>\"الاندماج الوظيفي\" هو الالتزام العاطفي بين الموظفين ومكان العمل ورغبتهم في تقديم أفضل ما لديهم وإظهار مستوى أداء عالٍ لتحقيق أهداف العمل.</p>\n  <p>وبشكل عام، ليس هناك تعريف محدد \"للاندماج الوظيفي\". إلا أنها مرتكزة على ارتباط الموظفين مع عملهم والمكان الذي يعملون فيه.</p>\n  <p>يُمثّل \"الاندماج الوظيفي\" دوراً أساسياً في تعزيز ثقافة الولاء وتشجيع الموظفين وتحفيزهم لتقديم أفضل ما عندهم، خصوصاً عند مقابلة مواقفهم بالدعم والتقدير.</p>\n  <p>يُطبق \"استبيان الاندماج الوظيفي\" منهجية “IMPACT” لقياس التفاعل الذي يُحققه ويُنجزه الموظفين في مكان العمل، والذي يتم عرضه في هذا التقرير من خلال التحليل المتعمق في التقييم، والردود، والتوصيات المقترحة.</p>"
  //       },
  //       {
  //         language: "FR",
  //         text: "<p>L’engagement des employés est l’engagement émotionnel de l’employé envers le lieu de travail et sa volonté de donner le meilleur de lui-même et de montrer des performances élevées pour atteindre les objectifs de l’entreprise.</p>\n <p> Il n'a pas de définition prédéterminée; cependant, il est enveloppé autour du lien que les employés ont avec leur travail et leur place.</p>\n <p>L'engagement des employés joue un rôle essentiel dans la promotion d'une culture de loyauté et la motivation des employés qui franchissent le pas pour le travail qui, selon eux, les reconnaît.</p>\n <p> L'enquête sur l'engagement des employés applique le modèle D'IMPACT pour mesurer l'interaction des employés sur le lieu de travail, qui est affichée dans ce rapport par le biais d'une analyse approfondie, de scores et de recommandations.</p>"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationDriverDesc",
  //     text: "Innovation and engagement are positively correlated through creativity and innovative capabilities. The employees encouraged to be creative while considering their ideas are more likely to be happy with the results they drive. They contribute more to achieve business goals.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الابتكار والاندماج الوظيفي يرتبطان بشكل إيجابي من خلال الإبداع والقدرات الابتكارية. فالموظفين الذين يتم تشجيعهم للإبداع في العمل ويتم أخذ أفكارهم بعين الاعتبار لديهم قابلية ليكونوا سعداء مع النتائج التي يحققونها، وبالتالي يساهمون بتحقيق أهداف العمل بشكل أفضل."
  //       },
  //       {
  //         language: "FR",
  //         text: "L'innovation et l'engagement sont positivement corrélés par la créativité et les capacités d'innovation. Les employés encouragés à faire preuve de créativité tout en considérant leurs idées sont plus susceptibles d'être satisfaits des résultats qu'ils génèrent. Ils contribuent davantage à atteindre les objectifs commerciaux."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationExtremeLowDriverReadings",
  //     text: "These results indicate that the environment does not allow the employees to unleash creativity and does not give them enough space to be creative and innovative. As a result, they refrain from developing ideas about new values and procedures.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير هذه النتائج  أن بيئة العمل لا تسمح للموظفين بإطلاق العنان للإبداع ولا تمنحهم المساحة الكافية للإبداع والابتكار، وبالتالي يمتنعون عن تطوير أفكار حول قيم وإجراءات جديدة."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ces résultats indiquent que l’environnement ne permet pas aux employés de libérer la créativité et ne leur donne pas assez d’espace pour être créatifs et innovateurs. Par conséquent, ils s’abstiennent d’élaborer des idées sur de nouvelles valeurs et procédures."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationExtremeLowDriverRecommendationBrief",
  //     text: "These results may indicate a high degree of risk in the work environment in terms of not encouraging the employees enough to be more creative and innovative, which in turn affects employees’ engagement. It is recommended to take immediate and rapid actions to motivate them to contribute innovative ideas, welcoming what they propose, making their contribution feel valued, and giving them the space to improve.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هذه النتائج قد تشير درجة عالية من الخطورة في بيئة العمل من حيث عدم تشجيع الموظفين ليكونوا أكثر إبداعاً وابتكاراً والذي يؤثر بدوره على اندماج الموظفين. ويجب اتخاذ إجراءات فورية وسريعة من خلال تحفيز الموظفين على المساهمة بأفكار مبتكرة، والترحيب بما يقترحونه، وتقدير مساهمتهم، ومنحهم مساحة للتحسين."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ces résultats peuvent indiquer un degré élevé de risque dans le milieu de travail en termes de non-encouragement des employés suffisamment pour être plus créatifs et innovateurs, ce qui à son tour affecte l’engagement des employés. Il est recommandé de prendre des mesures immédiates et rapides pour les motiver à apporter des idées novatrices, à accueillir ce qu’ils proposent, à valoriser leur contribution et à leur donner l’espace nécessaire pour s’améliorer."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationExtremeLowDriverRecommendationPointHeader",
  //     text: "You can take the following actions. However, they are not limited to these options:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين هذا البُعد:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Vous pouvez prendre les mesures suivantes. Cependant, ils ne sont pas limités à ces options:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationExtremeLowDriverRecommendationTitle_1",
  //     text: "Invest in more resources that drive innovation.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الاستثمار في المزيد من الموارد التي تدفع الابتكار."
  //       },
  //       {
  //         language: "FR",
  //         text: "Investissez dans plus de ressources qui stimulent l'innovation."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationExtremeLowDriverRecommendationDesc_1",
  //     text: "The workplace might lack the resources that it needs to drive Innovation and creativity from the employees. The investment in these unavailable resources is a must to obtain maximum efficiency and help the development of innovation. Give the employees access to those resources and encourage them to drive the change in the business.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قد يفتقر مكان العمل للموارد التي يحتاجها لدفع الموظفين للابتكار والإبداع. ويجب الاستثمار في هذه الموارد الغير متاحة، للحصول على أقصى قدر من الكفاءة والمساعدة في تنمية هذا الابتكار. ومنح الموظفين إمكانية الوصول إلى هذه الموارد وتشجيعهم على قيادة التغيير في العمل."
  //       },
  //       {
  //         language: "FR",
  //         text: "Le lieu de travail peut manquer des ressources dont il a besoin pour stimuler l'innovation et la créativité des employés. L'investissement dans ces ressources indisponibles est indispensable pour obtenir une efficacité maximale et contribuer au développement de l'innovation. Donner aux employés l’accès à ces ressources et les encourager à conduire le changement dans l’entreprise."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationExtremeLowDriverRecommendationTitle_2",
  //     text: "Team Diversity.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تنوع الفريق."
  //       },
  //       {
  //         language: "FR",
  //         text: "Diversité de l'Équipe."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationExtremeLowDriverRecommendationDesc_2",
  //     text: "Building a diverse team with different experiences, skills, and thinking styles contributes to bringing new ideas that help educate individuals and develop their creative skills. This is reflected in providing a positive contribution to achieve business goals.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "بناء فريق متنوع بخبرات ومهارات وأنماط تفكير مختلفة، يسهم في جلب أفكار جديدة تساعد في تعليم الأفراد وتطوير مهاراتهم الإبداعية، وينعكس ذلك بتقديم مساهمة إيجابية ومشتركة لتحقيق أهداف العمل."
  //       },
  //       {
  //         language: "FR",
  //         text: "Construire une équipe diversifiée avec des expériences, des compétences et des styles de réflexion différents contribue à apporter de nouvelles idées qui aident à éduquer les individus et à développer leurs compétences créatives. Cela se traduit par une contribution positive à la réalisation des objectifs commerciaux."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationExtremeLowDriverRecommendationTitle_3",
  //     text: "Inspire the employees to transform knowledge into products and services.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إلهام الموظفين لتحويل المعرفة إلى قيم وإجراءات جديدة."
  //       },
  //       {
  //         language: "FR",
  //         text: "Inspirer les employés ŕ transformer les connaissances en produits et en services."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationExtremeLowDriverRecommendationDesc_3",
  //     text: "This can be done through casual meetings, allowing each employee to brainstorm and present their ideas in an informal matter. It is important to give them a comfortable space where they can speak up. Note their ideas down and discuss the same with them. They will feel valued, and the discussions will help provoke their thought process into creating something new.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يمكن القيام بذلك من خلال اجتماعات غير رسمية، مما يسمح لكل موظف بالعصف الذهني وتقديم أفكارهم بطريقة غير رسمية. ومن المهم منحهم مساحة مريحة حيث يمكنهم التحدث. ويمكن تدوين أفكارهم ومناقشتها معهم، وبذلك سيشعرون بالتقدير وستساعد المناقشات في تعزيز عملية التفكير لديهم لخلق شيء جديد. "
  //       },
  //       {
  //         language: "FR",
  //         text: "Cela peut se faire par le biais de réunions informelles, ce qui permet à chaque employé de réfléchir et de présenter ses idées de manière informelle. Il est important de leur donner un espace confortable où ils peuvent s'exprimer. Leurs idées peuvent être écrites et discutées avec eux, Ils se sentiront valorisés, et les discussions aideront à provoquer leur processus de pensée en créant quelque chose de nouveau."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationExtremeLowDriverRecommendationTitle_4",
  //     text: "Continuous innovation in the work environment.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "التجديد المستمر في بيئة العمل."
  //       },
  //       {
  //         language: "FR",
  //         text: "Innovation continue dans l'environnement de travail."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationExtremeLowDriverRecommendationDesc_4",
  //     text: "The work environment has a huge impact on creativity. Creating a flexible and comfortable workspace that does not resemble the design of the workplace but rather is closer to life outside the office can enhance creativity and inspires employees to create new innovative ideas and products.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "بيئة العمل لها تأثير كبير على الإبداع. حيث أن إنشاء مساحة للعمل، مرنة ومريحة ولا تشبه تصميم مكان العمل، بل تكون أقرب للحياة خارج المكتب، يمكن أن تعزز روح الإبداع ,تلهم الموظفين لابتكار أفكار ومنتجات جديدة."
  //       },
  //       {
  //         language: "FR",
  //         text: "L'environnement de travail a un impact énorme sur la créativité. L'environnement de travail a un impact énorme sur la créativité. Comme la création d'un espace de travail flexible et confortable ne ressemble pas à la conception du lieu de travail, mais est plutôt plus proche de la vie en dehors du bureau, elle peut renforcer l'esprit de créativité, incitant les employés à créer de nouvelles idées et de nouveaux produits."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationExtremeLowDriverOtherRecommendationHeader",
  //     text: "We also encourage the following initiatives and training programs to implement the aforementioned:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين عامل الابتكار:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationExtremeLowDriverOtherRecommendation_1",
  //     text: "Set annual budget for the required resources and enablers",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "وضع موازنة سنوية للموارد والممكنات المطلوبة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Établir un budget annuel pour les ressources et les catalyseurs nécessaires"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationExtremeLowDriverOtherRecommendation_2",
  //     text: "Resources management training programs",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برامج تدريب إدارة الموارد"
  //       },
  //       {
  //         language: "FR",
  //         text: "Programmes de formation en gestion des ressources"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationExtremeLowDriverOtherRecommendation_3",
  //     text: "Strategic Innovation Programs",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برامج الابتكار الاستراتيجي"
  //       },
  //       {
  //         language: "FR",
  //         text: "Programmes d'Innovation Stratégique"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationExtremeLowDriverOtherRecommendation_4",
  //     text: "Building a Culture of Innovation",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "بناء ثقافة الابتكار"
  //       },
  //       {
  //         language: "FR",
  //         text: "Construire une Culture de l'Innovation"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationExtremeLowDriverOtherRecommendation_5",
  //     text: "Workplace Diversity management Program",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برنامج إدارة التنوع في مكان العمل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Programme de gestion de la diversité en milieu de travail"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationLowDriverReadings",
  //     text: "These results indicate that the environment does not allow the employees to unleash creativity. When the Innovation driver is low, employees tend to refrain from transforming knowledge and ideas into new values and procedures.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير هذه النتائج أن بيئة العمل لا تسمح للموظفين بإطلاق العنان للإبداع. عندما يكون دافع الابتكار منخفضاً، يميل الموظفون إلى الامتناع عن تحويل المعرفة والأفكار إلى قيم وإجراءات جديدة."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ces résultats indiquent que l’environnement ne permet pas aux employés de libérer la créativité et ne leur donne pas assez d’espace pour être créatifs et innovateurs. Par conséquent, ils s’abstiennent d’élaborer des idées sur de nouvelles valeurs et procédures."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationModerateDriverReadings",
  //     text: "These results indicate that the environment gives the employees limited space to be creative and innovative in their work. Some of the employees feel like they can contribute to transforming ideas into new products and services, while some might need a little guidance and attention.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير هذه النتائج إلى أن بيئة العمل توفر مساحة محدودة للموظفين للإبداع والبتكار في العمل الذي يؤدونه، وبالتالي يشعر بعض الموظفين أنهم قادرون على المساهمة في تحويل الأفكار إلى قيم وإجراءات جديدة، بينما قد يحتاج البعض إلى القليل من التوجيه والاهتمام."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ces résultats indiquent que l'environnement donne aux employés un espace limité pour être créatifs et innovants dans leur travail. Ainsi, certains employés sentent qu'ils peuvent contribuer à transformer des idées en nouvelles valeurs et services, tandis que certains peuvent avoir besoin d'un peu de conseils et d'attention."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationModerateDriverRecommendationBrief",
  //     text: "These results may indicate potential vulnerabilities in the work environment in terms of not encouraging the employees enough to be more creative and innovative, which in turn affects employees' engagement. It is recommended to take immediate actions to motivate the employees to boost creativity. This can be done by accepting the ideas they propose and giving them space for improvement.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هذه النتائج قد تشير إلى وجود ضعف محتمل في بيئة العمل من حيث عدم تشجيع الموظفين بالشكل الكافي ليكونوا أكثر إبداعاً وابتكاراً والذي يؤثر بدوره على اندماج الموظفين. ويجب اتخاذ إجراءات فورية من خلال تحفيز الموظفين لتعزيز الإبداع. ويمكن القيام بذلك عن طريق قبول الأفكار التي يقترحونها ومنحهم مساحة كافية للتحسين."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ces résultats peuvent indiquer des vulnérabilités potentielles dans l'environnement de travail en termes de ne pas encourager suffisamment les employés à être plus créatifs et innovants, ce qui affecte à son tour l'engagement des employés. Il est recommandé de prendre des mesures immédiates pour motiver les employés à stimuler la créativité. Cela peut se faire en acceptant les idées qu’ils proposent et en leur donnant un espace d’amélioration."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationModerateDriverRecommendationPointHeader",
  //     text: "You can take the following actions. However, they are not limited to these options:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين هذا البُعد:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Vous pouvez prendre les mesures suivantes. Cependant, ils ne sont pas limités à ces options:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationModerateDriverRecommendationTitle_1",
  //     text: "Reallocate resources required for Innovation.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إعادة تخصيص الموارد المطلوبة للابتكار"
  //       },
  //       {
  //         language: "FR",
  //         text: "Réaffecter les ressources nécessaires ŕ l'innovation."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationModerateDriverRecommendationDesc_1",
  //     text: "The workplace may hold a lot more resources than you know. It is important to allocate these resources to their utmost efficiency to help drive Innovation from your employees and give them the access to those resources and encourage them to drive the change in the business.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قد يتوفر في مكان العمل موارد أكثر بكثير مما تعرف. ويجب تخصيص هذه الموارد بأقصى قدر من الكفاءة للمساعدة في دفع الابتكار، ومنح الموظفين إمكانية الوصول إلى هذه الموارد وتشجيعهم على قيادة التغيير في العمل."
  //       },
  //       {
  //         language: "FR",
  //         text: "Votre lieu de travail peut avoir beaucoup plus de ressources que vous ne savez pas. Il est important d’allouer ces ressources à leur plus grande efficacité pour aider à stimuler l’innovation de vos employés et leur donner accès à ces ressources et les encourager à conduire le changement dans l’entreprise."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationModerateDriverRecommendationTitle_2",
  //     text: "Team Diversity.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تنوع الفريق."
  //       },
  //       {
  //         language: "FR",
  //         text: "Diversité de l'Équipe."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationModerateDriverRecommendationDesc_2",
  //     text: "Building a diverse team with different experiences, skills, and thinking styles contributes to bringing new ideas that help educate individuals and develop their creative skills. This is reflected in providing a positive contribution to achieve business goals.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "بناء فريق متنوع بخبرات ومهارات وأنماط تفكير مختلفة، يسهم في جلب أفكار جديدة تساعد في تعليم الأفراد وتطوير مهاراتهم الإبداعية، وينعكس ذلك بتقديم مساهمة إيجابية ومشتركة لتحقيق أهداف العمل."
  //       },
  //       {
  //         language: "FR",
  //         text: "Construire une équipe diversifiée avec des expériences, des compétences et des styles de réflexion différents contribue à apporter de nouvelles idées qui aident à éduquer les individus et à développer leurs compétences créatives. Cela se traduit par une contribution positive à la réalisation des objectifs commerciaux."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationModerateDriverRecommendationTitle_3",
  //     text: "Motivate your employees to experiment with new ideas.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تحفيز الموظفين لتجربة أفكار جديدة."
  //       },
  //       {
  //         language: "FR",
  //         text: "Motivez vos employés ŕ expérimenter de nouvelles idées."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationModerateDriverRecommendationDesc_3",
  //     text: "One of the best ways to do this is to eliminate the fear of failure that your employees may have. Make it clear to the employees that some progress is better than no progress at all and ensure that they will have the support regardless of the result.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "واحدة من أفضل الطرق للقيام بذلك هي القضاء على الخوف من الفشل الذي قد يكون لدى الموظفين. ربما يخشون أن يتركوا انطباعاً سيئاً عند مسؤولهم المباشر إذا فعلوا شيئاً خاطئاً، لذلك قرروا عدم القيام به. يجب التوضيح للموظفين بأن بعض التقدم أفضل من عدم إحراز أي تقدم على الإطلاق، وضمان حصولهم على الدعم بغض النظر عن النتيجة. "
  //       },
  //       {
  //         language: "FR",
  //         text: "L'un des meilleurs moyens d'y parvenir est d'éliminer la peur de l'échec que vos employés peuvent avoir. Expliquer clairement aux employés que certains progrès valent mieux que pas de progrès du tout. Et pour s'assurer qu'ils reçoivent un soutien quel que soit le résultat."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationModerateDriverRecommendationTitle_4",
  //     text: "Avoid penalizing employees.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تجنب معاقبة الموظفين."
  //       },
  //       {
  //         language: "FR",
  //         text: "Éviter de punir les employés."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationModerateDriverRecommendationDesc_4",
  //     text: "Many superiors tend to punish or discipline their employees for making mistakes when experimenting with new ideas. This is not the way to go. The recommended course of action is to show them how they can learn from those mistakes and understand why the mistake was made by going over the steps taken and directing them on how to fix it and avoid it next time.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يميل العديد من المسؤولين المباشرين إلى معاقبة موظفيهم لارتكابهم أخطاء عند تجربة أفكار جديدة. هذه ليست الطريقة المناسبة للتعامل مع الأمر. الطريقة الموصى بها هي التوضيح لهم كيف يمكنهم التعلم من تلك الأخطاء، ومساعدتهم على فهم سبب حدوث الخطأ من خلال مراجعة الخطوات التي تم اتخاذها، وتوجيههم لإصلاحه وتجنبه في المرة القادمة. "
  //       },
  //       {
  //         language: "FR",
  //         text: "De nombreux supérieurs ont tendance à punir ou à discipliner leurs employés pour avoir commis des erreurs lorsqu'ils expérimentent de nouvelles idées. Ce n’est pas la voie à suivre. La marche à suivre recommandée est de leur montrer comment ils peuvent apprendre de ces erreurs et comprendre pourquoi l'erreur a été commise en passant en revue les mesures prises et en leur indiquant comment la corriger et l'éviter la prochaine fois."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationModerateDriverOtherRecommendationHeader",
  //     text: "We also encourage the following initiatives and training programs to implement the aforementioned:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين عامل الابتكار:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nous encourageons également les initiatives et les programmes de formation suivants à mettre en œuvre les mesures susmentionnées:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationModerateDriverOtherRecommendation_1",
  //     text: "Resources management skills programs",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برامج تدريب إدارة الموارد"
  //       },
  //       {
  //         language: "FR",
  //         text: "Programmes de formation en gestion des ressources"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationModerateDriverOtherRecommendation_2",
  //     text: "Strategic Innovation Programs",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برامج الابتكار الاستراتيجي"
  //       },
  //       {
  //         language: "FR",
  //         text: "Programmes d'Innovation Stratégique"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationModerateDriverOtherRecommendation_3",
  //     text: "Building a Culture of Innovation",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "بناء ثقافة الابتكار"
  //       },
  //       {
  //         language: "FR",
  //         text: "Construire une Culture de l'Innovation"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationModerateDriverOtherRecommendation_4",
  //     text: "Workplace Diversity management Program",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برنامج إدارة التنوع في مكان العمل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Programme de gestion de la diversité en milieu de travail"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationEngagedLowDriverReadings",
  //     text: "These results indicate that the work environment is somehow limiting the employees to be creative and innovative in the work they perform, leading to better performance. Thus, it enables the employees to transform ideas into new products and services.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير هذه النتائج إلى أن بيئة العمل تسمح للموظفين حد معين للإبداع في العمل الذي يؤدونه مما يؤدي إلى أداء أفضل، وبالتالي تمكين الموظفين من تحويل الأفكار إلى قيم وإجراءات جديدة. "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationHighDriverReadings",
  //     text: "These results indicate that the work environment gives space for its employees to unleash creativity into the work they perform, leading to better performance. Thus, it enables the employees to transform ideas into new products and services.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير هذه النتائج إلى أن بيئة العمل توفر مساحة للموظفين للإبداع في العمل الذي يؤدونه مما يؤدي إلى أداء أفضل، وبالتالي تمكين الموظفين من تحويل الأفكار إلى قيم وإجراءات جديدة."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ces résultats indiquent que l’environnement de travail donne à ses employés l’espace pour libérer la créativité dans le travail qu’ils exécutent, menant à une meilleure exécution. Ainsi, il permet aux employés de transformer les idées en nouveaux produits et services."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationHighDriverRecommendationBrief",
  //     text: "Innovation is considered one of the main strengths of the work environment. It plays a role in enhancing employees’ creativity and increasing productivity. It is recommended to continue providing a work environment that supports innovation and creativity by encouraging the employees to adopt new creative methods at work and nurturing the current innovative spirit that drives the employees to think out of the box to contribute to the development of the work and achieve the goals.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يُعدّ الابتكار أحد نقاط القوة الأساسية في بيئة العمل، لما له من دور في تعزيز إبداع الموظفين وزيادة إنتاجيتهم. ويوصى بالاستمرار في توفير بيئة عمل داعمة للابتكار والإبداع من خلال تشجيع الموظفين على تبني أساليب إبداعية جديدة في العمل، وتغذية روح الابتكار الحالية التي تدفع الموظفين إلى التفكير خارج الصندوق للمساهمة في تطوير العمل وتحقيق أهدافه."
  //       },
  //       {
  //         language: "FR",
  //         text: "L’innovation est considérée comme l’une des principales forces de l’environnement de travail. Il joue un rôle dans l’amélioration de la créativité et de la productivité des employés. Il est recommandé de continuer à offrir un milieu de travail qui favorise l’innovation et la créativité en encourageant les employés à adopter de nouvelles méthodes créatives au travail et en favorisant l’esprit d’innovation actuel qui pousse les employés à sortir des sentiers battus pour contribuer à la développement du travail et atteindre les objectifs."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationHighDriverRecommendationPointHeader",
  //     text: "",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: ""
  //       },
  //       {
  //         language: "FR",
  //         text: ""
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtInnovationExtremeHighDriverReadings",
  //     text: "These results indicate that the work environment is truly driven by innovation, where employees are consistently being supported to be creative in transforming knowledge and ideas into new products and services.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير هذه النتائج إلى أن بيئة العمل مهتمة بشكل كبير بالابتكار حيث يتم دعم الموظفين وإلهامهم باستمرار ليكونوا مبدعين في تحويل المعرفة والأفكار إلى قيم وإجراءات جديدة."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ces résultats indiquent que l'environnement de travail est vraiment axé sur l’innovation, où les employés sont constamment encouragés à faire preuve de créativité dans la transformation des connaissances et des idées en nouveaux produits et services."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationDriverDesc",
  //     text: "The positive relationship between Motivation and Engagement is measured by the reward and recognition programs offered to the employees. The employees who are rewarded and recognized for the excellent work they do; show an increase in their productivity and contribution to achieve business goals. Therefore, this type of employee must be retained for their effective role in improving the workplace environment and performance.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقاس العلاقة الإيجابية بين التحفيز واندماج الموظفين بالمكافآت وبرامج التقدير المقدمة للموظفين. فالموظفون الذين يتم مكافأتهم وتقديرهم على العمل الجيد الذي يقومون به، لديهم زيادة في الإنتاجية ويبذلون جهداً إضافياً لتحقيق أهداف العمل. وبالتالي يجب المحافظة على هذه الفئة من الموظفين لما لهم من دور فعال في تحسين بيئة وأداء العمل."
  //       },
  //       {
  //         language: "FR",
  //         text: "La relation positive entre la motivation et l'engagement est mesurée par les programmes de récompense et de reconnaissance offerts aux employés. Les employés récompensés et reconnus pour l'excellent travail qu'ils accomplissent; montrent une augmentation de leur productivité et de leur contribution à l'atteinte des objectifs commerciaux. Par conséquent, ce type d'employé doit être retenu pour son rôle efficace dans l'amélioration de l'environnement de travail et de la performance."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationExtremeLowDriverReadings",
  //     text: "This analysis demonstrates that your employees are demotivated and do not feel like doing the work expected of them. They are lowly engaged with their job, and they do not feel sufficiently appreciated and rewarded for their work, and they may look for opportunities in a better work environment.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج بأن الموظفين محبطون ولا يبدون أي رغبة في القيام بالعمل الموكل إليهم. وقد يكون السبب عدم شعورهم بالتقدير الكافي لأعمالهم ومكافأتهم عليها. وبالتالي هنالك احتمالية لجوئهم للبحث عن فرص في بيئة عمل أفضل."
  //       },
  //       {
  //         language: "FR",
  //         text: "Cette analyse démontre que vos employés sont démotivés et n'ont pas envie de faire le travail qu'on attend d'eux. Ils sont peu engagés dans leur travail et ne se sentent pas suffisamment appréciés et récompensés pour leur travail. Par conséquent, il est possible qu'ils recherchent des opportunités dans un meilleur environnement de travail."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationExtremeLowDriverRecommendationBrief",
  //     text: "These results may indicate a high degree of risk in the motivation and recognition programs, which in turn affects employees' engagement. It is recommended to take immediate and rapid actions to motivate your employees, reward them for their effort, and thus contribute to increase their productivity and achieve business goals.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج لوجود درجة عالية من الخطورة في برامج التحفيز والتقدير والتي تؤثر بدورها على اندماج الموظفين. ويجب اتخاذ إجراءات فورية وسريعة بتطبيق وتنفيذ برامج التقدير والمكافأة للموظفين لزيادة تحفيزهم والمساهمة في رفع إنتاجيتهم لتحقيق أهداف العمل."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ces résultats peuvent indiquer un degré élevé de risque dans les programmes de motivation et de reconnaissance, ce qui à son tour affecte l'engagement des employés. Il est recommandé de prendre des mesures immédiates et rapides pour motiver vos employés, les récompenser pour leurs efforts et ainsi contribuer à accroître leur productivité et à atteindre les objectifs de l’entreprise. Vous pouvez prendre les mesures suivantes pour améliorer la motivation. Cependant, ils ne sont pas limités à ces options:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationExtremeLowDriverRecommendationPointHeader",
  //     text: "You can take the following actions to improve motivation. However, they are not limited to these options:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين عامل التحفيز:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Vous pouvez prendre les mesures suivantes. Cependant, ils ne sont pas limités à ces options:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationExtremeLowDriverRecommendationTitle_1",
  //     text: "Recognize your employees' contribution and success.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقدير عمل الموظفين ومكافأتهم على جهدهم الإضافي."
  //       },
  //       {
  //         language: "FR",
  //         text: "Reconnaissez la contribution et le succčs de vos employés."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationExtremeLowDriverRecommendationDesc_1",
  //     text: "Employees tend to be more motivated and achieve better results when they know that they will be recognized for it. When they contribute something unexpected, thank them and let them know that they are always welcomed to do so. Congratulate them on their successes, even when it is not directly related to your company. Their success should be your success.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يميل الموظفون إلى العمل الجاد وتحقيق نتائج أفضل في حال تم تقدير عملهم ومكافأتهم لبذل مجهود إضافي. عندما يساهمون بشيء غير متوقع، يجب تقديرهم وثناءهم على قيامهم بذلك ويجب تهنئتهم على نجاحاتهم ولو لم تكن مرتبطة بشكل مباشر بالعمل. فنجاح الموظفين هو نجاح العمل."
  //       },
  //       {
  //         language: "FR",
  //         text: "Les employés ont tendance à être plus motivés et accomplir de meilleurs résultats quand ils savent qu'ils seront reconnus pour cela. Lorsqu'ils apportent quelque chose d'inattendu, remerciez-les et faites-leur savoir qu'ils sont toujours les bienvenus. Félicitez-les pour leurs succès, même lorsqu'ils ne sont pas directement liés à votre entreprise. Leur succès doit être votre succès."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationExtremeLowDriverRecommendationTitle_2",
  //     text: "Implement non-monetary recognition programs.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تطوير برامج التقدير غير النقدية."
  //       },
  //       {
  //         language: "FR",
  //         text: "Mettre en śuvre des programmes de reconnaissance non monétaire."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationExtremeLowDriverRecommendationDesc_2",
  //     text: "It is important to implement non-monetary recognition programs to praise employees’ efforts and motivate them to achieve the best. Examples of non-monetary recognition programs: Employee of the month, awards and appreciation certificates, work anniversaries celebration, and more.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "أهمية تطبيق برامج التقدير غير النقدية كثناء على جهد الموظفين المبذولة وتحفيزهم على إنجاز الأفضل. ومن هذه البرامج: برامج تقدير الموظفين (الموظف المبدع والموظف المثالي)، جوائز وشهادات تقديرية، احتفالات الذكرى السنوية للعمل، وغيرها."
  //       },
  //       {
  //         language: "FR",
  //         text: "Il est important de mettre en œuvre des programmes de reconnaissance non monétaire pour saluer les efforts des employés et les motiver à réaliser le meilleur. Exemples de programmes de reconnaissance non monétaire: L'employé du mois, prix et les certificats d'appréciation, la célébration d'anniversaires de travail et plus."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationExtremeLowDriverRecommendationTitle_3",
  //     text: "Reward your employees for that extra mile.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقديم مكافآت نقدية للموظفين."
  //       },
  //       {
  //         language: "FR",
  //         text: "Récompensez vos employés pour cet effort supplémentaire."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationExtremeLowDriverRecommendationDesc_3",
  //     text: "Rewards are considered one of the most important ways to motivate employees. Providing rewards to the employees is essential and highly recommended when introducing new ideas to improve work and achieve goals. You can reward them through salary increases, bonuses, commissions, paid training, and so much more.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تعد المكافآت من أهم الطرق التحفيزية للموظفين، ففي حال نجاح الموظفين في طرح أفكار جديدة هادفة إلى تحسين العمل ونجاحه، يصبح تقديم المكافأة أمر ضروري ليشعر الموظفين بأهمية ما قدموه وسيدفعهم لتقديم المزيد. ويمكن مكافأتهم من خلال زيادة الرواتب وحوافز سنوية وعمولات وغيرها."
  //       },
  //       {
  //         language: "FR",
  //         text: "Les récompenses sont considérées comme l'un des moyens les plus importants de motiver les employés. Offrir des récompenses aux employés est essentiel et fortement recommandé lors de l'introduction de nouvelles idées pour améliorer le travail et atteindre les objectifs. Vous pouvez les récompenser par des augmentations de salaire, des primes, des commissions, des formations rémunérées et bien plus encore."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationExtremeLowDriverRecommendationTitle_4",
  //     text: "Introduce team-building activities.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تطبيق أنشطة بناء الفريق."
  //       },
  //       {
  //         language: "FR",
  //         text: "Introduisez des activités de consolidation d'équipe."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationExtremeLowDriverRecommendationDesc_4",
  //     text: "Build a collaborative workplace, enhance team spirit by implementing team-building activities, and conduct workshops to improve employee engagement and collaboration and achieve work goals.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: " نشر ثقافة التعاون وروح الفريق في بيئة العمل من خلال تطبيق بعض أنشطة بناء الفريق وورش عمل مختلفة لما لها من أهمية في تعزيز الاندماج وتقديم التعاون لتحقيق الأهداف المشتركة. "
  //       },
  //       {
  //         language: "FR",
  //         text: "Créez un lieu de travail collaboratif, améliorez l'esprit d'équipe en mettant en œuvre des activités de consolidation d'équipe et organisez des ateliers pour améliorer l'engagement et la collaboration des employés et atteindre les objectifs de travail."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationExtremeLowDriverOtherRecommendationHeader",
  //     text: "We also encourage the following initiatives and training programs to implement the aforementioned:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ونشجع على البرامج التدريبية والمبادرات التالية لتنفيذ ما سبق ذكره:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nous encourageons également les initiatives et les programmes de formation suivants à mettre en œuvre les mesures susmentionnées:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationExtremeLowDriverOtherRecommendation_1",
  //     text: "Teamwork and team leadership training programs",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برامج تدريب العمل الجماعي وقيادة الفريق"
  //       },
  //       {
  //         language: "FR",
  //         text: "Des programmes de formation sur le travail d'équipe et le leadership d'équipe."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationExtremeLowDriverOtherRecommendation_2",
  //     text: "Compensation & Benefits Programs Development",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تطوير برامج التعويضات والمزايا"
  //       },
  //       {
  //         language: "FR",
  //         text: "Développement de programmes de rémunération et d'avantages sociaux."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationExtremeLowDriverOtherRecommendation_3",
  //     text: "Motivation and Recognition Programs Development",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تطوير برامج التقدير والتحفيز"
  //       },
  //       {
  //         language: "FR",
  //         text: "Développement de programmes de motivation et de reconnaissance."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationExtremeLowDriverOtherRecommendation_4",
  //     text: "Set plans for team-building activities",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "وضع خطط لأنشطة بناء وتعزيز روح الفريق"
  //       },
  //       {
  //         language: "FR",
  //         text: "Établir des plans pour les activités de consolidation d'équipe."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationLowDriverReadings",
  //     text: "This analysis demonstrates the fact that your employees are demotivated and only do the work expected from them. They seem to be lowly engaged with their job, and they do not feel sufficiently appreciated and rewarded for their work.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج بأن الموظفين محبطين وينجزون فقط ما يوكل إليهم من المهام بالحد الأدنى، ولا يظهرون أية دوافع للقيام بأكثر من ذلك. وقد يكون السبب عدم شعورهم بالتقدير الكافي لأعمالهم ومكافأتهم عليها."
  //       },
  //       {
  //         language: "FR",
  //         text: "Cette analyse démontre le fait que vos employés sont démotivés et ne font que le travail attendu d'eux. Et ils ne montrent aucune motivation pour faire plus que cela. La raison peut être qu'ils ne se sentent pas suffisamment appréciés et récompensés pour leur travail."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationModerateDriverReadings",
  //     text: "This analysis demonstrates that your employees are motivated enough to do what is expected of them. But there is a chance for better effort if they receive more appreciation and recognition for their work.\n  ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج بأن الموظفين لديهم الحد الأدنى من الحافز للقيام بما هو متوقع منهم، ولكن هنالك مجال لبذل مجهود أفضل في حال تم تقدير عملهم ومكافأتهم بشكل أكثر."
  //       },
  //       {
  //         language: "FR",
  //         text: "Cette analyse démontre que vos employés sont suffisamment motivés pour faire ce que l'on attend d'eux. Mais il y a une chance pour un meilleur effort s’ils reçoivent plus d’appréciation et de reconnaissance pour leur travail."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationModerateDriverRecommendationBrief",
  //     text: "These results may indicate potential vulnerabilities in the motivation and recognition programs, which in turn affects employees' engagement. It is recommended to take immediate actions to motivate your employees by recognizing their contribution and success.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هذه النتائج قد تشير إلى وجود ضعف محتمل في برامج التحفيز والتقدير والتي تؤثر بدورها على اندماج الموظفين. ويوصى هنا بإتخاذ إجراءات تهدف لتحفيز الموظفين بشكل أكبر من خلال تقدير جهودهم المبذولة ومكافأتهم على ذلك."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ces résultats peuvent indiquer des vulnérabilités potentielles dans les programmes de motivation et de reconnaissance, ce qui à son tour affecte l'engagement des employés. Il est recommandé de prendre des mesures immédiates pour motiver vos employés en reconnaissant leur contribution et leur réussite."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationModerateDriverRecommendationPointHeader",
  //     text: "You can take the following actions to improve motivation. However, they are not limited to these options:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين هذا البُعد:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Vous pouvez prendre les mesures suivantes pour améliorer la motivation. Cependant, ils ne sont pas limités à ces options:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationModerateDriverRecommendationTitle_1",
  //     text: "Implement attractive compensation programs.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تنفيذ برامج تعويضات جاذبة."
  //       },
  //       {
  //         language: "FR",
  //         text: "Mettre en śuvre des programmes de rémunération attrayants."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationModerateDriverRecommendationDesc_1",
  //     text: "One of many ways to motivate and retain your key talent is compensation programs. In addition to the wage your employees are receiving on a monthly basis, the allowances, benefits, annual incentives, and more are recommended to motivate them to achieve the desired success.\n  ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تعد برامج التعويضات إحدى أهم الطرق المتعددة لتحفيز المواهب والكفاءات والاحتفاظ بها. فبالإضافة للأجر الذي يتقاضاه الموظفون بشكل ثابت وشهري، ينصح بصرف بدلات، ومزايا، وحوافز سنوية لدفعهم لتقديم جهد أفضل لتحقيق النجاح المرجو."
  //       },
  //       {
  //         language: "FR",
  //         text: "Les programmes de rémunération sont l'une des nombreuses façons de motiver et de fidéliser vos talents clés. Outre le salaire que vos employés reçoivent chaque mois, les indemnités, avantages sociaux, primes annuelles, etc. sont recommandés pour les motiver à atteindre le succès souhaité."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationModerateDriverRecommendationTitle_2",
  //     text: "Convert your employees' tasks into small, measurable goals.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تحويل مهام الموظفين إلى أهداف صغيرة قابلة للقياس."
  //       },
  //       {
  //         language: "FR",
  //         text: "Transformez les tâches de vos employés en petits objectifs mesurables."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationModerateDriverRecommendationDesc_2",
  //     text: "Although employees may not always feel demotivated, they may think that their tasks exceed their capabilities and are challenging to accomplish. It is important to assist them and show them how to break tasks into smaller and easier tasks to achieve goals.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قد يشعر بعض الموظفين بأن ما يوكل إليهم من مهام تفوق قدراتهم ويصعب تنفيذها، ويجب في هذه الحالة توجيه الموظفين لطرق إتمامها والتعامل من خلال تجزئتها إلى مهام أصغر وبالتالي سهولة تنفيذها."
  //       },
  //       {
  //         language: "FR",
  //         text: "Bien que les employés ne se sentent pas toujours démotivés, ils peuvent penser que leurs tâches dépassent leurs capacités et sont difficiles à accomplir. Il est important de les aider et de leur montrer comment décomposer les tâches en tâches plus petites et plus faciles pour atteindre leurs objectifs."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationModerateDriverRecommendationTitle_3",
  //     text: "Celebrate the results your employees bring to you.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقدير النتائج التي يحققها الموظفين."
  //       },
  //       {
  //         language: "FR",
  //         text: "Célébrer les résultats que vos employés vous apportent."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationModerateDriverRecommendationDesc_3",
  //     text: "Pay attention to the work that they do and appreciate the effort that has been put into it. You can motivate them to \"keep up the good work.”\n  Motivation & recognition help in enhancing the overall team spirit and building a collaborative workplace where employees feel more committed to the work.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يجب تقدير العمل الذي يقوم به الموظفين والجهد الذي تم بذله لإتمامه وتحفيزهم لمواصلة العمل الجيد بكفاءة. فالتقدير يُعزز روح الفريق ويبني بيئة عمل متعاونة حيث يشعر الموظفون بمزيد من الالتزام تجاه العمل. "
  //       },
  //       {
  //         language: "FR",
  //         text: "Faites attention au travail qu'ils font et appréciez les efforts qui y ont été consacrés. Vous pouvez les motiver à continuer le bon travail. La motivation et la reconnaissance contribuent à renforcer l'esprit d'équipe général et à créer un lieu de travail collaboratif où les employés se sentent plus engagés dans le travail."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationModerateDriverRecommendationTitle_4",
  //     text: "Change of scenery.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تغيير مكان العمل."
  //       },
  //       {
  //         language: "FR",
  //         text: "Changement de lieu."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationModerateDriverRecommendationDesc_4",
  //     text: "Sometimes the office may feel a little pressuring to your employees, and a constricting and unchanging environment places a block on their performance. A change in place or working outside once in a while can help with mindfulness.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "في بعض الأحيان قد يشعر الموظفين ببعض الضغط بالعمل داخل المكتب، وتضع البيئة المقيدة وغير المتغيرة عائقاً أمام أدائهم. تغيير مكان العمل أو العمل بالخارج من حين لآخر يساعد في زيادة التركيز في العمل."
  //       },
  //       {
  //         language: "FR",
  //         text: "Parfois, le bureau peut ressentir un peu de pression sur vos employés, et un environnement contraignant et immuable bloque leur performance. Un changement de place ou un travail à l'extérieur de temps en temps peut aider à la pleine conscience."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationModerateDriverOtherRecommendationHeader",
  //     text: "We also encourage the following initiatives and training programs to implement the aforementioned:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ونشجع على البرامج التدريبية والمبادرات التالية لتنفيذ ما سبق ذكره:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nous encourageons également les initiatives et les programmes de formation suivants à mettre en œuvre les mesures susmentionnées:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationModerateDriverOtherRecommendation_1",
  //     text: "Teamwork and Team Leadership Training Programs",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برامج تدريب العمل الجماعي وقيادة الفريق"
  //       },
  //       {
  //         language: "FR",
  //         text: "Des programmes de formation sur le travail d'équipe et le leadership d'équipe."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationModerateDriverOtherRecommendation_2",
  //     text: "Compensation & Benefits Programs Development",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تطوير برامج التعويضات والمزايا"
  //       },
  //       {
  //         language: "FR",
  //         text: "Développement de programmes de rémunération et d'avantages sociaux."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationModerateDriverOtherRecommendation_3",
  //     text: "Motivation and Recognition Programs Development",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تطوير برامج التقدير والتحفيز"
  //       },
  //       {
  //         language: "FR",
  //         text: "Développement de programmes de motivation et de reconnaissance."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationModerateDriverOtherRecommendation_4",
  //     text: "Set plans for team-building activities",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "وضع خطط لأنشطة بناء وتعزيز روح الفريق"
  //       },
  //       {
  //         language: "FR",
  //         text: "Établir des plans pour les activités de consolidation d'équipe."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationEngagedLowDriverReadings",
  //     text: "The analysis demonstrates that your employees are motivated enough to do more than what is expected of them as you reward and recognize their work. But there is a chance for better effort if they receive more appreciation and recognition for their work.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج بأن الموظفين لديهم الحافز الكافي للقيام بأكثر مما هو متوقع منهم نتيجة لمكافئتهم على عملهم وتقديرهم. ولكن هنالك مجال لبذل مجهود أفضل في حال تم تقدير عملهم ومكافأتهم بشكل أكبر."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationHighDriverReadings",
  //     text: "The analysis demonstrates that your employees are motivated to do more than what is expected of them as you reward and recognize their work. And continuing to appreciate them will contribute to accomplishing more achievements and successes.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج بأن الموظفين لديهم الحافز للقيام بأكثر مما هو متوقع منهم نتيجة لمكافئتهم على عملهم وتقديرهم، واستمرارية تقديرهم ستسهم في تحقيق إنجازات ونجاحات أكثر."
  //       },
  //       {
  //         language: "FR",
  //         text: "L'analyse démontre que vos employés sont motivés à faire plus que ce que l'on attend d'eux lorsque vous récompensez et reconnaissez leur travail. Et continuer à les apprécier contribuera à accomplir plus de réalisations et de succès."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationHighDriverRecommendationBrief",
  //     text: "Your company is highly engaged in terms of Motivation. It is highly recommended to continue implementing the recognition and reward programs for the employees' efforts in accomplishing their work.\n  The attractive reward programs attract and retain top talents and increase their productivity to achieve business goals.\n  ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يتضح من النتائج بأن الاندماج الوظيفي المرتفع هنا نتيجة لتحفيز الموظفين وتقديرهم. ويوصى بالاستمرار بتطبيق وتنفيذ برامج التقدير والمكافأة للموظفين لجهودهم المبذولة وتحفيزهم. ويجدر بالذكر أن برامج المكافآت الجاذبة تسهم في استقطاب والمحافظة على المواهب والكفاءات ورفع إنتاجيتها وبالتالي المساهمة بتحقيق أهداف العمل."
  //       },
  //       {
  //         language: "FR",
  //         text: "Votre société est très engagée en termes de motivation. Il est fortement recommandé de continuer à mettre en œuvre les programmes de reconnaissance et de récompense pour les efforts déployés par les employés dans l’accomplissement de leur travail. Les programmes de récompense attrayants attirent et retiennent les meilleurs talents et augmentent leur productivité pour atteindre leurs objectifs d’affaires."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationHighDriverRecommendationPointHeader",
  //     text: "",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: ""
  //       },
  //       {
  //         language: "FR",
  //         text: ""
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMotivationExtremeHighDriverReadings",
  //     text: "The analysis demonstrates that your employees are driven to do more than what is expected of them as you reward and recognize their work. And thus, they will continue to outperform in the tasks given to them and to accomplish more achievements and successes.\n  ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج بأن الموظفين لديهم الدافع الكافي للقيام بأكثر مما هو متوقع منهم نتيجة لمكافئتهم على عملهم وتقديرهم المستمر، وبالتالي سيواصلون التفوق في المهام الموكلة إليهم وتحقيق إنجازات ونجاحات أكثر."
  //       },
  //       {
  //         language: "FR",
  //         text: "L'analyse démontre que vos employés sont motivés à faire plus que ce que l'on attend d'eux alors que vous récompensez et reconnaissez leur travail. Et ainsi, ils continueront de surpasser les tâches qui leur sont confiées et d'accomplir plus de réalisations et de succès."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceDriverDesc",
  //     text: "The positive relationship between Performance and Engagement is measured in terms of growth and learning. When employees feel like they can grow professionally and personally as well as develop in their workplace, they are more likely to engage and drive the level of performance to achieve business goals.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقاس العلاقة الإيجابية بين الأداء واندماج الموظفين بمستوى النمو والتعلم المقدمين للموظفين. فعندما يشعر الموظفون أنهم قادرون على النمو مهنياً وشخصياً بالإضافة إلى إمكانية تطورهم في مكان عملهم، فمن المرجح أن يقدموا مستويات أعلى من الأداء للمشاركة في إنجاز الأعمال والمهام لتحقيق أهداف العمل."
  //       },
  //       {
  //         language: "FR",
  //         text: "La relation positive entre la performance et l'engagement se mesure en termes de croissance et d'apprentissage. Lorsque les employés sentent qu'ils peuvent évoluer professionnellement et personnellement ainsi que se développer sur leur lieu de travail, ils sont plus susceptibles de s'engager et de stimuler le niveau de performance pour atteindre les objectifs de l'entreprise."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceExtremeLowDriverReadings",
  //     text: "These results indicate that the workplace is unable to generate enough productivity from the employees, and they may need more space and encouragement to grow. There may be some constraints to develop any skills to perform their tasks, which affects their performance and the workplace.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج إلى أن الموظفين لا يقدمون الحد الأدنى من مستوى الأداء المطلوب لإنجاز المهام والأعمال الموكلة، وبالتالي يشكلون عائقاً أمام تحقيق إنتاجية العمل المطلوبة، وقد تكون هناك بعض القيود التي لا تمكنهم من تطوير مهاراتهم مما يؤثر على أدائهم وإنتاجية العمل. وهذا دليل واضح على حاجة الموظفين الماسة للتوجيه والتدريب لتطورهم ونموهم مهنياً وشخصياً."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ces résultats indiquent que le milieu de travail n’est pas en mesure de générer une productivité suffisante de la part des employés qu'ils peuvent avoir besoin de plus d'espace et d'encouragements pour se développer.  Il peut y avoir certaines contraintes pour développer des compétences pour accomplir leurs tâches, ce qui affecte et le lieu de travail. "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceExtremeLowDriverRecommendationBrief",
  //     text: "These results may indicate a high degree of risk in the level of performance, which in turn affects employees' engagement. It is recommended to take immediate and rapid actions to encourage employees to learn new skills and gain knowledge to grow professionally and personally. Also provides the necessary training programs to fill the gap between the current level of performance and the desired level.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هذه النتائج قد تشير إلى وجود درجة عالية من الخطورة في مستوى الأداء الذي يؤثر بدوره على اندماج الموظفين. ويوصى هنا بضرورة تطبيق إجراءات فورية لتشجيع الموظفين على التعلم وكسب المهارات التي ستساعدهم على نموهم مهنياً وشخصياً. وضرورة تقديم برامج التدريب اللازمة لسد الفجوة بين مستوى الأداء الحالي والمستوى المنشود."
  //       },
  //       {
  //         language: "FR",
  //         text: "Parfois, le bureau peut ressentir un peu de pression sur vos employés, et un environnement contraignant et immuable bloque leur performance. Un changement de place ou un travail à l'extérieur de temps en temps peut aider à la pleine conscience."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceExtremeLowDriverRecommendationPointHeader",
  //     text: "The following actions need to be taken to improve. However, they are not limited to these options:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين هذا البُعد:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ces résultats peuvent indiquer un degré élevé de risque dans le niveau de performance, qui à son tour affecte l'engagement des employés. Il est recommandé de prendre des mesures immédiates et rapides pour encourager les employés à acquérir de nouvelles compétences et à acquérir des connaissances pour se développer professionnellement et personnellement. Fournit également les programmes de formation nécessaires pour combler l’écart entre le niveau actuel de rendement et le niveau souhaité."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceExtremeLowDriverRecommendationTitle_1",
  //     text: "Support the growth of employees professionally and personally.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "دعم نمو الموظفين مهنياً وشخصياً."
  //       },
  //       {
  //         language: "FR",
  //         text: "Soutenir la croissance des employés professionnellement et personnellement."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceExtremeLowDriverRecommendationDesc_1",
  //     text: "Employees' personal growth is just as important as their professional growth and plays a vital role in their performance. Therefore, employees must be encouraged to learn skills that can be used at work and off-work, which would give them a great sense of accomplishment. Those skills may include persuasion, negotiation, budgeting, and more.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لا يقل النمو الشخصي للموظفين أهمية عن نموهم المهني ويلعب دوراً حيوياً في أدائهم. و يجب تشجيع الموظفين على تعلم المهارات التي يمكنهم استخدامها في العمل وخارجه، مما يمنحهم إحساساً كبيراً بالإنجاز. قد تشمل هذه المهارات: مهارات التعامل مع الآخرين، مهارات المفاوضة والإقناع، مهارات الابتكار، وغيرها."
  //       },
  //       {
  //         language: "FR",
  //         text: "La croissance personnelle des employés est tout aussi importante que leur croissance professionnelle et joue un rôle essentiel dans leur performance. Les employés doivent être encouragés à acquérir des compétences qui peuvent être utilisées au travail et en dehors du travail, ce qui leur donnerait un grand sentiment d’accomplissement. Ces compétences peuvent inclure la persuasion, la négociation, la budgétisation, etc."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceExtremeLowDriverRecommendationTitle_2",
  //     text: "Provide necessary training needed in specific roles.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "توفير التدريب اللازم في أدوار محددة."
  //       },
  //       {
  //         language: "FR",
  //         text: "Fournir la formation nécessaire dans des rôles spécifiques."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceExtremeLowDriverRecommendationDesc_2",
  //     text: "It is important to recognize the fact that different training programs are created for different purposes, and they should not apply to all employees in general. Instead, have employees in specific roles get the training they need to perform well in their field rather than wasting resources on training them for something they may not find useful, motivating, or have the ability to use in their field.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يجب إدراك حقيقة أن برامج التدريب المختلفة يتم إنشاؤها لأغراض مختلفة، ولا ينبغي أن تنطبق على جميع الموظفين بشكل عام. وعليه، يجب توفير برامج التدريب بحسب حاجة الموظفين لتقديم أداء جيد في مجالهم بدلاً من إهدار الموارد في تدريبهم على مهارات غير مفيدة ولا يمكن استخدامها وتطبيقها في مجال عملهم."
  //       },
  //       {
  //         language: "FR",
  //         text: "Il est important de reconnaître le fait que différents programmes de formation sont créés à des fins différentes et qu’ils ne devraient pas s’appliquer à tous les employés en général. Demandez plutôt aux employés occupant des rôles spécifiques d'obtenir la formation dont ils ont besoin pour bien performer dans leur domaine plutôt que de gaspiller des ressources sur leur formation pour quelque chose qu’ils peuvent ne pas trouver utile, motivant, ou qu'ils n'ont pas la capacité d'utiliser dans leur domaine."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceExtremeLowDriverRecommendationTitle_3",
  //     text: "Make learning and development a part of the mission.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "دعم التعليم والتطوير ليصبح جزءاً من مهمة العمل."
  //       },
  //       {
  //         language: "FR",
  //         text: "Faire de l’apprentissage et du développement une partie de la mission."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceExtremeLowDriverRecommendationDesc_3",
  //     text: "It is very important to make learning and development part of the business mission and goals and one of the top priorities by developing policies and procedures that ensure training and development opportunities for employees' career progression. The investment in the development of Human capital will lead to productive results that will help in achieving the business mission.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "من المهم جداً، جعل التعلم والتطور جزء من أهداف ومهمة العمل و إحدى أولوياته، وذلك من خلال تطوير السياسات والإجراءات التي تضمن توفير فرص تدريب وتطوير للموظفين وبالتالي تقدمهم مهنياً. فرأس المال البشري والاستثمار في تنميته سيؤديان إلى نتائج مثمرة تساعد في تحقيق الأهداف المرجوة."
  //       },
  //       {
  //         language: "FR",
  //         text: "Il est très important de faire de l’apprentissage et du perfectionnement une partie de la mission et des objectifs de l’entreprise et l’une des principales priorités en élaborant des politiques et des procédures qui garantissent des opportunités de formation et de développement pour la progression de carrière des employés. L’investissement dans le développement du capital humain conduira à des résultats productifs qui aideront à atteindre la mission d’affaires."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceExtremeLowDriverRecommendationTitle_4",
  //     text: "Provide good opportunities for career progression.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "توفير فرص جيدة للتقدم الوظيفي."
  //       },
  //       {
  //         language: "FR",
  //         text: "Fournir de bonnes opportunités ŕ la progression de carričre."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceExtremeLowDriverRecommendationDesc_4",
  //     text: "Career progression plans must be implemented for the employees and communicated with them. The employee should be directed and mentored by conducting different evaluations to improve their performance and enhance work productivity.\n  ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يجب تطبيق خطط للتقدم الوظيفي ومشاركتها مع الموظفين. ويجب توجيه وإرشاد الموظفين من خلال التقييمات والتي بدورها تعتبر وسيلة متميزة لتحسين أدائهم وتعزيز إنتاجيتتهم في العمل. "
  //       },
  //       {
  //         language: "FR",
  //         text: "Les plans de progression de carrière doivent être mis en œuvre pour les employés et communiqués avec eux. L'employé doit être dirigé et encadré en effectuant différentes évaluations pour améliorer ses performances et accroître sa productivité au travail."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceExtremeLowDriverOtherRecommendationHeader",
  //     text: "We also encourage the following initiatives and training programs to implement the aforementioned:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين عامل الأداء:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nous encourageons également les initiatives et les programmes de formation suivants à mettre en œuvre les mesures susmentionnées:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceExtremeLowDriverOtherRecommendation_1",
  //     text: "Prepare career development plans",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "وضع خطط واضحة للتطور الوظيفي"
  //       },
  //       {
  //         language: "FR",
  //         text: "Préparer des plans de développement de carričre"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceExtremeLowDriverOtherRecommendation_2",
  //     text: "Prepare training plans and the personal development plans",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "وضع خطة التدريب السنوية بالإضافة إلى خطط التطوير الفردي للموظفين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Préparer les plans de formation et les plans de développement personnel"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceExtremeLowDriverOtherRecommendation_3",
  //     text: "Set annual budget for training and development",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "وضع موازنة سنوية للتدريب والتطوير"
  //       },
  //       {
  //         language: "FR",
  //         text: "Établir un budget annuel pour la formation et le développement"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceExtremeLowDriverOtherRecommendation_4",
  //     text: "Performance Framework Development",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تطوير برامج تقييم الأداء"
  //       },
  //       {
  //         language: "FR",
  //         text: "Développement du cadre de performance"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceExtremeLowDriverOtherRecommendation_5",
  //     text: "Conduct 360-degree Assessment",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تطبيق تقييم 360°"
  //       },
  //       {
  //         language: "FR",
  //         text: "Effectuer une évaluation ŕ 360 degrés"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceExtremeLowDriverOtherRecommendation_6",
  //     text: "Building and Managing Teams Training Programs",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برامج تدريبة لبناء وإدارة فريق العمل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Création et gestion des programmes de formation des équipes"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceExtremeLowDriverOtherRecommendation_7",
  //     text: "Review and upgrade the automation systems",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مراجعة وتحديث أنظمة الأتمتة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Examiner et mettre ŕ niveau les systčmes d’automatisation"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceLowDriverReadings",
  //     text: "The results indicate that employees are not providing a sufficient level of performance in completing the assigned activities and tasks, and thus they do not contribute to achieving work productivity at the minimum required level. This indicates that the employees may need continuous assistance and more encouragement to grow and develop professionally and personally.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج إلى أن الموظفين لا يقدمون المستوى الكافي من الأداء في إنجاز المهام والأعمال الموكلة، وبالتالي لا يسهمون في تحقيق إنتاجية العمل بالدرجة المطلوبة. وهذا دليل على حاجة الموظفين للدعم المستمر والمساعدة في عملهم من خلال التوجيه والتدريب اللازمين لتطورهم ونموهم مهنياً وشخصياً."
  //       },
  //       {
  //         language: "FR",
  //         text: "Les résultats indiquent que les employés n’offrent pas un niveau de rendement suffisant pour accomplir les activités et les tâches assignées et qu’ils ne contribuent donc pas à atteindre la productivité au travail au niveau minimum requis. Cela indique que les employés peuvent avoir besoin d'une assistance continue et de plus d'encouragements pour grandir et se développer professionnellement et personnellement."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceModerateDriverReadings",
  //     text: "The results indicate that employees are providing an average level of performance in completing the assigned activities and tasks, and thus they contribute to achieving work productivity at the minimum required level. This indicates that the employees may need more guidance and training to complete their work.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج إلى أن الموظفين يقدمون مستوى معتدل من الأداء في إنجاز المهام والأعمال الموكلة، وبالتالي يسهمون في تحقيق إنتاجية العمل بالدرجة المطلوبة بالحد الأدنى. وقد يشير ذلك إلى حاجة الموظفين إلى مزيد من المساعدة في عملهم من خلال التوجيه والتدريب اللازمين لإتمام أعمالهم."
  //       },
  //       {
  //         language: "FR",
  //         text: "Les résultats indiquent que les employés fournissent un niveau de performance moyen dans l'accomplissement des activités et des tâches assignées et contribuent ainsi à atteindre la productivité du travail au niveau minimum requis. Cela indique que les employés peuvent avoir besoin de plus de conseils et de formation pour accomplir leur travail."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceModerateDriverRecommendationBrief",
  //     text: "These results may indicate potential vulnerabilities in the level of performance, which in turn affects employees' engagement. It is recommended to take immediate actions to encourage employees to learn new skills and gain knowledge that will help them grown professionally and personally. As well as providing the necessary training programs to fill the gap between the current level of performance and the desired level.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هذه النتائج قد تشير إلى وجود ضعف محتمل في مستوى الأداء الذي يؤثر بدوره على اندماج الموظفين. ويوصى هنا بأهمية تطبيق إجراءات لتشجيع الموظفين على التعلم وكسب المهارات التي ستساعدهم على نموهم مهنياً وشخصياً، وتقديم برامج التدريب اللازمة لسد الفجوة بين مستوى الأداء الحالي والمستوى المنشود."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ces résultats peuvent indiquer des vulnérabilités potentielles dans le niveau de performance, ce qui à son tour affecte l'engagement des employés. Il est recommandé de prendre des mesures immédiates pour encourager les employés à acquérir de nouvelles compétences et à acquérir des connaissances qui les aideront à acquérir des compétences professionnelles et personnelles. En plus de fournir les programmes de formation nécessaires pour combler l’écart entre le niveau actuel de rendement et le niveau souhaité."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceModerateDriverRecommendationPointHeader",
  //     text: "The following actions can be taken to improve this driver. However, they are not limited to these options:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين هذا البُعد:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ces résultats peuvent indiquer un degré élevé de risque dans le niveau de performance, qui à son tour affecte l'engagement des employés. Il est recommandé de prendre des mesures immédiates et rapides pour encourager les employés à acquérir de nouvelles compétences et à acquérir des connaissances pour se développer professionnellement et personnellement. Fournit également les programmes de formation nécessaires pour combler l’écart entre le niveau actuel de rendement et le niveau souhaité."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceModerateDriverRecommendationTitle_1",
  //     text: "Knowledge transfer.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مشاركة العلم والخبرات."
  //       },
  //       {
  //         language: "FR",
  //         text: "Le Transfert de Connaissances."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceModerateDriverRecommendationDesc_1",
  //     text: "It is the superior’s responsibility to instill the inspiration to learn and grow within the employees. Through experience and expertise, employees can be guided and helped through similar situations to improve their performance. Leaders that possess leadership skills provide a positive, supportive environment that contributes to raising employee productivity and loyalty.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقع على عاتق المدراء مسؤولية غرس الإلهام للتعلم والتطور في الموظفين. فمن خلال الخبرات والتجارب يمكن توجيه الموظفين ومساعدتهم لتحسين أدائهم وزيادة إنتاجيتهم. فالقادة الفاعلون الذين يمتلكون مهارات القيادة، يوفرون بيئة عمل إيجابية داعمة يسهمون في رفع إنتاجية الموظفين وولائهم."
  //       },
  //       {
  //         language: "FR",
  //         text: "C'est la responsabilité d’inspirer les employés à apprendre et à s’épanouir. Grâce à l’expérience et à l’expertise, les employés peuvent être guidés et aidés dans des situations semblables pour améliorer leur performance. Les leaders qui possèdent des compétences en leadership offrent un environnement positif et favorable qui contribue à accroître la productivité et la loyauté des employés."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceModerateDriverRecommendationTitle_2",
  //     text: "Have consistent performance appraisals.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقييم أداء الموظفين بشكل مستمر."
  //       },
  //       {
  //         language: "FR",
  //         text: "Avoir des évaluations de performance cohérentes."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceModerateDriverRecommendationDesc_2",
  //     text: "It is very important to conduct the performance evaluation programs on a regular basis to identify employees' hidden strengths and weaknesses and accordingly decide the required training programs to improve their skills and competencies that affect work productivity—examples on evaluation programs: 360-degree feedback, performance appraisal, and management by objectives.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "من المهم جداً العمل على تقييم أداء الموظفين بشكل دوري لتحديد نقاط قوتهم الغير مستغلة ونقاط ضعفهم، وبالتالي تحضير برامج التدريب اللازمة لتحسين مهاراتهم وكفاءتهم التي تؤثر على إنتاجية العمل. ومن الأمثلة على برامج التقييم: التقييم 360°، وتقييم أداء الموظفين، والإدارة بالأهداف."
  //       },
  //       {
  //         language: "FR",
  //         text: "Il est très important de mener régulièrement des programmes d'évaluation des performances pour identifier les forces et faiblesses cachées des employés et décider en conséquence des programmes de formation nécessaires pour améliorer leurs aptitudes et compétences qui affectent la productivité du travail - exemples sur les programmes d'évaluation: rétroaction à 360 degrés, évaluation des performances et gestion par objectifs."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceModerateDriverRecommendationTitle_3",
  //     text: "Utilize the right technology.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "استخدام التكنولوجيا المناسبة."
  //       },
  //       {
  //         language: "FR",
  //         text: "Utiliser la Technologie appropriée."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceModerateDriverRecommendationDesc_3",
  //     text: "Learning at work does not only come through doing things manually and from others' experiences. In addition to that, employees should learn how to utilize technology, systems, and applications that help them to do their work. It is important to provide employees with those resources.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لا يأتي التعلم في العمل فقط من خلال القيام بالأشياء يدوياً ومن تجارب الآخرين. بالإضافة إلى ذلك، يجب أن يتعلم الموظفون كيفية الاستفادة من التكنولوجيا والأنظمة والتطبيقات التي تساعدهم على القيام بعملهم. ومن المهم تزويد الموظفين بالمصادر اللازمة لذلك."
  //       },
  //       {
  //         language: "FR",
  //         text: "L'apprentissage au travail ne passe pas seulement par le fait de faire les choses manuellement et de l'expérience des autres. En outre, les employés devraient apprendre à utiliser la technologie, les systèmes et les applications qui les aident à faire leur travail. Il est important de fournir ces ressources aux employés."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceModerateDriverRecommendationTitle_4",
  //     text: "Invest in learning and development.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الاستثمار في التعلم والتطوير."
  //       },
  //       {
  //         language: "FR",
  //         text: "Investissez dans l'apprentissage et le développement."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceModerateDriverRecommendationDesc_4",
  //     text: "It is imperative to provide employees with the opportunity to upgrade their current knowledge and skills to improve their performance. One of the best ways to do that is by providing on-site classes for the employees, workshops, or even online training courses.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "من الضروري منح الموظفين الفرص الكافية لتطوير مهاراتهم الحالية واكتساب مهارات ومعارف جديدة لتحسين أدائهم. ومن أفضل الطرق للقيام بذلك هي توفير جلسة تبادل المعرفة، وورش عمل، وحضور دورات تدريبية عبر الإنترنت."
  //       },
  //       {
  //         language: "FR",
  //         text: "Il est impératif d'offrir aux employés la possibilité de mettre à niveau leurs connaissances et compétences actuelles pour améliorer leurs performances. L’une des meilleures façons de le faire est d’offrir des cours sur place aux employés, des ateliers ou même des cours de formation en ligne."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceModerateDriverOtherRecommendationHeader",
  //     text: "We also encourage the following initiatives and training programs to implement the aforementioned:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين عامل الأداء:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nous encourageons également les initiatives et les programmes de formation suivants à mettre en œuvre les mesures susmentionnées:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceModerateDriverOtherRecommendation_1",
  //     text: "Managerial and Supervisory Skills",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برامج تطوير المهارات الإدارية والإشرافية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Les Compétences de Gestion et de Supervision"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceModerateDriverOtherRecommendation_2",
  //     text: "How to Train your Employee Program",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برنامج \"كيف تدرب الموظف الخاص بك؟\""
  //       },
  //       {
  //         language: "FR",
  //         text: "Comment former votre programme d'employés"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceModerateDriverOtherRecommendation_3",
  //     text: "Performance Framework Development",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تطوير برامج تقييم الأداء"
  //       },
  //       {
  //         language: "FR",
  //         text: "Développement du cadre de performance"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceModerateDriverOtherRecommendation_4",
  //     text: "Conduct 360-degree Assessment",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تطبيق تقييم 360°"
  //       },
  //       {
  //         language: "FR",
  //         text: "Effectuer une évaluation ŕ 360 degrés"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceModerateDriverOtherRecommendation_5",
  //     text: "Building and Managing Teams Training Programs",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برامج تدريبة لبناء وإدارة فريق العمل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Création et gestion des programmes de formation des équipes"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceModerateDriverOtherRecommendation_6",
  //     text: "Review and upgrade the automation systems",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مراجعة أنظمة الأتمتة وسبل تطويرها"
  //       },
  //       {
  //         language: "FR",
  //         text: "Examiner et mettre ŕ niveau les systčmes d’automatisation"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceModerateDriverOtherRecommendation_7",
  //     text: "Set annual budget for training and development",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "وضع موازنة سنوية للتدريب والتطوير"
  //       },
  //       {
  //         language: "FR",
  //         text: "Établir un budget annuel pour la formation et le développement"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceEngagedLowDriverReadings",
  //     text: "The results indicate that employees are providing above average level of performance in completing the assigned activities and tasks. Thus they contribute to achieving work productivity at a somewhat satisfactory level by allowing them to develop and grow in their job through specific training and clear directions. This indicates that the employees are always learning new skills and gaining knowledge.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج إلى أن الموظفين يقدمون مستوى فوق المتوسط من الأداء في إنجاز المهام والأعمال الموكلة، وبالتالي يسهمون في تحقيق إنتاجية العمل بدرجة مرضية، وذلك نتيجة لتوافر فرص التعلم والتطور للموظفين من خلال برامج التدريب المميزة والمرتبطة بتوجيهات واضحة نحو النمو والتطور. وهذا دليل على تطور مهارات الموظفين واكتسابهم المعرفة المطلوبة"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceHighDriverReadings",
  //     text: "The results indicate that employees are providing a high level of performance in completing the assigned activities and tasks to achieve work productivity at a satisfactory high level by allowing them to develop and grow in their job through specific training and clear directions. This indicates that the employees are always learning new skills and gaining knowledge.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج إلى أن الموظفين يقدمون مستوى جيد من الأداء في إنجاز المهام والأعمال الموكلة، وبالتالي يسهمون في تحقيق إنتاجية العمل بدرجة مرضية، وذلك نتيجة لتوافر فرص التعلم والتطور للموظفين من خلال برامج التدريب المميزة والمرتبطة بتوجيهات واضحة نحو النمو والتطور. وهذا دليل على تطور مهارات الموظفين واكتسابهم المعرفة المطلوبة."
  //       },
  //       {
  //         language: "FR",
  //         text: "Les résultats indiquent que les employés fournissent un bon niveau de performance dans l'accomplissement des activités et tâches assignées, et contribuent ainsi à atteindre une productivité du travail à un niveau satisfaisant en leur permettant de se développer et d'évoluer dans leur travail grâce à une formation spécifique et des orientations claires. Cela indique que les employés apprennent toujours de nouvelles compétences et acquièrent des connaissances."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceHighDriverRecommendationBrief",
  //     text: "It is evident that the workplace has great opportunities to engage its employees by maintaining performance levels. It is recommended to continue to inspire the employees to consistently learn new skills and gain knowledge that will help them grow professionally and personally and provide them with good opportunities for career progression and provide the necessary training they require in their role. Keep investing in employees' learning and development to build a supportive environment that contributes to employee engagement and business success.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هنالك فرصة كبيرة لبيئة العمل لتحسين اندماج الموظفين من خلال المحافظة على مستوى الأداء. ويوصى بالاستمرار في تشجيع الموظفين لتعلم وكسب مهارات جديدة التي ستساعدهم على نموهم مهنياً وشخصياً، وتوفير فرصاً جيدة للتقدم الوظيفي وتقديم برامج التدريب اللازمة. ومن المهم مراعاة أن الاستثمار في تعليم الموظفين وتطويرهم، لها دور كبير في بناء بيئة داعمة تسهم في زيادة اندماج الموظفين، وبالتالي نجاح الأعمال."
  //       },
  //       {
  //         language: "FR",
  //         text: "Les résultats indiquent que les employés fournissent un bon niveau de performance dans l'accomplissement des activités et tâches assignées, et contribuent ainsi à atteindre une productivité du travail à un niveau satisfaisant en leur permettant de se développer et d'évoluer dans leur travail grâce à une formation spécifique et des orientations claires. Cela indique que les employés apprennent toujours de nouvelles compétences et acquièrent des connaissances."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceHighDriverRecommendationPointHeader",
  //     text: "",
  //     translations: [
  //       {
  //         language: "AR"
  //       },
  //       {
  //         language: "FR",
  //         text: ""
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPerformanceExtremeHighDriverReadings",
  //     text: "The results indicate that employees are providing a high level of performance in completing the assigned activities and tasks, and thus they contribute to achieving work productivity at a satisfactory high level by allowing them to develop and grow in their job through specific training and clear directions. This indicates that the employees are always learning new skills and gaining knowledge.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج إلى أن الموظفين يقدمون مستوى عال من الأداء في إنجاز المهام والأعمال الموكلة، وبالتالي يسهمون في تحقيق إنتاجية العمل بدرجة مرضية جداً، وذلك نتيجة لتوافر فرص التعلم والتطور للموظفين من خلال برامج التدريب المميزة والمرتبطة بتوجيهات واضحة نحو النمو والتطور. وهذا دليل على تطور مهارات الموظفين واكتسابهم المعرفة بشكل مستمر."
  //       },
  //       {
  //         language: "FR",
  //         text: "Les résultats indiquent que les employés fournissent un bon niveau de performance dans l'accomplissement des activités et tâches assignées, et contribuent ainsi à atteindre une productivité du travail à un niveau satisfaisant en leur permettant de se développer et d'évoluer dans leur travail grâce à une formation spécifique et des orientations claires. Cela indique que les employés apprennent toujours de nouvelles compétences et acquièrent des connaissances."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyDriverDesc",
  //     text: "Autonomy holds a constructive relation with engagement in terms of empowerment and enablement. Employees who tend to feel empowered to participate in work activities and contribute ideas tend to yield a higher engagement level in the workplace.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هنالك علاقة بناءة بين الاستقلالية والاندماج الوظيفي من حيث التمكين والتفويض. حيث يميل الموظفون الذين يشعرون بالتمكين وحرية التصرف في العمل للمشاركة في الأنشطة المتاحة، بالإضافة للمساهمة في تقديم أفكار لتحقيق مستوى أعلى من الاندماج الوظيفي."
  //       },
  //       {
  //         language: "FR",
  //         text: "L'autonomie entretient une relation constructive avec l'engagement en termes d'autonomisation et d'habilitation. Les employés qui ont tendance à se sentir habilités à participer aux activités de travail et à apporter des idées ont tendance à générer un niveau d'engagement plus élevé sur le lieu de travail."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyExtremeLowDriverReadings",
  //     text: "The analysis demonstrates that the work environment does not provide its employees with any level of autonomy and flexibility in their work, and that may happen because they do not have access to the enablers [tools, materials, and equipment] that they need to get their job done. It may require providing more activities for the employees and encouraging them to participate in.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج إلى أن بيئة العمل لا تمنح الموظفين استقلالية ومرونة في عملهم. وقد يكون السبب هو عدم توفير الممكنات من الأدوات والمواد والمعدات التي قد يحتاجها الموظفين لإنجاز مهامهم. ويجب توفير أنشطة مختلفة وتشجيع الموظفين للمشاركة فيها."
  //       },
  //       {
  //         language: "FR",
  //         text: "L'analyse démontre que l'environnement de travail n'offre à ses employés aucun niveau d'autonomie et de flexibilité dans leur travail, et cela peut se produire parce qu'ils n'ont pas accès aux facilitateurs [outils, matériaux et équipements] dont ils ont besoin pour obtenir leur travail accompli. Cela peut nécessiter d'offrir plus d'activités aux employés et de les encourager à y participer."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyExtremeLowDriverRecommendationBrief",
  //     text: "These results may indicate a high degree of risk in the autonomy level granted in the workplace, which in turn affects employees’ engagement. It is recommended to take immediate and rapid actions to provide the employees with the minimum level of flexibility required to complete their work. Additionally, start trusting them and allowing them to be involved in decisions that affect their job.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هذه النتائج قد تشير إلى وجود درجة عالية من الخطورة في مستوى الاستقلالية الممنوحة في بيئة العمل والذي يؤثر بدوره على اندماج الموظفين. ويوصى هنا بضرورة تطبيق إجراءات فورية لمنح الموظفين الحد الأدنى من الاستقلالية المطلوبة لقيامهم بأعمالهم. ويجب إظهار الثقة في الموظفين والسماح لهم بالمشاركة في اتخاذ القرارات التي تؤثر على أعمالهم."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ces résultats peuvent indiquer un degré élevé de risque dans le niveau d’autonomie accordé sur le lieu de travail, ce qui à son tour affecte l’engagement des employés. Il est recommandé de prendre des mesures immédiates et rapides pour offrir aux employés le niveau minimum de flexibilité requis pour terminer leur travail. De plus, commencez à leur faire confiance et à leur permettre de participer à des décisions qui affectent leur travail."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyExtremeLowDriverRecommendationPointHeader",
  //     text: "The following actions can be taken to improve autonomy. However, they are not limited to these options:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين هذا البُعد:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Les actions suivantes peuvent être prises pour améliorer l'autonomie. Cependant, ils ne sont pas limités à ces options:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyExtremeLowDriverRecommendationTitle_1",
  //     text: "Enhance workplace autonomy.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "توفير الاستقلالية."
  //       },
  //       {
  //         language: "FR",
  //         text: "Améliorer l'autonomie au travail."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyExtremeLowDriverRecommendationDesc_1",
  //     text: "Provide the employees with the required flexibility in their job has a great impact on the work environment. It makes them feel the confidence given and motivates them to take responsibility and show their potential powers and creativity to accomplish their tasks efficiently and effectively.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "منح الموظفين جزء من الاستقلالية لديه أثر كبير في بيئة العمل، حيث يشعرهم بالثقة الممنوحة ويحفزهم لتحمل المسؤولية وإظهار طاقاتهم الكامنة وإبداعاتهم نحو العمل وإنجازهم لمهامهم بكفاءة وفعالية عالية."
  //       },
  //       {
  //         language: "FR",
  //         text: "Offrir aux employés la flexibilité requise dans leur travail a un grand impact sur l'environnement de travail. Cela leur fait ressentir la confiance qui leur est donnée et les motive à assumer leurs responsabilités et à montrer leurs pouvoirs potentiels et leur créativité pour accomplir leurs tâches de manière efficace et efficiente."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyExtremeLowDriverRecommendationTitle_2",
  //     text: "Allow employees to be involved in the decision-making process.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "منح الموظفين فرصة المشاركة في صنع القرار."
  //       },
  //       {
  //         language: "FR",
  //         text: "Permettre aux employés d'ętre impliqués dans le processus de prise de décision."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyExtremeLowDriverRecommendationDesc_2",
  //     text: "It is important to involve the employees in the decision-making process as it directly impacts their jobs. This strategy has various benefits, the most important of which are motivation, raising their spirits, sense of responsibility, and increasing productivity. Additionally, it is possible to get benefit from their previous experiences in solving some problems.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إشراك الموظفين بعملية صنع القرار أمر هام للغاية، لما له من أثر مباشر على وظائفهم. ولهذه الاستراتيجية منافع أهمها تحفيزهم ورفع معنوياتهم، وتنمية شعورهم بالمسؤولية، وزيادة الإنتاجية. كما يمكن الاستفادة من خبرات الموظفين وتجاربهم في حل بعض المشاكل."
  //       },
  //       {
  //         language: "FR",
  //         text: "Il est important d'impliquer les employés dans le processus de prise de décision car cela a un impact direct sur leur travail. Cette stratégie a divers avantages, dont les plus importants sont la motivation, l’élévation du moral, le sens des responsabilités et l’augmentation de la productivité. En outre, il est possible de tirer profit de leurs expériences antérieures dans la résolution de certains problèmes."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyExtremeLowDriverRecommendationTitle_3",
  //     text: "Invest in enablers.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الاستثمار في الممكنات."
  //       },
  //       {
  //         language: "FR",
  //         text: "Investissez dans des catalyseurs."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyExtremeLowDriverRecommendationDesc_3",
  //     text: "Employees feel that they do not have the tools, materials, and equipment needed to get their job done and be more productive. It is important to identify what is required for specific job roles and departments to invest in the right resources to drive change.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يجب استشارة الموظفين في ما يخص الممكنات [الأدوات والمواد والمعدات] الغير متوافرة والتي يحتاجونها لإنجاز مهامهم ويكونوا أكثر إنتاجية. كما يجب تحدد ما هو مطلوب للأدوار الوظيفية والأقسام المختلفة حتى تتمكن من الاستثمار في الموارد المناسبة لدعم عملية التغيير."
  //       },
  //       {
  //         language: "FR",
  //         text: "Les employés estiment qu’ils n’ont pas les outils, le matériel et l’équipement nécessaires pour faire leur travail et être plus productifs. Il est important d'identifier ce qui est nécessaire pour que des rôles et des services spécifiques investissent dans les bonnes ressources pour conduire le changement."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyExtremeLowDriverRecommendationTitle_4",
  //     text: "Delegate work to employees.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "توزيع العمل والمهام."
  //       },
  //       {
  //         language: "FR",
  //         text: "Déléguer le travail aux employés."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyExtremeLowDriverRecommendationDesc_4",
  //     text: "It is important to instill a sense of responsibility and accountability. Accordingly, distribute and delegate work equally among employees and the set time they need to complete the work and contribute to achieving business goals efficiently.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يجب العمل على غرس الشعور بالمسؤولية والمساءلة. وعليه يحبّذ توزيع المهام والواجبات على الموظفين بشكل عادل ويجب تحديد الوقت الذي يحتاجونه لتنفيذ العمل. وبالتالي سيتمكنون من المشاركة في أهداف العمل وإنجازها بكفاءة عالية."
  //       },
  //       {
  //         language: "FR",
  //         text: ""
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyExtremeLowDriverOtherRecommendationHeader",
  //     text: "We also encourage the following initiatives and training programs to implement the aforementioned:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين عامل الاستقلالية:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nous encourageons également les initiatives et les programmes de formation suivants à mettre en œuvre les mesures susmentionnées:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyExtremeLowDriverOtherRecommendation_1",
  //     text: "Planning and organizing skills training programs",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برامج تدريب مهارات التخطيط والتنظيم"
  //       },
  //       {
  //         language: "FR",
  //         text: "Planifier et organiser des programmes de formation professionnelle"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyExtremeLowDriverOtherRecommendation_2",
  //     text: "Time management training programs",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برامج تدريب إدارة الوقت"
  //       },
  //       {
  //         language: "FR",
  //         text: "Programmes de formation ŕ la gestion du temps"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyExtremeLowDriverOtherRecommendation_3",
  //     text: "Delegation skills training programs",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برامج تدريب مهارات التفويض"
  //       },
  //       {
  //         language: "FR",
  //         text: "Programmes de formation aux compétences de délégation"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyExtremeLowDriverOtherRecommendation_4",
  //     text: "Set annual budget for the required enablers",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تحديد موازنة سنوية للممكنات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Définir un budget annuel pour les catalyseurs et les facilitateurs requis"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyExtremeLowDriverOtherRecommendation_5",
  //     text: "Set plans for practical & entertainment activities and events",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "وضع خطط للأنشطة والفعاليات الترفيهية والعملية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Établir des plans pour des activités et des événements pratiques et de divertissement"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyLowDriverReadings",
  //     text: "The analysis demonstrates that the work environment does not provide its employees with enough autonomy and flexibility in their work, and that may happen because employees need access to enablers [tools, materials, and equipment] to get their job done. It may require providing more activities for the employees and encouraging them to participate in.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج إلى أن بيئة العمل لا تمنح الموظفين استقلالية ومرونة كافية في عملهم. وقد يكون السبب صعوبة توفير الممكنات من الأدوات والمواد والمعدات التي قد يحتاجها الموظفين وصعوبة الوصول إليها لإنجاز مهامهم. ويجب توفير أنشطة مختلفة وتشجيع الموظفين للمشاركة فيها."
  //       },
  //       {
  //         language: "FR",
  //         text: "L'analyse démontre que l'environnement de travail n'offre à ses employés aucun niveau d'autonomie et de flexibilité dans leur travail, et cela peut se produire parce que les employés doivent avoir accès à des facilitateurs [outils, matériaux et équipement] pour faire leur travail. Cela peut nécessiter d'offrir plus d'activités aux employés et de les encourager à y participer."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyModerateDriverReadings",
  //     text: "The analysis demonstrates that the workplace has moderate autonomy and sometimes provides enablers [tools, materials, and equipment] that employees may need to get the job done. It may require providing more activities for the employees to participate in.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج إلى أن بيئة العمل تمنح الموظفين استقلالية ومرونة معتدلة في عملهم. كما وتوفير الحد الأدنى من الممكنات من الأدوات والمواد والمعدات التي قد يحتاجها الموظفين لإنجاز مهامهم، وتسعى لتوفير المزيد من الأنشطة للموظفين للمشاركة فيها."
  //       },
  //       {
  //         language: "FR",
  //         text: "L'analyse démontre que le milieu de travail a une autonomie modérée et fournit parfois des facilitateurs [outils, matériaux et équipement] dont les employés peuvent avoir besoin pour faire le travail. Cela peut nécessiter d'offrir plus d'activités aux employés et de les encourager à y participer."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyModerateDriverRecommendationBrief",
  //     text: "These results may indicate potential vulnerabilities in the autonomy level granted in the workplace, which in turn affects employees' engagement. It is recommended to take immediate actions to provide the employees with the flexibility required to complete their work. Additionally, trusting them and allowing them to be involved in decisions that affect their job.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هذه النتائج قد تشير إلى وجود ضعف محتمل بالنسبة لمستوى الاستقلالية الممنوحة في بيئة العمل والذي يؤثر بدوره على اندماج الموظفين. ويوصى هنا بأهمية تطبيق إجراءات لمنح الموظفين الاستقلالية المطلوبة لقيامهم بأعمالهم. ويجب الثقة في الموظفين والسماح لهم بالمشاركة في اتخاذ القرارات التي تؤثر على أعمالهم."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ces résultats peuvent indiquer des vulnérabilités potentielles dans le niveau d'autonomie accordé sur le lieu de travail, ce qui à son tour affecte l'engagement des employés. Ces résultats peuvent indiquer des vulnérabilités potentielles dans le niveau d'autonomie octroyé sur le lieu de travail, il est recommandé de prendre des mesures immédiates pour donner aux employés la flexibilité nécessaire pour terminer leur travail, ce qui affecte à son tour l'engagement des employés. En outre, leur faire confiance et leur permettre de participer à des décisions qui affectent leur travail."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyModerateDriverRecommendationPointHeader",
  //     text: "The following actions can be taken to improve autonomy. However, they are not limited to these options:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين هذا البُعد:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Les actions suivantes peuvent être prises pour améliorer l'autonomie. Cependant, ils ne sont pas limités à ces options:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyModerateDriverRecommendationTitle_1",
  //     text: "Provide a flexible work schedule.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "توفير جدول عمل مرن."
  //       },
  //       {
  //         language: "FR",
  //         text: "Fournir un horaire de travail flexible."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyModerateDriverRecommendationDesc_1",
  //     text: "In addition to sick leave and vacation permissions, employees sometimes have situations where they are unable to make it to the office, so it is important to allow them to work remotely and provide the enablers they need to get their job done. This contributes to increasing job satisfaction and productivity.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "بالإضافة إلى الإجازات المرضية والإجازات السنوية، قد يواجه الموظفون أحياناً مواقف يتعذر عليهم فيها الوصول إلى المكتب لظروف معينة، فمن المهم السماح لهم بالعمل عن بعد وتوفير الممكنات اللازمة، وذلك يسهم في زيادة الرضا الوظيفي والإنتاجية."
  //       },
  //       {
  //         language: "FR",
  //         text: "En plus des congés de maladie et des autorisations de vacances, les employés ont parfois des situations où ils sont incapables de se rendre au bureau, il est donc important de leur permettre de travailler à distance et de fournir les outils dont ils ont besoin pour faire leur travail. Cela contribue à accroître la satisfaction au travail et la productivité."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyModerateDriverRecommendationTitle_2",
  //     text: "Allow the freedom to set deadlines.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "السماح للموظفين بتحديد المواعيد النهائية."
  //       },
  //       {
  //         language: "FR",
  //         text: "Laissez la liberté de fixer des délais."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyModerateDriverRecommendationDesc_2",
  //     text: "Try trusting employees to set the deadline that they deem necessary for the tasks they need to complete. Employees may have more knowledge of the amount of time they need to complete the scope of work provided.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يجب إعطاء الموظفين فرصة لتحديد الموعد النهائي الذي يرونه منطقياً لإنهاء المهام المطلوبة. فقد يكون لديهم معرفة أكبر بمقدار الوقت الذي يحتاجون إليه لإتمام المهام الموكلة إليهم بفاعلية عالية."
  //       },
  //       {
  //         language: "FR",
  //         text: "Essayer de faire confiance aux employés pour fixer la date limite qu'ils jugent nécessaire pour les tâches qu'ils doivent accomplir. Les employés peuvent avoir une meilleure connaissance du temps dont ils ont besoin pour terminer la portée des travaux fournis."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyModerateDriverRecommendationTitle_3",
  //     text: "Provide access to enablers.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "توفير الممكنات."
  //       },
  //       {
  //         language: "FR",
  //         text: "Fournir un accčs aux facilitateurs."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyModerateDriverRecommendationDesc_3",
  //     text: "Sit down with the employees and find out what enablers [tools, materials, and equipment] they are missing or ones they need to update to get their job done.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يجب استشارة الموظفين في ما يخص الممكنات من الأدوات والمواد والمعدات الغير متوفرة والتي يحتاجونها لإنجاز مهامهم ويكونوا أكثر إنتاجية."
  //       },
  //       {
  //         language: "FR",
  //         text: "Asseyez-vous avec les employés et découvrez quels facilitateurs [outils, matériaux et équipements] ils manquent ou ceux dont ils ont besoin pour mettre à jour pour faire leur travail."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyModerateDriverRecommendationTitle_4",
  //     text: "Encourage employees to design their own process of doing things.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشجيع الموظفين على تصميم طرقهم الخاصة لإنجاز الأعمال."
  //       },
  //       {
  //         language: "FR",
  //         text: "Encourager les employés ŕ concevoir leur propre processus de travail."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyModerateDriverRecommendationDesc_4",
  //     text: "Sometimes employees may find it difficult to follow a specific pattern dictated to them by their superiors, and they do not complete the task as efficiently as possible. Allow them to come up with their own way and method to do things that make it easier for them to do the job.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "في بعض الأحيان، قد يجد الموظفين صعوبة في اتباع نمط معين تم فرضه عليهم من قبل رؤسائهم المباشرين، وعليه يواجهون صعوبة في إكماله بالكفاءة المطلوبة. لذلك يجب السماح لهم بالتوصل إلى طرق ومنهجيات خاصة بهم تسهل عليهم إتمام أعمالهم."
  //       },
  //       {
  //         language: "FR",
  //         text: "Parfois, les employés peuvent avoir du mal à suivre un modèle spécifique qui leur est dicté par leurs supérieurs et ils n'accomplissent pas la tâche aussi efficacement que possible. Permettez-leur de trouver leur propre façon et méthode de faire les choses qui leur facilitent la tâche."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyModerateDriverOtherRecommendationHeader",
  //     text: "We also encourage the following initiatives and training programs to implement the aforementioned:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين عامل الاستقلالية:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nous encourageons également les initiatives et les programmes de formation suivants à mettre en œuvre les mesures susmentionnées:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyModerateDriverOtherRecommendation_1",
  //     text: "Implement the work remotely policy",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تطبيق سياسة العمل عن بعد"
  //       },
  //       {
  //         language: "FR",
  //         text: "Mettre en śuvre la politique de travail ŕ distance"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyModerateDriverOtherRecommendation_2",
  //     text: "Planning and Organizing skills training programs",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برامج تدريب مهارات التخطيط والتنظيم"
  //       },
  //       {
  //         language: "FR",
  //         text: "Planifier et organiser des programmes de formation professionnelle"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyModerateDriverOtherRecommendation_3",
  //     text: "Time management training programs",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برامج تدريب مهارة إدارة الوقت"
  //       },
  //       {
  //         language: "FR",
  //         text: "Programmes de formation ŕ la gestion du temps"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyModerateDriverOtherRecommendation_4",
  //     text: "Set annual budget for the required enablers",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تحديد موازنة سنوية للممكنات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Définir un budget annuel pour les catalyseurs et les facilitateurs requis"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyModerateDriverOtherRecommendation_5",
  //     text: "Set plans for practical & entertainment activities and events",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "وضع خطط للأنشطة والفعاليات الترفيهية والعملية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Établir des plans pour des activités et des événements pratiques et de divertissement"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyEngagedLowDriverReadings",
  //     text: "The analysis demonstrates that the work environment provides its employees with enough autonomy and flexibility in their work, and it provides enablers [tools, materials, and equipment] that the employees may need to get the job done. It may require providing additional activities for the employees to participate in.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج إلى أن بيئة العمل تمنح الموظفين استقلالية ومرونة  كافية في عملهم. كما توفر جميع الممكنات من الأدوات والمواد والمعدات التي قد يحتاجها الموظفين لإنجاز مهامهم، وتسعى لمشاركتهم في أنشطتها الملائمة لوظائفهم."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyHighDriverReadings",
  //     text: "The analysis demonstrates that the work environment provides its employees with high autonomy and flexibility in their work, and it provides enablers [tools, materials, and equipment] that the employees may need to get the job done. It ensures that employees participate in workplace activities.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج إلى أن بيئة العمل تمنح الموظفين استقلالية ومرونة عالية في عملهم. كما توفر جميع الممكنات من الأدوات والمواد والمعدات التي قد يحتاجها الموظفين لإنجاز مهامهم، وتسعى لمشاركتهم في أنشطتها الملائمة لوظائفهم."
  //       },
  //       {
  //         language: "FR",
  //         text: "L'analyse démontre que l'environnement de travail offre à ses employés une grande autonomie et une grande flexibilité dans leur travail, et il fournit des outils [outils, matériaux et équipements] dont les employés peuvent avoir besoin pour faire le travail. Il veille à ce que les employés participent aux activités sur le lieu de travail."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyHighDriverRecommendationBrief",
  //     text: "The workplace presents the strength in terms of autonomy, and it is recommended to continue providing the employees with their current level of flexibility. Additionally, continue trusting them and encouraging them to be involved in decisions that affect their job, and ensuring that they participate in the workplace activities hosted.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يوصى هنا بالاستمرار في النهج الحالي المتبع فيما يخص تطبيق مبدأ الاستقلالية في العمل. ويجب المحافظة على إظهار الثقة في الموظفين وتشجيتعهم لاتخاذ القرارات التي تؤثر على أعمالهم. بالإضافة إلى استمرارية تحفيزهم للمشاركة في الأنشطة المختلفة."
  //       },
  //       {
  //         language: "FR",
  //         text: "Le lieu de travail présente la force en termes d'autonomie et il est recommandé de continuer à offrir aux employés leur niveau actuel de flexibilité. En outre, continuez de leur faire confiance et encouragez-les à participer aux décisions qui ont une incidence sur leur travail et à s’assurer qu’ils participent aux activités en milieu de travail organisées."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyHighDriverRecommendationPointHeader",
  //     text: "",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: ""
  //       },
  //       {
  //         language: "FR",
  //         text: ""
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAutonomyExtremeHighDriverReadings",
  //     text: "The analysis demonstrates that the work environment provides its employees with very high autonomy and flexibility in their work. And it continuously provides all the enablers [tools, materials, and equipment] that the employees may need to get the job done. It ensures that employees participate in workplace activities.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج إلى أن بيئة العمل تمنح الموظفين استقلالية ومرونة عالية جداً في عملهم. كما توفر باستمرار جميع الممكنات من الأدوات والمواد والمعدات التي قد يحتاجها الموظفين لإنجاز مهامهم، وتضمن مشاركتهم في أنشطتها المختلفة."
  //       },
  //       {
  //         language: "FR",
  //         text: "L'analyse démontre que l'environnement de travail offre à ses employés une très grande autonomie et flexibilité dans leur travail. Et il fournit continuellement tous les facilitateurs [outils, matériaux et équipement] dont les employés peuvent avoir besoin pour faire le travail.  Il veille à ce que les employés participent aux activités sur le lieu de travail."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionDriverDesc",
  //     text: "Employees' connection in the workplace is important in terms of communication, social connection, and culture in general. The reason for a positive relationship between connection and engagement is that employees are more likely to engage when they feel like the culture fits with their morals and two-way communication is flowing smoothly throughout the workplace.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الاتصال بين الموظفين مهم لرفع مستوى التواصل الاجتماعي ودعم ثقافة بيئة العمل بشكل عام. والسبب وراء وجود علاقة إيجابية بين التواصل والاندماج الوظيفي هو أن الموظفين يكونون أكثر عرضة للاندماج عندما يشعرون أن الثقافة متناسبة مع أخلاقهم وأن الاتصال المتبادل  (two-way communication) يكون سلساً في مكان العمل."
  //       },
  //       {
  //         language: "FR",
  //         text: "Le lien des employés sur le lieu de travail est important en termes de communication, de lien social et de culture en général. La raison d’une relation positive entre le lien et l’engagement est que les employés sont plus susceptibles de s’engager lorsqu’ils estiment que la culture correspond à leur moralité et que la communication bidirectionnelle se fait sans heurts dans l’ensemble du milieu de travail."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionExtremeLowDriverReadings",
  //     text: "These results indicate that the work environment doesn’t show any efficiency as a result of the lack of social connection between the teams and other functions. The work environment needs immediate attention to improve the social connection level and enhance employees’ team spirit and motivate them to communicate.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج إلى أن بيئة العمل لا تتمتع بكفاءة نتيجة إنعدام الاتصال والتعاون بين الفرق والأقسام الأخرى. إن بيئة العمل بحاجة ماسة لتحسين مستوى التواصل الاجتماعي بين الموظفين وتعزيز روح الفريق لديهم، وتشجيعهم على التواصل والتعاون ."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ces résultats indiquent que l’environnement de travail ne démontre aucune efficacité en raison du manque de lien social entre les équipes et les autres fonctions. L’environnement de travail nécessite une attention immédiate pour améliorer le niveau de connexion sociale et améliorer l’esprit d’équipe des employés et les motiver à communiquer."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionExtremeLowDriverRecommendationBrief",
  //     text: "These results may indicate a high degree of risk in the connection and communication levels in the workplace, which in turn affects employees’ engagement. It is recommended to take immediate and rapid actions to enhance the social connection and encourage collaboration between the teams and other functions.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هذه النتائج قد تشير إلى وجود درجة عالية من الخطورة في مستوى التواصل والاتصال في بيئة العمل والذي يؤثر بدوره على اندماج الموظفين. ويوصى هنا بضرورة اتخاذ إجراءات فورية لتعزيز التواصل الاجتماعي وتشجيع التعاون بين الفرق والأقسام الأخرى."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ces résultats peuvent indiquer un degré élevé de risque dans les niveaux de connexion et de communication en milieu de travail, ce qui influe sur l’engagement des employés. Il est recommandé de prendre des mesures immédiates et rapides pour améliorer les liens sociaux et encourager la collaboration entre les équipes et les autres fonctions."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionExtremeLowDriverRecommendationPointHeader",
  //     text: "The following actions can be taken to improve autonomy. However, they are not limited to these options:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين هذا البُعد:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Les actions suivantes peuvent être prises pour améliorer l'autonomie. Cependant, ils ne sont pas limités à ces options:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionExtremeLowDriverRecommendationTitle_1",
  //     text: "Communicate work mission & values.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ترسيخ رسالة العمل وقيم."
  //       },
  //       {
  //         language: "FR",
  //         text: "Communiquer la mission et les valeurs du travail."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionExtremeLowDriverRecommendationDesc_1",
  //     text: "It is important to communicate business mission and values to ensure a safe and secure work environment. For employees to feel engaged with the workplace, their values must be consistent with business values. Motivate the employees to contribute to the achievement of this mission and values. The best way to succeed in achieving this is by collaborating and working to achieve the common goal.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "من المهم جداً ترسيخ مهمة العمل وقيمه لضمان تحقيق بيئة عمل آمنة. وكي يشعر الموظفون بأنهم مرتبطون بمكان العمل يجب أن تتسق قيمهم الشخصية مع قيم العمل. ويجب تحفيز الموظفين لدعم وتحقيق هذه القيم. وتتمثل أفضل السبل نحو النجاح في تحقيق ذلك هو بالتعاون والعمل يداً واحدة لتحقيق الهدف المشترك."
  //       },
  //       {
  //         language: "FR",
  //         text: "Il est important de communiquer la mission et les valeurs de la société pour garantir un environnement de travail sûr et sécurisé. Pour que les employés se sentent impliqués dans le milieu de travail, leurs valeurs doivent être cohérentes avec les valeurs de la société. Motiver les employés à contribuer à la réalisation de cette mission et de ces valeurs. La meilleure façon d’y parvenir est de collaborer et de travailler pour atteindre l’objectif commun."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionExtremeLowDriverRecommendationTitle_2",
  //     text: "Encourage information sharing.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشجيع تبادل المعلومات."
  //       },
  //       {
  //         language: "FR",
  //         text: "Encourager le partage d'informations."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionExtremeLowDriverRecommendationDesc_2",
  //     text: "Some employees refrain from doing so because they fear rejection, not being listened to, or even ignored. It is important to show that there is no idea or information shared that is not useful. And always welcome their suggestions.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يمتنع بعض الموظفين عن مشاركة أفكارهم ذلك لأنهم يخشون الرفض، أو عدم الاستماع إليهم، أو حتى التجاهل. يجب التوضيح لهم أنه لا توجد أفكار أو معلومات غير مفيدة تتم مشاركتها. والترحيب باقتراحاتهم دائماً."
  //       },
  //       {
  //         language: "FR",
  //         text: "Certains employés s'abstiennent de le faire parce qu'ils craignent d'être rejetés, de ne pas être écoutés, voire ignorés. Il est important de montrer qu'il n'y a aucune idée ou information partagée qui ne soit pas utile. Et toujours accueillir leurs suggestions."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionExtremeLowDriverRecommendationTitle_3",
  //     text: "Collaborate with other functions and teams.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "التعاون مع الموظفين والأقسام الأخرى."
  //       },
  //       {
  //         language: "FR",
  //         text: "Collaborer avec d'autres fonctions et équipes."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionExtremeLowDriverRecommendationDesc_3",
  //     text: "There are times where employees find it difficult to collaborate with members outside of their teams and department. This is where it is necessary to show them support by communicating the common goals they are to achieve. Ensure rewarding the employees for project milestones and help them connect and collaborate and enhance team spirit.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هناك أوقات يجد فيها الموظفين صعوبة في التعاون مع الموظفين من الأقسام الأخرى. وفي هذه المواقف يجب الدعم من خلال مشاركة الأهداف العامة التي يتعين عليهم تحقيقها. والتأكد من مكافأتهم على المراحل الرئيسية في المشروع ومساعدتهم على التواصل والتعاون وتعزيز روح الفريق. "
  //       },
  //       {
  //         language: "FR",
  //         text: "Il y a des moments où les employés ont du mal à collaborer avec des membres en dehors de leurs équipes et de leur service. C'est là qu'il est nécessaire de leur montrer leur soutien en communiquant les objectifs communs qu'ils doivent atteindre. Assurez-vous de récompenser les employés pour les étapes importantes du projet et aidez-les à se connecter, à collaborer et à améliorer l’esprit d’équipe."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionExtremeLowDriverRecommendationTitle_4",
  //     text: "Celebrate culture and diversity.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "دعم تنوع الثقافات."
  //       },
  //       {
  //         language: "FR",
  //         text: "Célébrer la culture et la diversité."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionExtremeLowDriverRecommendationDesc_4",
  //     text: "This is a vital part of the work environment, given the fact that employees come from different ethnical backgrounds and cultures. There are many ways to celebrate them and make them feel welcome. Incorporate gatherings occasionally that include their local delicacies, cultural museum visits, and even game discussions.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هذا الجانب مهم جداً لبيئة العمل مع الأخذ بعين الاعتبار أن أغلب الموظفين يأتون من ثقافات مختلفة. وهناك العديد من الطرق التي يمكن من خلالها دعم الموظفين وجعلهم يشعرون بالترحيب. فمن الممكن تنظيم التجمعات من حين لآخر والتي قد تتضمن الأطباق المحلية الخاصة بهم، وزيارات للمتحف الثقافي، وحتى النقاش حول الألعاب."
  //       },
  //       {
  //         language: "FR",
  //         text: "Il s'agit d'un élément essentiel de l'environnement de travail, étant donné que les employés sont issus de cultures et d'ethnies différentes. Il existe de nombreuses façons de les célébrer et de les accueillir. Incorporez occasionnellement des rassemblements qui incluent leurs spécialités locales, des visites de musées culturels et même des discussions sur les jeux."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionExtremeLowDriverOtherRecommendationHeader",
  //     text: "We also encourage the following initiatives and training programs to implement the aforementioned:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين عامل الاتصال:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nous encourageons également les initiatives et les programmes de formation suivants à mettre en œuvre les mesures susmentionnées:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionExtremeLowDriverOtherRecommendation_1",
  //     text: "Communication skills training programs",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برامج تدريب مهارات الاتصال"
  //       },
  //       {
  //         language: "FR",
  //         text: "Programmes de formation en communication"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionExtremeLowDriverOtherRecommendation_2",
  //     text: "Adopt effective communication strategies",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تبني استراتيجيات الاتصال الفعالة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Adopter des stratégies de communication efficaces"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionExtremeLowDriverOtherRecommendation_3",
  //     text: "Set up weekly or monthly meetings to share business achievement",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قم بإعداد اجتماعات أسبوعية أو شهرية لمشاركة إنجازات الأعمال"
  //       },
  //       {
  //         language: "FR",
  //         text: "Organiser des réunions hebdomadaires ou mensuelles pour partager les réalisations de la société"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionExtremeLowDriverOtherRecommendation_4",
  //     text: "Corporate culture orientation",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برامج تهيئة الموظفين لثقافة العمل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Orientation de la culture de la société"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionExtremeLowDriverOtherRecommendation_5",
  //     text: "Building and managing teams training programs",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برامج بناء وإدارة فريق العمل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Création et gestion des programmes de formation des équipes"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionExtremeLowDriverOtherRecommendation_6",
  //     text: "Workplace Diversity management Program",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برامج إدارة التنوع في مكان العمل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Programme de gestion de la diversité en milieu de travail"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionLowDriverReadings",
  //     text: "These results indicate that the work environment doesn’t show any efficiency as a result of the weak social connections between the employees, and it is affecting the collaboration within the department and between other departments. The work environment needs to improve the social connection level and enhance employees’ team spirit.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج إلى أن بيئة العمل لا تتمتع بكفاءة نتيجة ضعف الاتصال والتعاون بين الموظفين والذي بدوره يؤثر على التعاون بين الفرق والأقسام الأخرى. إن بيئة العمل بحاجة لتحسين مستوى التواصل الاجتماعي بين الموظفين وتعزيز روح الفريق لديهم."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ces résultats indiquent que l’environnement de travail ne montre aucune efficacité en raison de la faiblesse des liens sociaux entre les employés et affecte la collaboration au sein du département et entre les autres départements. L’environnement de travail doit améliorer le niveau de connexion sociale et renforcer l’esprit d’équipe des employés."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionModerateDriverReadings",
  //     text: "These results indicate that the work environment shows average efficiency as a result of the collaboration and connection between the teams and other functions. The work environment requires improvement in the social connection between your employees, which may affect the collaboration between them, enhance the work culture, and increase employees’ productivity and efficiency.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج إلى أن بيئة العمل تتمتع بكفاءة معتدلة نتيجة الاتصال والتعاون بين الفرق والأقسام الأخرى. إن بيئة العمل تحتاج لتحسين مستوى التواصل الاجتماعي بين الموظفين والذي بدوره قد يؤثر على التعاون بينهم ويعزز ثقافة العمل ويزيد من كفاءة الموظفين وإنتاجيتهم. "
  //       },
  //       {
  //         language: "FR",
  //         text: "Ces résultats indiquent que l'environnement de travail montre une efficacité moyenne du fait de la collaboration et de la connexion entre les équipes et les autres fonctions. L’environnement de travail nécessite une amélioration du lien social entre vos employés, ce qui peut affecter la collaboration entre eux, améliorer la culture de travail et augmenter la productivité et l’efficacité des employés."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionModerateDriverRecommendationBrief",
  //     text: "These results may indicate potential vulnerabilities in the connection and communication levels in the workplace, which in turn affects employees' engagement. It is recommended to take immediate actions to enhance the social connection and encourage collaboration between the teams and other functions.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هذه النتائج قد تشير إلى وجود ضعف محتمل بالنسبة لمستوى التواصل والاتصال في بيئة العمل والذي يؤثر بدوره على اندماج الموظفين. ويوصى هنا بضرورة اتخاذ إجراءات لتعزيز التواصل الاجتماعي وتشجيع التعاون بين الفرق والأقسام الأخرى."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ces résultats peuvent indiquer des vulnérabilités potentielles dans les niveaux de connexion et de communication sur le lieu de travail, ce qui à son tour affecte l'engagement des employés. Il est recommandé de prendre des mesures immédiates pour renforcer le lien social et encourager la collaboration entre les équipes et les autres fonctions."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionModerateDriverRecommendationPointHeader",
  //     text: "The following actions can be taken to improve autonomy. However, they are not limited to these options:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين هذا البُعد:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Les actions suivantes peuvent être prises pour améliorer l'autonomie. Cependant, ils ne sont pas limités à ces options:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionModerateDriverRecommendationTitle_1",
  //     text: "Adopt an open-door policy.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تبنى سياسة الباب المفتوح (open-door policy)."
  //       },
  //       {
  //         language: "FR",
  //         text: "Adoptez une politique de porte ouverte."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionModerateDriverRecommendationDesc_1",
  //     text: "This policy is vital since it looks to create a connection and engage its employees. It is essential that you impose transparent communication and allow your employees to express their opinions freely without the fear of repercussions. Tell your employees that your office door is open to them any time they have feedback to give you or something they need to talk to you about.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تعتبر هذه السياسة مهمة جداً لأنها تتطلع إلى تعزيز التواصل بين الموظفين. من المهم أن تدعم مبدأ الشفافية، وتسمح للموظفين بالتعبير عن آرائهم بحرية دون خوف. أخبر الموظفين أن باب مكتبك مفتوح لهم في أي وقت حين يكون لديهم أية ملاحظات لمناقشتها معك."
  //       },
  //       {
  //         language: "FR",
  //         text: "Cette politique est essentielle puisqu’elle cherche à créer un lien et à mobiliser ses employés. Il est essentiel que vous imposiez une communication transparente et que vous permettiez à vos employés d’exprimer librement leurs opinions sans craindre de répercussions. Dites à vos employés que la porte de votre bureau leur est ouverte chaque fois qu’ils ont des commentaires à vous donner ou quelque chose dont ils ont besoin de vous parler."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionModerateDriverRecommendationTitle_2",
  //     text: "Communicate work mission & values.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ترسيخ رسالة العمل وقيم. "
  //       },
  //       {
  //         language: "FR",
  //         text: "Communiquer la mission et les valeurs du travail."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionModerateDriverRecommendationDesc_2",
  //     text: "It is important to communicate business mission and values to ensure a safe and secure work environment. For employees to feel engaged with the workplace, their values must be consistent with business values. Motivate the employees to contribute to the achievement of this mission and values. The best way to succeed in achieving this is by collaborating and working to achieve the common goal.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "من المهم جداً ترسيخ مهمة العمل وقيمه لضمان تحقيق بيئة عمل آمنة. وكي يشعر الموظفون بأنهم مرتبطون بمكان العمل يجب أن تتسق قيمهم الشخصية مع قيم العمل. ويجب تحفيز الموظفين لدعم وتحقيق هذه القيم. وتتمثل أفضل السبل نحو النجاح في تحقيق ذلك هو بالتعاون والعمل يداً واحدة لتحقيق الهدف المشترك."
  //       },
  //       {
  //         language: "FR",
  //         text: "Il est important de communiquer la mission et les valeurs de la société pour garantir un environnement de travail sûr et sécurisé. Pour que les employés se sentent impliqués dans le milieu de travail, leurs valeurs doivent être cohérentes avec les valeurs de la société. Motiver les employés à contribuer à la réalisation de cette mission et de ces valeurs. La meilleure façon d’y parvenir est de collaborer et de travailler pour atteindre l’objectif commun."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionModerateDriverRecommendationTitle_3",
  //     text: "Openly share experiences.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مشاركة الخبرات."
  //       },
  //       {
  //         language: "FR",
  //         text: "Partagez ouvertement vos expériences."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionModerateDriverRecommendationDesc_3",
  //     text: "Communicating with the employees and sharing the previous experiences has an important role in increasing their engagement. Sharing these experiences helps in performing their work effectively. As well as solving any problem or challenges they may face smoothly.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "التواصل مع الموظفين ومشاركة الخبرات والتجارب السابقة معهم له دور مهم في زيادة ارتباطهم بالعمل. فمشاركة هذه الخبرات تساعدهم في أداء وظائفهم بشكل فعال، ومواجهة الصعوبات والتحديات التي قد تواجههم بسلاسة."
  //       },
  //       {
  //         language: "FR",
  //         text: "Communiquer avec les employés et partager les expériences précédentes a un rôle important dans l'augmentation de leur engagement. Le partage de ces expériences aide à effectuer leur travail efficacement. Ainsi que la résolution de tout problème ou des défis auxquels ils peuvent faire face en douceur."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionModerateDriverRecommendationTitle_4",
  //     text: "Implement management by walking around.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تطبيق الإدارة من خلال التجول في مكان العمل."
  //       },
  //       {
  //         language: "FR",
  //         text: "Mettre en śuvre la gestion en se promenant."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionModerateDriverRecommendationDesc_4",
  //     text: "One of the most common ways to instill communication between the top management and other employees is using this method. It is recommended to walk around the offices and to check on how the employees are doing.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تعد هذه الطريقة من أكثر الطرق شيوعاً لغرس التواصل بين الإدارة العليا والموظفين. ومن المستحسن أن التجول بين مكاتب الموظفين لإجراء محادثة قصيرة مع الموظفين بين حين وآخر وسؤالهم عن أحوالهم. "
  //       },
  //       {
  //         language: "FR",
  //         text: "L'un des moyens les plus courants d'instaurer la communication entre la direction et les autres employés consiste à utiliser cette méthode. Il est recommandé de se promener dans les bureaux et de vérifier comment les employés se portent."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionModerateDriverOtherRecommendationHeader",
  //     text: "We also encourage the following initiatives and training programs to implement the aforementioned:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين عامل الاتصال:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nous encourageons également les initiatives et les programmes de formation suivants à mettre en œuvre les mesures susmentionnées:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionModerateDriverOtherRecommendation_1",
  //     text: "Communication skills training programs",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برامج تدريب مهارات الاتصال"
  //       },
  //       {
  //         language: "FR",
  //         text: "Programmes de formation en communication"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionModerateDriverOtherRecommendation_2",
  //     text: "Adopt effective communication strategies",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تبني استراتيجيات الاتصال الفعالة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Adopter des stratégies de communication efficaces"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionModerateDriverOtherRecommendation_3",
  //     text: "Set up weekly or monthly meetings to share business achievements",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قم بإعداد اجتماعات أسبوعية أو شهرية لمشاركة إنجازات الأعمال"
  //       },
  //       {
  //         language: "FR",
  //         text: "Organiser des réunions hebdomadaires ou mensuelles pour partager les réalisations de la société"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionModerateDriverOtherRecommendation_4",
  //     text: "Corporate culture orientation",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برامج تهيئة الموظفين لثقافة العمل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Orientation de la culture de la société"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionModerateDriverOtherRecommendation_5",
  //     text: "Building and managing teams training programs",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برامج بناء وإدارة فريق العمل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Création et gestion des programmes de formation des équipes"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionEngagedLowDriverReadings",
  //     text: "These results indicate that the work environment shows above average efficiency as a result of the collaboration and connection between the teams and other functions. The work environment requires improvement in the social connection between your employees, which may affect the collaboration between them, enhance the work culture, and increase employees’ productivity and efficiency.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج إلى أن بيئة العمل تتمتع بمستوى كفاءة فوق المتوسط نتيجة الاتصال والتعاون بين الفرق والأقسام الأخرى. إن بيئة العمل تحتاج لتحسين مستوى التواصل الاجتماعي بين الموظفين والذي بدوره قد يؤثر على التعاون بينهم ويعزز ثقافة العمل ويزيد من كفاءة الموظفين وإنتاجيتهم."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionHighDriverReadings",
  //     text: "These results indicate that the work environment shows good efficiency as a result of the smooth collaboration and connection between the teams and other functions. The collaborative environment enhances the work culture and increases employees’ productivity and efficiency.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج إلى أن بيئة العمل تتمتع بكفاءة جيدة نتيجة سلاسة الاتصال والتعاون بين الفرق والأقسام الأخرى. إن توافر بيئة متعاونة تسهم في تعزيز ثقافة العمل وتزيد من كفاءة الموظفين وإنتاجيتهم."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ces résultats indiquent que l'environnement de travail montre une bonne efficacité grâce à la bonne collaboration et à la connexion entre les équipes et les autres fonctions. L’environnement collaboratif améliore la culture de travail et augmente la productivité et l’efficacité des employés."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionHighDriverRecommendationBrief",
  //     text: "It is recommended to continue the followed strategies to enhance the employees social connection and encourage a continuous collaboration between the teams and other functions. It is important to communicate workplace values that provide a safe and secure environment at work and impose transparency of communication by adopting an open-door policy.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يوصى هنا بالاستمرار في النهج الحالي المتبع لتعزيز التواصل الاجتماعي بين الموظفين وتشجيع التعاون المستمر بين الفرق والأقسام الأخرى. ويجب المحافظة على ترسيخ قيم مكان العمل التي تضمن بيئة عمل آمنة وفرض مبدأ الشفافية من خلال تبني سياسة الباب المفتوح (open-door policy)."
  //       },
  //       {
  //         language: "FR",
  //         text: "Il est recommandé de poursuivre les stratégies suivies pour renforcer le lien social des employés et encourager une collaboration continue entre les équipes et les autres fonctions. Il est important de communiquer les valeurs du lieu de travail qui offrent un environnement de travail sûr et sécurisé et imposent la transparence de la communication en adoptant une politique de porte ouverte."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionHighDriverRecommendationPointHeader",
  //     text: "",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: ""
  //       },
  //       {
  //         language: "FR",
  //         text: ""
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConnectionExtremeHighDriverReadings",
  //     text: "These results indicate that the work environment shows extraordinary efficiency as a result of the smooth collaboration and connection between the teams and other functions. The collaborative environment enhances the work culture and increases employees’ productivity and efficiency.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج إلى أن بيئة العمل تتمتع بكفاءة مرتفعة نتيجة سلاسة الاتصال والتعاون بين الفرق والأقسام الأخرى. إن توافر بيئة متعاونة تسهم في تعزيز ثقافة العمل وتزيد من كفاءة الموظفين وإنتاجيتهم."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ces résultats indiquent que l'environnement de travail fait preuve d'une efficacité extraordinaire grâce à une collaboration et une connexion harmonieuse entre les équipes et les autres fonctions. L’environnement collaboratif améliore la culture de travail et augmente la productivité et l’efficacité des employés."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipDriverDesc",
  //     text: "Transformational leadership has a positive connection with engagement since it stimulates a relationship between the leader and the employee. When the employees feel like their leader sets a clear vision and inspires and motivates them to achieve a higher level of productivity, they are more likely to be highly engaged with the organization and trust their leaders.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ترتبط القيادة التحويلية بعلاقة إيجابية مع اندماج الموظفين لأنها تحفز العلاقة بين القائد والموظف. عندما يشعر الموظفون أن قائدهم يضع رؤية واضحة ويلهمهم ويحفزهم لتحقيق مستوى أعلى من الإنتاجية، فمن المرجح أن يثق الموظفون بقادتهم ويكونون أكثر ارتباطاً واندماجاً في العمل."
  //       },
  //       {
  //         language: "FR",
  //         text: "Le leadership transformationnel a un lien positif avec l’engagement puisqu’il stimule une relation entre le leader et l’employé. Lorsque les employés ont l’impression que leur chef établit une vision claire et les inspire et les motive à atteindre un niveau de productivité plus élevé, ils sont plus susceptibles d’être très engagés avec l’organisation et de faire confiance à leurs dirigeants."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipExtremeLowDriverReadings",
  //     text: "The analysis demonstrates that the employees do not trust the transformational leadership approach and practices. This shows the importance of the leader's role in helping the employees to understand the approach and building trust, and motivating them at the minimum required level to improve productivity and contribute to achieving business goals.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج إلى أن الموظفين ليس لديهم ثقة في نهج وسلوك القيادة للمرؤوسين. وهذا يُشير إلى أهمية دور القائد في مساعدتهم على فهم النهج المتبع ومحاولة بناء الثقة وتحفيزهم بالحد الأدنى المطلوب لتحسين مستوى الإنتاجية والمساهمة في تحقيق أهداف العمل. "
  //       },
  //       {
  //         language: "FR",
  //         text: "L'analyse démontre que les employés ne font pas confiance à l'approche et aux pratiques du leadership transformationnel. Cela montre l'importance du rôle du leader en aidant les employés à comprendre l'approche et à bâtir la confiance, et en les motivant au niveau minimum requis pour améliorer la productivité et contribuer à la réalisation des objectifs de la société."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipExtremeLowDriverRecommendationBrief",
  //     text: "These results may indicate a high risk in the transformational leadership approach and practices, which in turn affects employees' engagement. It is recommended to take immediate and rapid actions to enhance employee’s confidence and trust in transformational leadership and its approach.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هذه النتائج قد تشير إلى وجود درجة عالية من الخطورة بالنسبة لمنهج وسلوك القيادة للمرؤوسين والذي يؤثر بدوره على اندماج الموظفين. ويوصى هنا بضرورة اتخاذ إجراءات فورية لتعزيز ثقة الموظفين بنهج وسلوك القيادة المتبع."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ces résultats peuvent indiquer un risque élevé dans l'approche et les pratiques de leadership transformationnel, ce qui à son tour affecte l'engagement des employés. Il est recommandé de prendre des mesures immédiates et rapides pour renforcer la confiance des employés dans le leadership transformationnel et son approche."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipExtremeLowDriverRecommendationPointHeader",
  //     text: "You can take the following actions to improve this driver. However, they are not limited to these options:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين عامل القيادة التحويلية:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Les actions suivantes peuvent être prises pour améliorer l'autonomie. Cependant, ils ne sont pas limités à ces options:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipExtremeLowDriverRecommendationTitle_1",
  //     text: "Work in harmony towards achieving the business mission.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "العمل بانسجام لتحقيق رسالة العمل. "
  //       },
  //       {
  //         language: "FR",
  //         text: "Travailler en harmonie pour réaliser la mission d’affaires."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipExtremeLowDriverRecommendationDesc_1",
  //     text: "This can be done by conducting weekly meetings with team members and seeking updates from each of them. Listen to their opinions and feedback on the tasks that have been accomplished. Ask if they have been facing any obstacles that they may require help with.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يمكن القيام بذلك من خلال عقد اجتماعات أسبوعية مع أعضاء الفريق، والحصول على المستجدات من كل منهم، والاستماع إلى آرائهم وتعليقاتهم على المهام التي تم إنجازها. والاستفسار عما إذا كانوا يواجهون أي عقبات قد يحتاجون إلى المساعدة بشأنها."
  //       },
  //       {
  //         language: "FR",
  //         text: "Cela peut être fait en menant des réunions hebdomadaires avec les membres de l’équipe et en demandant des mises à jour de chacun d’eux. Écoutez leurs opinions et leurs commentaires sur les tâches qui ont été accomplies. Demandez-leur s'ils ont été confrontés à des obstacles pour lesquels ils pourraient avoir besoin d'aide."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipExtremeLowDriverRecommendationTitle_2",
  //     text: "Engage employees in transformational projects.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إشراك الموظفين في المشاريع التحويلية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Impliquer les employés dans des projets de transformation."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipExtremeLowDriverRecommendationDesc_2",
  //     text: "These projects are extremely important because they drive change in the workplace, and sometimes employees try to resist that change. Here, the leader’s role is to encourage them to be a part of those projects; they have a clearer understanding of the direction of the change and have an optimistic outlook on the situation. This way, they are more likely to adapt to change and think out of the box.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هذه المشاريع مهمة للغاية لأنها تقود التغيير في مكان العمل، وأحياناً يحاول الموظفون مقاومة هذا التغيير. وهنا يأتي دور القائد لتشجيعهم بأن يكونوا جزءاً من تلك المشاريع، وبالتالي سيكون لديهم فهم أوضح للهدف من التغيير ولديهم نظرة متفائلة تجاهه. بهذه الطريقة، هم أكثر احتمالاً وتقبُّلاً للتكيف مع التغيير والتفكير خارج الصندوق."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ces projets sont extrêmement importants car ils conduisent au changement sur le lieu de travail, et parfois les employés essaient de résister à ce changement. Ici, le rôle du leader est de les encourager à faire partie de ces projets; ils ont une meilleure compréhension de la direction du changement et ont une vision optimiste de la situation. De cette façon, ils sont plus susceptibles de s’adapter au changement et de penser hors de la boîte."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipExtremeLowDriverRecommendationTitle_3",
  //     text: "Clarify the importance of employees’ roles in the business strategy.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "توضيح أهمية دور الموظفين في استراتيجية العمل."
  //       },
  //       {
  //         language: "FR",
  //         text: "Clarifier l’importance du rôle des employés dans la stratégie d’entreprise."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipExtremeLowDriverRecommendationDesc_3",
  //     text: "Ensure that the employees understand the business vision and the importance of their role in achieving its objectives. The employees who feel the direct impact of their contributions on business performance are more likely to be engaged, and they seek to make better decisions and implement new methods to increase productivity and growth.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يجب التأكد من فهم الموظفين لرؤية العمل وأهمية دورهم في تحقيق أهدافه. إن الموظفين الذين يرون التأثير المباشر لمساهماتهم وانعكاسه على أداء العمل يكونون أكثر تفاعلاً واندماجاً في العمل، ويتخذون قرارات أفضل وتطبيق سبل جديدة لزيادة الإنتاجية والنمو. "
  //       },
  //       {
  //         language: "FR",
  //         text: "S'assurer que les employés comprennent la vision de l'entreprise et l'importance de leur rôle dans l'atteinte de ses objectifs. Les employés qui ressentent l'impact direct de leurs contributions sur la performance de l'entreprise sont plus susceptibles d'être impliqués, et ils cherchent à prendre de meilleures décisions et à mettre en œuvre de nouvelles méthodes pour augmenter la productivité et la croissance."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipExtremeLowDriverRecommendationTitle_4",
  //     text: "Enhance creative thinking.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تعزيز التفكير الإبداعي."
  //       },
  //       {
  //         language: "FR",
  //         text: "Améliorer la pensée créative."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipExtremeLowDriverRecommendationDesc_4",
  //     text: "The transformational leader can enhance the employees' creative thinking and motivate them to unleash their creativity by solving traditional problems by introducing new ideas methods, thus contributing to building and developing a supportive work environment that positively affects employee engagement.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لدى القائد التحويلي قدرة على تعزيز التفكير الإبداعي للموظفين وتحفيزهم لإطلاق طاقاتهم للتفكير في حل المشكلات التقليدية من خلال طرح أفكار وطرق جديدة مبدعة، وبذلك يُسهم في بناء وتطوير بيئة عمل داعمة والتي تؤثر بشكل إيجابي على اندماج الموظفين في العمل."
  //       },
  //       {
  //         language: "FR",
  //         text: "Le leader transformationnel peut améliorer la pensée créative des employés et les motiver à libérer leur créativité en résolvant les problèmes traditionnels en introduisant de nouvelles méthodes d'idées, contribuant ainsi à la construction et au développement d'un environnement de travail favorable qui affecte positivement l'engagement des employés."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipExtremeLowDriverRecommendationTitle_5",
  //     text: "Manage your employees and follow up.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إدارة الموظفين ومتابعتهم."
  //       },
  //       {
  //         language: "FR",
  //         text: "Gérez vos employés et suivez-les."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipExtremeLowDriverRecommendationDesc_5",
  //     text: "There are many situations where superiors tell their employees what is required of them, hand them a deadline, and wait for the work to get done. That is not the way to go about things. A leader must explain clearly and directly to employees what is expected of them, get their opinion on a reasonable deadline that can be set, and follow up with them on the periodic progress reports. Additionally, motivate them throughout the process from beginning to end.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هناك العديد من المواقف التي يخبر فيها الرؤساء المباشرون موظفيهم بما هو مطلوب منهم، ويعطونهم موعداً نهائياً، وينتظرون إنجاز العمل. ليس هذا هو السبيل للتعامل مع الأشياء. يجب أن يشرح القائد للموظفين/المرؤوسين ما هو متوقع منهم بشكل واضح ومباشر، وأن يحصل على رأيهم في موعد نهائي معقول ومقبول يمكن تحديده، وأن يتابع معهم تقارير الإنجاز الدورية. بالإضافة إلى ذلك، قم بتحفيزهم طوال العملية من البداية إلى النهاية."
  //       },
  //       {
  //         language: "FR",
  //         text: "Il existe de nombreuses situations où les supérieurs disent à leurs employés ce qu'on attend d'eux, leur donnent une date limite et attendent que le travail soit terminé. Ce n’est pas la façon de procéder. Un leader doit expliquer clairement et directement aux employés ce que l'on attend d'eux, obtenir leur avis sur un délai raisonnable qui peut être fixé et faire le suivi avec eux des rapports d'étape périodiques. En outre, motivez-les tout au long du processus du début jusqu'à la fin."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipExtremeLowDriverOtherRecommendationHeader",
  //     text: "We also encourage the following initiatives and training programs to implement the aforementioned:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ونشجع على البرامج التدريبية والمبادرات التالية لتنفيذ ما سبق ذكره:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nous encourageons également les initiatives et les programmes de formation suivants à mettre en œuvre les mesures susmentionnées:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipExtremeLowDriverOtherRecommendation_1",
  //     text: "Transformational Leadership Development Programs",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برامج تطوير القيادة التحويلية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Programmes de développement du leadership transformationnel"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipExtremeLowDriverOtherRecommendation_2",
  //     text: "Change Management training programs",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برامج التدريب على إدارة التغيير"
  //       },
  //       {
  //         language: "FR",
  //         text: "Programmes de formation en gestion du changement"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipExtremeLowDriverOtherRecommendation_3",
  //     text: "Workplace Conflict Management and Resolution programs",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برامج التدريب على إدارة النزاعات في مكان العمل وحلها"
  //       },
  //       {
  //         language: "FR",
  //         text: "Programmes de gestion et de résolution des conflits en milieu de travail"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipExtremeLowDriverOtherRecommendation_4",
  //     text: "Strategic Change Management programs",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برامج إدارة التغيير الاستراتيجي"
  //       },
  //       {
  //         language: "FR",
  //         text: "Programmes de gestion du changement stratégique"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipExtremeLowDriverOtherRecommendation_5",
  //     text: "Team Building Skills training programs",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برامج مهارات بناء الفريق"
  //       },
  //       {
  //         language: "FR",
  //         text: "Programmes de formation sur les compétences de consolidation d'équipe"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipExtremeLowDriverOtherRecommendation_6",
  //     text: "Leadership Skills workshops",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ورش عمل عن مهارات القيادة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ateliers sur les compétences en leadership"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipLowDriverReadings",
  //     text: "The analysis demonstrates that the employees do not trust the transformational leadership approach and practices. This shows the importance of the leader's role in helping the employees understand the approach, building trust, and motivating them to improve productivity and contribute to achieving business goals.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج إلى أن الموظفين ليس لديهم ثقة في نهج وسلوك القيادة للمرؤوسين. وهذا يُشير إلى أهمية دور القائد في مساعدتهم على فهم النهج المتبع ومحاولة بناء الثقة وتحفيزهم لتحسين مستوى الإنتاجية والمساهمة في تحقيق أهداف العمل. "
  //       },
  //       {
  //         language: "FR",
  //         text: "L'analyse démontre que les employés ne font pas confiance à l'approche et aux pratiques du leadership transformationnel. Cela montre l'importance du rôle du leader en aidant les employés à comprendre l'approche, en instaurant la confiance et en les motivant à améliorer la productivité et à contribuer à la réalisation des objectifs de la société."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipModerateDriverReadings",
  //     text: "The analysis demonstrates that some employees have limited trust in the transformational leadership approach and practices. This shows the importance of the leader's role in clarifying the business vision and motivating employees to achieve a higher level of productivity and execute the business goals.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج إلى أن بعض الموظفين لديهم الحد الأدنى من الثقة في نهج وسلوك القيادة للمرؤوسين. وهذا يُشير إلى أهمية دور القائد في توضيح رؤية العمل وتحفيز الموظفين للعمل من أجل تحقيق مستوى أعلى من الإنتاجية وتحقيق أهداف العمل."
  //       },
  //       {
  //         language: "FR",
  //         text: "L'analyse démontre que certains employés ont une confiance limitée dans l'approche et les pratiques du leadership transformationnel. Cela montre l'importance du rôle du leader dans la clarification de la vision de la société et la motivation des employés à atteindre un niveau de productivité plus élevé et à exécuter les objectifs de la société."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipModerateDriverRecommendationBrief",
  //     text: "These results may indicate potential vulnerabilities in the transformational leadership approach and practices, which in turn affects employees' engagement. It is recommended to take immediate actions to enhance employee’s confidence and trust in transformational leadership and its approach.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هذه النتائج قد تشير إلى وجود ضعف محتمل بالنسبة لمنهج وسلوك القيادة للمرؤوسين والذي يؤثر بدوره على اندماج الموظفين. ويوصى هنا بضرورة اتخاذ إجراءات لتعزيز ثقة الموظفين بنهج وسلوك القيادة المتبع."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ces résultats peuvent indiquer des vulnérabilités potentielles dans l'approche et les pratiques de leadership transformationnel, ce qui à son tour affecte l'engagement des employés. Il est recommandé de prendre des mesures immédiates pour renforcer la confiance des employés dans le leadership transformationnel et son approche."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipModerateDriverRecommendationPointHeader",
  //     text: "The following actions can be taken to improve this driver autonomy. However, they are not limited to these options:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين عامل القيادة التحويلية:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Les actions suivantes peuvent être entreprises pour améliorer cette autonomie du conducteur. Cependant, ils ne sont pas limités à ces options:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipModerateDriverRecommendationTitle_1",
  //     text: "Coach the employees.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تدريب الموظفين."
  //       },
  //       {
  //         language: "FR",
  //         text: "Formation et entraînement des employés."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipModerateDriverRecommendationDesc_1",
  //     text: "Coaching and developing others is one of the most important ways to improve employees' performance and broaden their skillset and knowledge to achieve a higher level of professionalism and foster a positive learning environment.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يُعد تعليم وتوجيه الآخرين من أهم الطرق التي تسهم في تحسين أدائهم وتوسيع مداركهم وتطوير مهاراتهم لدعم تطورهم على الصعيد المهني والوصول لمستوى عالٍ من المهنية والإحترافية ومن الممكن العمل على عقد حلقات تدريبية بشكل مستمر وبالتالي تعزيز وجود بيئة تعليمية إيجابية."
  //       },
  //       {
  //         language: "FR",
  //         text: "L'entraînement et le développement de d'autres sont une des voies les plus importantes qui contribuent à l'amélioration de la performance d'employé et à élargir leurs compétences et leurs connaissances pour atteindre un niveau plus élevé de professionnalisme et ainsi favoriser un environnement d’apprentissage positif."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipModerateDriverRecommendationTitle_2",
  //     text: "Work in harmony towards achieving the business mission.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "العمل بانسجام لتحقيق رسالة العمل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Travailler en harmonie pour réaliser la mission d’affaires."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipModerateDriverRecommendationDesc_2",
  //     text: "This can be done by conducting weekly meetings with team members and seeking updates from each of them. Listen to their opinions and feedback on the tasks that have been accomplished. Ask if they have been facing any obstacles that they may require help with.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يمكن القيام بذلك من خلال عقد اجتماعات أسبوعية مع أعضاء الفريق، والحصول على المستجدات من كل منهم، والاستماع إلى آرائهم وتعليقاتهم على المهام التي تم إنجازها. والاستفسار عما إذا كانوا يواجهون أي عقبات قد يحتاجون إلى المساعدة بشأنها."
  //       },
  //       {
  //         language: "FR",
  //         text: "Cela peut être fait en menant des réunions hebdomadaires avec les membres de l’équipe et en demandant des mises à jour de chacun d’eux. Écoutez leurs opinions et leurs commentaires sur les tâches qui ont été accomplies. Demandez-leur s'ils ont été confrontés à des obstacles pour lesquels ils pourraient avoir besoin d'aide."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipModerateDriverRecommendationTitle_3",
  //     text: "Involve the employees in the change management process.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إشراك الموظفين في عملية إدارة التغيير."
  //       },
  //       {
  //         language: "FR",
  //         text: "Impliquez les employés dans le processus de gestion du changement."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipModerateDriverRecommendationDesc_3",
  //     text: "Most of the time, employees tend to resist change, which in turn causes slow or even failure to implement change. Here, the leader’s role is to prepare and support the employees to accept and adopt the change and successfully enhance business success and achieve the desired results.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "في أغلب الأحيان يميل الموظفون إلى مقاومة التغيير والتي بدورها تسبب في بطء تنفيذ التغيير أو حتى فشله. وهنا يأتي دور القائد لإعداد وتجهيز ودعم الموظفين في نفس الوقت ليقوموا بتبني التغيير والمساهمة في نجاحه من أجل تعزيز روح العمل وتحقيق النتائج المرجوة. "
  //       },
  //       {
  //         language: "FR",
  //         text: "La plupart du temps, les employés ont tendance à résister au changement, ce qui ralentit, voire échoue, à mettre en œuvre le changement. Ici, le rôle du leader est de préparer et d’aider les employés à accepter et à adopter le changement et à le faire réussir à améliorer le succès de l’entreprise et à atteindre les résultats souhaités."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipModerateDriverRecommendationTitle_4",
  //     text: "Instill trust in the employees to trust in the implemented actions and approach.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "غرس الثقة في الموظفين حتى يتمكنوا من الثقة في الإجراءات والنهج المتبعة. "
  //       },
  //       {
  //         language: "FR",
  //         text: "Instaurer la confiance des employés pour qu'ils fassent confiance aux actions et à l'approche mises en œuvre."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipModerateDriverRecommendationDesc_4",
  //     text: "This factor is important because if your employees do not trust the leadership approach, they may not go with what is assigned to them and may deviate/ swerve from the goals that to be achieved. Instill that trust by communicating what to be achieved and the results of those achievements as well as involving the employees in the decision-making process.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هذا العامل مهم للغاية لأنه إذا كان الموظفون لا يثقون بنهج القيادة؛ ولا يتماشون مع ما يوكل إليهم، وينحرفون عن الأهداف المطلوب تحقيقها. فإنه يجب غرس هذه الثقة من خلال إيصال ما يتطلع القائد إلى تحقيقه، وإبراز نتائج تلك الإنجازات، وجعل الموظفين جزءاً من عملية صنع القرار في كل خطوة يتم اتخاذها."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ce facteur est important car si vos employés ne font pas confiance à l'approche du leadership, ils risquent de ne pas suivre ce qui leur est assigné et de s'écarter / dévier des objectifs à atteindre. Instaurer cette confiance en communiquant ce qui doit être réalisé et les résultats de ces réalisations ainsi qu'en impliquant les employés dans le processus de prise de décision."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipModerateDriverOtherRecommendationHeader",
  //     text: "We also encourage the following initiatives and training programs to implement the aforementioned:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ونشجع على البرامج التدريبية والمبادرات التالية لتنفيذ ما سبق ذكره:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nous encourageons également les initiatives et les programmes de formation suivants à mettre en œuvre les mesures susmentionnées:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipModerateDriverOtherRecommendation_1",
  //     text: "Transformational Leadership Development Programs",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برامج تطوير القيادة التحويلية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Programmes de développement du leadership transformationnel"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipModerateDriverOtherRecommendation_2",
  //     text: "Coaching and developing other programs",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برنامج التدريب والتوجيه"
  //       },
  //       {
  //         language: "FR",
  //         text: "L'entraînement et le développement d'autres programmes"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipModerateDriverOtherRecommendation_3",
  //     text: "Change management programs",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برامج تدريب إدارة التغيير"
  //       },
  //       {
  //         language: "FR",
  //         text: "Programmes de gestion du changement"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipModerateDriverOtherRecommendation_4",
  //     text: "Leadership Skills Workshops",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ورش عمل عن مهارات القيادة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ateliers sur les compétences en leadership"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipModerateDriverOtherRecommendation_5",
  //     text: "Team Building Skills training programs",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "برامج تدريب مهارات بناء الفريق"
  //       },
  //       {
  //         language: "FR",
  //         text: "Programmes de formation sur les compétences de consolidation d'équipe"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipEngagedLowDriverReadings",
  //     text: "The analysis demonstrates that some employees have an adequate level of trust in the transformational leadership approach and practices. This shows the importance of the leader's role in clarifying the business vision and motivating employees to achieve a higher level of productivity and execute the business goals.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج إلى أن بعض الموظفين لديهم مستوى كافٍ من الثقة في نهج وسلوك القيادة للمرؤوسين. وهذا يُشير إلى أهمية دور القائد في توضيح رؤية العمل وتحفيز الموظفين للعمل من أجل تحقيق مستوى أعلى من الإنتاجية وتحقيق أهداف العمل."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipHighDriverReadings",
  //     text: "The analysis demonstrates that the employees trust the transformational leadership approach and practices. This reflects the leader's role in clarifying the business vision and motivating the employees to work hard to achieve a higher level of productivity and execute the business goals.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج إلى أن الموظفين لديهم ثقة في نهج وسلوك القيادة للمرؤوسين. وهذا يعكس دور القائد في توضيح رؤية العمل وتحفيز الموظفين للعمل الجاد من أجل تحقيق مستوى أعلى من الإنتاجية وتحقيق أهداف العمل."
  //       },
  //       {
  //         language: "FR",
  //         text: "L'analyse démontre que les employés font confiance à l'approche et aux pratiques du leadership transformationnel. Cela reflète le rôle du leader dans la clarification de la vision d'entreprise et la motivation des employés à travailler dur pour atteindre un niveau de productivité plus élevé et exécuter les objectifs commerciaux."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipHighDriverRecommendationBrief",
  //     text: "The recommended action is to follow up and continue managing your employees with the current style. It helps them understand how their role contributes to the business strategy. It also motivates them to work in harmony to accomplish the business mission. Persevere in engaging the employees in transformational projects and promote their trust in the approach to achieve business goals.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مسار العمل الموصى به هو متابعة ومواصلة إدارة الموظفين بالأسلوب الحالي لأنه يساعدهم على فهم كيفية مساهمة دورهم في استراتيجية العمل. كما أنه يحفزهم على العمل بانسجام نحو مهمة العمل. ويجب المثابرة على إشراك الموظفين في المشاريع التحويلية وتعزيز ثقتهم في النهج المتبع لتحقيق أهداف العمل."
  //       },
  //       {
  //         language: "FR",
  //         text: "L’action recommandée est de faire un suivi et de continuer à gérer vos employés avec le style actuel. Il les aide à comprendre comment leur rôle contribue à la stratégie d'affaires. Il les motive également à travailler en harmonie pour accomplir la mission d’affaires. Persévérer dans l’engagement des employés dans des projets transformationnels et de promouvoir leur confiance dans l’approche pour atteindre les objectifs de l’entreprise."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipHighDriverRecommendationPointHeader",
  //     text: "",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: ""
  //       },
  //       {
  //         language: "FR",
  //         text: ""
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTransformationalLeadershipExtremeHighDriverReadings",
  //     text: "The analysis demonstrates that the employees have immense trust in the transformational leadership approach and practices. This reflects the leader's role in clarifying the business vision and motivating the employees to work in harmony to achieve a higher level of productivity and execute the business goals.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير النتائج إلى أن الموظفين لديهم ثقة كبيرة في نهج وسلوك القيادة للمرؤوسين. وهذا يعكس دور القائد في توضيح رؤية العمل وتحفيز الموظفين للعمل بانسجام من أجل تحقيق مستوى أعلى من الإنتاجية وتحقيق أهداف العمل."
  //       },
  //       {
  //         language: "FR",
  //         text: "L’analyse démontre que les employés ont une immense confiance dans l’approche et les pratiques de leadership transformationnel. Cela reflète le rôle du leader dans la clarification de la vision de la société et la motivation des employés à travailler en harmonie pour atteindre un niveau de productivité plus élevé et exécuter les objectifs de la société."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHappinessIntroductionPara",
  //     text: "<p>Employee Happiness is the extent to which an employee is happy or satisfied with their work and the workplace that they are in. In other words, are they happy with their job? Are they happy with the work environment and atmosphere?</p>\n  <p>Happiness is considered a powerful motivator that encourages employees to perform harder and invest more effort in achieving business goals in addition to its essential role in improving retention and promoting a driven workplace culture.</p>\n  <p>This Employee Happiness Survey applies the 6Cs Model to measure employees’ happiness and satisfaction at the workplace, displayed in this report through in-depth analysis, scores, and recommendations.</p>",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "<p>سعادة الموظف هي مدى سعادة الموظف أو رضاه عن عمله ومكان العمل الذي يتواجد فيه. بمعنى آخر ، هل هم سعداء بوظيفتهم؟ هل هم سعداء ببيئة العمل والجو العام؟</p>\n  <p>تعتبر السعادة حافزاً قوياً يشجع الموظفين على العمل بجدية أكبر واستثمار المزيد من الجهد في تحقيق أهداف العمل، بالإضافة إلى دورها الأساسي في تحسين معدل الاحتفاظ بالموظفين وتعزيز ثقافة مكان العمل.</p>\n  <p>يُطبق استبيان سعادة الموظف \"نموذج6Cs \" لقياس مدى سعادة الموظفين ورضاهم في مكان العمل، والذي يتم عرضه في هذا التقرير من خلال التحليل المتعمق والنتائج المفصّلة والتوصيات.</p>"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHappinessObjectives",
  //     text: "\n  <h4 class=\"mb-5 fw-bold\">Objectives of this Report</h4>\n  <div class=\"columns-content\">\n  <div class=\"col-left\">\n    <ul>\n      <li>\n        <i class=\"fas fa-circle\"></i>\n        <p>Identify the overall workplace happiness score and understand how happy and unhappy employees affect the workplace and its overall performance.</p>\n      </li>\n      <li>\n        <i class=\"fas fa-circle\"></i>\n        <p>Identify the factors that retain your employees and keep them happy.</p>\n      </li>\n      <li>\n        <i class=\"fas fa-circle\"></i>\n        <p>Understand areas of improvement through factors with a low happiness score and the reason behind such a score.</p>\n      </li>\n    </ul>\n  </div>\n  <div class=\"col-sep\"></div>\n  <div class=\"col-right\">\n    <ul>\n      <li>\n        <i class=\"fas fa-circle\"></i>\n        <p>Access recommended actions to be taken for each factor, regardless of the happiness score, to improve your environment at work.</p>\n      </li>\n      <li>\n        <i class=\"fas fa-circle\"></i>\n        <p>Obtain open-ended statements or feedback submitted by employees during the survey, use it to improve ways of doing things, and understand how they feel about the workplace.</p>\n      </li>\n    </ul>\n  </div>\n</div> ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "\n  <h4 class=\"mb-5 fw-bold\">أهداف التقرير</h4>\n  <div class=\"columns-content\">\n  <div class=\"col-left\">\n    <ul>\n      <li>\n        <i class=\"fas fa-circle\"></i>\n        <p>تحديد درجة السعادة الوظيفية الإجمالية في مكان العمل وفهم كيف يؤثر الموظفون السعداء وغير السعداء على مكان العمل وأدائه الكلي.</p>\n      </li>\n      <li>\n        <i class=\"fas fa-circle\"></i>\n        <p>تحديد العوامل التي تجعل الموظفين سعداء مما يساعد على الاحتفاظ بهم.</p>\n      </li>\n      <li>\n        <i class=\"fas fa-circle\"></i>\n        <p>تحديد نقَاط التحسين عن طريق العوامل ذات السعادة المتدنية والأسباب وراء هذه النتائج.</p>\n      </li>\n    </ul>\n  </div>\n  <div class=\"col-sep\"></div>\n  <div class=\"col-right\">\n    <ul>\n      <li>\n        <i class=\"fas fa-circle\"></i>\n        <p>الحصول على توصيات لأخذها بعين الاعتبار لكل عامل، بغض النظر عن درجة السعادة الخاصة به وكيفية تطبيق هذه التوصيات لتحسين بيئة ومكان العمل.</p>\n      </li>\n      <li>\n        <i class=\"fas fa-circle\"></i>\n        <p>الحصول على تعليقات الموظفين من خلال الاستبيان، للاستفادة منها في تطوير طرق تنفيذ الأعمال، وفهم شعور الموظفين تجاه مكان العمل. </p>\n      </li>\n    </ul>\n  </div>\n</div> "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt6CModelbyZENITHR",
  //     text: "The 6Cs Model by ZENITHR",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نموذج 6Cs - ZENITHR"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHappinessScience",
  //     text: "Science Behind the 6Cs Model",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "العلم الذي يرتكز عليه نموذج  6Cs"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHappinessSciencePara",
  //     text: "<p class=\"mb-4\">Building ground above our research and influential names, ZENITHR’s research team has selected the best factors that affect employees’ happiness and satisfaction and lead to their retention. The selection ranged from top-rated universities, organizations, and workplaces that revealed a positive correlation between employee happiness and a thriving, performance-driven culture. The availability of multiple factors that drive satisfaction has provided ZENITHR with the ability to carefully pluck out those that measure employee happiness using various factors that begin with the same letter, C.</p>\n  <p class=\"mb-4\">The 6Cs, influenced by the latest scientific practices, research, and recent business trends, have been modeled to represent the research conducted. It constitutes multiple factors named Culture, Compensation, Connection, Conditions, Career Advancement, and Continuity. </p>",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "<p class=\"mb-4\">بناءً على الأبحاث التي قمنا بها والدراسات التابعة لخبراء مختصين، قام فريق البحث في ZENITHR باختيار أفضل العوامل التي تؤثر على سعادة الموظفين ورضاهم وبالتالي الاحتفاظ بهم. وقد ارتكز البحث على نطاق واسع من جامعات ذات تصنيف عالي، ومؤسسات، وأماكن عمل كشفت عن وجود علاقة إيجابية بين سعادة الموظف والثقافة المبنية على الأداء. إن توافر العديد من العوامل التي تدفع بالرضا جعل ZENITHR تستخلص تلك العوامل التي تقيس سعادة الموظف باستخدام مجموعة مختلفة من العوامل تبدأ بالحرف نفسه \"C\".</p>\n  <p class=\"mb-4\">تم تصميم نموذج 6Cs لتمثيل البحث الذي تم إجراؤه والذي يرتكز على أحدث الممارسات والأبحاث واتجاهات الأعمال الحديثة والذي يهدف إلى تحقيق بيئة عمل سعيدة. ويشكل عدة عوامل هي:\n  الثقافة، والتعويضات، والتواصل، وظروف العمل، والتطور الوظيفي، والاستمرارية.</p>"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHappinessHowToUseThisReportPara",
  //     text: "<p class=\"mb-4\">This report is a representation of the current level of happiness at [Company Name]. The overall happiness score will help understand how the employees feel across the workplace.</p>\n  <p class=\"mb-4\">The factors and their happiness levels displayed in this report are a result of the employees’ responses. Below every score is the analysis of the employees’ happiness with this specific factor at the workplace.</p>\n  <p class=\"mb-4\">Recommended actions in this report are only a few of the many activities that can be taken to improve the environment, and they are not limited to the displayed suggestions. It is highly encouraged that the actions deemed fit for [Company Name] are considered to improve their employees’ happiness levels.</p>",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "<p class=\"mb-4\">يوضح هذا التقرير المستوى الحالي للسعادة الوظيفية في [Company Name]. وسوف تساعد النتيجة الإجمالية للسعادة في فهم شعور الموظفين في مكان العمل.</p>\n  <p class=\"mb-4\">إن عوامل السعادة المبينة في هذا التقرير ومستوى السعادة الخاص بها هي نتيجة وخلاصة استجابة الموظفين لهذا الاستبيان. ويلي كل نتيجة، تحليل خاص بسعادة الموظفين حسب كل عامل ومدى ارتباطه في مكان العمل.</p>\n  <p class=\"mb-4\">إن الإجراءات الموصى بها في هذا التقرير ما هي إلا جزء من الإجراءات التي من الممكن اتخاذها في تحسين بيئة العمل، ولا تقتصر عليها فقط. وتشجع على اتخاذ الإجراءات المناسبة لتحسين مستوى السعادة الوظيفية الخاص بـ[Company Name].</p>"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtFactorsofWorkplaceHappiness",
  //     text: "Workplace Happiness Factors",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عامل السعادة في مكان العمل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Workplace Happiness Factors"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtOverallWorkplaceHappiness",
  //     text: "Overall Workplace Happiness",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "السعادة الوظيفية الكلية في مكان العمل"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtOverallWorkplaceHappinesspara1",
  //     text: "The Workplace Happiness Score measures the overall happiness across the workplace. It is the average score of all the factors combined.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تعبر نتيجة السعادة الوظيفية في مكان العمل عن الرضى والسعادة الكلية في مكان العمل. وهي تشكل المعدل الكلي لنتائج عوامل السعادة."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEmployeesHappinessIndexpara",
  //     text: "The Employee Happiness Index is the next level of the workplace happiness score. The below results represent the happiness and satisfaction levels of your employees:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "وتعرض النتائج أدناه، النسب المئوية التي تمثل الوضع الحالي لمستويات السعادة والرضا للموظفين: "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtExtremelyHappyDesc",
  //     text: "[Percentage]% of the participated employees are extremely happy with their job and the workplace. These employees are driven to do more than what is expected of them as they are rewarded and recognized for their effort.  They will continue to outperform in the tasks given to them and accomplish more achievements and successes and contribute to improving workplace culture and overall performance.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "[Percentage]% من الموظفين المشاركين سعداء للغاية بوظائفهم ومكان عملهم. لدى هؤلاء الموظفين الدافع للقيام بأكثر مما هو متوقع منهم نتيجة مكافئتهم وتقديرهم المستمر على جهودهم، وبالتالي سيواصلون التفوق في المهام الموكلة إليهم وتحقيق إنجازات ونجاحات أكثر، كما يساهمون في تحسين أداء وثقافة مكان العمل."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHappyDesc",
  //     text: "[Percentage]% of the participated employees are happy with their job and the workplace. These employees are motivated and encouraged to do more than what is expected of them as they are rewarded and recognized for their effort. They contribute to accomplishing more achievements and successes.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "[Percentage]% من الموظفين المشاركين سعداء بوظائفهم ومكان عملهم. لدى هؤلاء الموظفين الحافز الكافي للقيام بأكثر مما هو متوقع منهم نتيجة مكافئتهم وتقديرهم المستمر على جهودهم، وبالتالي يساهمون في تحقيق إنجازات ونجاحات أكثر وتحسين أداء وثقافة مكان العمل."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtUnHappyDesc",
  //     text: "[Percentage]% the participated employees are unhappy with their job and the workplace. They feel demotivated and less likely to improve workplace culture and overall performance because they do not feel sufficiently appreciated and rewarded for their work. This category of employees needs more recognition of their progress, encouragement, and support to be happier and satisfied.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "[Percentage]% من الموظفين المشاركين غير سعداء بوظائفهم ومكان عملهم. يشعر هؤلاء الموظفين بالإحباط ولا يوجد لديهم ميول للمساهمة في تحسين ثقافة مكان العمل وأدائه نتيجة عدم شعورهم بالتقدير الكافي لأعمالهم ومكافأتهم عليها.\n\n  تحتاج هذه الفئة من الموظفين إلى مزيد من التقدير والتشجيع والدعم المستمر ليكونوا أكثر سعادة ورضا.\n  "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtExtremelyUnHappyDesc",
  //     text: "[Percentage]% of the participated employees are extremely unhappy with the workplace. They feel extremely demotivated and do not contribute to improving workplace culture and overall performance because they do not feel sufficiently appreciated and rewarded for their work. This category of employees needs more recognition of their progress, encouragement, and support to be happier and satisfied.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "[Percentage]% من الموظفين المشاركين غير سعداء للغاية بوظائفهم ومكان عملهم. يشعر هؤلاء الموظفين بالإحباط الشديد وليس لديهم ميول للمساهمة في تحسين ثقافة مكان العمل وأدائه نتيجة عدم شعورهم بتقدير أعمالهم ومكافأتهم عليها.\n\n  تحتاج هذه الفئة من الموظفين إلى مزيد من التقدير والتشجيع والدعم المستمر ليكونوا أكثر سعادة ورضا.\n  "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtFactorsofWorkplaceHappinessDesc",
  //     text: "The below indicates the scores for each of the [Drivers Count] drivers of Workplace Happiness at [Company Name]:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "The below indicates the scores for each of the [Drivers Count] drivers of Workplace Happiness at [Company Name]:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtOverallWorkplaceHappinessScore",
  //     text: "Overall Workplace Happiness Score",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نتيجة السعادة الوظيفية الكلية في مكان العمل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Overall Workplace Happiness Score"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCultureDriverDesc",
  //     text: "Managerial and leadership daily activities, work practices, and their accustomed policies conducted by workplaces are directly influenced by the work culture and its influence over employees' personal, professional, and peer to peer communication behavior. Thus, accommodating for an empowering and supportive work environment alongside providing a flexibly regulated, satisfactory, and joyful atmosphere positively reflects the employees’ performance by unifying their efforts and willingness to achieve expected goals while attracting and retaining high caliber qualifications.\n\n  Conclusively: the existence of a positive culture in the workplace is vital, adding specialness to its vibe while granting the employees an identity to a place they belong, are loyal to, and take pride in being a part of, thus driving their hard-working, cooperative work ethic for the prosperity of their workplace.\n  ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تؤثر ثقافة العمل بشكل مباشرا على الأنشطة اليومية الممارسة داخل أماكن العمل ان كانت الإدارية، القيادية أم على ممارسات العمل وسياساته المتبعة. كما تؤثر ثقافة العمل على سلوك الموظفين على الصعيدين المهني والشخصي، وعلى سلوكه في التعامل مع زملائه، ولذلك فإن تهيئة بيئة عمل تمكينية ساندة وتوفير أجواء عامة منظمة ومرنة تمنح الموظفين شعوراً بالرضا والسعادة وتنعكس إيجابيا على أدائهم من خلال توحيد الجهود والرغبة لدى كافة الموظفين في العمل على تحقيق الأهداف المرصودة والتطلعات المستقبلية، إضافته لمساهمتها في استقطاب الكفاءات العالية والاحتفاظ بها.\n\n  وبالخلاصة: تعد الثقافة الإيجابية في مكان العمل أمراً حيوياً تجعله مميزاً وتمنح كافة الموظفين إحساساً بالهوية مما يعزز شعورهم بالانتماء والولاء لمكان عملهم وإحساسهم بالفخر كونهم جزءاً من هذا المكان، مما يدفعهم للعمل بجهد وتكاتف في سبيل إنجاحه.\n    "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCultureActionDesc",
  //     text: "Listed below are some procedures that can be implemented to improve culture that include, but are not limited to:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "فيما يلي بعض الإجراءات التي من الممكن الاستعانة بها عند الحاجة على سبيل المثال لا الحصر والتي من شأنها تحسين ثقافة العمل:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCultureActionDescription_1",
  //     text: "Continuously provide support for extracurricular initiatives and activities that enhance the employees’ well-being that differs from routine ones that the employees have been accustomed to. This provides a sense of enjoyment and fulfillment inside the workplace and enriches non-work-related social relationships within boundaries.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الحرص الدائم على توفير الدعم لكافة المبادرات والأنشطة التي تتعلق برفاهية الموظفين من خلال الخروج عن الرتابة والعادات المعتادة لإضفاء شعور بالراحة والاستمتاع داخل مكان العمل، وتوطيد العلاقات الاجتماعية خارج إطار العمل ضمن المقبول."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCultureActionDescription_2",
  //     text: "Share and celebrate personal and group success to create and enrich a family-like work environment. This is done by sharing success stories via internal communication channels or events to celebrate, acknowledge, and show gratitude for employees’ efforts.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مشاركة النجاحات الفردية والجماعية المهنية منها والشخصية والاحتفال بها بهدف خلق شعور عائلي في بيئة العمل. وغرس روح الإنتماء من خلال تبادل قصص النجاح عبر وسائل التواصل الداخلية في مكان العمل، أو عمل احتفال خاص بالمناسبة للثناء على الزملاء المجتهدين والاعتراف بجهودهم."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCultureActionDescription_3",
  //     text: "Actively listen to the employees’ ideas and suggestions, which results in a state of intellectual and emotional infusion; thus, it will positively impact their productivity and level of accountability in the workplace.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "التأكد من خلق حالة من الاندماج والتوافق العاطفي والفكري عند الموظف من خلال الاستماع باستمرار لأفكاره والترحيب باقتراحاته وتقديم الدعم اللازم لتنفيذ الاقتراحات المجدية مما ينعكس ايجابياً على انتاجيته وشعوره بالمسؤولية تجاه نجاح مكان عمله. "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCultureActionDescription_4",
  //     text: "4.\tEnsure integrating employees of different skill calibers while using on-the-job learning, follow-up, and mentoring methods, ensuring knowledge exchange, and strengthening employee relations within work teams.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الحرص على تشارك الخبرات والمعرفة ضمن أفرقة العمل من خلال دمج الموظفين الجدد والأقل خبرة بالموظفين من ذوي الخبرة واستخدام أساليب التعلم من خلال العمل والمتابعة والتوجيه مما يضمن تبادل المعرفة وتعزيز العلاقات بين الموظفين."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCultureExtremelyUnhappyDriverRecommendation",
  //     text: "This result indicates that employees are extremely unhappy and dissatisfied with the culture. Their loyalty levels are dangerously low. Additionally, they are unhappy with the encouragement and support provided for them to achieve the adequate level of the business’s goals and requirements; thus, they require immediate support to tackle the reasons behind their overall unhappiness and distress.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير هذه النتيجة إلى أن الموظفون لا يشعرون أبداً بأي نوع من أنواع الرضا والارتياح بالثقافة السائدة، ويشعرون بالاستياء الشديد حيالها، كما أنهم غير راضيين عن التشجيع والدعم المقدم لهم لتلبية متطلبات وأهداف العمل ولذلك هم بحاجة إلى المساندة الفورية لفهم أسبابهم ومعالجتها."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCultureUnhappyDriverRecommendation",
  //     text: "This result indicates that employees are unhappy and dissatisfied with the culture; they don’t possess sufficient loyalty. Additionally, they tend to be unhappy with the encouragement and support provided to achieve the business’s goals and requirements; thus, they need further help through discussions to tackle the reasons behind their overall unhappiness and distress.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير هذه النتيجة إلى أن الموظفون لا يشعرون بالرضا والارتياح بالثقافة السائدة ويشعرون بالاستياء حيالها، كما أنهم لا يشعرون بالانتماء والولاء لأماكن عملهم، وغير راضيين عن التشجيع والدعم المقدم لهم لتلبية متطلبات وأهداف العمل، ولذلك هم بحاجة للمزيد من المساندة لفهم أسبابهم ومعالجتها."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCultureHappyDriverRecommendation",
  //     text: "This result indicates that employees are happy and satisfied with the culture, with a high level of affiliation, loyalty, and taking pride in being a part of the workplace. They achieve the required goals with relative ease. They are rewarded with the encouragement and inspiration needed accordingly while collaboratively executing prosperous best practices with devotion and dedication to their workplace.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير هذه النتيجة إلى أن الموظفون يشعرون بالرضا والارتياح بالثقافة السائدة ويشيدون بها، كما أنهم يشعرون بالانتماء والولاء والفخر كونهم جزءاً من هذا المكان، ويحصلون على بعض التشجيع والإلهام اللازم لتلبية متطلبات وأهداف العمل، ويؤمنون بالعمل التشاركي والمشاورة للوصول إلى أفضل الأساليب التي تحقق النجاح والازدهار لأماكن عملهم."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCultureExtremelyHappyDriverRecommendation",
  //     text: "This result indicates that employees are extremely happy and satisfied with the culture, alongside feeling a high level of affiliation, loyalty, and taking pride by being a part of the workplace. They achieve the required goals with ease. They are rewarded with the encouragement and inspiration needed while collaboratively executing best practices with devotion and dedication to their workplace.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير هذه النتيجة إلى أن الموظفون يشعرون بالرضا والارتياح التام بالثقافة السائدة ويشيدون بها، كما أنهم يشعرون بالانتماء والولاء والفخر كونهم جزءاً من هذا المكان، ويحصلون على التشجيع والإلهام اللازم لتلبية متطلبات وأهداف العمل، ويؤمنون بالعمل التشاركي والمشاورة للوصول إلى أفضل الأساليب التي تحقق النجاح والازدهار لأماكن عملهم."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompensationDriverDesc",
  //     text: "The compensations package offered to employees directly impacts the employees’ satisfaction and well-being and their work dedication and commitment. Thus, resulting in a higher drive in their efforts to attain accomplishments within their scope of work due to their belief of being compensated accordingly. Therefore, workplaces could execute clear and fair compensation schemes that achieve equality between employees internally and externally within the job market that aids in higher retention rates, attracts exceptional talents, and motivates the employees to be more productive.\n\n  Conclusively: the employees’ compensation and benefits packages granted in return for achieving their workplace’s goals are considered as a key pillar for improving their happiness, which in return improves their job satisfaction, efficiency, and productivity, in addition to lowering absence and resigning incidences.\n  ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تحظى مجموعة التعويضات المقدمة للموظفين بتأثير مباشر على سعادة ورضا الموظفين ومدى ارتباطهم وإخلاصهم لأعمالهم. كما تدفعهم إلى بذل المزيد من الجهد لتحقيق المزيد من النجاح في مكان عملهم لقناعتهم بأنهم سيحصلون على التعويض والتقدير مقابل الجهد والإنجاز المبذول. لذلك قد ترغب أماكن العمل في تنفيذ برامج تعويضات ومكافآت واضحة وعادلة تحقق المساواة الداخلية بين الموظفين، وتمنحهم المساواة الخارجية مع سوق العمل والذي من شأنه أيضاً الاحتفاظ بالموظفين الحاليين واجتذاب الكفاءات والمواهب الاستثنائية وتحفيز الموظفين على السعي لتحقيق مستويات أعلى من الإنتاجية.\n\n  وبالخلاصة: تعد مجموعة التعويضات والمزايا الممنوحة للموظفين مقابل مساهماتهم في تحقيق أهداف مكان عملهم أحد أبرز أسباب سعادة الموظف والتي تؤثر في تعزيز الرضا الوظيفي وزيادة الكفاءة والإنتاجية في العمل، كما تُسهم في تقليل غياب الموظفين وتقليل حالات ترك العمل.\n  "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompensationActionDesc",
  //     text: "Listed below are some procedures that can be implemented to improve compensation and benefits schemes that include, but are not limited to:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "فيما يلي بعض الإجراءات التي من الممكن الاستعانة بها عند الحاجة على سبيل المثال لا الحصر والتي من شأنها تحسين مجموعة التعويضات والمزايا:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompensationActionDescription_1",
  //     text: "Grant attractive and competitive compensation and rewards programs by conducting periodical market studies that assess the industry’s compensation and benefits schemes considering various factors such as employees’ age, job level, personal life, and perhaps age and social status to motivate them to achieve more progress and success",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "منح برامج تعويضات ومزايا جاذبة وتنافسية من خلال مسح ودراسة برامج التعويضات الممنوحة في الأسواق المحلية بشكل دوري واختيار البرامج المناسبة لكل موظف مع الأخذ بعين الاعتبار عوامل متعددة مثل درجته الوظيفية وحياته الشخصية وربما عمره ووضعه الاجتماعي، لتحفيزهم لتحقيق المزيد من التقدم والنجاح."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompensationActionDescription_2",
  //     text: "Appreciate and value employees’ accomplishments through monetary and non-monetary compensations and rewards, i.e., salary incrementation, short- and long-term incentives. Additionally, provide non-monetary recognition programs such as appreciation, gratitude, achievement letters, and creative employee and employee of the month initiatives.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقدير وتثمين الإنجازات المبذولة من قبل الموظفين من خلال منح التعويضات والمكافآت المادية استحقاقاً لجهودهم مثل زيادة على الراتب الأساسي، ومنح الحوافز قصيرة وطويلة الأجل، وربما بعض المكافآت المادية المخصصة لذلك الموظف بناءً على تفضيلاته، إضافة إلى منح التعويضات المعنوية مثل رسائل الشكر والتقدير اللفظي والبرامج المحفزة مثل (الموظف المثالي والموظف المبدع)، وغيرها."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompensationActionDescription_3",
  //     text: "Create a compensation and benefits scheme that is designed specifically in reference to each employee’s scope of work, responsibility, role, and job level, including housing allowance, transportation allowance, education allowance, telephone allowance, and travel allowance on top of employee and family health insurance, life insurance as primary benefits which provides the employee with a sense of stability, security, and responsibility towards improving upon their workplace.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تخصيص برامج مزايا وبدلات تتناسب مع طبيعة العمل والدور والمسؤوليات التي يقوم بها الموظف والدرجة الوظيفية والتي تشمل (بدل مواصلات، وبدل سكن، وبدل تعليم، وبدل هاتف، وبدل السفر) إضافة إلى المزايا الأساسية مثل التأمين الصحي للموظفين ولأفراد أسرهم وربما لأفراد أسرهم، وتأمين الحياة مما يعزز شعور الموظف بالاستقرار والأمن الوظيفي وشعوره بالمسؤولية تجاه تطور مكان عمله واستمراريته."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompensationActionDescription_4",
  //     text: "Create a unique compensation scheme to distinguish the workplace from others, giving it a competitive advantage that attracts and maintains talent such as exceptional holidays in certain circumstances that do not conflict with work requirements, gifting during social and religious events, and offering provident fund programs.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ابتكار برامج تعويضات مميزة ينفرد فيها مكان العمل عن باقي المؤسسات مما يكسبه ميزة تنافسية تساهم في استقطاب الكفاءات والمحافظة عليهم مثل منح عطلات استثنائية في ظروف معينة بما لا يتعارض مع متطلبات العمل، أو إهدائهم بعض الهدايا الرمزية في المناسبات الاجتماعية أو الدينية، أو برامج صندوق الادخار. "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompensationExtremelyUnhappyDriverRecommendation",
  //     text: "This result indicates that employees are extremely dissatisfied with the compensation, benefits, and allowances schemes, and all their efforts are not appreciated nor recognized. They do not hold an obligation or responsibility towards their workplace's success and growth, thus requiring an immediate restructuring of their schemes.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير هذه النتيجة إلى أن الموظفين مستاءين جداً مما يحصلون عليه من تعويضات ومزايا وبدلات ممنوحة، ويشعرون بأن جهودهم المبذولة في عملهم لا يتم مقابلتها بالتقدير أبداً، ولا يشعرون بالالتزام والمسؤولية حيال نجاح وازدهار مكان عملهم، ويحتاجون إلى إعادة النظر الفورية في المكافآت والمزايا الممنوحة لهم."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompensationUnhappyDriverRecommendation",
  //     text: "This result indicates that employees are dissatisfied with the compensation, benefits, and allowances schemes, and their efforts are underappreciated. They do not hold an obligation or responsibility towards their workplace's success, growth; thus, they require re-evaluating their schemes.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير هذه النتيجة إلى أن الموظفين مستاءين مما يحصلون عليه من تعويضات ومزايا وبدلات ممنوحة، ويشعرون بأن جهودهم المبذولة في عملهم لا يتم مقابلتها بالتقدير، ولا يشعرون بالالتزام والمسؤولية حيال نجاح وازدهار مكان عملهم، ويحتاجون إلى إعادة النظر في المكافآت والمزايا الممنوحة لهم."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompensationHappyDriverRecommendation",
  //     text: "This result indicates that employees are relatively fulfilled and satisfied with the compensation, benefits, and allowances schemes, and most of their efforts are appreciated. They feel obliged, committed, and responsible for attaining business growth and achieving its goals.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير هذه النتيجة إلى أن الموظفين يشعرون بالقناعة والرضا إلى حد ما عما يحصلون عليه من تعويضات ومزايا وبدلات ممنوحة، وبأن معظم جهودهم المبذولة في عملهم يتم مقابلتها بالتقدير. كما يشعرون بالالتزام والمسؤولية تجاه تحقيق أهداف العمل ونموه."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompensationExtremelyHappyDriverRecommendation",
  //     text: "This result indicates that employees are absolutely fulfilled and satisfied with the compensation, benefits, and allowances schemes, and their efforts are fully appreciated. They feel fully obliged, committed, and responsible for attaining business growth and achieving its goals.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير هذه النتيجة إلى أن الموظفين يشعرون بالقناعة التامة والرضا عما يحصلون عليه من تعويضات ومزايا وبدلات ممنوحة، وبأن كافة جهودهم المبذولة في عملهم يتم مقابلتها بالتقدير على أكمل وجه. كما يشعرون بالالتزام والمسؤولية تجاه تحقيق أهداف العمل ونموه."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCommunicationDriverDesc",
  //     text: "Effective communication at workplaces is an important  a result of the employee’s lack of sense of belonging and loyalty and the inexistence of cooperation and responsibility, thus the absence of job happiness.\n  ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يُعد التواصل الفعّال في مكان العمل أمر في غاية الأهمية وأداة فعالة في شعور الموظف بالسعادة الوظيفية، حيث يساهم التواصل الفعّال في تحقيق الفهم والحد من التشتيت والتخمين والتفسير الشخصي وتقليل الأخطاء الناجمة عن سوء التواصل والتي قد تؤدي إلى شعور الموظف بالإحباط وقلة الثقة بالنفس والاستياء. كما يساهم التواصل الفعّال في بناء علاقات جيدة بين الرؤساء ومرؤوسيهم وزيادة إنتاجيتهم نتيجة الفهم الواضح والمشترك للأدوار والمسؤوليات المطلوبة من كل فرد لتحقيق أهداف العمل.\n\n\n  وبالخلاصة: يساهم التواصل الفعّال في خلق بيئة عمل أكثر إنتاجية وأكثر انفتاحاً عنها في بيئات العمل المنغلقة الطاردة للكفاءات والتي تزداد فيها معدلات الدوران الوظيفي نتيجة لعدم شعور الموظف بالانتماء والولاء لمكان العمل وانعدام روح المسؤولية والتشاركية وبالتالي انعدام السعادة الوظيفية.\n      "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCommunicationActionDesc",
  //     text: "Listed below are some procedures that can be implemented to improve the communication that include, but are not limited to:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "فيما يلي بعض الإجراءات التي من الممكن الاستعانة بها عند الحاجة على سبيل المثال لا الحصر والتي من شأنها تحسين التواصل:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCommunicationActionDescription_1",
  //     text: "Ensure the implementation of the (Open-Door Policy) in the essence of its huge role of strengthening communication among employees while supporting transparency and freedom of speech principles.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الاستمرار بتبني سياسة الباب المفتوح (open-door policy) لما لها من دور كبير في تعزيز التواصل بين الموظفين، ومن المهم دعم مبدأ الشفافية والسماح للموظفين بالتعبير عن آرائهم بحرية دون خوف."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCommunicationActionDescription_2",
  //     text: "Ensure communicating with employees while sharing expertise and previous experiences, lessons learned, successes while clarifying how to overcome possible challenges and obstacles smoothly.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "التأكيد على التواصل مع الموظفين ومشاركة الخبرات والتجارب السابقة والتحدث معهم حول الإنجازات والأخطاء وتوضيح كيف يمكنهم التعامل مع الصعوبات والتحديات التي قد تواجههم بسلاسة."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCommunicationActionDescription_3",
  //     text: "Ensure the empowerment of communication between the top management and their subordinates by visiting their offices, exchange greetings, and having small chats that do not revolve around work precisely. This signifies the positive vibe in the workplace and shows appreciation and caring towards employees seeking this type of care.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "التأكيد على تعزيز التواصل بين الإدارة العليا والموظفين من خلال التجول بين مكاتب الموظفين وتبادل التحيات وإجراء محادثة قصيرة معهم بين حين وآخر وسؤالهم عن أحوالهم، وهذا يعبر عن إيجابية المكان ويوجه رسالة تقدير للموظف الذي يبحث عن الاهتمام. "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCommunicationActionDescription_4",
  //     text: "Continuously conduct periodic meetings with the employees to share and discuss work-related updates and anticipated challenges to signify the importance of employee involvement with their propositions, opinions, and ideas.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الاستمرار بعقد اجتماعات منتظمة مع الموظفين ومشاركة الأمور المتعلقة بالعمل والتطورات والتحديات المتوقعة حيث من شأن ذلك التنويه على أهمية مشاركة الموظفين آرائهم واقتراحاتهم."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCommunicationActionDescription_5",
  //     text: "Optimize communication and social engagement within and outside the workplace premises by including social events such as having lunch together as a team, meetups, or implementing other events or ideas that encourage informal and friendly talks and relationships among employees.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "5.\tالتأكيد على تحسين الاتصال وتسهيل التفاعل الاجتماعي داخل وخارج العمل. من خلال تشجيع الأنشطة الاجتماعية مثل عقد غداء عمل للفريق، أو عقد اجتماعات غير الرسمية، أو تطبيق أي فكرة تجعل الموظفين يبتعدون عن مكاتبهم والتحدث مع بعضهم البعض بشكل عفوي وودي."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCommunicationExtremelyUnhappyDriverRecommendation",
  //     text: "This indicates that employees are extremely dissatisfied due to the absence of communication between teams and departments, vertically and horizontally, and signals immediate care to motivate and satisfy them.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير هذه النتائج إلى أن الموظفين غير سعداء إطلاقاً بسبب الافتقار إلى التواصل بين الفرق والأقسام. ويحتاج مستوى التواصل في مكان العمل إلى اهتمام فوري لتحفيز الموظفين وإسعادهم."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCommunicationUnhappyDriverRecommendation",
  //     text: "This indicates that the employees are dissatisfied with the communication level between teams and other departments. This, in return, affects cooperation between departments; this represents their need for more Two-way communication.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير هذه النتائج إلى أن الموظفين غير سعداء بمستوى التواصل بين الفرق والأقسام، ويؤثر هذا على التعاون داخل القسم وبين الأقسام الأخرى. ويشعرون أنهم بحاجة إلى مزيد من التواصل المتبادل (two-way communication) في مكان العمل."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCommunicationHappyDriverRecommendation",
  //     text: "This indicates that the employees are happy with the effective communication and cooperation at a team and departmental level. This shows that when communication levels are high, employees are motivated in response to the general environment at the workplace.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير هذه النتائج إلى أن الموظفين سعداء بالتواصل والتعاون الجيد بين الفرق والأقسام. ويدل ذلك على أنه عندما يكون التواصل مرتفعاً، ويشعر الموظفين بالتشجيع بسبب الجو العام في مكان العمل."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCommunicationExtremelyHappyDriverRecommendation",
  //     text: "This indicates that the employees are extremely happy with the effective communication and cooperation at a team and departmental levels and being happier. In contrast, Two-Way communication is done with ease at the workplace without being hesitant and/or considering consequences from sharing their thoughts freely.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير هذه النتائج إلى أن الموظفين سعداء للغاية بالتواصل والتعاون الفعال في العمل بين الفرق والأقسام، بالإضافة إلى أنهم يكونون أكثر ميولاً للشعور بالسعادة عندما يشعرون أن التواصل المتبادل (two-way communication) سلساً في مكان العمل ويسمح لهم بالتعبير عن آرائهم دون الخوف من التبعات."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConditionsDriverDesc",
  //     text: "Employees’ comfort and happiness are crucial to their performance, productivity, and results’ quality. The working environment conditions directly impact employees; thus, implementing suitable and flexible procedures improves employees’ retainment. It drives them towards completing tasks enthusiastically and dedicatedly as it is in human nature to put in the effort in something that rewards happiness.\n  Conclusively: An environment that cares about the psychological and health conditions brings out its employees' fully utilized efforts and talents by creating a positive environment, which reflects the workplace's reputation, thus a place where high skills aspire to work.\n  ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تؤثر ظروف بيئة العمل بشكل مباشر على إحساس الموظفين بالراحة والسعادة الوظيفية، كما تمتلك أهمية كبيرة في تحسين أداء العاملين وإنتاجيتهم وجودة مخرجاتهم، فوجود بيئة عمل داخلية مناسبة تتوفر بها كافة الوسائل التي تساعد على إنجاز الأعمال بسهولة ويسر، وتوفر سياسات وإجراءات مرنة وملائمة لطبيعة الأعمال تساهم في الاحتفاظ بالموظفين ودفعهم للالتزام بعملهم وإنجاز مهامهم المطلوبة بحماس وتفاني حيث يمنح الإنسان بطبيعته جهده وطاقته لشيء يمنحه السعادة.\n\n  وبالخلاصة: إن بيئة العمل التي تُراعى فيها النواحي النفسية والصحية تؤدي إلى إخراج أفضل المهارات والمواهب لدى الموظفين، وتخلق جو ملئ بالإيجابية بينهم والذي ينعكس على سمعة مكان العمل ليصبح مكاناً جاذباً يتطلّع الجميع للعمل فيه ويشعر موظفيه بالسعادة الوظيفية.\n  "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConditionsActionDesc",
  //     text: "Listed below are some procedures that can be implemented to improve workplace Conditions that include, but are not limited to:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "فيما يلي بعض الإجراءات التي من الممكن الاستعانة بها عند الحاجة على سبيل المثال لا الحصر والتي من شأنها تحسين ظروف بيئة العمل:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConditionsActionDescription_1",
  //     text: "Provide a working environment that considers space, lighting, design, furniture, appliances, cleanliness, catering, and meetings’ rooms up to modern standards, in terms of spaciousness, modern technologies, uplifting designs, and comfortable with accessible facilities. Also, an interior layout that allows visual communication between peers.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "توفير بيئة عمل جيدة من حيث تنظيم المساحة والإضاءة والتصميم وجودة الأثاث وحداثة الأجهزة المستخدمة ونظافة ونظافة المكان وتخصيص أماكن ملائمة لتناول الأطعمة والاجتماعات، والتأكد من تصميم المكان بطريقة تسمح بانسيابية التواصل المرئي بين الموظفين وسهولة الوصول للمرافق."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConditionsActionDescription_2",
  //     text: "Divisional physical separation is essential among any workplace per each’s work practices. Departments that rely extensively on conducting phone calls and are relatively mobile should be separated from other departments with employees that are stationary with less reliance on phone calls.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "التأكيد على الفصل بين الأقسام التي تتطلب طبيعة عملها استخدام المكالمات الهاتفية والتنقل باستمرار والأقسام الأخرى التي يكون موظفيها ثابتين ولا يعتمدون على المكالمات الهاتفية للحصول على أجواء مهنية أكثر راحة وتركيزاً."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConditionsActionDescription_3",
  //     text: "Update the policies and procedures to reflect the employees’ values and unique culture, considering the dynamic circumstances and the employees’ different roles.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تحديث السياسات والإجراءات الخاصة بالعمل باستمرار بحيث تعكس القيم والثقافة الخاصة بالموظفين واحتياجاتهم في مكان العمل مع مراعاة الظروف المتغيرة ومرونة التطبيق بما يتناسب مع كافة الموظفين وأدوارهم ومسؤولياتهم الوظيفية. "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConditionsActionDescription_4",
  //     text: "Accommodating a work-life balance results in a success-driven team. It ensures the employees’ healthy state of mind, wellbeing, and improved productivity by offering hybrid work, sick and emergency leaves, and flexible working hours tailored to each’s specific needs when and if applicable",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المحافظة على خلق التوازن بين كل من العمل والحياة الشخصية من خلال ترتيبات العمل المتسمة بالمرونة لضمان راحة ونجاح الموظف ولتقليل ضغوطه النفسية ومن الأمثلة على ذلك السماح للموظفين بالعمل من المنزل، أو أخذ إجازة للمواعيد الطبية أو الحالات الطارئة والعمل لساعات مرنة تناسب احتياجاتهم الشخصية."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConditionsExtremelyUnhappyDriverRecommendation",
  //     text: "This result indicates that the employees are extremely unhappy, discomforted, and dissatisfied with their work environment and implemented procedures, thus hindering their focus from accomplishing required tasks, resulting in less motivated and productive teams that could demean it publicly, hence, Reflecting a negative image.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير هذه النتيجة إلى أن الموظفين غير سعداء ولا يشعرون بالراحة على الإطلاق حيال ظروف بيئة العمل، وغير راضيين أبداً عن السياسات والإجراءات المتبعة في أماكن عملهم مما يشعرهم بالاستياء وعدم التركيز لإتمام مهامهم المطلوبة ناتجة بطاقم ذو كفاءة ودافعية اقل، ومن الممكن انتقاد ظروف بيئة عملهم في العلن خارج نطاق العمل مما تعكس انطباعاً سلبياً."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConditionsUnhappyDriverRecommendation",
  //     text: "This result indicates the discomfort and unhappiness of employees with regards to their work environment, and implemented procedures, thus hindering their focus from accomplishing required tasks",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير هذه النتيجة إلى أن الموظفين غير سعداء ولا يشعرون بالراحة حيال ظروف بيئة العمل، وغير راضيين عن السياسات والإجراءات المتبعة مما يشعرهم بالاستياء وعدم التركيز لإتمام مهامهم المطلوبة."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConditionsHappyDriverRecommendation",
  //     text: "his result indicates that employees are happy and satisfied with their work environment and how smooth the implemented procedures are, resulting in productive teams, submitting deliverables on time with the expected quality, and complementing their work environment with gratitude.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير هذه النتيجة إلى أن الموظفين سعداء ومرتاحون لظروف بيئة العمل، ويشعرون بالرضا عن مدى سلاسة السياسات والإجراءات المتبعة في أماكن عملهم مما يشعرهم بالحماس والتحفيز تجاه انجاز مهامهم بالوقت المناسب وبالجودة المطلوبة، ويثنون على ظروف بيئة عملهم."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConditionsExtremelyHappyDriverRecommendation",
  //     text: "This result indicates that employees are extremely happy and satisfied with all aspects of the work environment and how smooth the implemented procedures are, resulting in driven, motivated teams submitting deliverables on time with the expected quality and complementing their work environment publicly with gratitude.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير هذه النتيجة إلى أن الموظفين سعداء ومرتاحون جداً لظروف بيئة العمل من كافة النواحي، ويشعرون بالرضا عن مدى سلاسة السياسات والإجراءات المتبعة مما يشعرهم بالحماس والتحفيز تجاه انجاز مهامهم بالوقت المناسب وبالجودة المطلوبة، ويثنون على ظروف بيئة عملهم في العلن، داخل وخارج نطاق العمل. "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCareerAdvancementDriverDesc",
  //     text: "One of the key pillars for personal and career happiness is career advancement. Employees seek to accomplish a variety of successes to advance and take pride in their work while attaining self-actualization. Having a planned, clear, and just career path empowers their passion to progress. It achieves higher positions up the hierarchy, igniting a motive to infuse and interact while leveraging opportunities to utilize their existing skillset and expand it.\n\n  Career Advancement aids in shortening the gap between the employees’ actual and required capabilities while identifying competent individuals to fill in different managerial, leadership-related, and vocational-skill vacancies accordingly while attaining exceptional talent and improve employees’ retention ratio.\n\n  Conclusively: Employees actively seek career advancement to keep pace with the era’s economic and social changes and challenges, emphasizing that taking on appropriate career paths is vital for their career happiness.\n  ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يعد التطور الوظيفي أحد متطلبات السعادة الوظيفية والشخصية، حيث يسعى الموظفون لتحقيق العديد من الانجازات التي تشعرهم بالتقدم والفخر وتحقيق ذاتهم، لذلك فإن رؤيتهم لمسار وظيفي واضح وعادل تعزز من شغفهم في التطور والوصول لأعلى مراتب السلم الوظيفي كما تولد لديهم حافز قوي للاندماج والتفاعل، واستغلال كافة الفرص التي تمكنهم من استخدام مهاراتهم واكتساب خبرات جديدة.\n\n  ومن جهة أخرى، يساعد التطور الوظيفي على سد الفجوة بين قدرات الموظفين ومتطلبات الوظيفة والتعرف على الأفراد المؤهلين لتولي المناصب المختلفة، منها القيادية والمهنية والإدارية واجتذاب المواهب الاستثنائية، ورفع معدل الاحتفاظ بالموظفين.\n\n  وبالخلاصة: يسعى الموظفون كافة للتطور الوظيفي بقدر الإمكان لمواكبة تغيرات وصعوبات العصر من احتياجات مادية ومجتمعية وغيرها، تأكيدا على أن تخطيط الفرد ل ليكون في مسار وظيفي مناسب ومهماً جداً لتحقيق غاياته والوصول إلى السعادة الوظيفية.\n  "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCareerAdvancementActionDesc",
  //     text: "Listed below are some procedures that can be implemented to improve Career Advancement that include, but are not limited to:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "فيما يلي بعض الإجراءات التي من الممكن الاستعانة بها عند الحاجة على سبيل المثال لا الحصر والتي من شأنها تحسين التطور الوظيفي:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCareerAdvancementActionDescription_1",
  //     text: "Ensure having a clear and fair career path for all employees at all job levels.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "التأكد من وجود خطة مسار وظيفي واضحة وعادلة للموظفين على كافة المستويات."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCareerAdvancementActionDescription_2",
  //     text: "Construct development and continuous learning culture by preparing annual training and guidance plans while abiding with each employee’s work nature and training needs, measured by the annual appraisal.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "خلق ثقافة التطور والتعلم المستمر، من خلال اعداد خطط التدريب السنوية والبرامج التوجيهية بما يتوافق مع طبيعة عمل كل موظف واحتياجاته التدريبية المستمدة من عملية التقييم السنوي."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCareerAdvancementActionDescription_3",
  //     text: "Correlate career development with professional, academic certificates, and courses related to employees’ work nature, with the compensation, rewards, and appraisal programs.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ربط التطور الوظيفي بالإنجازات العملية والعلمية مثل الشهادات المهنية الاحترافية والأكاديمية والدورات ذات العلاقة بطبيعة العمل ببرامج المكافآت والتقييمات والترقيات."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCareerAdvancementActionDescription_4",
  //     text: "Ensure employees are granted exceptional permissions to obtain academic and professional degrees, attend training courses and workshops, such as flexible working hours that suit attendance dates, exam preparation dates, and more.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الحرص على منح الموظفين تسهيلات استثنائية للحصول على الشهادات الأكاديمية والمهنية وحضور الدورات التدريبية وورش العمل، مثل ساعات دوام مرنة تتناسب مع مواعيد محاضراتهم وإجازات دراسية لتقديم الاختبارات وغيرها."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCareerAdvancementExtremelyUnhappyDriverRecommendation",
  //     text: "This result indicates that the employees are extremely unhappy with their current positions and the implemented career development plan. Alongside their extreme dissatisfaction with the incentives, facilities, and support they are offered towards their career development. They urgently desire to change their workplace as it is inversely aligned with their career ambitions.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير هذه النتيجة إلى أن الموظفين غير سعداء على الإطلاق بمناصبهم الحالية وبخطة المسار والتطور الوظيفي المعمول بها، ولا يشعرون بالرضا أبداً عن الدعم والحوافز والتسهيلات المقدمة لهم في سبيل تطورهم الوظيفي، مما يجعلهم يرغبون في تغيير مكان عملهم فوراً لأنه لا يتناسب مع طموحاتهم الوظيفية."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCareerAdvancementUnhappyDriverRecommendation",
  //     text: "This result indicates that the employees are unhappy with their current positions and their implemented career development plan. Alongside their dissatisfaction with the incentives, facilities, and the support they are offered towards their career development. They consider changing their workplace as it isn’t aligned with their career ambitions.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير هذه النتيجة إلى أن الموظفين غير سعداء بمناصبهم الحالية وبخطة المسار والتطور الوظيفي المعمول بها، ولا يشعرون بالرضا عن الدعم والحوافز والتسهيلات المقدمة لهم في سبيل تطورهم الوظيفي، مما يجعلهم يرغبون في تغيير مكان عملهم لأنه لا يتناسب مع طموحاتهم الوظيفية."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCareerAdvancementHappyDriverRecommendation",
  //     text: "This result indicates that the employees are happy with their current positions and the implemented career development plan. Alongside their satisfaction with the incentives, facilities, and support they are offered towards their career development. They provide utmost efforts to optimize productivity, actualize themselves, and achieve their ambitions.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير هذه النتيجة إلى أن الموظفين سعداء بمناصبهم الحالية وبخطة المسار والتطور الوظيفي المعمول بها، ويشعرون بالرضا عن الدعم والحوافز والتسهيلات المقدمة لهم في سبيل تطورهم الوظيفي، مما يجعلهم لا يرغبون في تغيير مكان عملهم، بل ويبذلون جهودهم في تحقيق ذاتهم وطموحاتهم ورفع إنتاجية العمل."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCareerAdvancementExtremelyHappyDriverRecommendation",
  //     text: "This result indicates that employees are extremely happy with their current positions and the implemented career development plan. Alongside their extreme satisfaction with the incentives, facilities, and the support they are offered towards their career development, thus their absolute unwillingness to change their workplaces, but on the contrary, provide their utmost efforts to optimize productivity, actualize themselves, and achieve their ambitions.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير هذه النتيجة إلى أن الموظفين سعداء للغاية بمناصبهم الحالية وبخطة التطور الوظيفي المعمول بها، ويشعرون بالرضا عن الدعم والحوافز والتسهيلات المقدمة لهم، مما يجعلهم لا يرغبون أبداً في تغيير مكان عملهم، بل ويبذلون أقصى جهودهم لتحقيق ذاتهم وطموحاتهم ورفع إنتاجيتهم."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtContinuityDriverDesc",
  //     text: "The continuity and sustainability of the workplace’s success is a core pillar that grants the employees stability and security. Employees need to operate in a stable, well-equipped workplace that can adapt to changing situations and effectively correspond to work plans consistent with best practices derived from the workplace’s strategy while aligning teams to achieve it cooperatively. This empowers the workforce with higher trust in their leaders and their decisions to preserve workflows that, in turn, promote creativity and productivity.\n\n  Conclusively: Continuity is an imperative pillar that should exist at all stages of a workplace, as it indicates stability, security and provide career happiness to employees, which lessens their career and job concerns and fears that could hinder their sense of initiative and creativity\n  ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ًعد استمرارية واستدامة نجاح مكان العمل من الركائز التي تمنح الموظفين الأمان والاستقرار. حيث يحتاجون للعمل في مكان مستقر ومجهز للتأقلم مع الظروف المتغيرة للتعامل معها بشكل فعال بناءً على خطط عمل منسقة لأفضل الممارسات ومنبثقة من استراتيجية مكان العمل ليعمل الجميع نحو تحقيقها بتكاتف واجتهاد مما يمنح الموظفين الثقة بقادتهم وقراراتهم وأساليبهم في المحافظة على الأعمال واستدامتها والذي بدوره يحفز الموظفين على الابداع والإنتاجية.\n\n  وبالخلاصة: الاستمرارية هي ضرورة حتميّة وركيزةً أساسيّة لا بدّ من وجودِها لضمان شعور الموظف بالاستقرار والامان والسعادة الوظيفية التي تقلل من قلقه وخوفه حيال مستقبله الوظيفي وخسارته لعمله وقتل روح المبادرة والابداع.\n    "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtContinuityActionDesc",
  //     text: "Listed below are some procedures that can be implemented to improve Continuity that include, but are not limited to:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "فيما يلي بعض الإجراءات التي من الممكن الاستعانة بها عند الحاجة على سبيل المثال لا الحصر والتي من شأنها تحسين الاستمرارية:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtContinuityActionDescription_1",
  //     text: "Ensure the clear delivery and correct interpretation of the mission and vision statements and strategic goals are communicated to the employees, emphasizing each employee's roles on an individual and teams level.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "التأكد من إيصال الرسالة والرؤية والأهداف الاستراتيجية وتوضيحها لكافة الموظفين وبيان مسؤولية ودور كل موظف على الصعيدين الفردي وكمجموعة للالتزام بها وتحقيقها."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtContinuityActionDescription_2",
  //     text: "Adopt a holistic continuity methodology to practice by implementing all necessary steps required to ensure the employees’ sense of security and stability by cherishing their efforts, ensure the retention of qualified employees by adopting the measures needed ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اتباع وممارسة نهج فكري شامل عن طريق اتخاذ جميع الخطوات اللازمة لضمان شعور الموظف بالأمان والاستقرار الوظيفي من خلال تثمين جهودهم والحرص على عدم فقدان الأكفاء منهم."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtContinuityActionDescription_3",
  //     text: "Ensure that manuals and guidelines are available to staff for use in exceptional cases to enhance employees’ knowledge of the workplace’s readiness and capabilities.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "التأكد من وجود الأدلة الارشادية والتوجيهية في متناول يد الموظفين لاستخدامها في الحالات الاستثنائية لتعزيز معرفة الموظفين بجاهزية مكان العمل."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtContinuityActionDescription_4",
  //     text: "Continuously motivate employees by providing them with the needed space to excel, innovate, produce initiatives that drive and develop the work creatively within a structure that ensures sustainability.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تحفيز الموظفين باستمرار نحو التمييز والابداع من خلال توفيريهم بالمساحة الكافية للخروج بمبادرات وأفكار ريادية التي من شأنها النهوض وتطوير مكان العمل بمنهجية استمرارية داعمة لاستدامته."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtContinuityExtremelyUnhappyDriverRecommendation",
  //     text: "This result indicates that the employees are extremely unhappy with the stability and job security they possess at their workplace, derived from its instability and their unknowing of the strategic goals the workplace is trying to achieve. Additionally, they are apprehensive about their career's future as well as their distrust with the leadership styles practiced by their managers when dealing with unprecedented circumstances.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير هذه النتيجة إلى أن الموظفين غير سعداء على الإطلاق في أماكن عملهم نتيجة لعدم استقرار وثبات أماكن عملهم وعدم معرفتهم للأهداف الاستراتيجية التي تسعى لتحقيقها ويشعرون بالقلق الشديد حيال مستقبلهم الوظيفي، كما أنهم لا يثقون أبداً بالأساليب القيادية لرؤسائهم ولا بقدرتهم على التعامل مع الظروف الاستثنائية."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtContinuityUnhappyDriverRecommendation",
  //     text: " This result indicates that the employees are unhappy with the stability and job security they possess at their workplace, derived from its instability and their unknowing of the strategic goals the workplace is trying to achieve. Additionally, they are worried about their career's future as well as their distrust of the leadership styles practiced by their managers when dealing with unprecedented circumstances ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير هذه النتيجة إلى أن الموظفين غير سعداء في أماكن عملهم نتيجة لعدم استقرار وثبات أماكن عملهم وعدم معرفتهم للأهداف الاستراتيجية التي تسعى لتحقيقها ويشعرون بالقلق حيال مستقبلهم الوظيفي، كما أنهم لا يثقون بالأساليب القيادية لرؤسائهم ولا بقدرتهم على التعامل مع الظروف الاستثنائية."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtContinuityHappyDriverRecommendation",
  //     text: "This result indicates that the employees are happy with the stability and job security they possess, derived by the continuity and sustainability existent at their workplace, while not having any concerns about their career's future. ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير هذه النتيجة إلى أن الموظفين سعداء بمدى الاستقرار والأمن الوظيفي الذي يتمتعون به نتيجة للاستمرارية والديمومة التي تحظى بها أماكن عملهم ولا يشعرون بالقلق حيال مستقبلهم الوظيفي."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtContinuityExtremelyHappyDriverRecommendation",
  //     text: "This result indicates that the employees are extremely happy with the stability and job security they possess, derived by the continuity and sustainability existent at their workplace, while not having any concerns about their career's future. Moreover, they praise the leadership styles of their managers when dealing with unprecedented circumstances.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تشير هذه النتيجة إلى أن الموظفين سعداء للغاية بمدى الاستقرار والأمن الوظيفي الذي يتمتعون به نتيجة للاستمرارية والديمومة التي تحظى بها أماكن عملهم ولا يشعرون بالقلق أبداً حيال مستقبلهم الوظيفي، كما يشيدون بالأساليب القيادية لمدراءهم وحكمتهم في التعامل مع الظروف الاستثنائية."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtSurveyQuestionsPreview",
  //     text: "Survey Questions Preview",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نظرة عامة على أسئلة الاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Aperçu des questions du Enquęte"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txttableofcontents",
  //     text: "Table of Contents",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "جدول المحتويات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Table des matičres"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtResponses2",
  //     text: "Responses",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الردود"
  //       },
  //       {
  //         language: "FR",
  //         text: "Réponses"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtOutOf",
  //     text: "out of",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "من"
  //       },
  //       {
  //         language: "FR",
  //         text: "Hors de "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtModeratelyEngagedDesc",
  //     text: "[Percentage]% of the participated employees are moderately engaged within the workplace. These employees are less likely to be passionate about their job and the workplace. These are the ones who only do the work expected from them, but there is a chance for better effort if they receive more appreciation and support in their work. They are less loyal and productive.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "[Percentage]% من الموظفين مندمجون في عملهم بقدر معتدل، وهم أقل شغفاً بوظائفهم وبيئة العمل. هؤلاء الموظين يقومون بالعمل المتوقع منهم فقط، ولكن هنالك مجال لبذل مجهود أفضل في حال تم تقدير عملهم ودعمهم بشكل أكثر. ويعتبرون أقل إخلاصاً وإنتاجية."
  //       },
  //       {
  //         language: "FR",
  //         text: "[Percentage]% des employés participants sont moyennement engagés sur le lieu de travail. Ces employés sont moins susceptibles d'être passionnés par leur travail et leur milieu de travail. Ce sont eux qui ne font que le travail attendu d'eux, mais il y a une chance pour un meilleur effort s'ils reçoivent plus d'appréciation et de soutien dans leur travail. Ils sont moins fidèles et moins productifs."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHighlyEngagedDesc",
  //     text: "[Percentage]% of the participated employees are highly engaged within the workplace. These employees feel involved and passionate about their job and the workplace. They are innovative and creative in transforming knowledge and ideas into new products and services to achieve business goals.\n  They show a high level of loyalty, and they are motivated to be more productive.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "[Percentage]% من الموظفين مندمجون في عملهم بقدر كبير، نتيجة شعورهم بالشغف اتجاه وظائفهم واندماجهم في بيئة العمل. وهم مبدعين ومبتكرين في تحويل المعرفة والأفكار إلى قيم وإجراءات جديدة لتحقيق أهداف العمل. وهؤلاء الموظفين على درجة عالية من الإخلاص والإنتاجية."
  //       },
  //       {
  //         language: "FR",
  //         text: "[Percentage]% des employés participants sont très engagés sur le lieu de travail. Ces employés se sentent impliqués et passionnés par leur travail et leur milieu de travail. Ils sont innovants et créatifs dans la transformation des connaissances et des idées en nouveaux produits et services pour atteindre les objectifs de l’entreprise et les objectifs commerciaux. Ils font preuve d'un haut niveau de loyauté et sont motivés pour être plus productifs."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtLowlyEngagedDesc",
  //     text: "[Percentage]% of the participated employees are lowly engaged within the workplace. These employees feel they are not involved in the workplace, demotivated, and do not feel like doing the work expected of them. They are not loyal and not productive, and they may look for opportunities in a better work environment.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "[Percentage]% من الموظفين غير مندمجون في بيئة العمل، وهم محبطين ولا يبدون أي رغبة في القيام بالعمل الموكل إليهم. وهؤلاء الموظفين لا يظهرون أي درجة من الإخلاص وليس لديهم الدافع ليكونوا منتجين. وهنالك احتمالية لجوئهم للبحث عن فرص في بيئة عمل أفضل."
  //       },
  //       {
  //         language: "FR",
  //         text: "[Percentage]% des employés participants qui sont peu engagés sur le lieu de travail. Ces employés se sentent non impliqués dans le milieu de travail, démotivés et n'ont pas envie de faire le travail qu'on attend d'eux. Ils ne sont ni loyaux, ni productifs, et ils peuvent chercher des opportunités dans un meilleur environnement de travail."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtDriversofWorkplaceEngagementDesc",
  //     text: "The below indicates the scores for each of the [Drivers Count] drivers of Workplace Engagement at [Company Name]:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "وتعرض أدناه نتائج عوامل الاندماج المختارة لقياس الاندماج الوظيفي في مكان العمل ل [Company Name]:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Les résultats des facteurs d’Intégration retenus pour mesurer l’intégration professionnelle sur le lieu de travail sont présentés ci-dessous pour < Fort > [Company Name] </Fort> :"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtStronglyDisagree",
  //     text: "Strongly Disagree",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "غير موافق بشدة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Fortement en désaccord"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtDisagree",
  //     text: "Disagree",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "غير موافق"
  //       },
  //       {
  //         language: "FR",
  //         text: "Désaccord"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtNeutral2",
  //     text: "Neutral",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "محايد"
  //       },
  //       {
  //         language: "FR",
  //         text: "Neutre"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAgree",
  //     text: "Agree",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "موافق"
  //       },
  //       {
  //         language: "FR",
  //         text: "Accepter "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtStronglyAgree",
  //     text: "Strongly Agree",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "موافق بشدة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Tout ŕ fait d'accord"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtWorkplaceEngagementScore",
  //     text: "Workplace Engagement Score",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نتيجة الاندماج الوظيفي في مكان العمل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Score d'Engagement sur le Lieu de Travail"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtSurveysByCompany",
  //     text: "Surveys By Company",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الاستبيانات حسب الشركة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Enquętes par Entreprise"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_already_exists",
  //     text: "Already Exists",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "موجود أصلاً "
  //       },
  //       {
  //         language: "FR",
  //         text: "Existe déjŕ "
  //       }
  //     ]
  //   },
  //   {
  //     key: "btn_cancel",
  //     text: "Cancel",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إلغاء"
  //       },
  //       {
  //         language: "FR",
  //         text: "Annuler "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_delete_confirmation_message_assessment",
  //     text: "Are you sure you want to delete this Assessment?",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هل أنت متأكد من حذف هذا التقييم؟"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ętes-vous sűr de vouloir supprimer cette évaluation?"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_your",
  //     text: "your",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الخاص بك"
  //       },
  //       {
  //         language: "FR",
  //         text: "Votre"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_you",
  //     text: "you",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "أنت"
  //       },
  //       {
  //         language: "FR",
  //         text: "Vous"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTotalEvaluators",
  //     text: "Total Evaluators",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مجموع المقيمين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Total des Évaluateur "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtExcludingSelf",
  //     text: "(Excluding Self)",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "(ما عدا المرشح)"
  //       },
  //       {
  //         language: "FR",
  //         text: "(Ŕ l'exclusion de soi)"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCandidatePerformanceScore",
  //     text: "Candidate Performance Score",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نتيجة تقييم أداء المرشح"
  //       },
  //       {
  //         language: "FR",
  //         text: "Note de performance du candidat"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompChartAvgSelf",
  //     text: "Self Score",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "النتيجة الذاتية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Auto-score"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompChartAvgEvaluator",
  //     text: "Evaluators Score",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نتيجة المقيمين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Score des évaluateurs"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompChartYAxis",
  //     text: "Score (out of 5)",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "النتيجة (من 5)"
  //       },
  //       {
  //         language: "FR",
  //         text: "Score (sur 5)"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompChartXAxis",
  //     text: "Candidates (Self / Evaluators)",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المرشح (ذاتي/مقيمون)"
  //       },
  //       {
  //         language: "FR",
  //         text: "Candidats (Auto/ Évaluateurs)"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompChartTitle",
  //     text: "Candidates Performance Score",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نتيجة تقييم أداء المرشحين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Note de performance des candidats"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompChartTitleBy",
  //     text: "By Candidates Performance Score",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "حسب نتيجة تقييم أداء المرشحين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Note de performance des candidats"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompChartFor",
  //     text: "For",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لـ"
  //       },
  //       {
  //         language: "FR",
  //         text: "Pour"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompChartChooseCompetency",
  //     text: "Choose Competencies",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اختر الجدارات والمهارات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Choisir les Compétences"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompChartView",
  //     text: "View",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عرض"
  //       },
  //       {
  //         language: "FR",
  //         text: "Voir"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompChartSortBy",
  //     text: "Sort By",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تصنيف حسب"
  //       },
  //       {
  //         language: "FR",
  //         text: "Classer par"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAssessmentsList",
  //     text: "Assessments List",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قائمة التقييمات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Liste des Evaluations"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAssessmentsListDesc",
  //     text: "A list of assessments created with their status:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قائمة التقييمات التي تم إنشاؤها مع بيان حالتها:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Une liste d'évaluations créées avec leur statut:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btnNewAssessment",
  //     text: "New Assessment",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقييم جديد"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nouvelle Evaluation"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAssessmentTitle",
  //     text: "Assessment Title",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عنوان التقييم"
  //       },
  //       {
  //         language: "FR",
  //         text: "Titre d'Evaluation"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAssessmentReports",
  //     text: "Assessment Reports",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقارير التقييمات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Rapport de l'Evaluation"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompetencies",
  //     text: "Competencies",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الجدارات والمهارات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Compétences"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompetency",
  //     text: "Competency",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الجدارة أو المهارة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Compétence"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtRank",
  //     text: "Rank",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المركز"
  //       },
  //       {
  //         language: "FR",
  //         text: "Rang"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompetenciesDesc",
  //     text: "Open the deep analysis of each competency",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اطلع على التحليل المتقدم لكل جدارة ومهارة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ouvrir l'analyse approfondie de chaque compétence"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtResponsesDesc",
  //     text: "View progressive analysis for the Candidates / Evaluators",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عرض تحليل التقدم للمرشحين/ المقيمين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Voir l'analyse progressive pour les Candidats / Evaluateurs"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtOverallResponseRate",
  //     text: "Overall Response Rate",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "معدل الاستجابة العام"
  //       },
  //       {
  //         language: "FR",
  //         text: "Taux de Réponse Global"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCandidates",
  //     text: "Candidates",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المرشحون"
  //       },
  //       {
  //         language: "FR",
  //         text: "Candidats"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtSearchcandidates",
  //     text: "Search candidates...",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "البحث عن المرشحين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Rechercher des candidats..."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCandidateID",
  //     text: "Candidate ID",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الرقم الوظيفي للمرشح"
  //       },
  //       {
  //         language: "FR",
  //         text: "Numéro d'étudiant ou de candidat"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCandidateName",
  //     text: "Candidate's Name",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اسم المرشح"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nom du Candidat"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtNoofEvaluators",
  //     text: "# of Evaluators",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عدد المقيمين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nombre d'évaluateurs"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompetencyAnalysis",
  //     text: "Competency Analysis",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تحليل الجدارات والمهارات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Analyse des Compétences"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtfor",
  //     text: "For",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لـ"
  //       },
  //       {
  //         language: "FR",
  //         text: "Pour"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTotalNumberofEvaluators",
  //     text: "Total Number of Evaluators:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "العدد الكلي للمقيمين:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nombre total d'évaluateurs:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtcompetencyOverallScore",
  //     text: "competency / Overall Score",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "النتيجة الكلية لكل جدارة ومهارة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Compétence / Score Global"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtDetailedScore",
  //     text: "Detailed Score",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "النتيجة المفصلة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Note Détaillé"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtSelf",
  //     text: "Self",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ذاتي"
  //       },
  //       {
  //         language: "FR",
  //         text: "Auto"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtGap",
  //     text: "Gap",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الفرق"
  //       },
  //       {
  //         language: "FR",
  //         text: "Différence "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtScore",
  //     text: "Score",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "النتيجة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Résultat"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtStatements",
  //     text: "Statements",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "العبارات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Déclarations"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtStatement",
  //     text: "Statement",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "العبارة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Déclaration"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtstatementOverallScore",
  //     text: "statement / Overall Score",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "النتيجة الكلية لكل عبارة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Déclaration/ Score Global"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtNA",
  //     text: "N/A",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لا ينطبق"
  //       },
  //       {
  //         language: "FR",
  //         text: "N/A"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEvaluatorsComments",
  //     text: "Evaluators Comments",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تعليقات المقيمين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Commentaire des évaluateurs"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtStrengthAreas",
  //     text: "Strength Areas",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نقاط القوة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Régions de Force"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAreasofImprovements",
  //     text: "Areas of Improvements",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مجالات التحسين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Régions d'Améliorations"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtResponsesAnalysis",
  //     text: "Responses Analysis",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تحليل الردود"
  //       },
  //       {
  //         language: "FR",
  //         text: "Analyse des Réponses"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtSearchevaluators",
  //     text: "Search evaluators...",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "بحث المقيمون"
  //       },
  //       {
  //         language: "FR",
  //         text: "Rechercher des évaluateurs ..."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtSearchEntities",
  //     text: "Search evaluators...",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "بحث الوحدات"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAddRemoveCandidate",
  //     text: "Add / Remove Candidate",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إضافة/حذف مرشح"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ajouter / Supprimer un Candidat"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAddRemoveEvaluators",
  //     text: "Add / Remove Evaluators",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إضافة/حذف مقيم"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ajouter / Supprimer un Évaluateur "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtType",
  //     text: "Type",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نوع"
  //       },
  //       {
  //         language: "FR",
  //         text: "Type"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtRelationshipType",
  //     text: "Relationship Type",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نوع العلاقة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Type de Relation"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCreateNewAssessment",
  //     text: "Assessment Setup",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إعداد التقييم"
  //       },
  //       {
  //         language: "FR",
  //         text: "Configuration de l'Evaluation"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_assessment_preview_survey",
  //     text: "360° Assessment Survey",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "استبيان تقييم 360°"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCreateNewAssessmentDesc",
  //     text: "Follow the steps below to easily create a new 360° Feedback Assessment. You can go back to continue later.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اتبع الخطوات أدناه لإنشاء تقييم °360 بشكل سلس. يمكنك العودة لاحقاً للاستكمال."
  //       },
  //       {
  //         language: "FR",
  //         text: "Suivez les étapes ci-dessous pour créer facilement une nouvelle évaluation à 360°. Vous pouvez retourner pour continuer plus tard."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAssessmentsetup",
  //     text: "Assessment setup",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إعداد التقييم"
  //       },
  //       {
  //         language: "FR",
  //         text: "Configuration de l'Evaluation"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAssessmentInfo",
  //     text: "Assessment Information",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "معلومات التقييم"
  //       },
  //       {
  //         language: "FR",
  //         text: "Information de l'Evaluation"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtSelectTemplate",
  //     text: "Select Template",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اختر النموذج"
  //       },
  //       {
  //         language: "FR",
  //         text: "Sélectionner un Modčle"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtSelectTemplateDesc",
  //     text: "Tailored for your needs, reuse it in other assessments.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مخصصة لتلبية احتياجاتك، ويمكنك استخدامها بأي تقييم آخر."
  //       },
  //       {
  //         language: "FR",
  //         text: "Adapté à vos besoins, réutilisez-le dans d'autres évaluations."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCreateTemplate",
  //     text: "Create Template",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "أنشئ نموذج"
  //       },
  //       {
  //         language: "FR",
  //         text: "Créer un Modčle"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPredefined",
  //     text: "Predefined",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "معرف مسبقاً"
  //       },
  //       {
  //         language: "FR",
  //         text: "Prédéfini"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAssessmentPreview",
  //     text: "Assessment Preview",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عرض التقييم"
  //       },
  //       {
  //         language: "FR",
  //         text: "Aperçu de l'Evaluation"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtassessmentof",
  //     text: "360° Feedback is a measurement of how an individual is rated by others on their performance against their behavioral competencies.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقييم °360 هو أداة قياس للكيفية التي يقيّم بها الآخرون أداء الفرد مقابل جداراته ومهاراته السلوكية."
  //       },
  //       {
  //         language: "FR",
  //         text: "Le Commentaire à 360° est une mesure de la façon dont une personne est évaluée par d’autres sur sa performance par rapport à ses compétences comportementales."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt360ManagementReport",
  //     text: "360° Management Report",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقرير °360 الإداري "
  //       },
  //       {
  //         language: "FR",
  //         text: "Rapport de Gestion 360°"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt360CandidateReport",
  //     text: "360° Candidate Report",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقرير °360 للمرشح"
  //       },
  //       {
  //         language: "FR",
  //         text: "Rapport du Candidat 360°"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtSelected",
  //     text: "Selected",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المختارة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Choisi"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtto",
  //     text: "to",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إلى"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ŕ "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtViewTemplate",
  //     text: "View Template",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عرض النموذج"
  //       },
  //       {
  //         language: "FR",
  //         text: "Exposition du Formulaire"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEditTemplate",
  //     text: "Edit Template",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تعديل النموذج"
  //       },
  //       {
  //         language: "FR",
  //         text: "Modifier le Formulaire"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btnBacktoTemplates",
  //     text: "Back to Templates",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "العودة للنماذج"
  //       },
  //       {
  //         language: "FR",
  //         text: "Retour aux Modčles"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTemplatetitle",
  //     text: "Template title",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عنوان النموذج"
  //       },
  //       {
  //         language: "FR",
  //         text: "Titre du Modčle"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCategories",
  //     text: "Categories",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "التصنيفات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Catégories"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCandidatesPool",
  //     text: "Candidate Pool",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قائمة المرشحين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Réserve de candidats"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEvaluatorsPool",
  //     text: "Evaluator Pool",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "قائمة المقيمين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Réserve  des Évaluateurs "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_360_q_welcome",
  //     text: "Thank you for taking the time to fill out the 360° Feedback Assessment. Your honest feedback is highly appreciated. Please note that your responses are strictly confidential, and your identity shall remain anonymous throughout the entire process. However, the results of the assessment will be used for research and improvement purposes by the Human Resources Team.\n  <br><br>\nDisclaimer: All inforsessment shall remain anonymous and shall not be disclosed to anyone.\n",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نشكرك لمشاركتك في هذا التقييم.\nأجوبتك النزيهة والصريحة مهمة لنا.\n\nيرجى العلم بأن جميع النتائج التي سيتم الحصول عليها من هذا التقييم سرية للغاية وستبقى هويتك مجهولة.\nوتستخدم هذه النتائج فقط لأغراض البحث والتطوير من قبل فريق الموارد البشرية.\n\nإخلاء المسؤولية: جميع المعلومات المتعلقة بهذا التقييم سرية ولن يتم الإفصاح عنها لأي جهة.\n"
  //       },
  //       {
  //         language: "FR",
  //         text: "Merci d'avoir pris le temps de remplir l'évaluation de rétroaction à 360 °. Votre rétroaction honnête est très appréciée. Veuillez noter que vos réponses sont strictement confidentielles et que votre identité restera anonyme tout au long du processus. Cependant, les résultats de l'évaluation sera utilisé à des fins de recherche et d'amélioration par l'équipe des ressources humaines. Avis de non-responsabilité: Toutes les informations relatives à cette évaluation resteront anonymes et ne seront divulguées à personne."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_360_q_thank_you",
  //     text: "Your responses have been submitted successfully.\nThank you for completing the assessment and providing your feedback.\n",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم استلام جميع ردودك بنجاح!\nنشكرك على وقتك المبذول في تعبئة هذا التقييم.\n  "
  //       },
  //       {
  //         language: "FR",
  //         text: "Vos réponses ont été soumises avec succès. Merci d'avoir terminé l'évaluation et de nous avoir fait part de vos commentaires."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtothers",
  //     text: "others",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "أخرى"
  //       },
  //       {
  //         language: "FR",
  //         text: "Autres"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtOthers",
  //     text: "Others",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "أخرى"
  //       },
  //       {
  //         language: "FR",
  //         text: "Autres"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtReminderTriggerTime",
  //     text: "Reminder Trigger Time",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "وقت تفعيل التذكير"
  //       },
  //       {
  //         language: "FR",
  //         text: "Temps de Déclenchement du Rappel"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btnSaveTemplate",
  //     text: "Save Template",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "حفظ النموذج"
  //       },
  //       {
  //         language: "FR",
  //         text: "Sauvegarder le Modčle"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAddStatement",
  //     text: "Add Statement",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إضافة عبارة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ajouter une Déclaration"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtatleast",
  //     text: "Recommended 5 to 15 competencies and 3 to 5 statements each.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يوصي باختيار 5 إلى 15 مهارة وجدارة واختيار 3 إلى 5 عبارات لكل منها."
  //       },
  //       {
  //         language: "FR",
  //         text: "Recommandé 5 ŕ 15 compétences et 3 ŕ 5 déclarations chacun."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtStatementsSelected",
  //     text: "Statements Selected",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "العبارات المختارة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Déclarations Choisies"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtForCompetency",
  //     text: "For Competency",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لكل جدارة ومهارة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Pour les Compétence"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAddCompetency",
  //     text: "Add Competency",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إضافة جدارة ومهارة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ajouter une Compétence"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCandidateTemplate",
  //     text: "Candidate Template",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نموذج المرشح"
  //       },
  //       {
  //         language: "FR",
  //         text: "Modčle du Candidat"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtevaluatorsTemplate",
  //     text: "evaluators Template",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نموذج المقيم"
  //       },
  //       {
  //         language: "FR",
  //         text: "Modčle d'évaluateurs"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMinimumAdvised",
  //     text: "Minimum Advised",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الحد الأدنى الذي ينصح به"
  //       },
  //       {
  //         language: "FR",
  //         text: "Minimum conseillé"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTotalWeight",
  //     text: "Total Weight",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الوزن الكلي"
  //       },
  //       {
  //         language: "FR",
  //         text: "Poids Total"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtWeight",
  //     text: "Weight",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الوزن "
  //       },
  //       {
  //         language: "FR",
  //         text: "Poids "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompetenciesSelected",
  //     text: "Competencies Selected",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الجدارات والمهارات المختارة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Compétences Choisies"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtChooseType",
  //     text: "Relationship Type",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نوع العلاقة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Type de Relation"
  //       }
  //     ]
  //   },
  //   {
  //     key: "TransformationalLeadership",
  //     text: "Transformational Leadership",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "القيادة التحويلية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Leadership transformationnel"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtManagement",
  //     text: "Management",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الإدارة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Gestion"
  //       }
  //     ]
  //   },
  //   {
  //     key: "Management",
  //     text: "Management",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الإدارة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Gestion"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtSelfDevelopment",
  //     text: "Self-Development",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تطوير الذات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Auto-Développement"
  //       }
  //     ]
  //   },
  //   {
  //     key: "SelfDevelopment",
  //     text: "Self-Development",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تطوير الذات"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtWorkingwithOthers",
  //     text: "Working with Others",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "العمل مع الآخرين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Travail avec D'autres"
  //       }
  //     ]
  //   },
  //   {
  //     key: "WorkingWithOthers",
  //     text: "Working with Others",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "العمل مع الآخرين"
  //       }
  //     ]
  //   },
  //   {
  //     key: "GENERALCOMMENT",
  //     text: "General Comment",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "التعليقات العامة"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtDeliveringResults",
  //     text: "Delivering Results",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تحقيق النتائج"
  //       },
  //       {
  //         language: "FR",
  //         text: "Atteindre des Résultats"
  //       }
  //     ]
  //   },
  //   {
  //     key: "DeliveringResults",
  //     text: "Delivering Results",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تحقيق النتائج"
  //       },
  //       {
  //         language: "FR",
  //         text: "Atteindre des Résultats"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtRename",
  //     text: "Rename",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إعادة تسمية"
  //       },
  //       {
  //         language: "FR",
  //         text: "Renommer"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEditSurvey",
  //     text: "Edit Survey",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تعديل الاستبيان"
  //       },
  //       {
  //         language: "FR",
  //         text: "Modifier l'enquęte"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtSelectedCandidate",
  //     text: "Select Candidate",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "اختر المرشح"
  //       },
  //       {
  //         language: "FR",
  //         text: "Choisir le Candidat"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAssessReminderSubject",
  //     text: "[Reminder] Assessment Feedback 2021",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "[تذكير] تقييم أداء 2021"
  //       },
  //       {
  //         language: "FR",
  //         text: "[Rappel] Commentaires sur l'Evaluation 2021"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAssessmentOverviewReport",
  //     text: "°360 Assessment Overview Report",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "التقرير العام لتقييم °360"
  //       },
  //       {
  //         language: "FR",
  //         text: "Rapport d'Évaluation global ŕ 360°"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCandidateComptencySummaryReport",
  //     text: "'s °360 Assessment Competency Summary Report",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "التقرير الملخص للجدارات والمهارات لتقييم °360 ل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Rapport sommaire de synthčse des aptitudes et compétences pour l'évaluation 360°"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCandidateRespondentsAnalysisReport",
  //     text: "'s 360 Assessment Respondent Analysis Report",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقرير تحليل المستجيبون لتقييم °360 ل"
  //       },
  //       {
  //         language: "FR",
  //         text: "Rapport d'analyse des répondants pour une évaluation ŕ 360°"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt360FeedbackAssessment",
  //     text: "360° Feedback Assessment",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقييم أداء 360° "
  //       },
  //       {
  //         language: "FR",
  //         text: "Évaluation du Commentaire ŕ 360°"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt360FeedbackAssessmentReport",
  //     text: "360° Feedback Assessment Report",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقرير تقييم أداء 360°"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtDefinition",
  //     text: "Definition",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "التعريف"
  //       },
  //       {
  //         language: "FR",
  //         text: "Définition"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtPreparedFor",
  //     text: "Prepared For",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "أُعدَّ لـ"
  //       },
  //       {
  //         language: "FR",
  //         text: "Préparé pour"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtratingscale",
  //     text: "<h4>Rating Scale</h4>\n<p class=\"s-12 mb-4\">\nThe rating scale determines how the statements were rated and what each score represents.\n</p>\n<table class=\"layout-fixed text-center\">\n<thead>\n  <tr class=\"v-align-middle\">\n    <th>N/A</th>\n    <th>1</th>\n    <th>2</th>\n    <th>3</th>\n    <th>4</th>\n    <th>5</th>\n  </tr>\n  </thead>\n  <tbody>\n  <tr class=\"v-align-middle\">\n    <td>Not applicable</td>\n    <td>Strongly disagree</td>\n    <td>Disagree</td>\n    <td>Neutral</td>\n    <td>Agree</td>\n    <td>Strongly Agree</td>\n  </tr>\n  </tbody>\n</table>",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "<h4>مقياس التقييم</h4>\n<p class=\"s-12 mb-4\">\nيحدد مقياس التقييم آلية تقييم العبارات والأسئلة وماذا تمثل النتائج التي تم الحصول عليها.\n</p>\n<table class=\"layout-fixed text-center\">\n<tr class=\"v-align-middle\">\n<th>لا ينطبق</th>\n    <th>1</th>\n    <th>2</th>\n    <th>3</th>\n    <th>4</th>\n    <th>5</th>\n  </tr>\n  </thead>\n  <tbody>\n  <tr class=\"v-align-middle\">\n    <td>لا ينطبق</td>\n    <td>لا أوافق بشدة</td>\n    <td>لا أوافق</td>\n    <td>محايد</td>\n    <td>أوافق</td>\n    <td>أوافق بشدة</td>\n  </tr>\n  </tbody>\n</table>\n"
  //       },
  //       {
  //         language: "FR",
  //         text: "<h4>Échelle d’Évaluation</h4>\n<p class=\"s-12 mb-4\"> L'échelle d'évaluation définit le mécanisme d'évaluation des phrases et des questions et ce que représentent les résultats obtenus. </p>\n<table class=\"layout-fixed text-center\"> <thead> <tr class=\"v-align-middle\">\n<th> N/A</th>\n<th>  1</th>\n<th>  2</th>\n<th>  3</th>\n<th> 4</th>\n<th>  5</th>\n</tr> </thead> <tbody> <tr class=\"v-align-middle\">\n<td> N/A (N'est pas applicable)</td>\n<td>Fortement en Désaccord</td>\n<td>Désaccord/<td>\n<td>Neutre</td>\n<td>Accepter (Être d'accord)</td>\n<td>Tout à fait d'accord </td>\n</tr> </tbody> </table>\n"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHowtousethisreportparaman",
  //     text: "<p class=\"mb-4\">This report is a representation of [Candidate Name]’s feedback.</p>\n  <p class=\"mb-4\">The competencies overview will display the [Candidate Name]’s score compared to the evaluator’s score.</p>\n  <p class=\"mb-4\">It will highlight [Candidate Name]’s top five hidden strengths and blind spots that can be used to reference areas of improvement and encouragement.</p>\n",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "<p class=\"mb-4\">يبين هذا التقرير آراء وملاحظات الأفراد الذين قاموا بتقييم المرشح .[Candidate Name]</p>\n  <p class=\"mb-4\">ستجد نتيجة التقييم الذاتي للمرشح ونتائج تقييم الآخرين له في قسم \"النظرة العامة على الجدارات والمهارات\" في هذا التقرير.</p>\n  <p class=\"mb-4\">هذا التقرير يسلط الضوء على أعلى (5) نقاط للقوة المجهولة ونقاط الضعف غير المدركة لدى المرشح لاستخدامها كحافز للتطوير والتحسين الذاتي.</p>\n"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHowtousethisreportparacan",
  //     text: "<p class=\"mb-4\">This report is a representation of your evaluators feedback.</p>\n  <p class=\"mb-4\">The competencies overview will display your self-evaluated score compared to the evaluator’s score.</p>\n  <p class=\"mb-4\">It will highlight your top five hidden strengths and blind spots that can be used as a reference for areas of improvement and encouragement.</p>\n",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "<p class=\"mb-4\">يبين هذا التقرير آراء وملاحظات الأفراد الذين قاموا بتقييمك.</p>\n  <p class=\"mb-4\">ستجد نتيجة التقييمك الذاتي ونتائج تقييم الآخرين لل في قسم \"النظرة العامة على الجدارات والمهارات\" في هذا التقرير.</p>\n  <p class=\"mb-4\">هذا التقرير يسلط الضوء على أعلى (5) نقاط للقوة المجهولة ونقاط الضعف غير المدركة لاستخدامها كحافز للتطوير والتحسين الذاتي.</p>\n"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ce rapport est une représentation des commentaires de vos évaluateurs. Vous trouverez les résultats de votre propre évaluation et ceux d’autres personnes dans la section « Aperçu des compétences et aptitudes » de ce rapport. Le présent rapport met en évidence les cinq forces et faiblesses inconnues les plus élevées à utiliser comme catalyseur pour le développement et l’auto-amélioration."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtIntroductionpara1",
  //     text: "360-degree performance appraisal is one of the most important modern methods of evaluating an employee's behavior in the working environment to show different views on his professional performance, unlike the traditional performance appraisal, which mainly focuses on management / superior feedback.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يعد تقييم 360° من أهم الأساليب الحديثة لتقييم سلوك الموظف في بيئة العمل بهدف إظهار وجهات النظر المختلفة حول أدائه المهني على عكس تقييم الأداء التقليدي الذي يعتمد بشكل رئيسي على آراء وملاحظات المدير المباشر/ الإدارة."
  //       },
  //       {
  //         language: "FR",
  //         text: "L’évaluation à 360 degrés est l’une des méthodes modernes les plus importantes pour évaluer le comportement d’un employé dans l’environnement de travail pour montrer des points de vue différents sur sa performance professionnelle, contrairement à l’évaluation traditionnelle du rendement, qui s’appuie principalement sur les points de vue et les commentaires du gestionnaire/administrateur direct."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtIntroductionpara2",
  //     text: "This report is designed to derive feedback from the candidate's managers, peers, team members, and customers to provide different garnered views. It is meant to serve as a starting baseline for workplace development.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم تصميم هذا التقرير لاستخلاص الملاحظات والآراء من مدراء المرشح، وزملائه، وأعضاء فريقه، والعملاء، لتوفير وجهات نظر مختلفة حول أدائه وسلوكه المهني. والهدف من هذا التقرير هو أن يكون نقطة البداية لتحسين وتطوير بيئة العمل."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ce rapport est conçu pour recueillir les commentaires des gestionnaires, des pairs, des membres de l’équipe et des clients des candidats afin de fournir des points de vue différents. Il est destiné à servir de base de départ pour le développement du lieu de travail."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtIntroductionpara2can",
  //     text: "This report is designed to derive feedback from your managers, peers, team members, and customers to provide different garnered views. It is meant to serve as a starting baseline for workplace development.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم تصميم هذا التقرير لاستخلاص الملاحظات والآراء من مدرائك، وزملائك، وأعضاء فريقك، والعملاء الخاصين بك، لتوفير وجهات نظر مختلفة حول أدائك وسلوكك المهني. والهدف من هذا التقرير هو أن يكون نقطة البداية لتحسين وتطوير بيئة العمل."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ce rapport est conçu pour recueillir les commentaires de vos responsables, pairs, membres de l'équipe et clients afin de fournir différentes vues collectées. Il est destiné à servir de base de départ pour le développement du lieu de travail."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtobjectivespara",
  //     text: "\n  <h4 >Objectives of this Report</h4>\n              <ul class=\"bullets\">\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Identify and understand the candidate's professional behavior in certain situations and how it affects the workplace and its performance</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Identify the Candidate's hidden strengths and understand how they may be beneficial to the workplace.</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Identify the Candidate's blind spots, identify the reason behind them, and how they can be improved.</p>\n                </li>\n\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Access the scores for every competency and statement chosen from the extensive library of customizable and predefined templates.</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Obtain open-ended statements or feedback submitted by evaluators and use it to improve the Candidate's ways of doing things. </p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Garner a better understanding of the Candidate's characteristics and use that information to improve performance. </p>\n                </li>\n              </ul>\n            ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "\n  <h4 >أهداف التقرير:</h4>\n\n              <ul class=\"bullets\">\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>تحديد وفهم السلوك المهني للمرشح في مواقف معينة، وكيف يؤثر ذلك على أداء العمل.</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>تحديد نقاط القوة المجهولة للمرشح ومعرفة كيف يمكن الاستفادة منها لتطوير مكان العمل.</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>تحديد وفهم نقاط الضعف غير المدركة للمرشح وما هي المسببات وراءها، وكيف يمكن العمل على تحسينها وتطويرها.</p>\n                </li>\n\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>الإطلاع على النتائج الخاصة بكل الجدارات والمهارات المختارة من قاعدة البيانات التي تحتوي على نماذج مخصصة أو معرّفة مسبقاً.</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>الحصول على ملاحظات وآراء من المقيمين واستخدامها لتطوير طريقة المرشح في إنجاز الأعمال.</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>الوصول إلى فهم أفضل لمميزات المرشح وتوظيف هذه المعلومات لتطوير أدائه. </p>\n                </li>\n              </ul>\n            "
  //       },
  //       {
  //         language: "FR",
  //         text: "Objectifs du Rapport\n\nIdentifier et comprendre le comportement professionnel du candidat dans certaines situations et comment il affecte le lieu de travail et ses performances\n\nIdentifier les forces inconnues du candidat et comprendre comment ils peuvent être bénéfiques et favorables pour le lieu de travail.\n\nIdentifier et comprendre les faiblesses inacceptables du candidat, les causes, ainsi que la façon dont elles peuvent être améliorées et développées.\n\nAccéder aux scores de toutes les compétences et aptitudes sélectionnées dans la base de données contenant des modèles personnalisés ou prédéfinis.\n\n\nObtenir des déclarations ou des commentaires ouverts soumis par les évaluateurs et les utiliser pour améliorer les façons de faire des candidats.\n\nMieux comprendre les avantages du candidat et utiliser cette information pour développer ses performances."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtobjectivesparacan",
  //     text: "\n  <h4 >Objectives of this Report</h4>\n              <ul class=\"bullets\">\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Identify and understand your behavior in certain situations and how it affects the workplace and its performance.</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Provide you with your hidden strengths and understand how they may be beneficial to the workplace.</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Understand your blind spots, identify the reason behind them, and how they can be improved.</p>\n                </li>\n\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Obtain open-ended statements or feedback submitted by evaluators and use it to improve your way of doing things.</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>Garner a better understanding of your characteristics and use that information to improve your performance.</p>\n                </li>\n              </ul>                ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "\n  <h4 >أهداف التقرير:</h4>\n              <ul class=\"bullets\">\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>تحديد وفهم سلوكك المهني في مواقف معينة، وكيف يؤثر ذلك على أداء العمل.</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>تحديد نقاط القوة المجهولة لديك ومعرفة كيف يمكن الاستفادة منها لتطوير مكان العمل.</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>تحديد وفهم نقاط الضعف غير المدركة لديك وما هي المسببات وراءها، وكيف يمكن العمل على تحسينها وتطويرها.</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>الحصول على ملاحظات وآراء من المقيمين واستخدامها لتطوير طريقتك في إنجاز الأعمال.</p>\n                </li>\n                <li>\n                  <i class=\"fas fa-circle\"></i>\n                  <p>الوصول إلى فهم أفضل مميزاتك وتوظيف هذه المعلومات لتطوير أدائك.</p>\n                </li>\n              </ul>"
  //       },
  //       {
  //         language: "FR",
  //         text: "Objectifs de ce Rapport\n\n\nIdentifier et comprendre le comportement professionnel du candidat dans certaines situations et comment il affecte le lieu de travail et ses performances\n\nIdentifier les forces inconnues du candidat et comprendre comment elles peuvent être bénéfiques et favorables pour le lieu de travail.\n\nIdentifier et comprendre les faiblesses inacceptables du candidat, les causes, ainsi que la façon dont elles peuvent être améliorées et développées.\n\nObtenir des déclarations ouvertes ou des commentaires soumis par les évaluateurs et les utiliser pour améliorer les façons de faire des candidats.\n\nMieux comprendre les avantages et les meilleures fonctionnalités du candidat et utiliser ces informations pour développer vos performances.\n\n"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtcalcpros",
  //     text: "\n  <h4>Calculation Process</h4>\n  <div class=\"numbered-point\">\n  <span>1</span>\n                      <p>Each statement score is given an average rating based on the received feedback.</p>\n                      </div>\n                      <div class=\"numbered-point\">\n                        <span>2</span>\n                      <p>Each competency score is calculated as the overall rating score of the selected statements.</p>\n                      </div>\n                      <div class=\"numbered-point\">\n                        <span>3</span>\n                      <p>“Not Applicable” is excluded from the average score calculation.</p>\n                      </div>\n                      <div class=\"numbered-point\">\n                        <span>4</span>\n                      <p>The overall performance is calculated as the average rating of the weighted competencies.</p>\n                      </div>",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "\n  <h4>عملية الحساب</h4>\n  <div class=\"numbered-point\">\n  <span>1</span>\n    <p>يتم احتساب نتيجة كل عبارة من خلال أخذ متوسط نتائج اختيارات المقييمين.</p>\n    </div>\n    <div class=\"numbered-point\">\n      <span>2</span>\n    <p>يتم احتساب نتيجة كل جدارة ومهارة من خلال أخذ متوسط نتائج العبارات المختارة. </p>\n    </div>\n    <div class=\"numbered-point\">\n      <span>3</span>\n    <p>يتم استثناء خيار \"لا ينطبق\" من حساب معدل التقييم.</p>\n    </div>\n    <div class=\"numbered-point\">\n      <span>4</span>\n    <p>يتم احتساب معدل تقييم الأداء الكلي بحسب الأوزان المعطاة لكل جدارة ومهارة.  </p>\n  </div>"
  //       },
  //       {
  //         language: "FR",
  //         text: "Processus de Calcul\n1\nChaque note de déclaration reçoit une note moyenne basée sur les commentaires reçus.\n\n2\nChaque  note de compétences est calculé comme le score global de notation des énoncés sélectionnés.\n\n3\n«Sans objet» est exclu du calcul de la note moyenne.\n\n4\nLa performance globale est calculée comme la note moyenne des compétences pondérées.\n"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCandidateComptencyStatementReport",
  //     text: "'s °360 Assessment Competency Statement Report",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تقرير عبارات الجدارات والمهارات لتقييم °360 لـ"
  //       },
  //       {
  //         language: "FR",
  //         text: "Rapport de Déclaration de Compétence d'Évaluation 360°"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtnote",
  //     text: "Note: For confidentiality purposes, any group that is less than the required individuals will be merged with another group and will be included in calculating the average rating.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "لغايات السرية يتم دمج نتائج أي مجموعة يقل عدد المقيمين فيها عن الحد الأدنى المطلوب مع مجموعة أخرى في عملية حساب معدل التقييم النهائي."
  //       },
  //       {
  //         language: "FR",
  //         text: "Note: À des fins de confidentialité, tout groupe inférieur au nombre d'individus requis sera fusionné avec un autre groupe et sera inclus dans le calcul de la note moyenne."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtoverall",
  //     text: "Competencies Analysis",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تحليل الجدارات والمهارات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Analyse des Compétences"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConfidential",
  //     text: "Confidential",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "خاص وسري"
  //       },
  //       {
  //         language: "FR",
  //         text: "Confidentiel"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtsummarycomments",
  //     text: "Comments Summary",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ملخص التعليقات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Commentaires"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtsummarycommentsDesc",
  //     text: "The following comments are segmented by evaluator group and are presented exactly as the respondent entered them, highlighting [Candidate Name]’s areas of strength and the suggested areas to develop.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم عرض التعليقات أدناه تماماً  كما عبر عنها المقيمون، مسلطين الضوء على نقاط القوة ومجالات التحسين المقترحة ل[Candidate Name]."
  //       },
  //       {
  //         language: "FR",
  //         text: "Les commentaires suivants sont segmentés par groupe d’évaluateurs et sont présentés exactement au fur et à mesure comme le répondant les a saisis, mettant en évidence les points forts de [Candidate Name] et les domaines suggérés à développer."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtsummarycommentsDesccan",
  //     text: "The following comments are presented exactly as the respondent entered them, highlighting the areas of your strength and the suggested areas to develop.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم عرض التعليقات أدناه تماماً  كما عبر عنها المقيمون، مسلطين الضوء على نقاط قوتك ومجالات التحسين المقترحة."
  //       },
  //       {
  //         language: "FR",
  //         text: "Les commentaires suivants sont présentés exactement tels que le répondant les a saisis, mettant en évidence les domaines de votre force et les domaines suggérés à développer."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtspiderchart",
  //     text: "Spider Chart",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المخطط الشبكي"
  //       },
  //       {
  //         language: "FR",
  //         text: "Diagramme de Réseau"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtspiderchartdesc",
  //     text: "An illustration of [Candidate Name]’s self-evaluated score compared with the overall evaluators’ score.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يوضح هذا المخطط مقارنة بين نتيجة [Candidate Name] الذاتية مع معدل نتائج المقيمين الآخرين."
  //       },
  //       {
  //         language: "FR",
  //         text: "Une illustration du score auto-évalué de [Candidate Name] par rapport au score global des évaluateurs."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtspiderchartdesccan",
  //     text: "An illustration of your self-evaluated score compared with the overall evaluators' score.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يوضح هذا المخطط مقارنة بين نتيجتك الذاتية مع معدل نتائج المقيمين الآخرين."
  //       },
  //       {
  //         language: "FR",
  //         text: "Une illustration de la note auto-évaluée par rapport ŕ la note globale des évaluateurs."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtOverallPerformanceScoredesc",
  //     text: "Overall Performance Score",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "معدل تقييم الأداء العام"
  //       },
  //       {
  //         language: "FR",
  //         text: "Note Global de Performance"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtOverallPerformanceScoredescdesc",
  //     text: "The following indicates the Overall Performance Score for ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يبين الشكل أدناه النتيجة الكلية لمعدل تقييم الأداء الخاص بـ "
  //       },
  //       {
  //         language: "FR",
  //         text: "Ce qui suit indique le note Global de Performance pour "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtOverallPerformanceScoredesccandesc",
  //     text: "The following indicates your Overall Performance Score.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يبين الشكل أدناه النتيجة العامة لمعدل تقييم الأداء الخاص بـك."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ce qui suit indique le note Global de Performance "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtNumberofEvaluators",
  //     text: "Number of Evaluators",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "عدد المقيمين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Nombre des Evaluateurs"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtGroup",
  //     text: "Group",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "مجموعة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Groupe "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtGroupsInvited",
  //     text: "The following groups of individuals were invited to participate in this assessment",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم دعوة المجموعات التالية للمشاركة في هذا التقييم."
  //       },
  //       {
  //         language: "FR",
  //         text: "Les groupes de personnes suivants ont été invités ŕ participer ŕ cette évaluation."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompetenciesOverview",
  //     text: "Competencies Overview",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "النظرة العامة على الجدارات والمهارات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Aperçu des Compétences "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompetenciesOverviewDesc",
  //     text: "The following summarizes the scores of [Candidate Name] for the selected competencies.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الملخص أدناه يحتوي على نتائج الجدارات والمهارات التي تم اختيارها ل[Candidate Name]."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ce qui suit résume les scores de [Candidate Name] pour les Compétences Sélectionnées."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompetenciesOverviewDesccan",
  //     text: "The following summarizes your scores for the selected competencies.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الملخص أدناه يحتوي على نتائج الجدارات والمهارات التي تم اختيارها."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ce qui suit résume les notes des Compétences Sélectionnées."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtStatementsOverview",
  //     text: "Statements Overview",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "النظرة العامة على العبارات"
  //       },
  //       {
  //         language: "FR",
  //         text: "Aperçu des Déclarations"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtStatementsOverviewDesc",
  //     text: "The following summarizes the scores of [Candidate Name] for the selected competencies’ statements.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الملخص أدناه يحتوي على نتائج عبارات الجدارات والمهارات التي تم اختيارها ل[Candidate Name]."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ce qui suit résume les scores de [Candidate Name] pour les Déclarations des Compétences Sélectionnées."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtStatementsOverviewDesccan",
  //     text: "The below summarizes your scores for the selected competencies' statements.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ملخص أدناه يحتوي على نتائج عبارات الجدارات والمهارات التي تم اختيارها."
  //       },
  //       {
  //         language: "FR",
  //         text: "Ce qui suit résume vos scores pour les Déclarations des Compétences Sélectionnées."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHiddenBlind",
  //     text: "Hidden Strengths and Blind Spots",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نقاط القوة المجهولة ونقاط الضعف غير المدركة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Forces cachées et points aveugles"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHiddenBlindDesc",
  //     text: "The following tables list the top five hidden strengths and blind spots for [Candidate Name].",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يبين الجدول أدناه أعلى (5) نقاط للقوة المجهولة ونقاط الضعف غير المدركة ل[Candidate Name]."
  //       },
  //       {
  //         language: "FR",
  //         text: "Les tableaux suivants présentent les cinq principales Forces Inconnues et les Taches aveugles pour [Candidate Name]."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHiddenBlindDesccan",
  //     text: "The following tables list your top five hidden strengths and blind spots.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يبين الجدول أدناه أعلى (5) نقاط للقوة المجهولة ونقاط الضعف غير المدركة لديك."
  //       },
  //       {
  //         language: "FR",
  //         text: "Les tableaux suivants répertorient les cinq principaux atouts cachés et points aveugles pour vos."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHiddenDesc",
  //     text: "Hidden Strengths are the professional behaviors where evaluators have given an average rating more than the candidate has rated them. ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نقاط القوة المجهولة: هي السلوكيات المهنية التي أعطاها المقيمون درجة تقييم أعلى من تقييم المرشح لنفسه. "
  //       },
  //       {
  //         language: "FR",
  //         text: "Les Forces cachées sont les comportements professionnels où les évaluateurs ont donné une note moyenne supérieure à celle que le candidat leur a attribuée.   "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHiddenDesccan",
  //     text: "Hidden Strengths are the professional behaviors where evaluators have given an average rating above your rating.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نقاط القوة المجهولة: هي السلوكيات المهنية التي أعطاها المقيمون درجة أعلى من تلك التي قمت بإعطائها لنفسك. "
  //       },
  //       {
  //         language: "FR",
  //         text: "Les Forces cachées sont les comportements professionnels où les évaluateurs ont donné une note moyenne supérieure à votre note."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHiddenStrength",
  //     text: "Hidden Strengths",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نقاط القوة المجهولة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Forces cachées"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtBlindDesc",
  //     text: "Blind Spots are the professional behaviors where evaluators have given an average rating lower than the candidate has rated them.  ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نقاط الضعف غير المدركة: هي السلوكيات المهنية التي أعطاها المقيمون درجة تقييم أقل من تقييم المرشح لنفسه. "
  //       },
  //       {
  //         language: "FR",
  //         text: "Les Taches aveugles sont les comportements professionnels où les évaluateurs ont donné une note moyenne inférieure à celle que le candidat leur a attribuée."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtBlindDesccan",
  //     text: "Blind Spots are the professional behaviors where evaluators have given an average rating below your rating.",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نقاط الضعف غير المدركة: هي السلوكيات المهنية التي أعطاها المقيمون درجة أقل من تلك التي قمت بإعطائها لنفسك."
  //       },
  //       {
  //         language: "FR",
  //         text: "Les Taches aveugles sont les comportements professionnels où les évaluateurs ont donné une note moyenne inférieure à votre note."
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtBlind",
  //     text: "Blind Spots ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نقاط الضعف غير المدركة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Taches aveugles"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtBlindSpot",
  //     text: "Blind Spot",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نقطة ضعف غير مدركة"
  //       },
  //       {
  //         language: "FR",
  //         text: "Tache aveugle"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtAllEvaluators",
  //     text: "All evaluators ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "جميع المقيمين"
  //       },
  //       {
  //         language: "FR",
  //         text: "Tous les Évaluateurs  "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtTotal",
  //     text: "Total ",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "المجموع"
  //       },
  //       {
  //         language: "FR",
  //         text: "Total "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtGenerated",
  //     text: "Generated",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "تم إنشاءه في"
  //       },
  //       {
  //         language: "FR",
  //         text: "Créé  "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCanReportDesc",
  //     text: "This report provides a summary of the scores of the feedback received from you and the other evaluators on the following competencies:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "يقدم هذا التقرير ملخص لنتائج التقييم التي تم الحصول عليها منك ومن المقيمين الآخرين للجدارات والمهارات التالية:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Le présent rapport présente un résumé des résultats de votre évaluation et de celle d’autres évaluateurs des compétences et aptitudes suivantes:"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtReportDesc",
  //     text: "This report provides a summary of the scores of the feedback that has been received from the candidate and other evaluators on the following competencies:",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "هذا التقرير يقدم ملخص لنتائج التقييم من المرشح ومن المقيمين الآخرين للجدارات والمهارات التالية:"
  //       },
  //       {
  //         language: "FR",
  //         text: "Ce rapport fournit un résumé des résultats d'évaluation du candidat et d'autres évaluateurs des compétences et aptitudes suivantes: "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtEmployeeHappiness",
  //     text: "Employee Happiness",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "سعادة الموظف"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtHappinessSurvey",
  //     text: "Employee Happiness Survey",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "استبيان سعادة الموظف"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCulture",
  //     text: "Culture",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الثقافة"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCompensation",
  //     text: "Compensation",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "التعويضات"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCareerAdvancement",
  //     text: "Career Advancement",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "التطور الوظيفي"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtConditions",
  //     text: "Conditions",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "ظروف العمل "
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtContinuity",
  //     text: "Continuity",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "الاستمرارية"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtCommunication",
  //     text: "Communication",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "التواصل"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt6csModel",
  //     text: "THE 6C's MODEL",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "نموذج الـ 6C's"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtFactors",
  //     text: "Factors",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "العوامل"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtGenerate",
  //     text: "Generate",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "إنشاء"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt6CsTemplate",
  //     text: "6C's Template",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "أسئلة نموذج الـ 6C's"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtWorkplaceHappiness",
  //     text: "Workplace Happiness",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "السعادة في مكان العمل"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtLandingPageURL",
  //     text: "Survey Link",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "رابط الاستبيان"
  //       }
  //     ]
  //   },
  //   {
  //     key: "btnBacktoLandingPage",
  //     text: "Back to Survey Link",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "العودة للاستبيان"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtLandingPage",
  //     text: "Survey Link",
  //     translations: [
  //       {
  //         language: "AR",
  //         text: "رابط الاستبيان"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txtMinimumAdvise",
  //     translations: [
  //       {
  //         language: "AR"
  //       },
  //       {
  //         language: "FR",
  //         text: "dMinimum conseillé"
  //       }
  //     ]
  //   },
  //   {
  //     key: "txt_remove_candidate_confirmation_message\t",
  //     translations: [
  //       {
  //         language: "AR"
  //       },
  //       {
  //         language: "FR",
  //         text: "Êtes-vous sûr de vouloir supprimer ce candidat? Les répondants de ce candidat seront également supprimés!"
  //       }
  //     ]
  //   }
  // ];
  competenciesDefs: any[] = [
    { language: 'EN', key: "-MP-Qn0CtOwwqb7GXH40", name: "Leading Change", def: "The ability to manage change through setting direction and urgency, building a coalition of support, communicating widely, handling resistance to change." },
    { language: 'AR', key: "-MP-Qn0CtOwwqb7GXH40", name: "قيادة التغيير", def: "القدرة على إدارة التغيير من خلال التوجية وتحديد الأولويات ذات الأهمية، وتشكيل فرق عمل لدعم هذا التغيير، والتواصل على نطاق واسع ضمن كافة المستويات للتعامل مع مقاومة التغيير." },

    { language: 'EN', key: "-MP-RD-oK6B-s1-36Q6J", name: "Motivating & Inspiring", def: "The ability to support, encourage, and motivate individuals and teams to give their best by conveying confidence in their capabilities." },
    { language: 'AR', key: "-MP-RD-oK6B-s1-36Q6J", name: "التحفيز والتشجيع", def: "القدرة على دعم وتشجيع وتحفيز الأفراد وفرق العمل لتقديم أفضل ما لديهم من خلال تعزيز الثقة في قدراتهم." },

    { language: 'EN', key: "-MP-U140rRFx_0kStEbP", name: "Integrity & trust", def: "The ability to perform job responsibilities, involve others, seek methods, and help people learn new skills to build trust." },
    { language: 'AR', key: "-MP-U140rRFx_0kStEbP", name: "الثقة والنزاهة", def: "القدرة على أداء المسؤوليات الوظيفية وإشراك الآخرين في تحقيقها من خلال البحث عن الطرق التي تساهم في انجاز الأعمال، ومساعدة الآخرين على تعلم مهارات جديدة وتعزيز السلوكيات التي تبني الثقة." },

    { language: 'EN', key: "-MP-UklkdrsJpxLNL-Mk", name: "Drive for excellence", def: "The ability to set the standards for professional development opportunities and provide access to the latest resources to team members to be on the cutting edge of the field." },
    { language: 'AR', key: "-MP-UklkdrsJpxLNL-Mk", name: "السعي للتميز", def: "القدرة على وضع معايير لفرص التطور المهني والوظيفي وتسهيل عملية الوصول إلى أحدث المراجع والموارد لأعضاء الفريق ليكونوا على إطلاع بآخر المستجدات في مجال العمل الخاص بهم." },

    { language: 'EN', key: "-MP-VxH4zxivqv9wd__O", name: "Strategic Thinking", def: "The ability to think long-term and have a broader perspective for future factors that will affect the business and motivates others toward achieving the goals." },
    { language: 'AR', key: "-MP-VxH4zxivqv9wd__O", name: "التفكير الاستراتيجي", def: "القدرة على التفكير على الأمد الطويل والحصول على نظرة أوسع للعوامل المستقبلية التي ستؤثر على العمل ومشاركة التوجهات المختلفة عن طريق إشراك الآخرين وتحفيزهم لتحقيق أهداف العمل." },

    { language: 'EN', key: "-MP-XhZChcsxnGjImeHn", name: "Decision Making", def: "The ability to generate creative solutions to various work situations and make timely decisions using accurate judgment with clear explanations." },
    { language: 'AR', key: "-MP-XhZChcsxnGjImeHn", name: "اتخاذ القرارات", def: "القدرة على إيجاد حلول إبداعية لمواقف العمل المختلفة واتخاذ القرارات في الوقت المناسب بحكمة ووضوح." },

    { language: 'EN', key: "-MP-Z8AmWEBypp8rCkMK", name: "Business Reasoning", def: "The ability to understand business functions and metrics and understand where the business is heading in light of internal and external trends and influences." },
    { language: 'AR', key: "-MP-Z8AmWEBypp8rCkMK", name: "التفكير المنطقي بالأعمال", def: "القدرة على فهم الوظائف ومقاييس العمل، وفهم مسار العمل في ضوء العوامل المؤثرة الداخلية والخارجية." },

    { language: 'EN', key: "-MP-_PNVz9eNH1-Cq0s-", name: "Coaching & Developing Others", def: "The ability to improve performance through coaching and training others to broaden their skill set and knowledge." },
    { language: 'AR', key: "-MP-_PNVz9eNH1-Cq0s-", name: "التدريب وتطوير الآخرين", def: "القدرة على  تحسين الأداء من خلال تعليم وتوجيه الآخرين لتوسيع مداركهم وتطوير مهاراتهم لدعم تطورهم على الصعيد المهني والوصول لمستوى عالٍ من المهنية والإحترافية." },

    { language: 'EN', key: "-MP-_yU6lj43-l-xg7Sd", name: "Emotional Intelligence ", def: "The ability to recognize our feelings and those of others, and to manage emotions effectively in ourselves and our relationships." },
    { language: 'AR', key: "-MP-_yU6lj43-l-xg7Sd", name: "الذكاء العاطفي", def: "القدرة على إدراك المشاعر الشخصية ومشاعرالآخرين، والتحكم بالعواطف بشكل فعال في العلاقات المختلفة." },

    { language: 'EN', key: "-MP-YGL9s3YZfsZnxRf1", name: "People and Resource Management", def: "The ability to effectively manage all resources to achieve business goals and results." },
    { language: 'AR', key: "-MP-YGL9s3YZfsZnxRf1", name: "إدارة الموظفين والموارد", def: "القدرة على إدارة جميع الموارد المتاحة بشكل فعال لتحقيق أهداف العمل والنتائج المرجوة." },

    { language: 'EN', key: "-MP-eV0zVFT1LG38aMFh", name: "Interpersonal Skills", def: "The ability to interrelate with others and analyze personalities and adapt the best way to deal with each character." },
    { language: 'AR', key: "-MP-eV0zVFT1LG38aMFh", name: "مهارات التعامل مع الآخرين", def: "القدرة على بناء العلاقات مع الآخرين وتحليل الشخصيات وتبني أفضل طريقة للتعامل مع كل شخصية." },

    { language: 'EN', key: "-MP2wlpclsLhHMdB5LNe", name: "Self-Confidence", def: "The ability to understand and trust your skills and capabilities regardless of any imperfections or what others may believe about you." },
    { language: 'AR', key: "-MP2wlpclsLhHMdB5LNe", name: "الثقة بالنفس", def: "القدرة على فهم مهاراتك وقدراتك والثقة بها بغض النظر عن أي عيوب أو ما يعتقده الآخرون عنك." },

    { language: 'EN', key: "-MP2zncQYempY4qgXGfQ", name: "Flexibility/Resilience", def: "Is open to change and new information; rapidly adapts to new information, changing conditions, or unexpected obstacles. Has the ability to work effectively in a variety of situations and with various individuals or groups." },
    { language: 'AR', key: "-MP2zncQYempY4qgXGfQ", name: "المرونة", def: "يمتلك عقلية منفتحة للتغيير، ويتكيف بشكل سريع مع المعطيات الجديدة والظروف المتغيرة أو العقبات غير المتوقعة. ولديه القدرة على العمل بشكل فعال جداً بشكل فردي أو مع الفريق." },

    { language: 'EN', key: "-MP3-Cok-B17fzmsBQJr", name: "Initiative", def: "The ability to do more than what is required or expected of the job without detailed instructions. Makes constructive suggestions to do things that will improve or enhance the work process and business. Develops work opportunities and plans ahead for upcoming issues/problems and takes the appropriate action." },
    { language: 'AR', key: "-MP3-Cok-B17fzmsBQJr", name: "المبادرة", def: "القدرة على بذل جهد أكبر مما هو مطلوب ومتوقع للوظيفة من دون تعليمات مفصلة. ويقّدم اقتراحات بنّاءة لتنفيذ الأعمال التي من الممكن أن تحسّن وتطوّر عمليات تنفيذ المهام. ويُطور فرص العمل ويُخطط للتعامل مع المخاطر والمشاكل المحتملة لاتخاذ الإجراءات اللازمة في حينه." },
    { language: 'EN', key: "-MP3QKwsm9lAXZewc1Py", name: "Problem Solving", def: "The ability to identify and solve problems on time, gather and analyze information skillfully, in addition, to develop alternative solutions, and work well in group-problem-solving meetings." },
    { language: 'AR', key: "-MP3QKwsm9lAXZewc1Py", name: "حل المشاكل", def: "القدرة على تحديد المشكلات وحلها في الوقت المناسب، وجمع المعلومات وتحليلها بمهارة، بالإضافة إلى تطوير حلول بديلة، والعمل بشكل جيد في اجتماعات حل المشكلات الجماعية." },
    { language: 'EN', key: "-MPsHRcRZCbX8PCuv__u", name: "Analytical Ability", def: "The ability to collect complex & diverse information, analyze the situation, identify causes, identify opportunities & alternatives. Provides quality solutions and implements the most appropriate action." },
    { language: 'AR', key: "-MPsHRcRZCbX8PCuv__u", name: "القدرة التحليلية", def: "القدرة على جمع المعلومات المعقدة والمتنوعة، وتحليل المواقف المختلفة، وتحديد الأسباب، والفرص والبدائل. ويُقدم حلولاً عالية الجودة ويُنفذها بإجراءات مناسبة." },
    { language: 'EN', key: "-MP3VDUcdVsarsC-BhLI", name: "Effective Communication", def: "The ability to effectively and efficiently communicate and collect information and enhance the communication skills to facilitate information sharing with others." },
    { language: 'AR', key: "-MP3VDUcdVsarsC-BhLI", name: "التواصل الفعال", def: "القدرة على إيصال وجمع المعلومات بفعالية وكفاءة وتعزيز مهارات الاتصال المختلفة لتسهيل مشاركة المعلومات بين الموظفين." },
    { language: 'EN', key: "-MP3VYuXwY5WyzbS30xC", name: "Influence", def: "The ability to create a good first impression and demonstrates the ability to convince others of your points of view and ideas." },
    { language: 'AR', key: "-MP3VYuXwY5WyzbS30xC", name: "التأثير", def: "القدرة على خلق انطباع أول جيد وإثبات قدرتك على إقناع الآخرين بآرائك وأفكارك." },
    { language: 'EN', key: '-MPsIer4pygEcGG7UceC', name: "Team Working", def: "The ability to contribute to teams and to improve their effectiveness and to accomplish goals." },
    { language: 'AR', key: '-MPsIer4pygEcGG7UceC', name: "العمل بروح الفريق ", def: "القدرة على العمل بفعالية مع الفريق أو مجموعات العمل لتحقيق أهداف العمل." },
    { language: 'EN', key: "-MP3Vs1c9YCiEUqv42sB", name: "Relationship Building", def: "The ability to build and maintain long-term trusting relationships within and outside the workplace." },
    { language: 'AR', key: "-MP3Vs1c9YCiEUqv42sB", name: "بناء العلاقات", def: "القدرة على بناء علاقات طويلة الأجل في مكان العمل وخارجه والحفاظ عليها." },
    { language: 'EN', key: "-MP3WC7L-PFJuhcpcGYz", name: "Accountability & Dependability", def: "The ability to hold people accountable to take responsibility for one's actions and decisions. Determines objectives, sets priorities, and delegates work." },
    { language: 'AR', key: "-MP3WC7L-PFJuhcpcGYz", name: "المسؤولية والاعتماد على الذات", def: "القدرة على جعل الموظفين مسؤولين عن نتائج أفعالهم وقراراتهم. ويساعدهم على تحديد الأهداف، وتحديد الأولويات، وتفويض العمل." },
    { language: 'EN', key: "-MP3WTag_z7c685Dd-Ue", name: "Negotiation & Persuasion", def: "The ability to negotiate and convince others to take a course of action and achieve results effectively." },
    { language: 'AR', key: "-MP3WTag_z7c685Dd-Ue", name: "المفاوضة والإقناع", def: "القدرة على التفاوض مع الآخرين وإقناعهم أو التأثير عليهم لاتخاذ مسار عمل وتحقيق النتائج بشكل فعال." },
    { language: 'EN', key: "-MP3WuBIv69hkmkwTTDK", name: "Customer Focus", def: "Seeking to determine the needs of customers and taking action to satisfy them." },
    { language: 'AR', key: "-MP3WuBIv69hkmkwTTDK", name: "التركيز على العملاء", def: "القدرة على تحديد احتياجات العملاء واتخاذ الإجراءات المناسبة لارضائهم." },
    { language: 'EN', key: "-MP3XWQ96Ucp8zYh8nXX", name: "Planning & Organizing ", def: "The ability to plan, organize and prioritize work for self and team members by defining tasks and milestones to achieve business objectives." },
    { language: 'AR', key: "-MP3XWQ96Ucp8zYh8nXX", name: "التخطيط والتنظيم", def: "القدرة على تحديد مسار عمل معين للذات و/أو للآخرين لتحقيق هدف معين من خلال التخطيط الفعال وعمل الجداول الزمنية المناسبة وتحديد الأولويات لتحقيق أهداف العمل." },
    { language: 'EN', key: "-MP3XrIaJr-n_0QIxOak", name: "Innovation", def: "The ability to develop useful ideas that are new, better, or unique and introduce new ways of looking at problems." },
    { language: 'AR', key: "-MP3XrIaJr-n_0QIxOak", name: "الابتكار", def: "القدرة على إيجاد أفكار جديدة مفيدة وفريدة وتقديم طرق جديدة للنظر في حل المشاكل." },
    { language: 'EN', key: "-MP3YBqYIRFOWS5dqd-D", name: "Result Oriented", def: "The ability to recognize what results are important and what to be done to achieve the expected outcomes within a specified schedule." },
    { language: 'AR', key: "-MP3YBqYIRFOWS5dqd-D", name: "محفّز بالنتائج", def: "القدرة على إدراك النتائج المهمة ومعرفة ما يجب تطبيقه لتحقيق نتائج فعالة ضمن جدول زمني محدد وذات جودة عالية." }
  ]
  getCompetencyDef(key: string, language: string) {
    var comp = this.competenciesDefs.find(x => x.key == key && x.language == language);
    return comp ? comp.def : "";
  }

  // getHappinessUILanguage(key: string, language: string) {
  //   let lngO = this.happinessComponentText.find(cT => (cT.key == key && cT.language == language));
  //   if (lngO) {
  //     return lngO.name;
  //   } else {
  //     lngO = this.happinessComponentText.find(cT => (cT.key == key));
  //     if (lngO) {
  //       return lngO.name;
  //     }
  //   }
  //   return '';
  // }
  // getAssessmentUILanguage(key: string, language: string) {
  //   let lngO = this.assessmentComponentText.find(cT => (cT.key == key && cT.language == language));
  //   if (lngO) {
  //     return lngO.name;
  //   } else {
  //     lngO = this.assessmentComponentText.find(cT => (cT.key == key));
  //     if (lngO) {
  //       return lngO.name;
  //     }
  //   }
  //   return '';
  // }




  supportedLanguages: any[] = [
    {
      "key": "EN",
      "name": "English",
      "nativeName": "English"
    },
    {
      "key": "AR",
      "name": "Arabic",
      "nativeName": "العربية"
    },
    {
      "key": "AB",
      "name": "Abkhaz",
      "nativeName": "аҧсуа"
    },
    {
      "key": "AA",
      "name": "Afar",
      "nativeName": "Afaraf"
    },
    {
      "key": "AF",
      "name": "Afrikaans",
      "nativeName": "Afrikaans"
    },
    {
      "key": "AK",
      "name": "Akan",
      "nativeName": "Akan"
    },
    {
      "key": "SQ",
      "name": "Albanian",
      "nativeName": "Shqip"
    },
    {
      "key": "AM",
      "name": "Amharic",
      "nativeName": "አማርኛ"
    },
    {
      "key": "AN",
      "name": "Aragonese",
      "nativeName": "Aragonés"
    },
    {
      "key": "HY",
      "name": "Armenian",
      "nativeName": "Հայերեն"
    },
    {
      "key": "AS",
      "name": "Assamese",
      "nativeName": "অসমীয়া"
    },
    {
      "key": "AV",
      "name": "Avaric",
      "nativeName": "авар мацӀ, магӀарул мацӀ"
    },
    {
      "key": "AE",
      "name": "Avestan",
      "nativeName": "avesta"
    },
    {
      "key": "AY",
      "name": "Aymara",
      "nativeName": "aymar aru"
    },
    {
      "key": "AZ",
      "name": "Azerbaijani",
      "nativeName": "azərbaycan dili"
    },
    {
      "key": "BM",
      "name": "Bambara",
      "nativeName": "bamanankan"
    },
    {
      "key": "BA",
      "name": "Bashkir",
      "nativeName": "башҡорт теле"
    },
    {
      "key": "EU",
      "name": "Basque",
      "nativeName": "euskara, euskera"
    },
    {
      "key": "BE",
      "name": "Belarusian",
      "nativeName": "Беларуская"
    },
    {
      "key": "BN",
      "name": "Bengali",
      "nativeName": "বাংলা"
    },
    {
      "key": "BH",
      "name": "Bihari",
      "nativeName": "भोजपुरी"
    },
    {
      "key": "BI",
      "name": "Bislama",
      "nativeName": "Bislama"
    },
    {
      "key": "BS",
      "name": "Bosnian",
      "nativeName": "bosanski jezik"
    },
    {
      "key": "BR",
      "name": "Breton",
      "nativeName": "brezhoneg"
    },
    {
      "key": "BG",
      "name": "Bulgarian",
      "nativeName": "български език"
    },
    {
      "key": "MY",
      "name": "Burmese",
      "nativeName": "ဗမာစာ"
    },
    {
      "key": "CA",
      "name": "Catalan; Valencian",
      "nativeName": "Català"
    },
    {
      "key": "CH",
      "name": "Chamorro",
      "nativeName": "Chamoru"
    },
    {
      "key": "CE",
      "name": "Chechen",
      "nativeName": "нохчийн мотт"
    },
    {
      "key": "NY",
      "name": "Chichewa; Chewa; Nyanja",
      "nativeName": "chiCheŵa, chinyanja"
    },
    {
      "key": "ZH",
      "name": "Chinese",
      "nativeName": "中文 (Zhōngwén), 汉语, 漢語"
    },
    {
      "key": "CV",
      "name": "Chuvash",
      "nativeName": "чӑваш чӗлхи"
    },
    {
      "key": "KW",
      "name": "Cornish",
      "nativeName": "Kernewek"
    },
    {
      "key": "CO",
      "name": "Corsican",
      "nativeName": "corsu, lingua corsa"
    },
    {
      "key": "CR",
      "name": "Cree",
      "nativeName": "ᓀᐦᐃᔭᐍᐏᐣ"
    },
    {
      "key": "HR",
      "name": "Croatian",
      "nativeName": "hrvatski"
    },
    {
      "key": "CS",
      "name": "Czech",
      "nativeName": "česky, čeština"
    },
    {
      "key": "DA",
      "name": "Danish",
      "nativeName": "dansk"
    },
    {
      "key": "DV",
      "name": "Divehi; Dhivehi; Maldivian;",
      "nativeName": "ދިވެހި"
    },
    {
      "key": "NL",
      "name": "Dutch",
      "nativeName": "Nederlands, Vlaams"
    },

    {
      "key": "EO",
      "name": "Esperanto",
      "nativeName": "Esperanto"
    },
    {
      "key": "ET",
      "name": "Estonian",
      "nativeName": "eesti, eesti keel"
    },
    {
      "key": "EE",
      "name": "Ewe",
      "nativeName": "Eʋegbe"
    },
    {
      "key": "FO",
      "name": "Faroese",
      "nativeName": "føroyskt"
    },
    {
      "key": "FJ",
      "name": "Fijian",
      "nativeName": "vosa Vakaviti"
    },
    {
      "key": "FI",
      "name": "Finnish",
      "nativeName": "suomi, suomen kieli"
    },
    {
      "key": "FR",
      "name": "French",
      "nativeName": "français, langue française"
    },
    {
      "key": "FF",
      "name": "Fula; Fulah; Pulaar; Pular",
      "nativeName": "Fulfulde, Pulaar, Pular"
    },
    {
      "key": "GL",
      "name": "Galician",
      "nativeName": "Galego"
    },
    {
      "key": "KA",
      "name": "Georgian",
      "nativeName": "ქართული"
    },
    {
      "key": "DE",
      "name": "German",
      "nativeName": "Deutsch"
    },
    {
      "key": "EL",
      "name": "Greek, Modern",
      "nativeName": "Ελληνικά"
    },
    {
      "key": "GN",
      "name": "Guaraní",
      "nativeName": "Avañeẽ"
    },
    {
      "key": "GU",
      "name": "Gujarati",
      "nativeName": "ગુજરાતી"
    },
    {
      "key": "HT",
      "name": "Haitian; Haitian Creole",
      "nativeName": "Kreyòl ayisyen"
    },
    {
      "key": "HA",
      "name": "Hausa",
      "nativeName": "Hausa, هَوُسَ"
    },
    {
      "key": "HE",
      "name": "Hebrew (modern)",
      "nativeName": "עברית"
    },
    {
      "key": "HZ",
      "name": "Herero",
      "nativeName": "Otjiherero"
    },
    {
      "key": "HI",
      "name": "Hindi",
      "nativeName": "हिन्दी, हिंदी"
    },
    {
      "key": "HO",
      "name": "Hiri Motu",
      "nativeName": "Hiri Motu"
    },
    {
      "key": "HU",
      "name": "Hungarian",
      "nativeName": "Magyar"
    },
    {
      "key": "IA",
      "name": "Interlingua",
      "nativeName": "Interlingua"
    },
    {
      "key": "ID",
      "name": "Indonesian",
      "nativeName": "Bahasa Indonesia"
    },
    {
      "key": "IE",
      "name": "Interlingue",
      "nativeName": "Originally called Occidental; then Interlingue after WWII"
    },
    {
      "key": "GA",
      "name": "Irish",
      "nativeName": "Gaeilge"
    },
    {
      "key": "IG",
      "name": "Igbo",
      "nativeName": "Asụsụ Igbo"
    },
    {
      "key": "IK",
      "name": "Inupiaq",
      "nativeName": "Iñupiaq, Iñupiatun"
    },
    {
      "key": "IO",
      "name": "Ido",
      "nativeName": "Ido"
    },
    {
      "key": "IS",
      "name": "Icelandic",
      "nativeName": "Íslenska"
    },
    {
      "key": "IT",
      "name": "Italian",
      "nativeName": "Italiano"
    },
    {
      "key": "IU",
      "name": "Inuktitut",
      "nativeName": "ᐃᓄᒃᑎᑐᑦ"
    },
    {
      "key": "JA",
      "name": "Japanese",
      "nativeName": "日本語 (にほんご／にっぽんご)"
    },
    {
      "key": "JV",
      "name": "Javanese",
      "nativeName": "basa Jawa"
    },
    {
      "key": "KL",
      "name": "Kalaallisut, Greenlandic",
      "nativeName": "kalaallisut, kalaallit oqaasii"
    },
    {
      "key": "KN",
      "name": "Kannada",
      "nativeName": "ಕನ್ನಡ"
    },
    {
      "key": "KR",
      "name": "Kanuri",
      "nativeName": "Kanuri"
    },
    {
      "key": "KS",
      "name": "Kashmiri",
      "nativeName": "कश्मीरी, كشميري‎"
    },
    {
      "key": "KK",
      "name": "Kazakh",
      "nativeName": "Қазақ тілі"
    },
    {
      "key": "KM",
      "name": "Khmer",
      "nativeName": "ភាសាខ្មែរ"
    },
    {
      "key": "KI",
      "name": "Kikuyu, Gikuyu",
      "nativeName": "Gĩkũyũ"
    },
    {
      "key": "RW",
      "name": "Kinyarwanda",
      "nativeName": "Ikinyarwanda"
    },
    {
      "key": "KY",
      "name": "Kirghiz, Kyrgyz",
      "nativeName": "кыргыз тили"
    },
    {
      "key": "KV",
      "name": "Komi",
      "nativeName": "коми кыв"
    },
    {
      "key": "KG",
      "name": "Kongo",
      "nativeName": "KiKongo"
    },
    {
      "key": "KO",
      "name": "Korean",
      "nativeName": "한국어 (韓國語), 조선말 (朝鮮語)"
    },
    {
      "key": "KU",
      "name": "Kurdish",
      "nativeName": "Kurdî, كوردی‎"
    },
    {
      "key": "KJ",
      "name": "Kwanyama, Kuanyama",
      "nativeName": "Kuanyama"
    },
    {
      "key": "LA",
      "name": "Latin",
      "nativeName": "latine, lingua latina"
    },
    {
      "key": "LB",
      "name": "Luxembourgish, Letzeburgesch",
      "nativeName": "Lëtzebuergesch"
    },
    {
      "key": "LG",
      "name": "Luganda",
      "nativeName": "Luganda"
    },
    {
      "key": "LI",
      "name": "Limburgish, Limburgan, Limburger",
      "nativeName": "Limburgs"
    },
    {
      "key": "LN",
      "name": "Lingala",
      "nativeName": "Lingála"
    },
    {
      "key": "LO",
      "name": "Lao",
      "nativeName": "ພາສາລາວ"
    },
    {
      "key": "LT",
      "name": "Lithuanian",
      "nativeName": "lietuvių kalba"
    },
    {
      "key": "LU",
      "name": "Luba-Katanga",
      "nativeName": ""
    },
    {
      "key": "LV",
      "name": "Latvian",
      "nativeName": "latviešu valoda"
    },
    {
      "key": "GV",
      "name": "Manx",
      "nativeName": "Gaelg, Gailck"
    },
    {
      "key": "MK",
      "name": "Macedonian",
      "nativeName": "македонски јазик"
    },
    {
      "key": "MG",
      "name": "Malagasy",
      "nativeName": "Malagasy fiteny"
    },
    {
      "key": "MS",
      "name": "Malay",
      "nativeName": "bahasa Melayu, بهاس ملايو‎"
    },
    {
      "key": "ML",
      "name": "Malayalam",
      "nativeName": "മലയാളം"
    },
    {
      "key": "MT",
      "name": "Maltese",
      "nativeName": "Malti"
    },
    {
      "key": "MI",
      "name": "Māori",
      "nativeName": "te reo Māori"
    },
    {
      "key": "MR",
      "name": "Marathi (Marāṭhī)",
      "nativeName": "मराठी"
    },
    {
      "key": "MH",
      "name": "Marshallese",
      "nativeName": "Kajin M̧ajeļ"
    },
    {
      "key": "MN",
      "name": "Mongolian",
      "nativeName": "монгол"
    },
    {
      "key": "NA",
      "name": "Nauru",
      "nativeName": "Ekakairũ Naoero"
    },
    {
      "key": "NV",
      "name": "Navajo, Navaho",
      "nativeName": "Diné bizaad, Dinékʼehǰí"
    },
    {
      "key": "NB",
      "name": "Norwegian Bokmål",
      "nativeName": "Norsk bokmål"
    },
    {
      "key": "ND",
      "name": "North Ndebele",
      "nativeName": "isiNdebele"
    },
    {
      "key": "NE",
      "name": "Nepali",
      "nativeName": "नेपाली"
    },
    {
      "key": "NG",
      "name": "Ndonga",
      "nativeName": "Owambo"
    },
    {
      "key": "NN",
      "name": "Norwegian Nynorsk",
      "nativeName": "Norsk nynorsk"
    },
    {
      "key": "NO",
      "name": "Norwegian",
      "nativeName": "Norsk"
    },
    {
      "key": "II",
      "name": "Nuosu",
      "nativeName": "ꆈꌠ꒿ Nuosuhxop"
    },
    {
      "key": "NR",
      "name": "South Ndebele",
      "nativeName": "isiNdebele"
    },
    {
      "key": "OC",
      "name": "Occitan",
      "nativeName": "Occitan"
    },
    {
      "key": "OJ",
      "name": "Ojibwe, Ojibwa",
      "nativeName": "ᐊᓂᔑᓈᐯᒧᐎᓐ"
    },
    {
      "key": "CU",
      "name": "Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic",
      "nativeName": "ѩзыкъ словѣньскъ"
    },
    {
      "key": "OM",
      "name": "Oromo",
      "nativeName": "Afaan Oromoo"
    },
    {
      "key": "OR",
      "name": "Oriya",
      "nativeName": "ଓଡ଼ିଆ"
    },
    {
      "key": "OS",
      "name": "Ossetian, Ossetic",
      "nativeName": "ирон æвзаг"
    },
    {
      "key": "PA",
      "name": "Panjabi, Punjabi",
      "nativeName": "ਪੰਜਾਬੀ, پنجابی‎"
    },
    {
      "key": "PI",
      "name": "Pāli",
      "nativeName": "पाऴि"
    },
    {
      "key": "FA",
      "name": "Persian",
      "nativeName": "فارسی"
    },
    {
      "key": "PL",
      "name": "Polish",
      "nativeName": "polski"
    },
    {
      "key": "PS",
      "name": "Pashto, Pushto",
      "nativeName": "پښتو"
    },
    {
      "key": "PT",
      "name": "Portuguese",
      "nativeName": "Português"
    },
    {
      "key": "QU",
      "name": "Quechua",
      "nativeName": "Runa Simi, Kichwa"
    },
    {
      "key": "RM",
      "name": "Romansh",
      "nativeName": "rumantsch grischun"
    },
    {
      "key": "RN",
      "name": "Kirundi",
      "nativeName": "kiRundi"
    },
    {
      "key": "RO",
      "name": "Romanian, Moldavian, Moldovan",
      "nativeName": "română"
    },
    {
      "key": "RU",
      "name": "Russian",
      "nativeName": "русский язык"
    },
    {
      "key": "SA",
      "name": "Sanskrit (Saṁskṛta)",
      "nativeName": "संस्कृतम्"
    },
    {
      "key": "SC",
      "name": "Sardinian",
      "nativeName": "sardu"
    },
    {
      "key": "SD",
      "name": "Sindhi",
      "nativeName": "सिन्धी, سنڌي، سندھی‎"
    },
    {
      "key": "SE",
      "name": "Northern Sami",
      "nativeName": "Davvisámegiella"
    },
    {
      "key": "SM",
      "name": "Samoan",
      "nativeName": "gagana faa Samoa"
    },
    {
      "key": "SG",
      "name": "Sango",
      "nativeName": "yângâ tî sängö"
    },
    {
      "key": "SR",
      "name": "Serbian",
      "nativeName": "српски језик"
    },
    {
      "key": "GD",
      "name": "Scottish Gaelic; Gaelic",
      "nativeName": "Gàidhlig"
    },
    {
      "key": "SN",
      "name": "Shona",
      "nativeName": "chiShona"
    },
    {
      "key": "SI",
      "name": "Sinhala, Sinhalese",
      "nativeName": "සිංහල"
    },
    {
      "key": "SK",
      "name": "Slovak",
      "nativeName": "slovenčina"
    },
    {
      "key": "SL",
      "name": "Slovene",
      "nativeName": "slovenščina"
    },
    {
      "key": "SO",
      "name": "Somali",
      "nativeName": "Soomaaliga, af Soomaali"
    },
    {
      "key": "ST",
      "name": "Southern Sotho",
      "nativeName": "Sesotho"
    },
    {
      "key": "ES",
      "name": "Spanish; Castilian",
      "nativeName": "español, castellano"
    },
    {
      "key": "SU",
      "name": "Sundanese",
      "nativeName": "Basa Sunda"
    },
    {
      "key": "SW",
      "name": "Swahili",
      "nativeName": "Kiswahili"
    },
    {
      "key": "SS",
      "name": "Swati",
      "nativeName": "SiSwati"
    },
    {
      "key": "SV",
      "name": "Swedish",
      "nativeName": "svenska"
    },
    {
      "key": "TL",
      "name": "Tamil",
      "nativeName": "தமிழ்"
    },
    {
      "key": "TE",
      "name": "Telugu",
      "nativeName": "తెలుగు"
    },
    {
      "key": "TG",
      "name": "Tajik",
      "nativeName": "тоҷикӣ, toğikī, تاجیکی‎"
    },
    {
      "key": "TH",
      "name": "Thai",
      "nativeName": "ไทย"
    },
    {
      "key": "TI",
      "name": "Tigrinya",
      "nativeName": "ትግርኛ"
    },
    {
      "key": "BO",
      "name": "Tibetan Standard, Tibetan, Central",
      "nativeName": "བོད་ཡིག"
    },
    {
      "key": "TK",
      "name": "Turkmen",
      "nativeName": "Türkmen, Түркмен"
    },
    {
      "key": "TA",
      "name": "Tagalog",
      "nativeName": "Wikang Tagalog"
    },
    {
      "key": "TN",
      "name": "Tswana",
      "nativeName": "Setswana"
    },
    {
      "key": "TO",
      "name": "Tonga (Tonga Islands)",
      "nativeName": "faka Tonga"
    },
    {
      "key": "TR",
      "name": "Turkish",
      "nativeName": "Türkçe"
    },
    {
      "key": "TS",
      "name": "Tsonga",
      "nativeName": "Xitsonga"
    },
    {
      "key": "TT",
      "name": "Tatar",
      "nativeName": "татарча, tatarça, تاتارچا‎"
    },
    {
      "key": "TW",
      "name": "Twi",
      "nativeName": "Twi"
    },
    {
      "key": "TY",
      "name": "Tahitian",
      "nativeName": "Reo Tahiti"
    },
    {
      "key": "UG",
      "name": "Uighur, Uyghur",
      "nativeName": "Uyƣurqə, ئۇيغۇرچە‎"
    },
    {
      "key": "UK",
      "name": "Ukrainian",
      "nativeName": "українська"
    },
    {
      "key": "UR",
      "name": "Urdu",
      "nativeName": "اردو"
    },
    {
      "key": "UZ",
      "name": "Uzbek",
      "nativeName": "zbek, Ўзбек, أۇزبېك‎"
    },
    {
      "key": "VE",
      "name": "Venda",
      "nativeName": "Tshivenḓa"
    },
    {
      "key": "VI",
      "name": "Vietnamese",
      "nativeName": "Tiếng Việt"
    },
    {
      "key": "VO",
      "name": "Volapük",
      "nativeName": "Volapük"
    },
    {
      "key": "WA",
      "name": "Walloon",
      "nativeName": "Walon"
    },
    {
      "key": "CY",
      "name": "Welsh",
      "nativeName": "Cymraeg"
    },
    {
      "key": "WO",
      "name": "Wolof",
      "nativeName": "Wollof"
    },
    {
      "key": "FY",
      "name": "Western Frisian",
      "nativeName": "Frysk"
    },
    {
      "key": "XH",
      "name": "Xhosa",
      "nativeName": "isiXhosa"
    },
    {
      "key": "YI",
      "name": "Yiddish",
      "nativeName": "ייִדיש"
    },
    {
      "key": "YO",
      "name": "Yoruba",
      "nativeName": "Yorùbá"
    },
    {
      "key": "ZA",
      "name": "Zhuang, Chuang",
      "nativeName": "Saɯ cueŋƅ, Saw cuengh"
    }
  ];

  getAvailableLanguages() {
    return this.supportedLanguages.filter(s =>
      s.key == 'EN'
      || s.key == 'AR'
      || s.key == 'FR'
      || s.key == 'HI'
      || s.key == 'TA'
      || s.key == 'UR'
      || s.key == 'BN'
      || s.key == 'NL'
      || s.key == 'ES'
      || s.key == 'DE'
      || s.key == 'LA'
      || s.key == 'SI'
      || s.key == 'NE'
      || s.key == 'ML'
      || s.key == 'ID'
      || s.key == 'TR'
    );
  }


  languageTranslation: any[] = [
    {
      key: 'EN', name: [
        {
          "key": "AB",
          "name": "Abkhaz",
          "nativeName": "аҧсуа"
        },
        {
          "key": "AA",
          "name": "Afar",
          "nativeName": "Afaraf"
        },
        {
          "key": "AF",
          "name": "Afrikaans",
          "nativeName": "Afrikaans"
        },
        {
          "key": "AK",
          "name": "Akan",
          "nativeName": "Akan"
        },
        {
          "key": "SQ",
          "name": "Albanian",
          "nativeName": "Shqip"
        },
        {
          "key": "AM",
          "name": "Amharic",
          "nativeName": "አማርኛ"
        },
        {
          "key": "AR",
          "name": "Arabic",
          "nativeName": "العربية"
        },
        {
          "key": "AN",
          "name": "Aragonese",
          "nativeName": "Aragonés"
        },
        {
          "key": "HY",
          "name": "Armenian",
          "nativeName": "Հայերեն"
        },
        {
          "key": "AS",
          "name": "Assamese",
          "nativeName": "অসমীয়া"
        },
        {
          "key": "AV",
          "name": "Avaric",
          "nativeName": "авар мацӀ, магӀарул мацӀ"
        },
        {
          "key": "AE",
          "name": "Avestan",
          "nativeName": "avesta"
        },
        {
          "key": "AY",
          "name": "Aymara",
          "nativeName": "aymar aru"
        },
        {
          "key": "AZ",
          "name": "Azerbaijani",
          "nativeName": "azərbaycan dili"
        },
        {
          "key": "BM",
          "name": "Bambara",
          "nativeName": "bamanankan"
        },
        {
          "key": "BA",
          "name": "Bashkir",
          "nativeName": "башҡорт теле"
        },
        {
          "key": "EU",
          "name": "Basque",
          "nativeName": "euskara, euskera"
        },
        {
          "key": "BE",
          "name": "Belarusian",
          "nativeName": "Беларуская"
        },
        {
          "key": "BN",
          "name": "Bengali",
          "nativeName": "বাংলা"
        },
        {
          "key": "BH",
          "name": "Bihari",
          "nativeName": "भोजपुरी"
        },
        {
          "key": "BI",
          "name": "Bislama",
          "nativeName": "Bislama"
        },
        {
          "key": "BS",
          "name": "Bosnian",
          "nativeName": "bosanski jezik"
        },
        {
          "key": "BR",
          "name": "Breton",
          "nativeName": "brezhoneg"
        },
        {
          "key": "BG",
          "name": "Bulgarian",
          "nativeName": "български език"
        },
        {
          "key": "MY",
          "name": "Burmese",
          "nativeName": "ဗမာစာ"
        },
        {
          "key": "CA",
          "name": "Catalan; Valencian",
          "nativeName": "Català"
        },
        {
          "key": "CH",
          "name": "Chamorro",
          "nativeName": "Chamoru"
        },
        {
          "key": "CE",
          "name": "Chechen",
          "nativeName": "нохчийн мотт"
        },
        {
          "key": "NY",
          "name": "Chichewa; Chewa; Nyanja",
          "nativeName": "chiCheŵa, chinyanja"
        },
        {
          "key": "ZH",
          "name": "Chinese",
          "nativeName": "中文 (Zhōngwén), 汉语, 漢語"
        },
        {
          "key": "CV",
          "name": "Chuvash",
          "nativeName": "чӑваш чӗлхи"
        },
        {
          "key": "KW",
          "name": "Cornish",
          "nativeName": "Kernewek"
        },
        {
          "key": "CO",
          "name": "Corsican",
          "nativeName": "corsu, lingua corsa"
        },
        {
          "key": "CR",
          "name": "Cree",
          "nativeName": "ᓀᐦᐃᔭᐍᐏᐣ"
        },
        {
          "key": "HR",
          "name": "Croatian",
          "nativeName": "hrvatski"
        },
        {
          "key": "CS",
          "name": "Czech",
          "nativeName": "česky, čeština"
        },
        {
          "key": "DA",
          "name": "Danish",
          "nativeName": "dansk"
        },
        {
          "key": "DV",
          "name": "Divehi; Dhivehi; Maldivian;",
          "nativeName": "ދިވެހި"
        },
        {
          "key": "NL",
          "name": "Dutch",
          "nativeName": "Nederlands, Vlaams"
        },
        {
          "key": "EN",
          "name": "English",
          "nativeName": "English"
        },
        {
          "key": "EO",
          "name": "Esperanto",
          "nativeName": "Esperanto"
        },
        {
          "key": "ET",
          "name": "Estonian",
          "nativeName": "eesti, eesti keel"
        },
        {
          "key": "EE",
          "name": "Ewe",
          "nativeName": "Eʋegbe"
        },
        {
          "key": "FO",
          "name": "Faroese",
          "nativeName": "føroyskt"
        },
        {
          "key": "FJ",
          "name": "Fijian",
          "nativeName": "vosa Vakaviti"
        },
        {
          "key": "FI",
          "name": "Finnish",
          "nativeName": "suomi, suomen kieli"
        },
        {
          "key": "FR",
          "name": "French",
          "nativeName": "français, langue française"
        },
        {
          "key": "FF",
          "name": "Fula; Fulah; Pulaar; Pular",
          "nativeName": "Fulfulde, Pulaar, Pular"
        },
        {
          "key": "GL",
          "name": "Galician",
          "nativeName": "Galego"
        },
        {
          "key": "KA",
          "name": "Georgian",
          "nativeName": "ქართული"
        },
        {
          "key": "DE",
          "name": "German",
          "nativeName": "Deutsch"
        },
        {
          "key": "EL",
          "name": "Greek, Modern",
          "nativeName": "Ελληνικά"
        },
        {
          "key": "GN",
          "name": "Guaraní",
          "nativeName": "Avañeẽ"
        },
        {
          "key": "GU",
          "name": "Gujarati",
          "nativeName": "ગુજરાતી"
        },
        {
          "key": "HT",
          "name": "Haitian; Haitian Creole",
          "nativeName": "Kreyòl ayisyen"
        },
        {
          "key": "HA",
          "name": "Hausa",
          "nativeName": "Hausa, هَوُسَ"
        },
        {
          "key": "HE",
          "name": "Hebrew (modern)",
          "nativeName": "עברית"
        },
        {
          "key": "HZ",
          "name": "Herero",
          "nativeName": "Otjiherero"
        },
        {
          "key": "HI",
          "name": "Hindi",
          "nativeName": "हिन्दी, हिंदी"
        },
        {
          "key": "HO",
          "name": "Hiri Motu",
          "nativeName": "Hiri Motu"
        },
        {
          "key": "HU",
          "name": "Hungarian",
          "nativeName": "Magyar"
        },
        {
          "key": "IA",
          "name": "Interlingua",
          "nativeName": "Interlingua"
        },
        {
          "key": "ID",
          "name": "Indonesian",
          "nativeName": "Bahasa Indonesia"
        },
        {
          "key": "IE",
          "name": "Interlingue",
          "nativeName": "Originally called Occidental; then Interlingue after WWII"
        },
        {
          "key": "GA",
          "name": "Irish",
          "nativeName": "Gaeilge"
        },
        {
          "key": "IG",
          "name": "Igbo",
          "nativeName": "Asụsụ Igbo"
        },
        {
          "key": "IK",
          "name": "Inupiaq",
          "nativeName": "Iñupiaq, Iñupiatun"
        },
        {
          "key": "IO",
          "name": "Ido",
          "nativeName": "Ido"
        },
        {
          "key": "IS",
          "name": "Icelandic",
          "nativeName": "Íslenska"
        },
        {
          "key": "IT",
          "name": "Italian",
          "nativeName": "Italiano"
        },
        {
          "key": "IU",
          "name": "Inuktitut",
          "nativeName": "ᐃᓄᒃᑎᑐᑦ"
        },
        {
          "key": "JA",
          "name": "Japanese",
          "nativeName": "日本語 (にほんご／にっぽんご)"
        },
        {
          "key": "JV",
          "name": "Javanese",
          "nativeName": "basa Jawa"
        },
        {
          "key": "KL",
          "name": "Kalaallisut, Greenlandic",
          "nativeName": "kalaallisut, kalaallit oqaasii"
        },
        {
          "key": "KN",
          "name": "Kannada",
          "nativeName": "ಕನ್ನಡ"
        },
        {
          "key": "KR",
          "name": "Kanuri",
          "nativeName": "Kanuri"
        },
        {
          "key": "KS",
          "name": "Kashmiri",
          "nativeName": "कश्मीरी, كشميري‎"
        },
        {
          "key": "KK",
          "name": "Kazakh",
          "nativeName": "Қазақ тілі"
        },
        {
          "key": "KM",
          "name": "Khmer",
          "nativeName": "ភាសាខ្មែរ"
        },
        {
          "key": "KI",
          "name": "Kikuyu, Gikuyu",
          "nativeName": "Gĩkũyũ"
        },
        {
          "key": "RW",
          "name": "Kinyarwanda",
          "nativeName": "Ikinyarwanda"
        },
        {
          "key": "KY",
          "name": "Kirghiz, Kyrgyz",
          "nativeName": "кыргыз тили"
        },
        {
          "key": "KV",
          "name": "Komi",
          "nativeName": "коми кыв"
        },
        {
          "key": "KG",
          "name": "Kongo",
          "nativeName": "KiKongo"
        },
        {
          "key": "KO",
          "name": "Korean",
          "nativeName": "한국어 (韓國語), 조선말 (朝鮮語)"
        },
        {
          "key": "KU",
          "name": "Kurdish",
          "nativeName": "Kurdî, كوردی‎"
        },
        {
          "key": "KJ",
          "name": "Kwanyama, Kuanyama",
          "nativeName": "Kuanyama"
        },
        {
          "key": "LA",
          "name": "Latin",
          "nativeName": "latine, lingua latina"
        },
        {
          "key": "LB",
          "name": "Luxembourgish, Letzeburgesch",
          "nativeName": "Lëtzebuergesch"
        },
        {
          "key": "LG",
          "name": "Luganda",
          "nativeName": "Luganda"
        },
        {
          "key": "LI",
          "name": "Limburgish, Limburgan, Limburger",
          "nativeName": "Limburgs"
        },
        {
          "key": "LN",
          "name": "Lingala",
          "nativeName": "Lingála"
        },
        {
          "key": "LO",
          "name": "Lao",
          "nativeName": "ພາສາລາວ"
        },
        {
          "key": "LT",
          "name": "Lithuanian",
          "nativeName": "lietuvių kalba"
        },
        {
          "key": "LU",
          "name": "Luba-Katanga",
          "nativeName": ""
        },
        {
          "key": "LV",
          "name": "Latvian",
          "nativeName": "latviešu valoda"
        },
        {
          "key": "GV",
          "name": "Manx",
          "nativeName": "Gaelg, Gailck"
        },
        {
          "key": "MK",
          "name": "Macedonian",
          "nativeName": "македонски јазик"
        },
        {
          "key": "MG",
          "name": "Malagasy",
          "nativeName": "Malagasy fiteny"
        },
        {
          "key": "MS",
          "name": "Malay",
          "nativeName": "bahasa Melayu, بهاس ملايو‎"
        },
        {
          "key": "ML",
          "name": "Malayalam",
          "nativeName": "മലയാളം"
        },
        {
          "key": "MT",
          "name": "Maltese",
          "nativeName": "Malti"
        },
        {
          "key": "MI",
          "name": "Māori",
          "nativeName": "te reo Māori"
        },
        {
          "key": "MR",
          "name": "Marathi (Marāṭhī)",
          "nativeName": "मराठी"
        },
        {
          "key": "MH",
          "name": "Marshallese",
          "nativeName": "Kajin M̧ajeļ"
        },
        {
          "key": "MN",
          "name": "Mongolian",
          "nativeName": "монгол"
        },
        {
          "key": "NA",
          "name": "Nauru",
          "nativeName": "Ekakairũ Naoero"
        },
        {
          "key": "NV",
          "name": "Navajo, Navaho",
          "nativeName": "Diné bizaad, Dinékʼehǰí"
        },
        {
          "key": "NB",
          "name": "Norwegian Bokmål",
          "nativeName": "Norsk bokmål"
        },
        {
          "key": "ND",
          "name": "North Ndebele",
          "nativeName": "isiNdebele"
        },
        {
          "key": "NE",
          "name": "Nepali",
          "nativeName": "नेपाली"
        },
        {
          "key": "NG",
          "name": "Ndonga",
          "nativeName": "Owambo"
        },
        {
          "key": "NN",
          "name": "Norwegian Nynorsk",
          "nativeName": "Norsk nynorsk"
        },
        {
          "key": "NO",
          "name": "Norwegian",
          "nativeName": "Norsk"
        },
        {
          "key": "II",
          "name": "Nuosu",
          "nativeName": "ꆈꌠ꒿ Nuosuhxop"
        },
        {
          "key": "NR",
          "name": "South Ndebele",
          "nativeName": "isiNdebele"
        },
        {
          "key": "OC",
          "name": "Occitan",
          "nativeName": "Occitan"
        },
        {
          "key": "OJ",
          "name": "Ojibwe, Ojibwa",
          "nativeName": "ᐊᓂᔑᓈᐯᒧᐎᓐ"
        },
        {
          "key": "CU",
          "name": "Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic",
          "nativeName": "ѩзыкъ словѣньскъ"
        },
        {
          "key": "OM",
          "name": "Oromo",
          "nativeName": "Afaan Oromoo"
        },
        {
          "key": "OR",
          "name": "Oriya",
          "nativeName": "ଓଡ଼ିଆ"
        },
        {
          "key": "OS",
          "name": "Ossetian, Ossetic",
          "nativeName": "ирон æвзаг"
        },
        {
          "key": "PA",
          "name": "Panjabi, Punjabi",
          "nativeName": "ਪੰਜਾਬੀ, پنجابی‎"
        },
        {
          "key": "PI",
          "name": "Pāli",
          "nativeName": "पाऴि"
        },
        {
          "key": "FA",
          "name": "Persian",
          "nativeName": "فارسی"
        },
        {
          "key": "PL",
          "name": "Polish",
          "nativeName": "polski"
        },
        {
          "key": "PS",
          "name": "Pashto, Pushto",
          "nativeName": "پښتو"
        },
        {
          "key": "PT",
          "name": "Portuguese",
          "nativeName": "Português"
        },
        {
          "key": "QU",
          "name": "Quechua",
          "nativeName": "Runa Simi, Kichwa"
        },
        {
          "key": "RM",
          "name": "Romansh",
          "nativeName": "rumantsch grischun"
        },
        {
          "key": "RN",
          "name": "Kirundi",
          "nativeName": "kiRundi"
        },
        {
          "key": "RO",
          "name": "Romanian, Moldavian, Moldovan",
          "nativeName": "română"
        },
        {
          "key": "RU",
          "name": "Russian",
          "nativeName": "русский язык"
        },
        {
          "key": "SA",
          "name": "Sanskrit (Saṁskṛta)",
          "nativeName": "संस्कृतम्"
        },
        {
          "key": "SC",
          "name": "Sardinian",
          "nativeName": "sardu"
        },
        {
          "key": "SD",
          "name": "Sindhi",
          "nativeName": "सिन्धी, سنڌي، سندھی‎"
        },
        {
          "key": "SE",
          "name": "Northern Sami",
          "nativeName": "Davvisámegiella"
        },
        {
          "key": "SM",
          "name": "Samoan",
          "nativeName": "gagana faa Samoa"
        },
        {
          "key": "SG",
          "name": "Sango",
          "nativeName": "yângâ tî sängö"
        },
        {
          "key": "SR",
          "name": "Serbian",
          "nativeName": "српски језик"
        },
        {
          "key": "GD",
          "name": "Scottish Gaelic; Gaelic",
          "nativeName": "Gàidhlig"
        },
        {
          "key": "SN",
          "name": "Shona",
          "nativeName": "chiShona"
        },
        {
          "key": "SI",
          "name": "Sinhala, Sinhalese",
          "nativeName": "සිංහල"
        },
        {
          "key": "SK",
          "name": "Slovak",
          "nativeName": "slovenčina"
        },
        {
          "key": "SL",
          "name": "Slovene",
          "nativeName": "slovenščina"
        },
        {
          "key": "SO",
          "name": "Somali",
          "nativeName": "Soomaaliga, af Soomaali"
        },
        {
          "key": "ST",
          "name": "Southern Sotho",
          "nativeName": "Sesotho"
        },
        {
          "key": "ES",
          "name": "Spanish; Castilian",
          "nativeName": "español, castellano"
        },
        {
          "key": "SU",
          "name": "Sundanese",
          "nativeName": "Basa Sunda"
        },
        {
          "key": "SW",
          "name": "Swahili",
          "nativeName": "Kiswahili"
        },
        {
          "key": "SS",
          "name": "Swati",
          "nativeName": "SiSwati"
        },
        {
          "key": "SV",
          "name": "Swedish",
          "nativeName": "svenska"
        },
        {
          "key": "TA",
          "name": "Tamil",
          "nativeName": "தமிழ்"
        },
        {
          "key": "TE",
          "name": "Telugu",
          "nativeName": "తెలుగు"
        },
        {
          "key": "TG",
          "name": "Tajik",
          "nativeName": "тоҷикӣ, toğikī, تاجیکی‎"
        },
        {
          "key": "TH",
          "name": "Thai",
          "nativeName": "ไทย"
        },
        {
          "key": "TI",
          "name": "Tigrinya",
          "nativeName": "ትግርኛ"
        },
        {
          "key": "BO",
          "name": "Tibetan Standard, Tibetan, Central",
          "nativeName": "བོད་ཡིག"
        },
        {
          "key": "TK",
          "name": "Turkmen",
          "nativeName": "Türkmen, Түркмен"
        },
        {
          "key": "TL",
          "name": "Tagalog",
          "nativeName": "Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔"
        },
        {
          "key": "TN",
          "name": "Tswana",
          "nativeName": "Setswana"
        },
        {
          "key": "TO",
          "name": "Tonga (Tonga Islands)",
          "nativeName": "faka Tonga"
        },
        {
          "key": "TR",
          "name": "Turkish",
          "nativeName": "Türkçe"
        },
        {
          "key": "TS",
          "name": "Tsonga",
          "nativeName": "Xitsonga"
        },
        {
          "key": "TT",
          "name": "Tatar",
          "nativeName": "татарча, tatarça, تاتارچا‎"
        },
        {
          "key": "TW",
          "name": "Twi",
          "nativeName": "Twi"
        },
        {
          "key": "TY",
          "name": "Tahitian",
          "nativeName": "Reo Tahiti"
        },
        {
          "key": "UG",
          "name": "Uighur, Uyghur",
          "nativeName": "Uyƣurqə, ئۇيغۇرچە‎"
        },
        {
          "key": "UK",
          "name": "Ukrainian",
          "nativeName": "українська"
        },
        {
          "key": "UR",
          "name": "Urdu",
          "nativeName": "اردو"
        },
        {
          "key": "UZ",
          "name": "Uzbek",
          "nativeName": "zbek, Ўзбек, أۇزبېك‎"
        },
        {
          "key": "VE",
          "name": "Venda",
          "nativeName": "Tshivenḓa"
        },
        {
          "key": "VI",
          "name": "Vietnamese",
          "nativeName": "Tiếng Việt"
        },
        {
          "key": "VO",
          "name": "Volapük",
          "nativeName": "Volapük"
        },
        {
          "key": "WA",
          "name": "Walloon",
          "nativeName": "Walon"
        },
        {
          "key": "CY",
          "name": "Welsh",
          "nativeName": "Cymraeg"
        },
        {
          "key": "WO",
          "name": "Wolof",
          "nativeName": "Wollof"
        },
        {
          "key": "FY",
          "name": "Western Frisian",
          "nativeName": "Frysk"
        },
        {
          "key": "XH",
          "name": "Xhosa",
          "nativeName": "isiXhosa"
        },
        {
          "key": "YI",
          "name": "Yiddish",
          "nativeName": "ייִדיש"
        },
        {
          "key": "YO",
          "name": "Yoruba",
          "nativeName": "Yorùbá"
        },
        {
          "key": "ZA",
          "name": "Zhuang, Chuang",
          "nativeName": "Saɯ cueŋƅ, Saw cuengh"
        }
      ]
    },
    {
      key: 'AR', name: [
        { key: 'AR', name: 'عربى' },
        { key: 'EN', name: 'الإنجليزية' },
        { key: 'FR', name: 'فرنسي' },
        , { key: 'HI', name: "هندي" }
        , { key: 'TA', name: "تاجالوج" }
        , { key: 'UR', name: "أوردو" }, { key: 'BN', name: "بنغالي" }

      ]
    },
    {
      key: 'FR', name: [
        { key: 'AR', name: 'Arabe' },
        { key: 'EN', name: 'Anglais' },
        { key: 'FR', name: 'Français' },
        , { key: 'HI', name: "Hindi" }
        , { key: 'TA', name: "Tagalog" }
        , { key: 'UR', name: "Urdu" }, { key: 'BN', name: "Bengali" }

      ]
    }
  ];


  companyLanguages: any[] = [
    { key: 'EN', name: 'Company' },
    { key: 'AR', name: 'شركة' },
    { key: 'FR', name: 'Compagnie' }

  ]




  // getEngagementUILanguage(key: string, language: string) {
  //   let lngO = this.engagementComponentText.find(cT => (cT.key == key && cT.language == language));
  //   if (lngO) {
  //     return lngO.name;
  //   } else {
  //     lngO = this.engagementComponentText.find(cT => (cT.key == key));
  //     if (lngO) {
  //       return lngO.name;
  //     }
  //   }
  //   return '';
  // }

  getTenant(tenantKey) {
    let overrideTenant = localStorage.getItem('tenantOverride');
    if (overrideTenant)
      tenantKey = overrideTenant;
    return tenantKey;
  }


  // getUILanguage(key: string, language: string) {
  //   // let lngO = this.componentText.find(cT => (cT.key == key && cT.language == language));
  //   // if (lngO) {
  //   //   return lngO.name;
  //   // } else {
  //   //   lngO = this.componentText.find(cT => (cT.key == key));
  //   //   if (lngO) {
  //   //     return lngO.name;
  //   //   }
  //   // }
  //   // return '';
  //   let lngO = this.componentText.find(cT => (cT.key == key));
  //   if (language == "EN") {
  //     if (lngO) {
  //       return lngO.text;
  //     }
  //   } else {
  //     if (lngO) {
  //       let translation = lngO.translations.find(cT => (cT.language == language));
  //       if (translation) {
  //         return translation.text;
  //       }
  //     }
  //   }
  //   return key
  // }


  extractNameLanguage(name: any, language?: string) {
    if (name instanceof Array) {
      let eGName: any = name?.find(nm => nm.key == language);
      if (eGName) {
        if (eGName?.name != '') {
          return eGName.name.toString();
        } else {
          eGName = name?.find(nm => nm.name != '');
          if (eGName) {
            return eGName.name;
          } else {
            return '';
          }
        }
      } else {
        eGName = name.find(nm => nm?.name != '');
        if (eGName) {
          return eGName.name;
        } else {
          return '';
        }
      }
    }
    return '';
  }

  getLanguageName(key: string) {
    return this.supportedLanguages.find(l => l.key == key).name;
  }

  getLongLanguageName(langISO: string, currentLanguage: string) {
    let currentLanguageList = this.languageTranslation.find(lT => lT.key == currentLanguage);
    if (currentLanguageList)
      return currentLanguageList?.name?.find(lang => lang?.key == langISO)?.nativeName || currentLanguageList?.name?.find(lang => lang?.key == langISO)?.name;
  }
}
